import React, { useState } from 'react';

export const languageOptions = [
  { code: 'de', flag: '🇩🇪', label: 'Deutsch' },
  { code: 'en', flag: '🇬🇧', label: 'English' },
  { code: 'ru', flag: '🇷🇺', label: 'Русский' },
  { code: 'es', flag: '🇪🇸', label: 'Español' },
  { code: 'fr', flag: '🇫🇷', label: 'Français' },
  { code: 'fa', flag: '🇮🇷', label: 'فارسی' },
  { code: 'ja', flag: '🇯🇵', label: '日本語' },
  { code: 'pt', flag: '🇵🇹', label: 'Português' },
  { code: 'ar', flag: '🇸🇦', label: 'العربية' },
  { code: 'zh', flag: '🇨🇳', label: '简体中文' },
  { code: 'hi', flag: '🇮🇳', label: 'हिन्दी' },
  { code: 'tr', flag: '🇹🇷', label: 'Türkçe' },
  { code: 'it', flag: '🇮🇹', label: 'Italiano' },
  { code: 'pl', flag: '🇵🇱', label: 'Polski' },
  { code: 'uk', flag: '🇺🇦', label: 'Українська' },
  { code: 'ko', flag: '🇰🇷', label: '한국어' },
  { code: 'id', flag: '🇮🇩', label: 'Indonesia' },
  { code: 'sq', flag: '🇦🇱', label: 'Shqip' }
];

export const translations = {
  de: {
    sc_title: "Security Center",
    sc_subtitle: "GaiaShield Integrated Security Layer",
    sc_tab_status: "🛡️ Schutzstatus",
    sc_tab_events: "📋 Sicherheitsprotokoll",
    sc_tab_node: "⚙️ Node-Sicherheit",
    sc_loading: "Lade Sicherheitsdaten...",
    sc_status_secured: "Systemstatus: Konto ist geschützt",
    sc_status_warning: "Systemstatus: Warnungen aktiv",
    sc_desc_secured: "Es liegen keine offenen kritischen Sicherheitswarnungen vor. GaiaShield überwacht dein Konto aktiv.",
    sc_desc_warning: "Achtung: Es gibt offene Sicherheitsereignisse, die deine Aufmerksamkeit erfordern.",
    sc_account_protection: "Konto-Schutz",
    sc_message_protection: "Nachrichten-Schutz",
    sc_audits: "Sicherheitsprüfungen",
    sc_active: "AKTIV",
    sc_failed_logins: "Fehlgeschlagene Logins",
    sc_tamper_checks: "Manipulationsprüfungen",
    sc_blocked_replays: "Blockierte Replays",
    sc_last_check: "Letzte Prüfung",
    sc_just_now: "Gerade eben",
    sc_open_warnings: "Offene Warnungen",
    sc_btn_acknowledge: "Bestätigen",
    sc_filter_severity: "Dringlichkeit",
    sc_filter_category: "Kategorie",
    sc_filter_hide_ack: "Bestätigte ausblenden",
    sc_btn_export: "Exportieren",
    sc_col_details: "Details",
    sc_col_time: "Zeit",
    sc_col_status: "Status",
    sc_col_action: "Aktion",
    sc_no_events: "Keine Sicherheitsereignisse gefunden.",
    sc_node_title: "Node-Betreiber-Sicherheitskonsole",
    sc_system_health: "Systemgesundheit",
    sc_last_audit: "Letztes Audit",
    sc_packed_logs: "Gepackte Logs",
    sc_unconfirmed_events: "Unbestätigte Events",
    sc_operator_action: "Betreiber-Aktion erforderlich",
    sc_all_ok: "Alles in Ordnung",
    sc_critical_events: "Kritische Systemereignisse",
    ac_title: "Governance- & Meldecenter",
    ac_subtitle: "GaiaCom Governance & Abuse Consensus",
    ac_tab_my_reports: "Meine Meldungen",
    ac_tab_queue: "Review Warteschlange",
    ac_tab_operator: "Node Operator",
    ac_tab_transparency: "Föderation & Transparenz",
    ac_loading: "Lade Daten...",
    ac_reported_cases: "Gemeldete Fälle",
    ac_no_reports: "Sie haben noch keine Meldungen eingereicht.",
    ac_case_details: "Fall-Details",
    ac_appeal_submit: "Einspruch einlegen",
    ac_appeal_status: "Status des Einspruchs",
    ac_appeal_reason: "Grund für den Einspruch",
    ac_appeal_statement: "Stellungnahme",
    ac_btn_appeal: "Einspruch abschicken",
    ac_trusted_reviewer_queue: "Trusted Reviewer Warteschlange",
    ac_case_review: "Fall überprüfen (Review)",
    ac_review_category: "Empfohlene Kategorie",
    ac_review_severity: "Empfohlener Schweregrad",
    ac_review_action: "Empfohlene Maßnahme",
    ac_review_reason: "Begründung des Reviewers",
    ac_btn_submit_review: "Review einreichen",
    ac_node_operator_dashboard: "Node Operator Dashboard",
    ac_apply_action: "Maßnahme anwenden (Override)",
    ac_target_type: "Ziel-Typ",
    ac_target_id: "Ziel-ID (GaiaID oder Channel ID)",
    ac_suspend: "Sperrung aktiv (Suspend)",
    ac_reason: "Offizielle Begründung",
    ac_btn_apply: "Maßnahme durchsetzen",
    ac_transparency_title: "Konsens- & Transparenz-Logbuch",
    ac_transparency_desc: "Öffentlich einsehbare Snapshot-Nachweise aller moderierten Kanäle und Identitäten.",
    ac_btn_snapshot: "Transparenz-Snapshot erzeugen",
    search_placeholder: "Mails nach Betreff, Sender, Text suchen...",
    abuse_center_title: "Meldecenter",
    abbrechen: "Abbrechen",
    active_identities: "Aktive Identitäten",
    active_identity: "Aktive Identität",
    add_btn: "Hinzufügen",
    add_contact_title: "Kontakt hinzufügen",
    admin: "Admin",
    adressbuch: "Adressbuch",
    aktiviert: "Aktiviert",
    an: "An",
    anonymous_sender: "Anonymer Absender",
    antworten: "Antworten",
    attachment_gaia_hint: "GaiaCOM-Anhänge bleiben Ende-zu-Ende verschlüsselt.",
    attachment_smtp_hint: "Legacy-SMTP blockt ausführbare/scriptartige Anhänge und speichert Mails als unsicher.",
    attachments: "Anhänge",
    auffaellig: "Auffällig",
    auth_beta_notice: "Beta-Testphase: GaiaCOM wird aktiv getestet. Fehler können auftreten; sichere wichtige Seeds und prüfe vertrauliche Workflows sorgfältig.",
    auth_btn_login: "Identität laden & einloggen",
    auth_btn_register: "Registrieren & Krypto erstellen",
    auth_copied: "Kopiert",
    auth_copy_seed: "Seed kopieren",
    auth_generate_seed: "Seed generieren",
    auth_headline: "GaiaCOM ist das erste quantensichere E-Mail-Protokoll und Kommunikationssystem, gebaut für die Menschheit.",
    auth_kicker: "Post-Quantum Secure Communication",
    auth_mnemonic: "Mnemonic-Phrase",
    auth_mnemonic_placeholder: "12 Wörter durch Leerzeichen getrennt...",
    auth_password: "Passwort",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "Private Schlüssel verlassen dein Gerät nicht. Nur die vorgesehenen Empfänger können Inhalte entschlüsseln.",
    auth_proof_gaiadata_desc: "Zero-Knowledge: Du behältst die Kontrolle über deine Daten. Metadaten werden minimiert und nicht als Klartext-Profil verwertet.",
    auth_proof_gaiadrop_desc: "Externe Personen können vertrauliche Text-Hinweise ohne Account an deine GaiaID senden.",
    auth_proof_gaiaproof_desc: "Zustell- und Integritätsbeweise zeigen, dass Ciphertext, Sender und Zeitstempel nicht manipuliert wurden.",
    auth_proof_gaiavault_desc: "Private Notizen, Recovery-Hinweise und Security Records bleiben lokal verschlüsselt.",
    auth_proof_hybrid_desc: "Quantum Shield: Hybride Verschlüsselung mit ML-KEM und X25519 schützt gegen heutige Angriffe und Store-Now-Decrypt-Later-Risiken.",
    auth_secure_mail: "Secure Quantum Federated Mail",
    auth_subline: "GaiaCOM ist ein quantensicheres Kommunikationssystem für E-Mail, Chat, Krisenräume, GaiaDrop und lokale Sicherheitsakten. Private Schlüssel bleiben auf deinem Gerät, Inhalte werden Ende-zu-Ende verschlüsselt und Beweise können ohne Klartext exportiert werden.",
    auth_success_btn: "Jetzt einloggen",
    auth_success_text: "Dein GaiaCOM-Konto wurde erstellt. Die Schlüssel wurden lokal aus deinem Seed abgeleitet und nicht auf dem Server gespeichert.",
    auth_success_title: "Registrierung erfolgreich",
    auth_tab_drop: "GaiaDrop",
    auth_tab_login: "Login / Account",
    auth_toggle_login: "Bereits Account vorhanden",
    auth_toggle_register: "Neuen Account erstellen",
    auth_usecase_text: "Geeignet für Anwälte, Unternehmen, Behörden, Journalisten, Whistleblower und private Sicherheitsfälle.",
    auth_usecase_title: "Für sensible Kommunikation gebaut",
    auth_username: "Benutzername",
    auth_username_placeholder: "Name eingeben...",
    auth_value_chat: "E2E Chat",
    auth_value_drop: "Secure Drop",
    auth_value_mail: "Sichere Mail",
    auth_value_rooms: "GaiaRooms",
    bestaetigen: "Bestätigen",
    bestaetigt: "Bestätigt",
    bio_status: "Biografie / Status",
    biography: "Biografie",
    change_password_desc: "Ändert dein serverseitiges Login-Passwort. Deine lokale Recovery Phrase bleibt separat durch dein Vault-/Unlock-Passwort geschützt.",
    change_password_menu_desc: "GaiaCOM Login-Passwort aktualisieren.",
    change_password_title: "Passwort ändern",
    channel_id: "Kanal-ID",
    channel_name_label: "Kanalname",
    chat_deleted_hidden: "Chat gelöscht und ausgeblendet.",
    chat_input_placeholder: "Sichere Nachricht eingeben...",
    chat_start_hint: "Starten Sie die Konversation! Alle Chat-Nachrichten sind quantensicher E2E verschlüsselt.",
    choose_avatar: "Avatar wählen",
    ciphertext_hash: "Ciphertext Hash",
    clear_chat: "Chat leeren",
    clear_for_everyone: "Für alle leeren",
    clear_for_me: "Nur für mich leeren",
    click_to_write_mail: "Klicken zum Schreiben einer Mail",
    click_top_right: "Klicke oben rechts auf",
    close: "Schließen",
    code_kopieren: "Code kopieren",
    code_kopieren_success: "Code kopiert",
    confirm_clear_channel_desc: "Möchtest du diesen Kanal aus deiner lokalen Ansicht leeren?",
    confirm_clear_channel_title: "Kanal leeren",
    confirm_clear_chat: "Möchtest du diesen Chat leeren?",
    confirm_clear_chat_desc: "Möchtest du diesen Chat leeren?",
    confirm_clear_chat_title: "Chat leeren",
    confirm_clear_everyone: "Möchtest du den Chat für beide Partner leeren? (OK = Für alle, Abbrechen = Nur für mich)",
    confirm_delete_everyone: "Möchtest du die Nachricht für beide Partner löschen? (OK = Für alle, Abbrechen = Nur für mich)",
    confirm_delete_msg: "Möchtest du diese Nachricht löschen?",
    confirm_delete_msg_desc: "Möchtest du diese Chat-Nachricht löschen?",
    confirm_delete_msg_title: "Nachricht löschen",
    confirm_new_password: "Neues Passwort bestätigen",
    copy: "Kopieren",
    create_btn: "Erstellen",
    create_channel_title: "Kanal erstellen",
    create_group_is_crisis: "Als Krisenraum markieren",
    create_group_title: "Neue Gruppe erstellen",
    crypto_lock_desc: "Steuert, wann GaiaCOM lokale Kryptoschluessel wieder aus dem Arbeitsspeicher entfernt.",
    crypto_lock_menu_desc: "Reload- und Inaktivitaets-Timer steuern.",
    crypto_lock_title: "Kryptografische Sperre",
    crypto_session_duration: "Entsperrt nach Reload",
    crypto_session_duration_desc: "Haelt die Kryptositzung nur fuer die gewaehlte Dauer in diesem Browser-Tab offen.",
    cryptographic_fingerprint: "Kryptographischer Fingerprint",
    current_password: "Aktuelles Passwort",
    data_minimization: "Datenminimierung",
    decrypt_failed: "Nicht entschlüsselbar",
    delete: "Löschen",
    delete_account_button: "Account unwiderruflich loeschen",
    delete_account_confirm_label: "Zur Bestaetigung DELETE eingeben",
    delete_account_confirmation_error: "Passwort und DELETE-Bestaetigung sind erforderlich.",
    delete_account_desc: "Dieser Modus vernichtet dein Konto, Identitaeten, Geraetesitzungen, GaiaDrop-Daten, Upload-Metadaten und serverseitig zuordenbare Nachrichten unwiderruflich.",
    delete_account_done_desc: "Alle zuordenbaren GaiaCOM-Daten wurden geloescht.",
    delete_account_done_title: "Account geloescht",
    delete_account_menu_desc: "Konto und zuordenbare Daten vernichten.",
    delete_account_not_authenticated: "Kein aktiver Account.",
    delete_account_title: "Account loeschen",
    delete_for_everyone: "Für alle löschen",
    delete_for_me: "Nur für mich löschen",
    device_current: "Dieses Gerät",
    device_last_seen: "Zuletzt",
    device_logout: "Abmelden",
    device_sessions_desc: "Prüfe aktive Sitzungen und melde Geräte ab, denen du nicht mehr vertraust.",
    device_sessions_empty: "Keine Geräte gefunden.",
    device_sessions_menu_desc: "Aktive Sitzungen verwalten und beenden.",
    device_sessions_title: "Angemeldete Geräte",
    device_since: "Seit",
    display_name: "Anzeigename",
    drop_address_copied: "GaiaDrop-Adresse kopiert.",
    drop_btn_decrypting: "Inbox wird entschlüsselt...",
    drop_btn_load: "GaiaDrop Inbox laden",
    drop_delete_desc: "Möchtest du diesen Drop wirklich unwiderruflich löschen?",
    drop_delete_title: "GaiaDrop löschen",
    drop_desc: "Text-only Zero-Knowledge Drop-Kanal für externe Hinweise, Responsible Disclosure und vertrauliche Meldungen. Externe können ohne Account unter Angabe deiner GaiaID Nachrichten senden.",
    drop_empty: "Noch keine GaiaDrop Meldungen geladen.",
    drop_id: "Drop-ID:",
    drop_own_address: "Deine GaiaDrop-Adresse",
    drop_proof: "DROP BEWEIS",
    drop_title: "GaiaDrop Secure Inbox",
    dunkler_modus: " Dunkler Modus",
    e2e_chat_room_open: "E2E Chat-Raum öffnen",
    edit_profile: "Profil bearbeiten",
    edit_profile_desc: "Anzeigename, Biografie und Avatar anpassen.",
    einladungscode: "Einladungscode",
    enter_fingerprint_chars_confirm: "Gib die angeforderten Fingerprint-Zeichen zur Bestätigung ein.",
    envelope_hash: "Envelope Hash",
    erasability: "Löschbarkeit",
    erfolg: "Erfolg",
    exclude_plaintext: "Ohne Klartext exportieren",
    export_disclosure: "Sicherheitsfall exportieren",
    export_package_desc: "Klartext nur aufnehmen, wenn diese Offenlegung bewusst vorgesehen ist.",
    export_package_title: "Sicherheits-Paket exportieren",
    fehler: "Fehler",
    gaiacom_reader: "GaiaCOM Reader",
    gaiadrop_inbox_title: "GaiaDrop Posteingang",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM minimiert Metadaten, haelt private Schluessel lokal, verschluesselt Inhalte Ende-zu-Ende und ermoeglicht vollstaendige Account-Loeschung.",
    gdpr_home_title: "100% DSGVO-konform",
    gdpr_reason_delete: "Account-Loeschung entfernt Konto, Identitaeten, lokale Sitzungen und serverseitig zuordenbare Daten.",
    gdpr_reason_e2ee: "Private Inhalte bleiben nur fuer vorgesehene Empfaenger entschluesselbar.",
    gdpr_reason_minimal: "Metadaten werden nur fuer Routing, Zustellung und Sicherheitsnachweise genutzt.",
    gdpr_reason_zero_knowledge: "Private Schluessel und Recovery-Daten bleiben lokal unter Nutzerkontrolle.",
    gesendet: "Gesendet",
    gesperrt_verdaechtig: "Gesperrt / Verdächtig",
    group_delete_desc: "Möchtest du diese Gruppe wirklich unwiderruflich löschen? Alle Kanäle und Nachrichten dieser Gruppe werden gelöscht.",
    group_delete_title: "Gruppe löschen",
    group_description: "Beschreibung",
    group_icon_label: "Gruppen-Icon / Avatar",
    group_name: "Gruppenname",
    group_settings_avatar: "Avatar",
    group_settings_desc: "Beschreibung",
    group_settings_is_crisis: "Als Krisenraum markieren",
    group_settings_name: "Gruppenname",
    group_settings_title: "Gruppeneinstellungen",
    groups_empty_desc: "Erstelle einen sicheren Arbeitsraum für Projekt-, Krisen- oder Teamkommunikation.",
    groups_empty_title: "Noch keine Gruppen-Chats",
    gruppe_beitreten: "Gruppe beigetreten",
    gruppe_erstellen: "+ Gruppe erstellen",
    gruppe_verlassen: "Gruppe verlassen",
    gruppen_chats: "Gruppen-Chats",
    heller_modus: " Heller Modus",
    how_to_receive_drops: "Wie empfange ich Drops?",
    identitaets_assistent: "Identitäts-Assistent",
    inactivity_lock_duration: "Sperren bei Inaktivitaet",
    inactivity_lock_duration_desc: "Nach dieser Zeit ohne Eingabe wird GaiaCOM automatisch kryptografisch gesperrt.",
    inactivity_lock_notice: "GaiaCOM wurde wegen Inaktivitaet kryptografisch gesperrt.",
    include_plaintext: "Klartext einschließen",
    invite_code_label: "Einladungscode",
    join_group_title: "Gruppe beitreten",
    kanaele: "Kanäle",
    kanal_erstellen: "+ Kanal",
    kein_chat_ausgewaehlt: "Kein Chat ausgewählt",
    kein_kanal_ausgewaehlt: "Kein Kanal ausgewählt",
    keine_gruppe_ausgewaehlt: "Keine Gruppe ausgewählt",
    keine_mails: "Keine Mails vorhanden.",
    key_change_warn_desc: "Der öffentliche Schlüssel dieses Kontakts hat sich geändert. Prüfe den Fingerprint, bevor du ihm vertraust.",
    key_change_warn_title: "Kryptographische Warnung",
    key_change_warning_changed: "hat sich geändert. Dies kann ein Anzeichen für einen Man-in-the-Middle-Angriff sein!",
    key_change_warning_msg: "Der Identitätsschlüssel für den Kontakt",
    key_transparency: "Key Transparency (Schlüssel-Verlauf)",
    kopiert: "Kopiert",
    kryptographische_schluessel: "Kryptographische Schlüssel",
    kryptographische_schluessel_desc: "Private Schluessel und Backup Seed Phrase anzeigen.",
    laden: "Laden...",
    leeren: "Leeren",
    loading: "Laden...",
    local_key_vault: "Lokaler Schlüssel-Tresor",
    local_keys_label: "Lokale Schlüssel",
    lock_on_reload: "Immer nach Reload sperren",
    logout: "Abmelden",
    mail_compose: "Mail schreiben",
    mein_profil: "Mein Profil",
    melden: "Melden",
    menu: "Menü",
    message: "Nachricht",
    message_id: "Message ID",
    message_pin: "Anpinnen",
    message_pinned_title: "Angepinnte Nachrichten",
    message_react: "Reagieren",
    message_reply: "Antworten",
    message_replying_to: "Antwort auf",
    message_save: "Speichern",
    message_saved: "Gespeichert",
    message_to_channel: "Nachricht an",
    message_unpin: "Loesen",
    message_unsave: "Nicht speichern",
    mitglied: "Mitglied",
    mitglieder: "Mitglieder",
    ml_kem: "ML-KEM",
    neue_mail: "Neue Mail",
    never_auto_lock: "Nie automatisch",
    new_fingerprint: "Neuer Fingerprint",
    new_identity: "Neue Identität",
    new_password: "Neues Passwort",
    no_description: "Keine Beschreibung",
    no_key_history: "Keine Schlüssel-Historie aufgezeichnet.",
    no_specification: "Keine Angabe",
    old_fingerprint: "Alter Fingerprint",
    open_privacy_imprint: "Impressum und Datenschutz oeffnen",
    post_quantum_e2e: "Post-Quanten E2E",
    posteingang: "Posteingang",
    powered_by: "Powered by",
    privacy_imprint_menu_desc: "DSGVO, Datenschutz und Impressum anzeigen.",
    privacy_imprint_profile_desc: "GaiaCOM verarbeitet Kommunikationsinhalte nach dem Prinzip Datenminimierung, Ende-zu-Ende-Verschluesselung und lokaler Schluesselkontrolle.",
    privacy_imprint_title: "Datenschutz & Impressum",
    profil: "Profil",
    profile_details: "Profil-Details",
    profile_settings_hint: "Profil-Einstellungen werden im rechten Panel angezeigt.",
    profile_unlock_desc: "Aus Sicherheitsgründen müssen Sie Ihr Passwort erneut eingeben, um Ihre privaten kryptographischen Schlüssel anzuzeigen.",
    proof_hash: "Proof-Hash:",
    public_drop_desc: "Secure Drop für externe Text-Hinweise ohne GaiaCOM Account.",
    public_drop_message: "Nachricht",
    public_drop_message_placeholder: "Vertraulichen Text eingeben...",
    public_drop_send: "GaiaDrop senden",
    public_drop_sender: "Absender-Hinweis optional",
    public_drop_sender_placeholder: "Name, Aktenzeichen oder anonym",
    public_drop_target: "Ziel-GaiaID",
    quanten_chat: "Quanten-Chat",
    quantum_secure_exchange: "Quantensicherer Austausch über...",
    quantum_secure_net: "GaiaCOM Quantensicheres Netzwerk (Ed25519 & ML-KEM)",
    quantum_shield_desc: "Das GaiaCOM-Netzwerk schützt Ihre Privatsphäre mit einem mehrschichtigen, hybriden Verschlüsselungs-Protokoll, das gegen Angriffe von zukünftigen Quantencomputern geschützt ist.",
    quantum_shield_l1_desc: "Verwendet den FIPS 203 Standard zur Kapselung eines symmetrischen gemeinsamen Schlüssels. Verhindert das passive Aufzeichnen und spätere Entschlüsseln (\\\\\\",
    quantum_shield_l1_title: "1. Post-Quanten-Schutz (ML-KEM-1024)",
    quantum_shield_l2_desc: "Ein klassisches, extrem schnelles Diffie-Hellman-Schlüsselaustauschverfahren, das als zusätzliche Sicherheitsebene im Hybridverfahren dient.",
    quantum_shield_l2_title: "2. Elliptic-Curve-Kryptografie (X25519)",
    quantum_shield_l3_desc: "Jede Nachricht und jeder Föderations-Umschlag wird kryptographisch signiert, um die Authentizität des Absenders zweifelsfrei zu verifizieren.",
    quantum_shield_l3_title: "3. Digitale Signaturen (Ed25519)",
    quantum_shield_l4_desc: "Verschlüsselt Nachrichteninhalte symmetrisch und bindet Absender, Empfänger und Metadaten fest in die Authentifizierten Zusatzdaten (AAD) ein, um Replay-Angriffe zu verhindern.",
    quantum_shield_l4_title: "4. AAD Authentifizierung (AES-256-GCM)",
    quantum_shield_status: " Quantum Shield Status",
    receive_drops_step1: "Teile deine GaiaID (z. B. oben per Kopieren-Knopf) mit externen Quellen.",
    receive_drops_step2: "Diese rufen die Login-Seite deiner GaiaCOM-Instanz auf, wechseln zum Reiter",
    receive_drops_step3: "und senden dort ihre verschlüsselte Nachricht an deine Adresse.",
    receiver_gaia: "GaiaCOM-Empfänger",
    receiver_smtp: "SMTP-Empfänger",
    records_stored: "Records gespeichert",
    refresh: "Aktualisieren",
    report_abuse_desc: "Möchtest du diese Nachricht melden und einen kryptographischen Missbrauchsbeweis an den Server übermitteln?",
    report_abuse_title: "Missbrauch melden",
    reputation_status: "Reputation Status",
    room_chat_start_hint: "Starten Sie die Konversation! Alle Nachrichten in diesem Gruppenkanal sind dezentral quantensicher E2E verschlüsselt.",
    room_policy_audit: "Audit-Trail und Key-Rotation aktiv.",
    room_policy_crisis: "Krisenraum",
    room_policy_e2ee: "Zero-Knowledge-Raum. E2EE quantensicher.",
    room_policy_title: "Raum-Richtlinien",
    room_policy_zero_knowledge: "Policy",
    room_security_note_desc: "Alle Schluesselwechsel werden ueber Key Transparency validiert. Nutze GaiaVault fuer private Backup-Logs.",
    room_security_note_title: "Angeheftete Sicherheitsnotiz",
    save_profile: "Profil speichern",
    schluessel_entsperrt: "🔑 Schlüssel wieder sperren",
    search_gaia_label: "Gaia-Adresse suchen",
    security_warning_title: "Sicherheitswarnung",
    select_channel_chat: "Wähle einen Kanal aus der linken Seitenleiste aus, um zu chatten.",
    select_contact_chat: "Wähle einen Kontakt aus dem linken Panel aus, um einen quantensicheren E2E-Chat zu starten.",
    select_mail_read: "Wähle eine Mail aus der Liste aus, um deren quantensichere Inhalte zu lesen, oder erstelle eine neue Nachricht.",
    senden: "Senden",
    sender_signature: "Sender Signature",
    server_log: "Server-Log:",
    server_received: "Server Received",
    session_lock: "Sitzungssperre",
    setup_address_keys: "Adresse und Schlüsselsatz anlegen",
    setup_profile: "Im Profil einrichten",
    smtp_inbox_title: "SMTP Empfang",
    smtp_legacy_badge: "Legacy SMTP / Unsicher",
    smtp_mode_option: "Legacy-SMTP-Bridge",
    smtp_security_warning: "Diese Mail wurde über das klassische, unverschlüsselte SMTP-Protokoll übertragen. Keine End-to-End-Verschlüsselung aktiv.",
    smtp_security_warning_desc: "Diese Nachricht verlässt den GaiaCom-Sicherheitsraum. SMTP-Zustellung bietet keine GaiaCom-native Ende-zu-Ende-Garantie, keine TrustMesh-Garantie und keine No-Godmode-Garantie ab dem Gateway.",
    spam_verdacht: "Spam/Verdacht",
    spam_warning_desc: "Diese Nachricht hat verdächtige Reputationssignale.",
    spam_warning_title: "Spam-Warnung",
    speichern: "Speichern",
    sperren: "Sperren",
    standard_group_status: "Standard-Gruppenchat (E2EE verschluesselt)",
    status: "Status",
    subject: "Betreff",
    suchen: "Neue Gaia-Adresse suchen...",
    tage: "Tage",
    time_unknown: "Zeitpunkt unbekannt",
    transmission_mode: "Übertragungsmodus",
    trust_age: "Vertrauensalter",
    trust_passport_title: "Trust Passport",
    unbestaetigt: "Unbestätigt",
    unknown_sender: "Unbekannt",
    unlock_btn: "Entsperren",
    unlock_btn_profile: "Freischalten",
    unlock_desc: "Deine private Schlüsseldatei ist verschlüsselt gespeichert. Gib dein Passwort ein, um die kryptographischen Schlüssel nur im Arbeitsspeicher zu laden.",
    unlock_logout: "Abmelden und lokale Schlüssel schließen",
    unlock_title: "Identität entsperren",
    untrusted: "Nicht vertrauenswürdig",
    update_password: "Passwort aktualisieren",
    upload_avatar_btn: "Bild hochladen (Sanitized)",
    vault_btn_encrypt: "Record verschlüsseln",
    vault_btn_lock: "Tresor sperren",
    vault_btn_unlock: "Tresor entsperren",
    vault_copied_success: "In die Zwischenablage kopiert",
    vault_decrypted_content: "Entschlüsselter Inhalt",
    vault_desc: "Lokaler verschlüsselter Tresor für Recovery-Backups, Identitätsnotizen, Server-Zugänge, Notfallkontakte, Rechtsnotizen, Security Events und private Logs.",
    vault_empty: "Noch keine Secure Records gespeichert.",
    vault_locked_pane_notice: "Tresor ist gesperrt. Bitte rechts entsperren.",
    vault_new_record: "Neuer Secure Record",
    vault_pwd_placeholder: "Vault-Passwort eingeben...",
    vault_record_body: "Record-Inhalt",
    vault_record_body_placeholder: "Verschlüsselten Record-Inhalt eingeben...",
    vault_record_category: "Kategorie",
    vault_record_title: "Record-Titel",
    vault_record_title_placeholder: "Titel des Secure Records",
    vault_title: "GaiaVault Secure Records",
    verify_new_fingerprint_hint: "Prüfe den neuen Fingerprint, bevor du den Schlüssel akzeptierst.",
    vertrauenswuerdig: "Vertrauenswürdig",
    vision_gaia_technology: "VisionGaiaTechnology",
    von: "Von",
    warnung: "Warnung",
    wizard_address: "Adresse",
    wizard_back: "Zurück",
    wizard_check1: "Ich habe meinen Seed sicher gespeichert.",
    wizard_custom_domain: "Eigene Domain verwenden",
    wizard_desc1: "GaiaCOM speichert private Schlüssel nicht serverseitig. Ohne Mnemonic Seed kann niemand verlorene Nachrichten wiederherstellen.",
    wizard_desc2: "Deine Adresse bestimmt den föderierten Node, über den verschlüsselte Umschläge geroutet werden.",
    wizard_fallback: "Fallback Nodes",
    wizard_finish: "Einrichtung abschließen",
    wizard_next: "Weiter",
    wizard_server_domain: "Server-Node-Domain",
    wizard_step1: "1. Backup Seed",
    wizard_step2: "2. Adresse & Server",
    wizard_title1: "Wiederherstellungs-Schlüssel sichern",
    wizard_title2: "GaiaCOM-Adresse wählen",
    write_message_placeholder: "Sichere Nachricht schreiben...",
    you: "Du",
    zero_knowledge: "Zero Knowledge",
    zero_knowledge_encryption: "Zero-Knowledge Verschlüsselung",
    "Chat fuer alle geleert": "Der Chat wurde für alle Teilnehmer geleert.",
    "Chat geleert": "Der Chat wurde für deine lokale Inbox geleert.",
    "Nachricht fuer alle geloescht": "Die Nachricht wurde für alle Teilnehmer gelöscht.",
    "Nachricht geloescht": "Die Chat-Nachricht wurde lokal aus deiner Inbox entfernt.",
    "anpinnen": "Anpinnen",
    "chat_loeschen": "Chat löschen",
    "confirm_delete_chat_desc": "Möchtest du den Chat wirklich löschen und ausblenden?",
    "confirm_leave_group_desc": "Möchtest du diese Gruppe wirklich verlassen?",
    "entpinnen": "Entpinnen",
    "group_deleted": "Gruppe erfolgreich gelöscht.",
    "group_left": "Gruppe erfolgreich verlassen.",
    "gruppe_loeschen": "Gruppe löschen",
    "loeschen": "Löschen",
    "no_active_chats": "Keine aktiven Chats. Suche oben nach Kontakten, um einen Chat zu starten.",
    "pinned": "Angepinnt",
    "wizard_check_credentials": "Ich bin für die sichere Aufbewahrung meiner Zugangsdaten selbst verantwortlich.",
    "wizard_check_is_beta": "Ich verstehe, dass GaiaCom Beta-Software ist.",
    "wizard_check_no_illegal": "Ich werde GaiaCom nicht für rechtswidrige Zwecke verwenden.",
    "wizard_check_no_uptime": "Ich verstehe, dass keine Verfügbarkeitsgarantie besteht.",
    "wizard_check_smtp_security": "Ich verstehe, dass SMTP-Nachrichten nicht den vollen GaiaCom-Sicherheitsumfang bieten.",
    "wizard_check_terms_read": "Ich habe die Beta-Nutzungsbedingungen gelesen.",
    "wizard_step_terms": "Nutzungsbedingungen",
    "wizard_terms_text": "Nutzungsbedingungen und Beta-Testvereinbarung für GaiaCom (Beta-Phase)\n\nAnbieterin: VisionGaiaTechnology (nachfolgend „Anbieterin“ genannt)\nStatus: Öffentliche Beta-Testphase\nGültigkeit: Ab dem 21. Juni 2026\n\n⚠️ DER WICHTIGSTE HINWEIS VORAB (BITTE AUFMERKSAM LESEN)\nGaiaCom befindet sich in einer öffentlichen Beta-Testphase. Trotz umfangreicher Sicherheitsmaßnahmen kann die Fehlerfreiheit, kontinuierliche Verfügbarkeit oder absolute Sicherheit der Software und der zugrundeliegenden Infrastruktur nicht garantiert werden. Die Nutzung erfolgt auf eigenes Risiko. Nutzer sind für die sichere Aufbewahrung ihrer Zugangsdaten (insb. Schlüssel für GaiaVault) sowie für die Einhaltung geltender Gesetze selbst verantwortlich.\n\n1. Gegenstand und Zweck der Beta-Testphase\n1.1. Zweck der Bereitstellung: GaiaCom ist ein neuartiger, auf Post-Quanten-Kryptografie (PQC) basierter E-Mail- und Chat-Dienst. Die Bereitstellung während der Beta-Phase dient ausschließlich der technischen Erprobung, der Lastsimulation, dem Finden von Programmfehlern (Bugs) sowie der Optimierung der Benutzerfreundlichkeit.\n1.2. Beta-Status: Dem Nutzer ist bewusst, dass es sich bei der angebotenen Software um eine Vorabversion (Beta-Software) handelt. Diese ist technisch noch nicht vollständig ausgereift, entspricht nicht dem Standard eines finalen, kommerziellen Produkts und kann Fehler, Datenverluste, Übertragungsverzögerungen oder Systemabstürze verursachen.\n1.3. Kein Anspruch auf Fortführung: Die Anbieterin ist jederzeit berechtigt, den Dienst ohne Angabe von Gründen ganz oder teilweise einzustellen, Funktionen zu verändern, einzuschränken oder temporär oder dauerhaft zu entfernen.\n\n2. Verfügbarkeit und Gewährleistungsausschluss\n2.1. Keine Verfügbarkeitsgarantie: Die Bereitstellung von GaiaCom erfolgt ohne jegliche Zusicherung von Verfügbarkeit oder Uptime. Es besteht kein Anspruch auf eine ununterbrochene Erreichbarkeit des Dienstes.\n2.2. Ausschluss der Gewährleistung: Die Software wird im aktuellen Zustand („as is“ / wie gesehen) und nach Verfügbarkeit bereitgestellt. Soweit gesetzlich zulässig, sind jegliche Gewährleistungsansprüche für Sach- und Rechtsmängel der Software ausgeschlossen. Insbesondere wird nicht garantiert, dass die Software fehlerfrei, frei von Schadsoftware oder für einen bestimmten Zweck geeignet ist.\n\n3. Risikomanagement und Pflichten der Nutzer\n3.1. Verbot der Speicherung kritischer Daten: Der Nutzer verpflichtet sich, über GaiaCom keine geschäftskritischen, lebenswichtigen, betriebsnotwendigen oder gesetzlich besonders schutzbedürftigen Daten (wie z.B. Patientenakten, hochsensible Finanzdaten oder behördlich regulierte Geheimnisse) ausschließlich zu speichern oder zu übertragen. Der Dienst darf nicht für Infrastrukturen genutzt werden, bei denen unvorhergesehene Ausfälle zu Personen-, Sach- oder erheblichen Vermögensschaben führen können.\n3.2. Eigenverantwortliches Backup: Der Nutzer ist selbst dafür verantwortlich, alle über GaiaCom empfangenen oder gesendeten Daten, die er langfristig benötigt, auf eigenen, unabhängigen Systemen (Sicherheitskopien) zu sichern. Die Anbieterin übernimmt keine Garantie für die dauerhafte Speicherung oder Wiederherstellbarkeit von Daten auf ihren Servern.\n\n4. Kryptografische Besonderheiten und GaiaVault\n4.1. Post-Quanten-Kryptografie (PQC): GaiaCom implementiert modernste, zukunftsweisende Verschlüsselungsverfahren, die auch Angriffen durch zukünftige Quantencomputer standhalten sollen. Dem Nutzer ist jedoch bewusst, dass es sich hierbei um ein dynamisches und neues wissenschaftliches Feld handelt. Eine absolute, unumstößliche Sicherheit kann nach dem aktuellen Stand der Wissenschaft und Technik nicht garantiert werden. Begrifflichkeiten wie „100 % sicher“, „unknackbar“ oder „militärsicher“ werden ausdrücklich nicht zugesichert.\n4.2. Keine Recovery-Garantie (GaiaVault): GaiaCom setzt auf ein konsequentes Zero-Knowledge-Sicherheitskonzept. Die Verschlüsselungskeile und Zugangsdaten verbleiben ausschließlich in der Kontrolle des Nutzers (gesichert über GaiaVault).\nWICHTIG: Verliert der Nutzer seine Passwörter, Passphrasen, privaten Schlüssel oder Wiederherstellungs-Seeds, hat die Anbieterin keinerlei technische Möglichkeit, diese Daten zu rekonstruieren oder zurückzusetzen. Ein Verlust dieser Zugangsdaten führt unweigerlich zum unwiderruflichen Verlust des Zugriffs auf das Benutzerkonto und alle darin verschlüsselten Daten.\n4.3. Noch nicht vollständig auditiert: Die Software wird kontinuierlich internen Sicherheitsprüfungen unterzogen, hat jedoch zum Zeitpunkt dieser Beta-Phase noch kein abschließendes, vollumfängliches externes Sicherheitsaudit durch unabhängige Prüfstellen durchlaufen.\n\n5. Schnittstellen, Legacy-Protokolle und Föderation\n5.1. SMTP-Bridge-Hinweis: GaiaCom bietet die Möglichkeit der Kommunikation über klassische E-Mail-Protokolle (wie SMTP). Dem Nutzer ist bewusst, dass Nachrichten, die den nativen GaiaCom-Sicherheitsraum verlassen (z.B. beim Senden an eine herkömmliche @gmail.com oder @gmx.de Adresse), über unverschlüsselte oder fremde Server transportiert werden. Die Ende-zu-Ende-Sicherheitsgarantien von GaiaCom gelten für solche ausgehenden oder von außen eingehenden Legacy-Nachrichten nur eingeschränkt bzw. gar nicht.\n5.2. Föderations-Hinweis: Sofern GaiaCom in einem föderierten Netzwerk betrieben wird, können Nachrichten und Daten über Server von Drittanbietern geleitet werden. Während die Inhalte der Nachrichten durch die Ende-zu-Ende-Verschlüsselung geschützt bleiben, können Metadaten (wie Sendezeitpunkt, IP-Adressen der beteiligten Server und Empfängeradressen) für die Betreiber dieser föderierten Server technisch sichtbar sein. Die Anbieterin hat keinen Einfluss auf die Datenschutzpraktiken dritter Serverbetreiber im föderierten Netzwerk.\n\n6. Zulässige Nutzung und Verbotene Aktivitäten\nDer Nutzer verpflichtet sich, den Dienst nicht missbräuchlich oder für rechtswidrige Zwecke zu verwenden. Untersagt sind insbesondere:\n- Die Verbreitung, der Versand oder das Hosten von Viren, Malware, Phishing-Inhalten oder anderer Schadsoftware.\n- Die Nutzung des Dienstes zur Durchführung von Denial-of-Service-Angriffen (DDoS) oder unaufgefordertem Massenversand (Spam).\n- Der Missbrauch des Systems zur Begehung von Betrugsdelikten.\n- Die Verbreitung oder der Austausch von illegalen Inhalten, insbesondere Darstellungen von sexuellem Missbrauch von Kindern (CSAM), terroristischer Propaganda, Gewaltaufrufen oder sonstigen strafrechtlich relevanten Inhalten.\n\n7. Missbrauchsmeldesystem (Abuse-System)\n7.1. Meldung missbräuchlichen Verhaltens: Nutzer haben die Möglichkeit, missbräuchliche Kommunikation oder illegale Aktivitäten über das integrierte Abuse-System zu melden.\n7.2. Verarbeitung von Meldungen: Um den Missbrauchsschutz zu gewährleisten, können eingehende Meldungen technisch (unter Wahrung der Privatsphäre und Verschlüsselungsgrenzen) analysiert werden. Dies kann bei nachgewiesenen Verstößen gegen diese Nutzungsbedingungen zu temporären oder dauerhaften Sperren von Benutzerkonten oder IP-Adressen führen.\n\n8. Haftungsbegrenzung\n8.1. Haftungsmaßstab: Die Bereitstellung der Beta-Software erfolgt unentgeltlich. Die Anbieterin haftet daher nach den gesetzlichen Regeln für Schenkung bzw. Leihe nur für Vorsatz (Vorsätzliche Schädigung) und grobe Fahrlässigkeit.\n8.2. Haftungsausschluss für Datenverluste: Die Haftung für den Verlust von Daten ist ausgeschlossen, es sei denn, der Verlust wurde durch die Anbieterin vorsätzlich oder grob fahrlässig herbeigeführt und der Nutzer hat durch regelmäßige Backups (außerhalb von GaiaCom) seiner Schadensminderungspflicht Genüge getan.\n8.3. Gesetzliche Grenzen: Die vorstehenden Haftungsbeschränkungen gelten nicht bei der Verletzung von Leben, Körper oder Gesundheit sowie bei der Haftung nach dem Produkthaftungsgesetz.\n\n9. Open Source\nBestimmte Komponenten, Bibliotheken oder Client-Anwendungen von GaiaCom können unter Open-Source-Lizenzen (z. B. GPL, MIT, Apache) lizenziert sein. Die jeweiligen Lizenzbedingungen dieser Komponenten bleiben von diesen Nutzungsbedingungen unberührt und sind in den entsprechenden Quelltext-Repositorys einsehbar.\n\n10. Exportkontrolle und Compliance\nDer Nutzer ist sich bewusst, dass kryptografische Software strengen Exportkontrollen und gesetzlichen Beschränkungen unterliegen kann. Der Nutzer ist selbst dafür verantwortlich, sicherzustellen, dass die Nutzung von GaiaCom nicht gegen die Gesetze, Import-/Exportbeschränkungen oder Kryptografie-Regulierungen seines jeweiligen Aufenthaltslandes verstoßt.\n\n11. Datenschutz-Hinweis (Kurzfassung für die Beta)\n11.1. Minimale Datenerhebung: Im Rahmen der Beta-Phase erhebt die Anbieterin nur solche Daten, die für den technischen Betrieb, die Fehlersuche und die Weiterentwicklung zwingend erforderlich sind (z. B. Server-Logdateien zur Fehlerdiagnose).\n11.2. Keine inhaltliche Einsicht: Durch die konsequente Zero-Knowledge- und E2E-Verschlüsselung hat die Anbieterin zu keinem Zeitpunkt Zugriff auf die Inhalte Ihrer Chats, E-Mails oder in der GaiaVault abgelegten Schlüssel.\n11.3. Detaillierte Datenschutzerklärung: Die detaillierten Datenschutzbestimmungen sind separat verlinkt und müssen vom Nutzer vor der Registrierung ebenfalls zur Kenntnis genommen werden.\n\n12. Schlussbestimmungen\n12.1. Anwendbares Recht: Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.\n12.2. Änderungsvorbehalt: Da sich GaiaCom in der aktiven Entwicklung befindet, behält sich die Anbieterin das Recht vor, diese Bedingungen jederzeit mit Wirkung für die Zukunft anzupassen. Die jeweils aktuelle Version ist in der Anwendung abrufbar.",
    "wizard_terms_title": "Nutzungsbedingungen und Beta-Testvereinbarung für GaiaCom (Beta-Phase)",
    "node_operator": "Node Operator",
    "search_channels": "Kanäle suchen...",
    "senior_reviewer": "Senior Reviewer",
    "trusted_reviewer": "Trusted Reviewer",
    "active_frequencies": "Aktive Frequenzen",
    "connected_rooms": "VERBUNDENE RÄUME",
    "dashboard": "Dashboard",
    "empty_chats": "Keine aktiven Chats vorhanden.",
    "empty_messages": "Keine neuen Nachrichten vorhanden.",
    "encrypted": "Verschlüsselt",
    "gaiacom_uplink": "GAIACOM UPLINK",
    "install_app": "App installieren",
    "install_app_desc": "Für schnellen Start & Offline-Modus",
    "kommandozentrale_alpha": "Kommandozentrale ALPHA",
    "network_online": "NETWORK: ONLINE",
    "new_room": "Neuer Raum",
    "no_frequencies_active": "Keine Frequenzen aktiv. Erstellen Sie einen neuen Raum, um die Kommunikation zu starten.",
    "no_id": "Keine ID",
    "open_chats": "Chats öffnen",
    "open_inbox": "Posteingang öffnen",
    "primary_identity": "PRIMÄRE IDENTITÄT",
    "recent_chats": "Neue Chats",
    "recent_messages": "Neueste Nachrichten",
    "session_encrypted": "Sitzung verschlüsselt: {name}",
    "session_secure": "STATUS: SECURE",
    "system_verlassen": "System verlassen",
    "write_message": "Nachricht schreiben",
  },
  en: {
    sc_title: "Security Center",
    sc_subtitle: "GaiaShield Integrated Security Layer",
    sc_tab_status: "🛡️ Protection Status",
    sc_tab_events: "📋 Security Log",
    sc_tab_node: "⚙️ Node Security",
    sc_loading: "Loading security data...",
    sc_status_secured: "System Status: Account is protected",
    sc_status_warning: "System Status: Warnings active",
    sc_desc_secured: "There are no active critical security warnings. GaiaShield is actively monitoring your account.",
    sc_desc_warning: "Attention: There are active security events that require your attention.",
    sc_account_protection: "Account Protection",
    sc_message_protection: "Message Protection",
    sc_audits: "Security Audits",
    sc_active: "ACTIVE",
    sc_failed_logins: "Failed Logins",
    sc_tamper_checks: "Tamper Checks",
    sc_blocked_replays: "Blocked Replays",
    sc_last_check: "Last Check",
    sc_just_now: "Just now",
    sc_open_warnings: "Open Warnings",
    sc_btn_acknowledge: "Acknowledge",
    sc_filter_severity: "Severity",
    sc_filter_category: "Category",
    sc_filter_hide_ack: "Hide Confirmed",
    sc_btn_export: "Export",
    sc_col_details: "Details",
    sc_col_time: "Time",
    sc_col_status: "Status",
    sc_col_action: "Action",
    sc_no_events: "No security events found.",
    sc_node_title: "Node Operator Security Console",
    sc_system_health: "System Health",
    sc_last_audit: "Last Audit",
    sc_packed_logs: "Packed Logs",
    sc_unconfirmed_events: "Unconfirmed Events",
    sc_operator_action: "Operator Action Required",
    sc_all_ok: "All OK",
    sc_critical_events: "Critical System Events",
    ac_title: "Governance & Abuse Center",
    ac_subtitle: "GaiaCom Governance & Abuse Consensus",
    ac_tab_my_reports: "My Reports",
    ac_tab_queue: "Review Queue",
    ac_tab_operator: "Node Operator",
    ac_tab_transparency: "Federation & Transparency",
    ac_loading: "Loading data...",
    ac_reported_cases: "Reported Cases",
    ac_no_reports: "You have not submitted any reports yet.",
    ac_case_details: "Case Details",
    ac_appeal_submit: "Submit Appeal",
    ac_appeal_status: "Appeal Status",
    ac_appeal_reason: "Reason for Appeal",
    ac_appeal_statement: "Statement",
    ac_btn_appeal: "Send Appeal",
    ac_trusted_reviewer_queue: "Trusted Reviewer Queue",
    ac_case_review: "Review Case",
    ac_review_category: "Recommended Category",
    ac_review_severity: "Recommended Severity",
    ac_review_action: "Recommended Action",
    ac_review_reason: "Reviewer Reason",
    ac_btn_submit_review: "Submit Review",
    ac_node_operator_dashboard: "Node Operator Dashboard",
    ac_apply_action: "Apply Action (Override)",
    ac_target_type: "Target Type",
    ac_target_id: "Target ID (GaiaID or Channel ID)",
    ac_suspend: "Suspend active",
    ac_reason: "Official Reason",
    ac_btn_apply: "Enforce Action",
    ac_transparency_title: "Consensus & Transparency Logbook",
    ac_transparency_desc: "Publicly viewable snapshot proofs of all moderated channels and identities.",
    ac_btn_snapshot: "Create Transparency Snapshot",
    search_placeholder: "Search mails by subject, sender, text...",
    abuse_center_title: "Abuse Center",
    abbrechen: "Cancel",
    active_identities: "Active Identities",
    active_identity: "Active Identity",
    add_btn: "Add",
    add_contact_title: "Add contact",
    admin: "Admin",
    adressbuch: "Address Book",
    aktiviert: "Enabled",
    an: "To",
    anonymous_sender: "Anonymous Sender",
    antworten: "Reply",
    attachment_gaia_hint: "GaiaCOM attachments remain end-to-end encrypted.",
    attachment_smtp_hint: "Legacy SMTP blocks executable/script-like attachments and saves emails as insecure.",
    attachments: "Attachments",
    auffaellig: "Conspicuous",
    auth_beta_notice: "Beta test phase: GaiaCOM is actively being tested. Bugs may occur; keep important seeds backed up and verify sensitive workflows carefully.",
    auth_btn_login: "Load Identity & Log In",
    auth_btn_register: "Register & Create Keys",
    auth_copied: "Copied",
    auth_copy_seed: "Copy Seed",
    auth_generate_seed: "Generate Seed",
    auth_headline: "GaiaCOM is the first quantum-secure email protocol and communication system built for humanity.",
    auth_kicker: "Post-Quantum Secure Communication",
    auth_mnemonic: "Mnemonic Phrase",
    auth_mnemonic_placeholder: "12 words separated by spaces...",
    auth_password: "Password",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "Private keys never leave your device. Only intended recipients can decrypt content.",
    auth_proof_gaiadata_desc: "Zero-knowledge: You keep control of your data. Metadata is minimized and not turned into a plaintext profile.",
    auth_proof_gaiadrop_desc: "External people can submit confidential text-only reports to your GaiaID without an account.",
    auth_proof_gaiaproof_desc: "Delivery and integrity proofs show that ciphertext, sender, and timestamp were not manipulated.",
    auth_proof_gaiavault_desc: "Private notes, recovery hints, and security records remain locally encrypted.",
    auth_proof_hybrid_desc: "Quantum Shield: Hybrid encryption with ML-KEM and X25519 protects against current attacks and store-now-decrypt-later risk.",
    auth_secure_mail: "Secure Quantum Federated Mail",
    auth_subline: "GaiaCOM is a quantum-secure communication system for mail, chat, crisis rooms, GaiaDrop, and local security records. Private keys stay on your device, content is end-to-end encrypted, and evidence can be exported without revealing plaintext.",
    auth_success_btn: "Log In Now",
    auth_success_text: "Your GaiaCOM account has been created. The keys were derived locally from your seed and not stored on the server.",
    auth_success_title: "Registration Successful",
    auth_tab_drop: "GaiaDrop",
    auth_tab_login: "Login / Account",
    auth_toggle_login: "Already have an account",
    auth_toggle_register: "Create new account",
    auth_usecase_text: "Designed for lawyers, companies, agencies, journalists, whistleblowers, and private security incidents.",
    auth_usecase_title: "Built for sensitive communication",
    auth_username: "Username",
    auth_username_placeholder: "Enter username...",
    auth_value_chat: "E2E Chat",
    auth_value_drop: "Secure Drop",
    auth_value_mail: "Secure Mail",
    auth_value_rooms: "GaiaRooms",
    bestaetigen: "Confirm",
    bestaetigt: "Confirmed",
    bio_status: "Biography / Status",
    biography: "Biography",
    change_password_desc: "Changes your server-side login password. Your local recovery phrase remains separate and protected by your Vault/Unlock password.",
    change_password_menu_desc: "Update GaiaCOM login password.",
    change_password_title: "Change Password",
    channel_id: "Channel ID",
    channel_name_label: "Channel name",
    chat_deleted_hidden: "Chat deleted and hidden.",
    chat_input_placeholder: "Enter secure message...",
    chat_start_hint: "Start the conversation! All chat messages are quantum-secure E2E encrypted.",
    choose_avatar: "Choose Avatar",
    ciphertext_hash: "Ciphertext Hash",
    clear_chat: "Empty chat",
    clear_for_everyone: "Empty for everyone",
    clear_for_me: "Empty just for me",
    click_to_write_mail: "Click to write an email",
    click_top_right: "Click on the top right",
    close: "Close",
    code_kopieren: "Copy Code",
    code_kopieren_success: "Code copied",
    confirm_clear_channel_desc: "Do you want to clear this channel from your local view?",
    confirm_clear_channel_title: "Empty channel",
    confirm_clear_chat: "Do you want to clear this chat?",
    confirm_clear_chat_desc: "Do you want to empty this chat?",
    confirm_clear_chat_title: "Empty chat",
    confirm_clear_everyone: "Do you want to clear this chat for both partners? (OK = For everyone, Cancel = Only for me)",
    confirm_delete_everyone: "Do you want to delete this message for both partners? (OK = For everyone, Cancel = Only for me)",
    confirm_delete_msg: "Do you want to delete this message?",
    confirm_delete_msg_desc: "Do you want to delete this chat message?",
    confirm_delete_msg_title: "Delete message",
    confirm_new_password: "Confirm New Password",
    copy: "Copy",
    create_btn: "Create",
    create_channel_title: "Create channel",
    create_group_is_crisis: "Mark as a crisis area",
    create_group_title: "Create new group",
    crypto_lock_desc: "Controls when GaiaCOM removes local crypto keys from memory.",
    crypto_lock_menu_desc: "Control reload and inactivity timers.",
    crypto_lock_title: "Cryptographic lock",
    crypto_session_duration: "Unlocked after reload",
    crypto_session_duration_desc: "Only keeps the crypto session open in this browser tab for the selected duration.",
    cryptographic_fingerprint: "Cryptographic Fingerprint",
    current_password: "Current Password",
    data_minimization: "Data Minimization",
    decrypt_failed: "Not decryptable",
    delete: "Delete",
    delete_account_button: "Delete account irrevocably",
    delete_account_confirm_label: "Enter DELETE to confirm",
    delete_account_confirmation_error: "Password and DELETE confirmation are required.",
    delete_account_desc: "This mode permanently destroys your account, identities, device sessions, GaiaDrop data, upload metadata, and server-side attributable messages.",
    delete_account_done_desc: "All assignable GaiaCOM data has been deleted.",
    delete_account_done_title: "Account deleted",
    delete_account_menu_desc: "Destroy account and associated data.",
    delete_account_not_authenticated: "No active account.",
    delete_account_title: "Delete account",
    delete_for_everyone: "Delete for everyone",
    delete_for_me: "Delete just for me",
    device_current: "This device",
    device_last_seen: "Last",
    device_logout: "Log out",
    device_sessions_desc: "Check active sessions and deregister devices you no longer trust.",
    device_sessions_empty: "No devices found.",
    device_sessions_menu_desc: "Manage and end active sessions.",
    device_sessions_title: "Registered devices",
    device_since: "Since",
    display_name: "Display Name",
    drop_address_copied: "GaiaDrop address copied.",
    drop_btn_decrypting: "Decrypting inbox...",
    drop_btn_load: "Load GaiaDrop Inbox",
    drop_delete_desc: "Do you really want to permanently delete this drop?",
    drop_delete_title: "Delete GaiaDrop",
    drop_desc: "Text-only zero-knowledge drop channel for external hints, responsible disclosure, and confidential reports. External users can send messages using your GaiaID without an account.",
    drop_empty: "No GaiaDrop messages loaded yet.",
    drop_id: "Drop ID:",
    drop_own_address: "Your GaiaDrop address",
    drop_proof: "DROP PROOF",
    drop_title: "GaiaDrop Secure Inbox",
    dunkler_modus: " Dark Mode",
    e2e_chat_room_open: "Open E2E Chat Room",
    edit_profile: "Edit Profile",
    edit_profile_desc: "Customize display name, bio and avatar.",
    einladungscode: "Invite Code",
    enter_fingerprint_chars_confirm: "Enter the requested fingerprint characters to confirm.",
    envelope_hash: "Envelope Hash",
    erasability: "Erasability",
    erfolg: "Success",
    exclude_plaintext: "Export without plain text",
    export_disclosure: "Export Disclosure",
    export_package_desc: "Only include plain text if this disclosure is intentionally intended.",
    export_package_title: "Export security package",
    fehler: "Error",
    gaiacom_reader: "GaiaCOM Reader",
    gaiadrop_inbox_title: "GaiaDrop Inbox",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM minimizes metadata, keeps private keys local, encrypts content end-to-end and enables complete account deletion.",
    gdpr_home_title: "100% GDPR compliant",
    gdpr_reason_delete: "Account deletion removes account, identities, local sessions, and server-side assignable data.",
    gdpr_reason_e2ee: "Private content remains decryptable only for intended recipients.",
    gdpr_reason_minimal: "Metadata is only used for routing, delivery and security credentials.",
    gdpr_reason_zero_knowledge: "Private keys and recovery data remain locally under user control.",
    gesendet: "Sent",
    gesperrt_verdaechtig: "Blocked / Suspicious",
    group_delete_desc: "Do you really want to permanently delete this group? All channels and messages in this group will be deleted.",
    group_delete_title: "Delete group",
    group_description: "Description",
    group_icon_label: "Group icon / avatar",
    group_name: "Group name",
    group_settings_avatar: "Avatar",
    group_settings_desc: "Description",
    group_settings_is_crisis: "Mark as a crisis area",
    group_settings_name: "Group Name",
    group_settings_title: "Group Settings",
    groups_empty_desc: "Create a secure workspace for project, crisis, or team communication.",
    groups_empty_title: "No group chats yet",
    gruppe_beitreten: "Group Joined",
    gruppe_erstellen: "+ Create Group",
    gruppe_verlassen: "Leave Group",
    gruppen_chats: "Group Chats",
    heller_modus: " Light Mode",
    how_to_receive_drops: "How do I receive drops?",
    identitaets_assistent: "Identity Wizard",
    inactivity_lock_duration: "Lock when inactive",
    inactivity_lock_duration_desc: "After this period of no input, GaiaCOM will automatically be cryptographically locked.",
    inactivity_lock_notice: "GaiaCOM has been cryptographically blocked due to inactivity.",
    include_plaintext: "Include plain text",
    invite_code_label: "Invitation code",
    join_group_title: "Join group",
    kanaele: "Channels",
    kanal_erstellen: "+ Channel",
    kein_chat_ausgewaehlt: "No chat selected",
    kein_kanal_ausgewaehlt: "No channel selected",
    keine_gruppe_ausgewaehlt: "No group selected",
    keine_mails: "No mails available.",
    key_change_warn_desc: "This contact's public key has changed. Check the fingerprint before trusting it.",
    key_change_warn_title: "Cryptographic warning",
    key_change_warning_changed: "has changed. This may be a sign of a man-in-the-middle attack!",
    key_change_warning_msg: "The identity key for contact",
    key_transparency: "Key Transparency (Key History)",
    kopiert: "Copied",
    kryptographische_schluessel: "Cryptographic Keys",
    kryptographische_schluessel_desc: "Show private keys and backup seed phrase.",
    laden: "Loading...",
    leeren: "Empty",
    loading: "Load...",
    local_key_vault: "Local key vault",
    local_keys_label: "Local keys",
    lock_on_reload: "Always lock after reload",
    logout: "Log Out",
    mail_compose: "Compose mail",
    mein_profil: "My Profile",
    melden: "Report",
    menu: "Menu",
    message: "News",
    message_id: "Message ID",
    message_pin: "Pin",
    message_pinned_title: "Pinned messages",
    message_react: "React",
    message_reply: "Answer",
    message_replying_to: "Answer to",
    message_save: "Save",
    message_saved: "Saved",
    message_to_channel: "Message to",
    message_unpin: "Solve",
    message_unsave: "Don't save",
    mitglied: "Member",
    mitglieder: "Members",
    ml_kem: "ML-KEM",
    neue_mail: "New email",
    never_auto_lock: "Never automatically",
    new_fingerprint: "New fingerprint",
    new_identity: "New Identity",
    new_password: "New Password",
    no_description: "No description",
    no_key_history: "No key history recorded.",
    no_specification: "No specification",
    old_fingerprint: "Old fingerprint",
    open_privacy_imprint: "Open imprint and data protection",
    post_quantum_e2e: "Post-Quantum E2E",
    posteingang: "Inbox",
    powered_by: "Powered by",
    privacy_imprint_menu_desc: "Show GDPR, data protection and legal notice.",
    privacy_imprint_profile_desc: "GaiaCOM processes communication content according to the principles of data minimization, end-to-end encryption and local key control.",
    privacy_imprint_title: "Data protection & legal notice",
    profil: "Profile",
    profile_details: "Profile Details",
    profile_settings_hint: "Profile settings are displayed in the right panel.",
    profile_unlock_desc: "For security reasons, you must enter your password again to view your private cryptographic keys.",
    proof_hash: "Proof Hash:",
    public_drop_desc: "Secure Drop for external text-only reports without a GaiaCOM account.",
    public_drop_message: "Message",
    public_drop_message_placeholder: "Enter confidential text...",
    public_drop_send: "Send GaiaDrop",
    public_drop_sender: "Optional sender note",
    public_drop_sender_placeholder: "Name, case ID, or anonymous",
    public_drop_target: "Target GaiaID",
    quanten_chat: "Quantum Chat",
    quantum_secure_exchange: "Quantum-secure exchange via...",
    quantum_secure_net: "GaiaCOM Quantum-Secure Network (Ed25519 & ML-KEM)",
    quantum_shield_desc: "The GaiaCOM network protects your privacy with a multi-layered, hybrid encryption protocol secure against attacks from future quantum computers.",
    quantum_shield_l1_desc: "Uses the FIPS 203 standard to encapsulate a symmetric shared key. Prevents passive eavesdropping and later decryption (\\\\\\",
    quantum_shield_l1_title: "1. Post-Quantum Protection (ML-KEM-1024)",
    quantum_shield_l2_desc: "A classical, ultra-fast Diffie-Hellman key exchange method serving as an additional security layer in the hybrid scheme.",
    quantum_shield_l2_title: "2. Elliptic-Curve Cryptography (X25519)",
    quantum_shield_l3_desc: "Every message and federation envelope is cryptographically signed to verify sender authenticity beyond doubt.",
    quantum_shield_l3_title: "3. Digital Signatures (Ed25519)",
    quantum_shield_l4_desc: "Encrypts message content symmetrically and binds sender, recipient, and metadata tightly into the Authenticated Additional Data (AAD) to prevent replay attacks.",
    quantum_shield_l4_title: "4. AAD Authentication (AES-256-GCM)",
    quantum_shield_status: " Quantum Shield Status",
    receive_drops_step1: "Share your GaiaID (e.g. via the copy button above) with external sources.",
    receive_drops_step2: "They open the login page of your GaiaCOM instance, switch to the tab",
    receive_drops_step3: "and send their encrypted message to your address there.",
    receiver_gaia: "GaiaCOM receiver",
    receiver_smtp: "SMTP recipient",
    records_stored: "Records saved",
    refresh: "Update",
    report_abuse_desc: "Do you want to report this message and submit cryptographic evidence of abuse to the server?",
    report_abuse_title: "Report abuse",
    reputation_status: "Reputation Status",
    room_chat_start_hint: "Start the conversation! All messages in this group channel are decentralized, quantum-secure E2E encrypted.",
    room_policy_audit: "Audit trail and key rotation active.",
    room_policy_crisis: "Crisis room",
    room_policy_e2ee: "Zero-knowledge space. E2EE quantum safe.",
    room_policy_title: "Room guidelines",
    room_policy_zero_knowledge: "Policy",
    room_security_note_desc: "All key changes are validated via Key Transparency. Use GaiaVault for private backup logs.",
    room_security_note_title: "Pinned security note",
    save_profile: "Save Profile",
    schluessel_entsperrt: "🔑 Lock keys again",
    search_gaia_label: "Find Gaia address",
    security_warning_title: "Security warning",
    select_channel_chat: "Select a channel from the left sidebar to start chatting.",
    select_contact_chat: "Select a contact from the left panel to start a quantum-secure E2E chat.",
    select_mail_read: "Select a mail from the list to read its quantum-secure contents, or create a new message.",
    senden: "Send",
    sender_signature: "Sender Signature",
    server_log: "Server Log:",
    server_received: "Server Received",
    session_lock: "Session lock",
    setup_address_keys: "Create address and keys",
    setup_profile: "Setup in Profile",
    smtp_inbox_title: "SMTP Inbox",
    smtp_legacy_badge: "Legacy SMTP / Unsafe",
    smtp_mode_option: "Legacy SMTP bridge",
    smtp_security_warning: "This mail was transmitted via the classical, unencrypted SMTP protocol. No End-to-End encryption active.",
    smtp_security_warning_desc: "This message is leaving the GaiaCom security room. SMTP delivery does not provide GaiaCom native end-to-end guarantee, no TrustMesh guarantee and no Godmode guarantee from the gateway.",
    spam_verdacht: "Spam/Suspected",
    spam_warning_desc: "This message has suspicious reputation signals.",
    spam_warning_title: "Spam warning",
    speichern: "Save",
    sperren: "Lock",
    standard_group_status: "Standard group chat (E2EE encrypted)",
    status: "status",
    subject: "Regarding",
    suchen: "Search Gaia address...",
    tage: "Days",
    time_unknown: "Time unknown",
    transmission_mode: "Transfer mode",
    trust_age: "Trust Age",
    trust_passport_title: "Trust Passport",
    unbestaetigt: "Unconfirmed",
    unknown_sender: "Unknown",
    unlock_btn: "Unlock",
    unlock_btn_profile: "Unlock",
    unlock_desc: "Your private key file is stored encrypted. Enter your password to load the cryptographic keys only in RAM.",
    unlock_logout: "Log out and close local keys",
    unlock_title: "Unlock Identity",
    untrusted: "Untrusted",
    update_password: "Update Password",
    upload_avatar_btn: "Upload Image (Sanitized)",
    vault_btn_encrypt: "Encrypt Record",
    vault_btn_lock: "Lock Vault",
    vault_btn_unlock: "Unlock Vault",
    vault_copied_success: "Copied to clipboard",
    vault_decrypted_content: "Decrypted content",
    vault_desc: "Local encrypted vault for recovery backups, identity notes, server credentials, emergency contacts, legal notes, security events, and private logs.",
    vault_empty: "No secure records stored yet.",
    vault_locked_pane_notice: "Vault is locked. Please unlock on the right.",
    vault_new_record: "New secure record",
    vault_pwd_placeholder: "Enter Vault password...",
    vault_record_body: "Record content",
    vault_record_body_placeholder: "Enter encrypted record content...",
    vault_record_category: "category",
    vault_record_title: "Record title",
    vault_record_title_placeholder: "Title of Secure Record",
    vault_title: "GaiaVault Secure Records",
    verify_new_fingerprint_hint: "Check the new fingerprint before accepting the key.",
    vertrauenswuerdig: "Trustworthy",
    vision_gaia_technology: "VisionGaiaTechnology",
    von: "From",
    warnung: "Warning",
    wizard_address: "Address",
    wizard_back: "Back",
    wizard_check1: "I have securely stored my seed.",
    wizard_custom_domain: "Use custom domain",
    wizard_desc1: "GaiaCOM does not store private keys server-side. Without the Mnemonic Seed, no one can recover lost messages.",
    wizard_desc2: "Your address determines the federated node through which encrypted envelopes are routed.",
    wizard_fallback: "Fallback Nodes",
    wizard_finish: "Finish Setup",
    wizard_next: "Next",
    wizard_server_domain: "Server node domain",
    wizard_step1: "1. Backup Seed",
    wizard_step2: "2. Address & Server",
    wizard_title1: "Secure Recovery Keys",
    wizard_title2: "Select GaiaCOM Address",
    write_message_placeholder: "Write a secure message...",
    you: "You",
    zero_knowledge: "Zero Knowledge",
    zero_knowledge_encryption: "Zero-Knowledge Encryption",
    "Chat fuer alle geleert": "The chat has been emptied for all participants.",
    "Chat geleert": "The chat has been cleared for your local inbox.",
    "Nachricht fuer alle geloescht": "The message has been deleted for all participants.",
    "Nachricht geloescht": "The chat message has been removed locally from your inbox.",
    "anpinnen": "Pin",
    "chat_loeschen": "Delete chat",
    "confirm_delete_chat_desc": "Are you sure you want to delete and hide the chat?",
    "confirm_leave_group_desc": "Do you really want to leave this group?",
    "entpinnen": "Unpin",
    "group_deleted": "Group deleted successfully.",
    "group_left": "Leave the group successfully.",
    "gruppe_loeschen": "Delete group",
    "loeschen": "Delete",
    "no_active_chats": "No active chats. Search for contacts above to start a chat.",
    "pinned": "Pinned",
    "wizard_check_credentials": "I am responsible for keeping my access data safe.",
    "wizard_check_is_beta": "I understand that GaiaCom is beta software.",
    "wizard_check_no_illegal": "I will not use GaiaCom for unlawful purposes.",
    "wizard_check_no_uptime": "I understand that there is no guarantee of availability.",
    "wizard_check_smtp_security": "I understand that SMTP messages do not provide full GaiaCom security.",
    "wizard_check_terms_read": "I have read the Beta Terms of Service.",
    "wizard_step_terms": "Terms of Use",
    "wizard_terms_text": "GaiaCom Terms of Use and Beta Testing Agreement (Beta Phase)\n\nProvider: VisionGaiaTechnology (hereinafter referred to as “Provider”)\nStatus: Public beta testing phase\nValidity: From June 21, 2026\n\n⚠️ THE MOST IMPORTANT NOTE IN ADVANCE (PLEASE READ CAREFULLY)\nGaiaCom is in a public beta testing phase. Despite extensive security measures, the freedom from errors, continuous availability or absolute security of the software and the underlying infrastructure cannot be guaranteed. Use at your own risk. Users are responsible for the safe storage of their access data (especially keys for GaiaVault) and for compliance with applicable laws.\n\n1. Subject and purpose of the beta test phase\n1.1. Purpose of provision: GaiaCom is a novel email and chat service based on post-quantum cryptography (PQC). The provision during the beta phase is intended exclusively for technical testing, load simulation, finding program errors (bugs) and optimizing user-friendliness.\n1.2. Beta status: The user is aware that the software offered is a preliminary version (beta software). This is not yet fully developed technically, does not meet the standard of a final, commercial product and can cause errors, data loss, transmission delays or system crashes.\n1.3. No right to continuation: The provider is entitled at any time to discontinue the service in whole or in part, to change or restrict functions or to remove them temporarily or permanently without giving reasons.\n\n2. Availability and Disclaimer of Warranty\n2.1. No availability guarantee: GaiaCom is provided without any guarantee of availability or uptime. There is no right to uninterrupted availability of the service.\n2.2. Exclusion of warranty: The software is provided in its current state (“as is”) and subject to availability. To the extent permitted by law, any warranty claims for material and legal defects in the software are excluded. In particular, there is no guarantee that the software is error-free, free of malware or suitable for a particular purpose.\n\n3. Risk management and user obligations\n3.1. Prohibition of storage of critical data: The user undertakes not to exclusively store or transmit via GaiaCom any business-critical, vital, operationally necessary or legally particularly sensitive data (such as patient files, highly sensitive financial data or officially regulated secrets). The service may not be used for infrastructure where unforeseen failures could result in personal injury, property damage or significant financial loss.\n3.2. Self-responsible backup: The user is responsible for backing up all data received or sent via GaiaCom that he needs in the long term on his own, independent systems (backup copies). The provider does not guarantee the permanent storage or restoreability of data on its servers.\n\n4. Cryptographic features and GaiaVault\n4.1. Post-quantum cryptography (PQC): GaiaCom implements state-of-the-art, future-oriented encryption processes that are designed to withstand attacks from future quantum computers. However, the user is aware that this is a dynamic and new scientific field. Absolute, irrefutable security cannot be guaranteed based on the current state of science and technology. Terms such as “100% secure”, “uncrackable” or “military secure” are expressly not guaranteed.\n4.2. No recovery guarantee (GaiaVault): GaiaCom relies on a consistent zero-knowledge security concept. The encryption wedges and access data remain solely in the control of the user (secured via GaiaVault).\nIMPORTANT: If the user loses their passwords, passphrases, private keys or recovery seeds, the provider has no technical ability to reconstruct or reset this data. Loss of these access data inevitably leads to the irrevocable loss of access to the user account and all data encrypted therein.\n4.3. Not yet fully audited: The software is continuously subjected to internal security checks, but at the time of this beta phase it has not yet undergone a final, comprehensive external security audit by independent testing bodies.\n\n5. Interfaces, legacy protocols and federation\n5.1. SMTP Bridge Note: GaiaCom offers the ability to communicate via classic email protocols (such as SMTP). The user is aware that messages that leave the native GaiaCom security area (e.g. when sent to a conventional @gmail.com or @gmx.de address) are transported via unencrypted or third-party servers. GaiaCom's end-to-end security guarantees apply only to a limited extent or not at all to such outgoing or externally incoming legacy messages.\n5.2. Federation Note: If GaiaCom operates on a federated network, messages and data may pass through third-party servers. While the contents of the messages remain protected by end-to-end encryption, metadata (such as time of sending, IP addresses of the servers involved and recipient addresses) may be technically visible to the operators of these federated servers. The provider has no influence on the data protection practices of third-party server operators in the federated network.\n\n6. Acceptable Uses and Prohibited Activities\nThe user undertakes not to use the service improperly or for illegal purposes. In particular, the following are prohibited:\n- Distributing, sending or hosting viruses, malware, phishing content or other malicious software.\n- Using the Service to conduct denial-of-service attacks (DDoS) or unsolicited bulk mailing (spam).\n- Abusing the system to commit fraud.\n- The distribution or exchange of illegal content, in particular depictions of child sexual abuse (CSAM), terrorist propaganda, calls for violence or other criminally relevant content.\n\n7. Abuse reporting system\n7.1. Reporting abusive behavior: Users have the opportunity to report abusive communications or illegal activities via the integrated abuse system.\n7.2. Processing of reports: In order to ensure protection against misuse, incoming reports can be technically analyzed (while maintaining privacy and encryption limits). This can lead to temporary or permanent suspension of user accounts or IP addresses in the event of proven violations of these terms of use.\n\n8. Limitation of Liability\n8.1. Standard of liability: The beta software is provided free of charge. According to the legal rules for donations or loans, the provider is therefore only liable for intent (intentional damage) and gross negligence.\n8.2. Exclusion of liability for data loss: Liability for the loss of data is excluded unless the loss was caused intentionally or through gross negligence by the provider and the user has fulfilled his obligation to mitigate damage through regular backups (outside GaiaCom).\n8.3. Legal limits: The above liability limitations do not apply to injury to life, body or health or to liability under the Product Liability Act.\n\n9. Open Source\nCertain GaiaCom components, libraries or client applications may be licensed under open source licenses (e.g. GPL, MIT, Apache). The respective license terms of these components remain unaffected by these terms of use and can be viewed in the corresponding source code repositories.\n\n10. Export Control and Compliance\nThe user is aware that cryptographic software may be subject to strict export controls and legal restrictions. The user is responsible for ensuring that the use of GaiaCom does not violate the laws, import/export restrictions or cryptography regulations of their respective country of residence.\n\n11. Data protection notice (short version for the beta)\n11.1. Minimal data collection: As part of the beta phase, the provider only collects data that is absolutely necessary for technical operation, troubleshooting and further development (e.g. server log files for error diagnosis).\n11.2. No insight into the content: Thanks to the consistent zero-knowledge and E2E encryption, the provider never has access to the contents of your chats, emails or keys stored in the GaiaVault.\n11.3. Detailed data protection declaration: The detailed data protection regulations are linked separately and must also be taken into account by the user before registering.\n\n12. Final provisions\n12.1. Applicable law: The law of the Federal Republic of Germany applies, excluding the UN Convention on Contracts for the International Sale of Goods.\n12.2. Subject to change: Since GaiaCom is in active development, the provider reserves the right to adapt these conditions at any time with effect for the future. The current version is available in the application.",
    "wizard_terms_title": "GaiaCom Terms of Use and Beta Testing Agreement (Beta Phase)",
    "node_operator": "Node operator",
    "search_channels": "Search channels...",
    "senior_reviewer": "Senior Reviewer",
    "trusted_reviewer": "Trusted Reviewer",
    "active_frequencies": "Active frequencies",
    "connected_rooms": "CONNECTED SPACES",
    "dashboard": "Dashboard",
    "empty_chats": "No active chats available.",
    "empty_messages": "No new messages available.",
    "encrypted": "Encrypted",
    "gaiacom_uplink": "GAIACOM UPLINK",
    "install_app": "Install app",
    "install_app_desc": "For quick start & offline mode",
    "kommandozentrale_alpha": "ALPHA command center",
    "network_online": "NETWORK: ONLINE",
    "new_room": "New space",
    "no_frequencies_active": "No frequencies active. Create a new room to start communication.",
    "no_id": "No ID",
    "open_chats": "Open chats",
    "open_inbox": "Open inbox",
    "primary_identity": "PRIMARY IDENTITY",
    "recent_chats": "New chats",
    "recent_messages": "Latest news",
    "session_encrypted": "Session encrypted: {name}",
    "session_secure": "STATUS: SECURE",
    "system_verlassen": "Exit system",
    "write_message": "Write a message",
  },
  ru: {
    sc_title: "Центр безопасности",
    sc_subtitle: "Интегрированный уровень безопасности GaiaShield",
    sc_tab_status: "🛡️ Статус защиты",
    sc_tab_events: "📋 Журнал безопасности",
    sc_tab_node: "⚙️ Безопасность узла",
    sc_loading: "Загрузка данных безопасности...",
    sc_status_secured: "Статус системы: Учетная запись защищена",
    sc_status_warning: "Статус системы: Активные предупреждения",
    sc_desc_secured: "Нет активных критических предупреждений. GaiaShield активно отслеживает вашу учетную запись.",
    sc_desc_warning: "Внимание: Есть активные события безопасности, требующие вашего внимания.",
    sc_account_protection: "Защита учетной записи",
    sc_message_protection: "Защита сообщений",
    sc_audits: "Аудит безопасности",
    sc_active: "АКТИВНО",
    sc_failed_logins: "Неудачные входы",
    sc_tamper_checks: "Проверка целостности",
    sc_blocked_replays: "Заблокированные повторы",
    sc_last_check: "Последняя проверка",
    sc_just_now: "Только что",
    sc_open_warnings: "Открытые предупреждения",
    sc_btn_acknowledge: "Подтвердить",
    sc_filter_severity: "Важность",
    sc_filter_category: "Категория",
    sc_filter_hide_ack: "Скрыть подтвержденные",
    sc_btn_export: "Экспорт",
    sc_col_details: "Подробности",
    sc_col_time: "Время",
    sc_col_status: "Статус",
    sc_col_action: "Действие",
    sc_no_events: "Событий безопасности не найдено.",
    sc_node_title: "Консоль безопасности оператора узла",
    sc_system_health: "Здоровье системы",
    sc_last_audit: "Последний аудит",
    sc_packed_logs: "Архивированные журналы",
    sc_unconfirmed_events: "Неподтвержденные события",
    sc_operator_action: "Требуется действие оператора",
    sc_all_ok: "Все в порядке",
    sc_critical_events: "Критические события системы",
    ac_title: "Центр управления и жалоб",
    ac_subtitle: "Консенсус управления и жалоб GaiaCom",
    ac_tab_my_reports: "Мои жалобы",
    ac_tab_queue: "Очередь проверок",
    ac_tab_operator: "Оператор узла",
    ac_tab_transparency: "Федерация и прозрачность",
    ac_loading: "Загрузка данных...",
    ac_reported_cases: "Зарегистрированные случаи",
    ac_no_reports: "Вы еще не отправляли жалоб.",
    ac_case_details: "Детали дела",
    ac_appeal_submit: "Подать апелляцию",
    ac_appeal_status: "Статус апелляции",
    ac_appeal_reason: "Причина апелляции",
    ac_appeal_statement: "Заявление",
    ac_btn_appeal: "Отправить апелляцию",
    ac_trusted_reviewer_queue: "Очередь доверенных рецензентов",
    ac_case_review: "Рассмотреть дело",
    ac_review_category: "Рекомендуемая категория",
    ac_review_severity: "Рекомендуемая степень тяжести",
    ac_review_action: "Рекомендуемое действие",
    ac_review_reason: "Обоснование рецензента",
    ac_btn_submit_review: "Отправить отзыв",
    ac_node_operator_dashboard: "Панель оператора узла",
    ac_apply_action: "Применить действие (Переопределение)",
    ac_target_type: "Тип цели",
    ac_target_id: "ID цели (GaiaID или ID канала)",
    ac_suspend: "Блокировка активна",
    ac_reason: "Официальная причина",
    ac_btn_apply: "Применить меру",
    ac_transparency_title: "Журнал консенсуса и прозрачности",
    ac_transparency_desc: "Публично просматриваемые доказательства моментальных снимков всех модерируемых каналов и удостоверений.",
    ac_btn_snapshot: "Создать моментальный снимок прозрачности",
    search_placeholder: "Поиск писем по теме, отправителю, тексту...",
    abuse_center_title: "Центр жалоб",
    abbrechen: "Отмена",
    active_identities: "Активные личности",
    active_identity: "Активная личность",
    add_btn: "Добавлять",
    add_contact_title: "Добавить контакт",
    admin: "Админ",
    adressbuch: "Адресная книга",
    aktiviert: "Активирован",
    an: "Кому",
    anonymous_sender: "Анонимный отправитель",
    antworten: "Ответить",
    attachment_gaia_hint: "Вложения GaiaCOM остаются сквозным зашифрованным.",
    attachment_smtp_hint: "Устаревший SMTP блокирует вложения в виде исполняемых файлов и сценариев и сохраняет электронные письма как небезопасные.",
    attachments: "Вложения",
    auffaellig: "Подозрительный",
    auth_beta_notice: "Бета-тест: GaiaCOM активно проверяется. Возможны ошибки; храните важные seed-фразы в резерве и внимательно проверяйте критичные сценарии.",
    auth_btn_login: "Загрузить личность и войти",
    auth_btn_register: "Регистрация и создание ключей",
    auth_copied: "Скопировано",
    auth_copy_seed: "Копировать сид",
    auth_generate_seed: "Сгенерировать сид",
    auth_headline: "GaiaCOM — первый квантово-стойкий протокол электронной почты и система связи, созданная для человечества.",
    auth_kicker: "Постквантовая защищенная связь",
    auth_mnemonic: "Мнемоническая фраза",
    auth_mnemonic_placeholder: "12 слов, разделенных пробелами...",
    auth_password: "Пароль",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "Закрытые ключи никогда не покидают ваше устройство. Расшифровать содержимое могут только предназначенные получатели.",
    auth_proof_gaiadata_desc: "Zero-Knowledge: вы сохраняете контроль над своими данными. Метаданные минимизируются и не превращаются в открытый профиль.",
    auth_proof_gaiadrop_desc: "Внешние отправители могут передавать конфиденциальные текстовые сообщения на ваш GaiaID без учетной записи.",
    auth_proof_gaiaproof_desc: "Доказательства доставки и целостности показывают, что шифротекст, отправитель и временная метка не были изменены.",
    auth_proof_gaiavault_desc: "Личные заметки, подсказки восстановления и записи безопасности остаются локально зашифрованными.",
    auth_proof_hybrid_desc: "Quantum Shield: гибридное шифрование ML-KEM и X25519 защищает от современных атак и риска «сохранить сейчас, расшифровать позже».",
    auth_secure_mail: "Безопасная квантовая федеративная почта",
    auth_subline: "GaiaCOM — квантово-устойчивая система связи для почты, чатов, кризисных комнат, GaiaDrop и локальных записей безопасности. Закрытые ключи остаются на вашем устройстве, содержимое шифруется сквозным шифрованием, а доказательства можно экспортировать без раскрытия открытого текста.",
    auth_success_btn: "Войти сейчас",
    auth_success_text: "Ваш аккаунт GaiaCOM создан. Ключи были созданы локально из вашего сида и не хранятся на сервере.",
    auth_success_title: "Регистрация успешна",
    auth_tab_drop: "GaiaDrop",
    auth_tab_login: "Вход / аккаунт",
    auth_toggle_login: "Уже есть аккаунт",
    auth_toggle_register: "Создать новый аккаунт",
    auth_usecase_text: "Подходит для юристов, компаний, ведомств, журналистов, информаторов и частных инцидентов безопасности.",
    auth_usecase_title: "Создано для чувствительной коммуникации",
    auth_username: "Имя пользователя",
    auth_username_placeholder: "Введите имя...",
    auth_value_chat: "E2E-чат",
    auth_value_drop: "Secure Drop",
    auth_value_mail: "Защищенная почта",
    auth_value_rooms: "GaiaRooms",
    bestaetigen: "Подтверждать",
    bestaetigt: "Подтверждено",
    bio_status: "Биография / Статус",
    biography: "Биография",
    change_password_desc: "Изменяет ваш пароль для входа на сервере. Ваша локальная резервная фраза остается отдельно защищенной паролем Vault/Unlock.",
    change_password_menu_desc: "Обновите пароль для входа в GaiaCOM.",
    change_password_title: "Изменить пароль",
    channel_id: "Идентификатор канала",
    channel_name_label: "Название канала",
    chat_deleted_hidden: "Чат удален и скрыт.",
    chat_input_placeholder: "Введите безопасное сообщение...",
    chat_start_hint: "Начните разговор! Все сообщения в чате защищены квантово-безопасным сквозным шифрованием.",
    choose_avatar: "Выбрать аватар",
    ciphertext_hash: "Хэш шифртекста",
    clear_chat: "Пустой чат",
    clear_for_everyone: "Пусто для всех",
    clear_for_me: "Пустой только для меня",
    click_to_write_mail: "Нажмите, чтобы написать письмо",
    click_top_right: "Нажмите вверху справа на",
    close: "Закрыть",
    code_kopieren: "Копировать код",
    code_kopieren_success: "Код скопирован.",
    confirm_clear_channel_desc: "Вы хотите удалить этот канал из локального просмотра?",
    confirm_clear_channel_title: "Пустой канал",
    confirm_clear_chat: "Вы хотите очистить этот чат?",
    confirm_clear_chat_desc: "Вы хотите очистить этот чат?",
    confirm_clear_chat_title: "Пустой чат",
    confirm_clear_everyone: "Вы хотите очистить этот чат для обеих сторон? (OK = Для всех, Отмена = Только для меня)",
    confirm_delete_everyone: "Вы хотите удалить это сообщение для обеих сторон? (OK = Для всех, Отмена = Только для меня)",
    confirm_delete_msg: "Вы хотите удалить это сообщение?",
    confirm_delete_msg_desc: "Вы хотите удалить это сообщение в чате?",
    confirm_delete_msg_title: "Удалить сообщение",
    confirm_new_password: "Подтвердить новый пароль",
    copy: "Копировать",
    create_btn: "Создавать",
    create_channel_title: "Создать канал",
    create_group_is_crisis: "Отметить как кризисную зону",
    create_group_title: "Создать новую группу",
    crypto_lock_desc: "Управляет тем, когда GaiaCOM удаляет локальные криптоключи из памяти.",
    crypto_lock_menu_desc: "Управляйте таймерами перезагрузки и бездействия.",
    crypto_lock_title: "Криптографический замок",
    crypto_session_duration: "Разблокируется после перезагрузки",
    crypto_session_duration_desc: "Криптосессия остается открытой на этой вкладке браузера только в течение выбранного периода.",
    cryptographic_fingerprint: "Криптографический отпечаток",
    current_password: "Текущий пароль",
    data_minimization: "Минимизация данных",
    decrypt_failed: "Не удается расшифровать",
    delete: "Удалить",
    delete_account_button: "Удалить аккаунт безвозвратно",
    delete_account_confirm_label: "Введите DELETE для подтверждения.",
    delete_account_confirmation_error: "Требуется пароль и подтверждение DELETE.",
    delete_account_desc: "Этот режим безвозвратно уничтожает вашу учетную запись, личные данные, сеансы устройства, данные GaiaDrop, загружаемые метаданные и сообщения, связанные с сервером.",
    delete_account_done_desc: "Все назначаемые данные GaiaCOM были удалены.",
    delete_account_done_title: "Аккаунт удален",
    delete_account_menu_desc: "Уничтожить учетную запись и связанные с ней данные.",
    delete_account_not_authenticated: "Нет активного аккаунта.",
    delete_account_title: "Удалить аккаунт",
    delete_for_everyone: "Удалить для всех",
    delete_for_me: "Удалить только для меня",
    device_current: "Это устройство",
    device_last_seen: "Последний",
    device_logout: "Выйти",
    device_sessions_desc: "Проверьте активные сеансы и отмените регистрацию устройств, которым вы больше не доверяете.",
    device_sessions_empty: "Устройства не найдены.",
    device_sessions_menu_desc: "Управляйте активными сеансами и завершайте их.",
    device_sessions_title: "Зарегистрированные устройства",
    device_since: "С",
    display_name: "Отображаемое имя",
    drop_address_copied: "Адрес GaiaDrop скопирован.",
    drop_btn_decrypting: "Дешифрование папки...",
    drop_btn_load: "Загрузить GaiaDrop Inbox",
    drop_delete_desc: "Вы действительно хотите навсегда удалить этот дроп?",
    drop_delete_title: "Удалить GaiaDrop",
    drop_desc: "Текстовый канал с нулевым разглашением для внешних сообщений, раскрытия уязвимостей и конфиденциальных отчетов. Внешние пользователи могут отправлять сообщения на ваш GaiaID без аккаунта.",
    drop_empty: "Входящих сообщений GaiaDrop пока нет.",
    drop_id: "Drop ID:",
    drop_own_address: "Ваш адрес GaiaDrop",
    drop_proof: "DROP PROOF",
    drop_title: "Приемник GaiaDrop Secure Inbox",
    dunkler_modus: " Тёмная тема",
    e2e_chat_room_open: "Открыть чат-комнату E2E",
    edit_profile: "Редактировать профиль",
    edit_profile_desc: "Настройте отображаемое имя, биографию и аватар.",
    einladungscode: "Код приглашения",
    enter_fingerprint_chars_confirm: "Введите запрошенные символы отпечатка пальца для подтверждения.",
    envelope_hash: "Хэш конверта",
    erasability: "Возможность удаления",
    erfolg: "Успех",
    exclude_plaintext: "Экспорт без обычного текста",
    export_disclosure: "Экспорт дела безопасности",
    export_package_desc: "Включайте простой текст только в том случае, если такое раскрытие информации сделано намеренно.",
    export_package_title: "Экспортный пакет безопасности",
    fehler: "Ошибка",
    gaiacom_reader: "GaiaCOM Reader",
    gaiadrop_inbox_title: "Входящие GaiaDrop",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM сводит к минимуму метаданные, хранит закрытые ключи локально, осуществляет сквозное шифрование контента и позволяет полностью удалить учетную запись.",
    gdpr_home_title: "100% соответствие GDPR",
    gdpr_reason_delete: "При удалении учетной записи удаляются учетная запись, идентификационные данные, локальные сеансы и данные, назначаемые на стороне сервера.",
    gdpr_reason_e2ee: "Частный контент остается доступным для расшифровки только для предполагаемых получателей.",
    gdpr_reason_minimal: "Метаданные используются только для маршрутизации, доставки и учетных данных безопасности.",
    gdpr_reason_zero_knowledge: "Закрытые ключи и данные для восстановления остаются локально под контролем пользователя.",
    gesendet: "Отправленные",
    gesperrt_verdaechtig: "Заблокирован / Подозрительный",
    group_delete_desc: "Вы действительно хотите навсегда удалить эту группу? Все каналы и сообщения в этой группе будут удалены.",
    group_delete_title: "Удалить группу",
    group_description: "Описание",
    group_icon_label: "Значок группы/аватар",
    group_name: "Название группы",
    group_settings_avatar: "Аватар",
    group_settings_desc: "Описание",
    group_settings_is_crisis: "Отметить как кризисную зону",
    group_settings_name: "Название группы",
    group_settings_title: "Настройки группы",
    groups_empty_desc: "Создайте защищенное рабочее пространство для проекта, кризисной ситуации или командной коммуникации.",
    groups_empty_title: "Групповых чатов пока нет",
    gruppe_beitreten: "Группа присоединена",
    gruppe_erstellen: "+ Создать группу",
    gruppe_verlassen: "Выйти из группы",
    gruppen_chats: "Групповые чаты",
    heller_modus: " Светлая тема",
    how_to_receive_drops: "Как получать дропы?",
    identitaets_assistent: "Помощник личности",
    inactivity_lock_duration: "Блокировать, когда неактивен",
    inactivity_lock_duration_desc: "После этого периода отсутствия ввода GaiaCOM автоматически будет криптографически заблокирован.",
    inactivity_lock_notice: "GaiaCOM был криптографически заблокирован из-за неактивности.",
    include_plaintext: "Включить простой текст",
    invite_code_label: "Пригласительный код",
    join_group_title: "Присоединиться к группе",
    kanaele: "Каналы",
    kanal_erstellen: "+ Канал",
    kein_chat_ausgewaehlt: "Чат не выбран",
    kein_kanal_ausgewaehlt: "Канал не выбран",
    keine_gruppe_ausgewaehlt: "Группа не выбрана",
    keine_mails: "Нет писем.",
    key_change_warn_desc: "Открытый ключ этого контакта изменился. Проверьте отпечаток пальца, прежде чем доверять ему.",
    key_change_warn_title: "Криптографическое предупреждение",
    key_change_warning_changed: "изменилось. Это может быть признаком атаки «человек посередине»!",
    key_change_warning_msg: "Идентификационный ключ для контакта",
    key_transparency: "Прозрачность ключей (История ключей)",
    kopiert: "Скопировано",
    kryptographische_schluessel: "Криптографические ключи",
    kryptographische_schluessel_desc: "Показать закрытые ключи и резервную исходную фразу.",
    laden: "Загрузка...",
    leeren: "Пустой",
    loading: "Нагрузка...",
    local_key_vault: "Локальное хранилище ключей",
    local_keys_label: "Локальные ключи",
    lock_on_reload: "Всегда блокировать после перезагрузки",
    logout: "Выйти",
    mail_compose: "Написать письмо",
    mein_profil: "Мой профиль",
    melden: "Пожаловаться",
    menu: "Меню",
    message: "Новости",
    message_id: "ID сообщения",
    message_pin: "Приколоть",
    message_pinned_title: "Закрепленные сообщения",
    message_react: "Реагировать",
    message_reply: "Отвечать",
    message_replying_to: "Ответ на",
    message_save: "Сохранять",
    message_saved: "Сохранено",
    message_to_channel: "Сообщение в",
    message_unpin: "Решать",
    message_unsave: "Не сохранять",
    mitglied: "Участник",
    mitglieder: "Участники",
    ml_kem: "МЛ-КЕМ",
    neue_mail: "Новое письмо",
    never_auto_lock: "Никогда автоматически",
    new_fingerprint: "Новый отпечаток пальца",
    new_identity: "Новая личность",
    new_password: "Новый пароль",
    no_description: "Нет описания",
    no_key_history: "История ключей не записана.",
    no_specification: "Не указано",
    old_fingerprint: "Старый отпечаток пальца",
    open_privacy_imprint: "Открытая информация и защита данных",
    post_quantum_e2e: "Постквантовый E2E",
    posteingang: "Входящие",
    powered_by: "Powered by",
    privacy_imprint_menu_desc: "Покажите GDPR, защиту данных и юридическое уведомление.",
    privacy_imprint_profile_desc: "GaiaCOM обрабатывает коммуникационный контент в соответствии с принципами минимизации данных, сквозного шифрования и управления локальными ключами.",
    privacy_imprint_title: "Защита данных и юридическое уведомление",
    profil: "Профиль",
    profile_details: "Детали профиля",
    profile_settings_hint: "Настройки профиля отображаются на правой панели.",
    profile_unlock_desc: "По соображениям безопасности вам необходимо ввести свой пароль еще раз, чтобы просмотреть свои закрытые криптографические ключи.",
    proof_hash: "Хэш подтверждения:",
    public_drop_desc: "Secure Drop для внешних текстовых обращений без аккаунта GaiaCOM.",
    public_drop_message: "Сообщение",
    public_drop_message_placeholder: "Введите конфиденциальный текст...",
    public_drop_send: "Отправить GaiaDrop",
    public_drop_sender: "Заметка отправителя, необязательно",
    public_drop_sender_placeholder: "Имя, номер дела или анонимно",
    public_drop_target: "Целевой GaiaID",
    quanten_chat: "Квантовый чат",
    quantum_secure_exchange: "Квантово-безопасный обмен через...",
    quantum_secure_net: "Квантово-безопасная сеть GaiaCOM (Ed25519 и ML-KEM)",
    quantum_shield_desc: "Сеть GaiaCOM защищает вашу конфиденциальность с помощью многоуровневого гибридного протокола шифрования, устойчивого к атакам будущих квантовых компьютеров.",
    quantum_shield_l1_desc: "Использует стандарт FIPS 203 для инкапсуляции симметричного общего ключа. Предотвращает пассивный перехват и последующую расшифровку (\\\\\\",
    quantum_shield_l1_title: "1. Постквантовая защита (ML-KEM-1024)",
    quantum_shield_l2_desc: "Классический, сверхбыстрый метод обмена ключами Диффи-Хеллмана, служащий дополнительным уровнем безопасности в гибридной схеме.",
    quantum_shield_l2_title: "2. Эллиптическая криптография (X25519)",
    quantum_shield_l3_desc: "Каждое сообщение и федеративный конверт подписываются криптографически, чтобы однозначно подтвердить подлинность отправителя.",
    quantum_shield_l3_title: "3. Цифровые подписи (Ed25519)",
    quantum_shield_l4_desc: "Шифрует содержимое сообщений симметрично и жестко привязывает отправителя, получателя и метаданные к аутентифицированным дополнительным данным (AAD) для предотвращения атак повторного воспроизведения.",
    quantum_shield_l4_title: "4. AAD аутентификация (AES-256-GCM)",
    quantum_shield_status: " Статус Quantum Shield",
    receive_drops_step1: "Поделитесь вашим GaiaID (например, скопировав его выше) с внешними источниками.",
    receive_drops_step2: "Они открывают страницу входа вашего инстанса GaiaCOM, переходят на вкладку",
    receive_drops_step3: "и отправляют свое зашифрованное сообщение на ваш адрес.",
    receiver_gaia: "приемник GaiaCOM",
    receiver_smtp: "SMTP-получатель",
    records_stored: "Записи сохранены",
    refresh: "Обновлять",
    report_abuse_desc: "Хотите сообщить об этом сообщении и отправить на сервер криптографические доказательства злоупотреблений?",
    report_abuse_title: "Сообщить о нарушении",
    reputation_status: "Статус репутации",
    room_chat_start_hint: "Начните беседу! Все сообщения в этом групповом канале децентрализованы и защищены сквозным квантово-безопасным шифрованием.",
    room_policy_audit: "Контрольный журнал и ротация ключей активны.",
    room_policy_crisis: "Кризисная комната",
    room_policy_e2ee: "Пространство нулевого знания. Квантовый сейф E2EE.",
    room_policy_title: "Рекомендации по выбору номера",
    room_policy_zero_knowledge: "Политика",
    room_security_note_desc: "Все ключевые изменения проверяются с помощью Key Transparency. Используйте GaiaVault для частных журналов резервного копирования.",
    room_security_note_title: "Закрепленное примечание по безопасности",
    save_profile: "Сохранить профиль",
    schluessel_entsperrt: "🔑 Снова заблокировать ключи",
    search_gaia_label: "Найти адрес Гайи",
    security_warning_title: "Предупреждение безопасности",
    select_channel_chat: "Выберите канал в левой боковой панели, чтобы начать чат.",
    select_contact_chat: "Выберите контакт на левой панели, чтобы начать безопасный квантово-защищенный чат E2E.",
    select_mail_read: "Выберите письмо из списка, чтобы прочитать его квантово-безопасное содержимое, или создайте новое сообщение.",
    senden: "Отправить",
    sender_signature: "Подпись отправителя",
    server_log: "Лог сервера:",
    server_received: "Получено сервером",
    session_lock: "Блокировка сеанса",
    setup_address_keys: "Создать адрес и набор ключей",
    setup_profile: "Настроить в профиле",
    smtp_inbox_title: "SMTP-прием",
    smtp_legacy_badge: "Устаревший SMTP/небезопасный",
    smtp_mode_option: "Устаревший SMTP-мост",
    smtp_security_warning: "Это письмо было передано по классическому незашифрованному протоколу SMTP. Сквозное шифрование неактивно.",
    smtp_security_warning_desc: "Это сообщение покидает комнату безопасности GaiaCom. Доставка SMTP не обеспечивает встроенную сквозную гарантию GaiaCom, гарантию TrustMesh и гарантию Godmode со стороны шлюза.",
    spam_verdacht: "Спам/Подозрение",
    spam_warning_desc: "Это сообщение содержит подозрительные сигналы репутации.",
    spam_warning_title: "Предупреждение о спаме",
    speichern: "Сохранить",
    sperren: "Заблокировать",
    standard_group_status: "Стандартный групповой чат (с шифрованием E2EE)",
    status: "статус",
    subject: "Касательно",
    suchen: "Поиск адреса Gaia...",
    tage: "дней",
    time_unknown: "Время неизвестно",
    transmission_mode: "Режим передачи",
    trust_age: "Возраст доверия",
    trust_passport_title: "Доверительный паспорт",
    unbestaetigt: "Не подтверждено",
    unknown_sender: "Неизвестный",
    unlock_btn: "Разблокировать",
    unlock_btn_profile: "Разблокировать",
    unlock_desc: "Файл вашего закрытого ключа зашифрован. Введите пароль для загрузки криптографических ключей только в оперативную память.",
    unlock_logout: "Выйти и закрыть локальные ключи",
    unlock_title: "Разблокировать личность",
    untrusted: "Недоверенный",
    update_password: "Обновить пароль",
    upload_avatar_btn: "Загрузить изображение (очищенное)",
    vault_btn_encrypt: "Зашифровать запись",
    vault_btn_lock: "Заблокировать сейф",
    vault_btn_unlock: "Разблокировать сейф",
    vault_copied_success: "Скопировано в буфер обмена",
    vault_decrypted_content: "Расшифрованный контент",
    vault_desc: "Локальный зашифрованный сейф для резервных копий восстановления, личных заметок, учетных данных серверов, экстренных контактов, юридических заметок, событий безопасности и частных логов.",
    vault_empty: "В сейфе пока нет сохраненных записей.",
    vault_locked_pane_notice: "Сейф заблокирован. Пожалуйста, разблокируйте справа.",
    vault_new_record: "Новая безопасная запись",
    vault_pwd_placeholder: "Введите пароль сейфа...",
    vault_record_body: "Запись контента",
    vault_record_body_placeholder: "Введите зашифрованное содержимое записи...",
    vault_record_category: "категория",
    vault_record_title: "Название записи",
    vault_record_title_placeholder: "Название записи",
    vault_title: "Сейф GaiaVault Secure Records",
    verify_new_fingerprint_hint: "Проверьте новый отпечаток пальца, прежде чем принять ключ.",
    vertrauenswuerdig: "Доверенный",
    vision_gaia_technology: "VisionGaiaTechnology",
    von: "От",
    warnung: "Предупреждение",
    wizard_address: "Адрес",
    wizard_back: "Назад",
    wizard_check1: "Я надежно сохранил свою сид-фразу.",
    wizard_custom_domain: "Использовать свой домен",
    wizard_desc1: "GaiaCOM не хранит закрытые ключи на стороне сервера. Без мнемонического сида никто не сможет восстановить утерянные сообщения.",
    wizard_desc2: "Ваш адрес определяет федеративный узел, через который маршрутизируются зашифрованные конверты.",
    wizard_fallback: "Резервные узлы",
    wizard_finish: "Завершить настройку",
    wizard_next: "Далее",
    wizard_server_domain: "Домен узла сервера",
    wizard_step1: "1. Резервный сид",
    wizard_step2: "2. Адрес и Сервер",
    wizard_title1: "Защитить ключи восстановления",
    wizard_title2: "Выберите адрес GaiaCOM",
    write_message_placeholder: "Напишите защищенное сообщение...",
    you: "Ты",
    zero_knowledge: "Zero Knowledge",
    zero_knowledge_encryption: "Шифрование с нулевым разглашением",
    "Chat fuer alle geleert": "Чат опустел для всех участников.",
    "Chat geleert": "Чат был удален для вашего локального почтового ящика.",
    "Nachricht fuer alle geloescht": "Сообщение удалено у всех участников.",
    "Nachricht geloescht": "Сообщение чата было локально удалено из вашего почтового ящика.",
    "anpinnen": "Приколоть",
    "chat_loeschen": "Удалить чат",
    "confirm_delete_chat_desc": "Вы уверены, что хотите удалить и скрыть чат?",
    "confirm_leave_group_desc": "Вы действительно хотите покинуть эту группу?",
    "entpinnen": "Открепить",
    "group_deleted": "Группа успешно удалена.",
    "group_left": "Успешно покиньте группу.",
    "gruppe_loeschen": "Удалить группу",
    "loeschen": "Удалить",
    "no_active_chats": "Нет активных чатов. Найдите контакты выше, чтобы начать чат.",
    "pinned": "Закреплено",
    "wizard_check_credentials": "Я несу ответственность за безопасность моих данных доступа.",
    "wizard_check_is_beta": "Я понимаю, что GaiaCom — это бета-версия программного обеспечения.",
    "wizard_check_no_illegal": "Я не буду использовать GaiaCom в незаконных целях.",
    "wizard_check_no_uptime": "Я понимаю, что нет никакой гарантии наличия.",
    "wizard_check_smtp_security": "Я понимаю, что сообщения SMTP не обеспечивают полную безопасность GaiaCom.",
    "wizard_check_terms_read": "Я прочитал Условия использования бета-версии.",
    "wizard_step_terms": "Условия эксплуатации",
    "wizard_terms_text": "Условия использования GaiaCom и соглашение о бета-тестировании (бета-фаза)\n\nПоставщик: VisionGaiaTechnology (далее «Поставщик»)\nСтатус: этап публичного бета-тестирования.\nСрок действия: с 21 июня 2026 г.\n\n⚠️ САМОЕ ВАЖНОЕ ПРИМЕЧАНИЕ ЗАРАНЕЕ (ПОЖАЛУЙСТА, ПРОЧИТАЙТЕ ВНИМАТЕЛЬНО)\nGaiaCom находится на стадии публичного бета-тестирования. Несмотря на обширные меры безопасности, отсутствие ошибок, постоянная доступность или абсолютная безопасность программного обеспечения и базовой инфраструктуры не могут быть гарантированы. Используйте на свой страх и риск. Пользователи несут ответственность за безопасное хранение своих данных доступа (особенно ключей для GaiaVault) и за соблюдение действующего законодательства.\n\n1. Предмет и цель этапа бета-тестирования\n1.1. Цель предоставления: GaiaCom — это новая служба электронной почты и чата, основанная на постквантовой криптографии (PQC). Положение на этапе бета-тестирования предназначено исключительно для технического тестирования, моделирования нагрузки, поиска программных ошибок (багов) и оптимизации удобства использования.\n1.2. Статус бета-версии: пользователь осознает, что предлагаемое программное обеспечение является предварительной версией (бета-версией). Технически он еще не полностью разработан, не соответствует стандарту конечного коммерческого продукта и может вызвать ошибки, потерю данных, задержки передачи или сбои системы.\n1.3. Отсутствие права на продолжение: Поставщик имеет право в любое время прекратить предоставление услуги полностью или частично, изменить или ограничить функции или удалить их временно или навсегда без объяснения причин.\n\n2. Доступность и отказ от гарантии\n2.1. Нет гарантии доступности: GaiaCom предоставляется без каких-либо гарантий доступности или времени безотказной работы. Право на бесперебойную доступность услуги отсутствует.\n2.2. Исключение гарантии: Программное обеспечение предоставляется в его текущем состоянии («как есть») и при условии его доступности. В пределах, разрешенных законом, любые гарантийные претензии в отношении материальных и юридических дефектов программного обеспечения исключаются. В частности, нет никакой гарантии, что программное обеспечение не содержит ошибок, вредоносных программ или пригодно для определенной цели.\n\n3. Управление рисками и обязательства пользователей\n3.1. Запрет на хранение критически важных данных: Пользователь обязуется не хранить и не передавать исключительно через GaiaCom любые критически важные для бизнеса, жизненно важные, оперативно необходимые или юридически особо конфиденциальные данные (такие как файлы пациентов, высокочувствительные финансовые данные или официально регулируемые секреты). Услугу нельзя использовать для инфраструктуры, где непредвиденные сбои могут привести к травмам, материальному ущербу или значительным финансовым потерям.\n3.2. Самостоятельное резервное копирование: Пользователь несет ответственность за резервное копирование всех данных, полученных или отправленных через GaiaCom, которые ему понадобятся в долгосрочной перспективе, на собственных независимых системах (резервные копии). Провайдер не гарантирует постоянное хранение или возможность восстановления данных на своих серверах.\n\n4. Криптографические функции и GaiaVault\n4.1. Постквантовая криптография (PQC): GaiaCom реализует современные, ориентированные на будущее процессы шифрования, которые предназначены для противостояния атакам будущих квантовых компьютеров. Однако пользователь осознает, что это динамичная и новая научная область. Абсолютная, неопровержимая безопасность не может быть гарантирована на основе современного состояния науки и техники. Такие термины, как «100% безопасность», «невзламываемость» или «военная безопасность», явно не гарантируются.\n4.2. Отсутствие гарантии восстановления (GaiaVault): GaiaCom опирается на последовательную концепцию безопасности с нулевым разглашением данных. Ключи шифрования и данные доступа остаются исключительно под контролем пользователя (защищены с помощью GaiaVault).\nВАЖНО: Если пользователь потеряет свои пароли, кодовые фразы, закрытые ключи или начальные данные для восстановления, у провайдера нет технической возможности восстановить или сбросить эти данные. Утрата этих данных доступа неизбежно приводит к безвозвратной утрате доступа к учетной записи пользователя и всем зашифрованным в ней данным.\n4.3. Еще не прошел полный аудит: программное обеспечение постоянно подвергается внутренним проверкам безопасности, но на момент бета-фазы оно еще не прошло окончательный комплексный внешний аудит безопасности независимыми организациями по тестированию.\n\n5. Интерфейсы, устаревшие протоколы и федерация\n5.1. Примечание по SMTP Bridge: GaiaCom предлагает возможность связи через классические протоколы электронной почты (например, SMTP). Пользователь осознает, что сообщения, выходящие за пределы собственной зоны безопасности GaiaCom (например, при отправке на обычный адрес @gmail.com или @gmx.de), передаются через незашифрованные или сторонние серверы. Гарантии сквозной безопасности GaiaCom применяются лишь в ограниченной степени или не применяются вообще к таким исходящим или входящим извне устаревшим сообщениям.\n5.2. Примечание для федерации. Если GaiaCom работает в федеративной сети, сообщения и данные могут проходить через сторонние серверы. Хотя содержимое сообщений остается защищенным сквозным шифрованием, метаданные (такие как время отправки, IP-адреса задействованных серверов и адреса получателей) могут быть технически видны операторам этих объединенных серверов. Провайдер не имеет никакого влияния на методы защиты данных сторонних операторов серверов в федеративной сети.\n\n6. Допустимое использование и запрещенная деятельность\nПользователь обязуется не использовать сервис ненадлежащим образом или в незаконных целях. В частности, запрещено:\n- Распространение, отправка или размещение вирусов, вредоносных программ, фишингового контента или другого вредоносного программного обеспечения.\n- Использование Сервиса для проведения атак типа «отказ в обслуживании» (DDoS) или нежелательной массовой рассылки (спама).\n- Злоупотребление системой для совершения мошенничества.\n- Распространение или обмен незаконным контентом, в частности изображениями сексуального насилия над детьми (CSAM), террористической пропагандой, призывами к насилию или другим криминально значимым контентом.\n\n7. Система сообщения о злоупотреблениях\n7.1. Сообщение о оскорбительном поведении. Пользователи имеют возможность сообщать об оскорбительных сообщениях или незаконной деятельности через интегрированную систему злоупотреблений.\n7.2. Обработка отчетов. Чтобы обеспечить защиту от неправомерного использования, входящие отчеты могут быть подвергнуты техническому анализу (при сохранении ограничений конфиденциальности и шифрования). Это может привести к временной или постоянной блокировке учетных записей пользователей или IP-адресов в случае доказанных нарушений настоящих условий использования.\n\n8. Ограничение ответственности\n8.1. Стандарт ответственности: Бета-версия программного обеспечения предоставляется бесплатно. Таким образом, в соответствии с правовыми нормами в отношении пожертвований или займов поставщик несет ответственность только за умысл (намеренный ущерб) и грубую небрежность.\n8.2. Исключение ответственности за потерю данных: Ответственность за потерю данных исключается, за исключением случаев, когда потеря была вызвана умышленно или по грубой неосторожности со стороны провайдера и пользователь выполнил свое обязательство по уменьшению ущерба посредством регулярного резервного копирования (за пределами GaiaCom).\n8.3. Юридические ограничения: Вышеуказанные ограничения ответственности не распространяются на причинение вреда жизни, телу или здоровью, а также на ответственность в соответствии с Законом об ответственности за качество продукции.\n\n9. Открытый исходный код\nОпределенные компоненты, библиотеки или клиентские приложения GaiaCom могут лицензироваться по лицензиям с открытым исходным кодом (например, GPL, MIT, Apache). Настоящие условия использования не затрагивают соответствующие условия лицензии этих компонентов, и их можно просмотреть в соответствующих репозиториях исходного кода.\n\n10. Экспортный контроль и соблюдение требований\nПользователь осознает, что криптографическое программное обеспечение может подлежать строгому экспортному контролю и юридическим ограничениям. Пользователь несет ответственность за то, чтобы использование GaiaCom не нарушало законы, ограничения на импорт/экспорт или правила криптографии своей страны проживания.\n\n11. Уведомление о защите данных (краткая версия для бета-версии)\n11.1. Минимальный сбор данных: в рамках бета-фазы провайдер собирает только те данные, которые абсолютно необходимы для технической эксплуатации, устранения неполадок и дальнейшего развития (например, файлы журналов сервера для диагностики ошибок).\n11.2. Никакого понимания содержимого: благодаря последовательному принципу нулевого разглашения и шифрованию E2E провайдер никогда не имеет доступа к содержимому ваших чатов, электронных писем или ключей, хранящихся в GaiaVault.\n11.3. Подробное заявление о защите данных: подробные правила защиты данных приведены отдельно и также должны быть приняты во внимание пользователем перед регистрацией.\n\n12. Заключительные положения\n12.1. Применимое право: Применяется право Федеративной Республики Германия, за исключением Конвенции ООН о договорах международной купли-продажи товаров.\n12.2. Возможны изменения: поскольку GaiaCom находится в активной разработке, провайдер оставляет за собой право адаптировать эти условия в любое время с эффектом на будущее. Текущая версия доступна в приложении.",
    "wizard_terms_title": "Условия использования GaiaCom и соглашение о бета-тестировании (бета-фаза)",
    "node_operator": "Оператор узла",
    "search_channels": "Поиск каналов...",
    "senior_reviewer": "Старший рецензент",
    "trusted_reviewer": "Доверенный рецензент",
    "active_frequencies": "Активные частоты",
    "connected_rooms": "СОЕДИНЕННЫЕ ПРОСТРАНСТВА",
    "dashboard": "Панель управления",
    "empty_chats": "Активных чатов нет.",
    "empty_messages": "Новых сообщений нет.",
    "encrypted": "Зашифрованный",
    "gaiacom_uplink": "ГАЙАКОМ-АПЛИНК",
    "install_app": "Установить приложение",
    "install_app_desc": "Для быстрого запуска и автономного режима",
    "kommandozentrale_alpha": "Командный центр АЛЬФА",
    "network_online": "СЕТЬ: ОНЛАЙН",
    "new_room": "Новое пространство",
    "no_frequencies_active": "Нет активных частот. Создайте новую комнату, чтобы начать общение.",
    "no_id": "Нет удостоверения личности",
    "open_chats": "Открытые чаты",
    "open_inbox": "Открыть входящие",
    "primary_identity": "ПЕРВИЧНАЯ ИДЕНТИЧНОСТЬ",
    "recent_chats": "Новые чаты",
    "recent_messages": "Последние новости",
    "session_encrypted": "Сеанс зашифрован: {name}",
    "session_secure": "СТАТУС: БЕЗОПАСНЫЙ",
    "system_verlassen": "Система выхода",
    "write_message": "Написать сообщение",
  },
  es: {
    sc_title: "Centro de seguridad",
    sc_subtitle: "Capa de seguridad integrada GaiaShield",
    sc_tab_status: "🛡️ Estado de protección",
    sc_tab_events: "📋 Log de seguridad",
    sc_tab_node: "⚙️ Seguridad del nodo",
    sc_loading: "Cargando datos de seguridad...",
    sc_status_secured: "Estado del sistema: Cuenta protegida",
    sc_status_warning: "Estado del sistema: Advertencias activas",
    sc_desc_secured: "No hay advertencias de seguridad críticas activas. GaiaShield está monitoreando activamente su cuenta.",
    sc_desc_warning: "Atención: Hay eventos de seguridad activos que requieren su atención.",
    sc_account_protection: "Protección de cuenta",
    sc_message_protection: "Protección de mensajes",
    sc_audits: "Auditorías de seguridad",
    sc_active: "ACTIVO",
    sc_failed_logins: "Inicios de sesión fallidos",
    sc_tamper_checks: "Pruebas de manipulación",
    sc_blocked_replays: "Replays bloqueados",
    sc_last_check: "Última comprobación",
    sc_just_now: "Justo ahora",
    sc_open_warnings: "Advertencias abiertas",
    sc_btn_acknowledge: "Confirmar",
    sc_filter_severity: "Gravedad",
    sc_filter_category: "Categoría",
    sc_filter_hide_ack: "Ocultar confirmados",
    sc_btn_export: "Exportar",
    sc_col_details: "Detalles",
    sc_col_time: "Hora",
    sc_col_status: "Estado",
    sc_col_action: "Acción",
    sc_no_events: "No se encontraron eventos de seguridad.",
    sc_node_title: "Consola de seguridad del operador de nodo",
    sc_system_health: "Salud del sistema",
    sc_last_audit: "Última auditoría",
    sc_packed_logs: "Logs empaquetados",
    sc_unconfirmed_events: "Eventos no confirmados",
    sc_operator_action: "Acción del operador requerida",
    sc_all_ok: "Todo correcto",
    sc_critical_events: "Eventos críticos del sistema",
    ac_title: "Centro de gobernanza y denuncias",
    ac_subtitle: "Consenso de gobernanza y abuso de GaiaCom",
    ac_tab_my_reports: "Mis denuncias",
    ac_tab_queue: "Cola de revisión",
    ac_tab_operator: "Operador de nodo",
    ac_tab_transparency: "Federación y transparencia",
    ac_loading: "Cargando datos...",
    ac_reported_cases: "Casos denunciados",
    ac_no_reports: "Aún no ha enviado ninguna denuncia.",
    ac_case_details: "Detalles del caso",
    ac_appeal_submit: "Presentar apelación",
    ac_appeal_status: "Estado de la apelación",
    ac_appeal_reason: "Motivo de la apelación",
    ac_appeal_statement: "Declaración",
    ac_btn_appeal: "Enviar apelación",
    ac_trusted_reviewer_queue: "Cola de revisores de confianza",
    ac_case_review: "Revisar caso",
    ac_review_category: "Categoría recomendada",
    ac_review_severity: "Gravedad recomendada",
    ac_review_action: "Acción recomendada",
    ac_review_reason: "Motivo del revisor",
    ac_btn_submit_review: "Enviar revisión",
    ac_node_operator_dashboard: "Tablero del operador de nodo",
    ac_apply_action: "Aplicar acción (Override)",
    ac_target_type: "Tipo de objetivo",
    ac_target_id: "ID del objetivo (GaiaID o ID del canal)",
    ac_suspend: "Suspensión activa",
    ac_reason: "Motivo oficial",
    ac_btn_apply: "Forzar acción",
    ac_transparency_title: "Registro de consenso y transparencia",
    ac_transparency_desc: "Pruebas de instantáneas visibles públicamente de todos los canales e identidades moderados.",
    ac_btn_snapshot: "Crear instantánea de transparencia",
    search_placeholder: "Buscar correos por asunto, remitente, texto...",
    abuse_center_title: "Centro de abuso",
    abbrechen: "Cancelar",
    active_identities: "Identidades Activas",
    active_identity: "Identidad Activa",
    add_btn: "Agregar",
    add_contact_title: "Añadir contacto",
    admin: "Administrador",
    adressbuch: "Libreta de Direcciones",
    aktiviert: "Activado",
    an: "Para",
    anonymous_sender: "Remitente Anónimo",
    antworten: "Responder",
    attachment_gaia_hint: "Los archivos adjuntos de GaiaCOM permanecen cifrados de extremo a extremo.",
    attachment_smtp_hint: "SMTP heredado bloquea archivos adjuntos ejecutables/tipo script y guarda los correos electrónicos como inseguros.",
    attachments: "Adjuntos",
    auffaellig: "Llamativo",
    auth_beta_notice: "Fase beta: GaiaCOM se está probando activamente. Pueden aparecer errores; guarda tus seeds importantes y verifica con cuidado los flujos sensibles.",
    auth_btn_login: "Cargar Identidad e Iniciar Sesión",
    auth_btn_register: "Registrarse y Crear Cripto",
    auth_copied: "Copiado",
    auth_copy_seed: "Copiar semilla",
    auth_generate_seed: "Generar semilla",
    auth_headline: "GaiaCOM es el primer protocolo de correo electrónico y sistema de comunicación seguro frente a la computación cuántica, creado para la humanidad.",
    auth_kicker: "Comunicación segura poscuántica",
    auth_mnemonic: "Frase mnemónica",
    auth_mnemonic_placeholder: "12 palabras separadas por espacios...",
    auth_password: "Contraseña",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "Las claves privadas nunca salen de su dispositivo. Solo los destinatarios previstos pueden descifrar el contenido.",
    auth_proof_gaiadata_desc: "Zero-Knowledge: usted mantiene el control de sus datos. Los metadatos se minimizan y no se convierten en un perfil en texto claro.",
    auth_proof_gaiadrop_desc: "Personas externas pueden enviar avisos de texto confidenciales a su GaiaID sin tener una cuenta.",
    auth_proof_gaiaproof_desc: "Las pruebas de entrega e integridad muestran que el texto cifrado, el remitente y la marca temporal no fueron manipulados.",
    auth_proof_gaiavault_desc: "Las notas privadas, las pistas de recuperación y los registros de seguridad permanecen cifrados localmente.",
    auth_proof_hybrid_desc: "Quantum Shield: el cifrado híbrido con ML-KEM y X25519 protege frente a ataques actuales y al riesgo de guardar ahora y descifrar después.",
    auth_secure_mail: "Correo Federado Cuántico Seguro",
    auth_subline: "GaiaCOM es un sistema de comunicación resistente a la computación cuántica para correo, chat, salas de crisis, GaiaDrop y registros locales de seguridad. Las claves privadas permanecen en su dispositivo, el contenido se cifra de extremo a extremo y las pruebas pueden exportarse sin revelar texto claro.",
    auth_success_btn: "Iniciar Sesión Ahora",
    auth_success_text: "Su cuenta de GaiaCOM ha sido creada. Las claves se derivaron localmente de su semilla y no se almacenaron en el servidor.",
    auth_success_title: "Registro Exitoso",
    auth_tab_drop: "GaiaDrop",
    auth_tab_login: "Inicio de sesión / cuenta",
    auth_toggle_login: "Ya tengo una cuenta",
    auth_toggle_register: "Crear nueva cuenta",
    auth_usecase_text: "Diseñado para abogados, empresas, organismos, periodistas, informantes y casos privados de seguridad.",
    auth_usecase_title: "Creado para comunicación sensible",
    auth_username: "Nombre de usuario",
    auth_username_placeholder: "Ingrese el nombre...",
    auth_value_chat: "Chat E2E",
    auth_value_drop: "Secure Drop",
    auth_value_mail: "Correo seguro",
    auth_value_rooms: "GaiaRooms",
    bestaetigen: "Confirmar",
    bestaetigt: "Confirmado",
    bio_status: "Biografía / Estado",
    biography: "Biografía",
    change_password_desc: "Cambia tu contraseña de inicio de sesión en el servidor. Tu frase de recuperación local permanece guardada por separado protegida por tu contraseña de Vault/Unlock.",
    change_password_menu_desc: "Actualice la contraseña de inicio de sesión de GaiaCOM.",
    change_password_title: "Cambiar Contraseña",
    channel_id: "ID de canal",
    channel_name_label: "Nombre del canal",
    chat_deleted_hidden: "Chat eliminado y oculto.",
    chat_input_placeholder: "Introduce mensaje seguro...",
    chat_start_hint: "¡Comienza la conversación! Todos los mensajes de chat están cifrados E2E de forma cuántica segura.",
    choose_avatar: "Elegir Avatar",
    ciphertext_hash: "Hash del texto cifrado",
    clear_chat: "charla vacía",
    clear_for_everyone: "Vacio para todos",
    clear_for_me: "Vacio solo para mi",
    click_to_write_mail: "Haz clic para escribir un correo",
    click_top_right: "Haz clic arriba a la derecha en",
    close: "Cerrar",
    code_kopieren: "Copiar Código",
    code_kopieren_success: "Código copiado",
    confirm_clear_channel_desc: "¿Quieres borrar este canal de tu vista local?",
    confirm_clear_channel_title: "canal vacio",
    confirm_clear_chat: "¿Quieres vaciar este chat?",
    confirm_clear_chat_desc: "¿Quieres vaciar este chat?",
    confirm_clear_chat_title: "charla vacía",
    confirm_clear_everyone: "¿Quieres vaciar este chat para ambos? (OK = Para todos, Cancelar = Solo para mí)",
    confirm_delete_everyone: "¿Quieres borrar este mensaje para ambos? (OK = Para todos, Cancelar = Solo para mí)",
    confirm_delete_msg: "¿Quieres borrar este mensaje?",
    confirm_delete_msg_desc: "¿Quieres eliminar este mensaje de chat?",
    confirm_delete_msg_title: "Eliminar mensaje",
    confirm_new_password: "Confirmar Nueva Contraseña",
    copy: "Copiar",
    create_btn: "Crear",
    create_channel_title: "Crear canal",
    create_group_is_crisis: "Marcar como zona de crisis",
    create_group_title: "Crear nuevo grupo",
    crypto_lock_desc: "Controla cuándo GaiaCOM elimina las claves criptográficas locales de la memoria.",
    crypto_lock_menu_desc: "Controla los temporizadores de recarga e inactividad.",
    crypto_lock_title: "Bloqueo criptográfico",
    crypto_session_duration: "Desbloqueado después de recargar",
    crypto_session_duration_desc: "Solo mantiene abierta la sesión criptográfica en esta pestaña del navegador durante el tiempo seleccionado.",
    cryptographic_fingerprint: "Huella criptográfica",
    current_password: "Contraseña Actual",
    data_minimization: "Minimización de datos",
    decrypt_failed: "No descifrable",
    delete: "Borrar",
    delete_account_button: "Eliminar cuenta irrevocablemente",
    delete_account_confirm_label: "Ingrese BORRAR para confirmar",
    delete_account_confirmation_error: "Se requiere contraseña y confirmación de BORRAR.",
    delete_account_desc: "Este modo destruye permanentemente su cuenta, identidades, sesiones de dispositivo, datos de GaiaDrop, metadatos de carga y mensajes atribuibles del lado del servidor.",
    delete_account_done_desc: "Se han eliminado todos los datos asignables de GaiaCOM.",
    delete_account_done_title: "Cuenta eliminada",
    delete_account_menu_desc: "Destruir cuenta y datos asociados.",
    delete_account_not_authenticated: "Ninguna cuenta activa.",
    delete_account_title: "Eliminar cuenta",
    delete_for_everyone: "Eliminar para todos",
    delete_for_me: "Eliminar solo para mi",
    device_current: "este dispositivo",
    device_last_seen: "Último",
    device_logout: "Finalizar la sesión",
    device_sessions_desc: "Verifique las sesiones activas y cancele el registro de dispositivos en los que ya no confía.",
    device_sessions_empty: "No se encontraron dispositivos.",
    device_sessions_menu_desc: "Administrar y finalizar sesiones activas.",
    device_sessions_title: "Dispositivos registrados",
    device_since: "Desde",
    display_name: "Nombre de Mostrar",
    drop_address_copied: "Dirección de GaiaDrop copiada.",
    drop_btn_decrypting: "Descifrando buzón...",
    drop_btn_load: "Cargar GaiaDrop Inbox",
    drop_delete_desc: "¿Realmente deseas eliminar permanentemente este drop?",
    drop_delete_title: "Eliminar GaiaDrop",
    drop_desc: "Canal de entrega anónimo de texto sin conocimiento previo para pistas externas, revelación responsable e informes confidenciales. Usuarios externos pueden enviar mensajes a tu GaiaID sin cuenta.",
    drop_empty: "No hay mensajes de GaiaDrop cargados aún.",
    drop_id: "ID del Drop:",
    drop_own_address: "Tu dirección de GaiaDrop",
    drop_proof: "DROP PROOF",
    drop_title: "Buzón Seguro GaiaDrop",
    dunkler_modus: " Modo Oscuro",
    e2e_chat_room_open: "Abrir sala de chat E2E",
    edit_profile: "Editar Perfil",
    edit_profile_desc: "Personaliza el nombre para mostrar, la biografía y el avatar.",
    einladungscode: "Código de Invitación",
    enter_fingerprint_chars_confirm: "Ingrese los caracteres de huellas digitales solicitados para confirmar.",
    envelope_hash: "Hash del sobre",
    erasability: "Eliminabilidad",
    erfolg: "Éxito",
    exclude_plaintext: "Exportar sin texto plano",
    export_disclosure: "Exportar caso de seguridad",
    export_package_desc: "Solo incluya texto sin formato si esta divulgación es intencional.",
    export_package_title: "Paquete de seguridad de exportación",
    fehler: "Error",
    gaiacom_reader: "Lector GaiaCOM",
    gaiadrop_inbox_title: "Bandeja de entrada de GaiaDrop",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM minimiza los metadatos, mantiene las claves privadas locales, cifra el contenido de un extremo a otro y permite la eliminación completa de la cuenta.",
    gdpr_home_title: "100% compatible con el RGPD",
    gdpr_reason_delete: "La eliminación de cuentas elimina cuentas, identidades, sesiones locales y datos asignables del lado del servidor.",
    gdpr_reason_e2ee: "El contenido privado sigue siendo descifrable sólo para los destinatarios previstos.",
    gdpr_reason_minimal: "Los metadatos solo se utilizan para credenciales de enrutamiento, entrega y seguridad.",
    gdpr_reason_zero_knowledge: "Las claves privadas y los datos de recuperación permanecen localmente bajo el control del usuario.",
    gesendet: "Enviados",
    gesperrt_verdaechtig: "Bloqueado / Sospechoso",
    group_delete_desc: "¿Realmente deseas eliminar permanentemente este grupo? Se eliminarán todos los canales y mensajes de este grupo.",
    group_delete_title: "Eliminar grupo",
    group_description: "Descripción",
    group_icon_label: "Icono de grupo/avatar",
    group_name: "Nombre del grupo",
    group_settings_avatar: "Avatar",
    group_settings_desc: "Descripción",
    group_settings_is_crisis: "Marcar como zona de crisis",
    group_settings_name: "Nombre de Grupo",
    group_settings_title: "Configuración de Grupo",
    groups_empty_desc: "Cree un espacio de trabajo seguro para proyectos, crisis o comunicación de equipo.",
    groups_empty_title: "Aún no hay chats grupales",
    gruppe_beitreten: "Grupo Unido",
    gruppe_erstellen: "+ Crear Grupo",
    gruppe_verlassen: "Salir del Grupo",
    gruppen_chats: "Chats de Grupo",
    heller_modus: " Modo Claro",
    how_to_receive_drops: "¿Cómo recibo Drops?",
    identitaets_assistent: "Asistente de Identidad",
    inactivity_lock_duration: "Bloquear cuando esté inactivo",
    inactivity_lock_duration_desc: "Después de este período sin entrada, GaiaCOM se bloqueará criptográficamente automáticamente.",
    inactivity_lock_notice: "GaiaCOM ha sido bloqueado criptográficamente debido a inactividad.",
    include_plaintext: "Incluir texto sin formato",
    invite_code_label: "Código de invitación",
    join_group_title: "Unirse al grupo",
    kanaele: "Canales",
    kanal_erstellen: "+ Canal",
    kein_chat_ausgewaehlt: "Ningún chat seleccionado",
    kein_kanal_ausgewaehlt: "Ningún canal seleccionado",
    keine_gruppe_ausgewaehlt: "Ningún grupo seleccionado",
    keine_mails: "No hay correos disponibles.",
    key_change_warn_desc: "La clave pública de este contacto ha cambiado. Verifique la huella digital antes de confiar en ella.",
    key_change_warn_title: "Advertencia criptográfica",
    key_change_warning_changed: "ha cambiado. ¡Esto puede ser una señal de un ataque de intermediario!",
    key_change_warning_msg: "La clave de identidad para el contacto",
    key_transparency: "Transparencia de claves (Historial de claves)",
    kopiert: "Copiado",
    kryptographische_schluessel: "Llaves Criptográficas",
    kryptographische_schluessel_desc: "Muestra claves privadas y frase inicial de respaldo.",
    laden: "Cargando...",
    leeren: "Vacío",
    loading: "Carga...",
    local_key_vault: "Almacén de claves local",
    local_keys_label: "Claves locales",
    lock_on_reload: "Bloquear siempre después de recargar",
    logout: "Cerrar sesión",
    mail_compose: "Escribir correo",
    mein_profil: "Mi Perfil",
    melden: "Reportar",
    menu: "Menú",
    message: "Noticias",
    message_id: "ID del mensaje",
    message_pin: "Alfiler",
    message_pinned_title: "Mensajes fijados",
    message_react: "Reaccionar",
    message_reply: "Respuesta",
    message_replying_to: "Responder a",
    message_save: "Ahorrar",
    message_saved: "Guardado",
    message_to_channel: "Mensaje para",
    message_unpin: "Resolver",
    message_unsave: "no guardar",
    mitglied: "Miembro",
    mitglieder: "Miembros",
    ml_kem: "ML-KEM",
    neue_mail: "Nuevo correo electrónico",
    never_auto_lock: "Nunca automáticamente",
    new_fingerprint: "Nueva huella digital",
    new_identity: "Nueva Identidad",
    new_password: "Nueva Contraseña",
    no_description: "Sin descripción",
    no_key_history: "No hay historial de claves registrado.",
    no_specification: "Sin especificar",
    old_fingerprint: "huella digital antigua",
    open_privacy_imprint: "Impresión abierta y protección de datos",
    post_quantum_e2e: "E2E Post-Cuántico",
    posteingang: "Bandeja de entrada",
    powered_by: "Desarrollado por",
    privacy_imprint_menu_desc: "Mostrar RGPD, protección de datos y aviso legal.",
    privacy_imprint_profile_desc: "GaiaCOM procesa el contenido de las comunicaciones de acuerdo con los principios de minimización de datos, cifrado de extremo a extremo y control de claves local.",
    privacy_imprint_title: "Protección de datos y aviso legal",
    profil: "Perfil",
    profile_details: "Detalles del Perfil",
    profile_settings_hint: "La configuración del perfil se muestra en el panel derecho.",
    profile_unlock_desc: "Por razones de seguridad, debes ingresar tu contraseña nuevamente para ver tus llaves criptográficas privadas.",
    proof_hash: "Hash de prueba:",
    public_drop_desc: "Secure Drop para avisos externos de solo texto sin cuenta GaiaCOM.",
    public_drop_message: "Mensaje",
    public_drop_message_placeholder: "Introduzca texto confidencial...",
    public_drop_send: "Enviar GaiaDrop",
    public_drop_sender: "Nota opcional del remitente",
    public_drop_sender_placeholder: "Nombre, número de caso o anónimo",
    public_drop_target: "GaiaID de destino",
    quanten_chat: "Chat Cuántico",
    quantum_secure_exchange: "Intercambio cuántico-seguro a través de...",
    quantum_secure_net: "Red cuántico-segura GaiaCOM (Ed25519 y ML-KEM)",
    quantum_shield_desc: "La red GaiaCOM protege su privacidad con un protocolo de cifrado híbrido multicapa seguro contra ataques de futuros ordenadores cuánticos.",
    quantum_shield_l1_desc: "Utiliza el estándar FIPS 203 para encapsular una clave compartida simétrica. Evita la escucha pasiva y el descifrado posterior (\\\\\\",
    quantum_shield_l1_title: "1. Protección Post-Cuántica (ML-KEM-1024)",
    quantum_shield_l2_desc: "Un método de intercambio de claves Diffie-Hellman clásico y ultrarrápido que sirve como capa de seguridad adicional en el esquema híbrido.",
    quantum_shield_l2_title: "2. Criptografía de Curva Elíptica (X25519)",
    quantum_shield_l3_desc: "Cada mensaje y sobre de federación está firmado criptográficamente para verificar la autenticidad del remitente fuera de toda duda.",
    quantum_shield_l3_title: "3. Firmas Digitales (Ed25519)",
    quantum_shield_l4_desc: "Cifra el contenido del mensaje de forma simétrica y une estrechamente al remitente, destinatario y metadatos en los Datos Adicionales Autenticados (AAD) para evitar ataques de reproducción.",
    quantum_shield_l4_title: "4. Autenticación AAD (AES-256-GCM)",
    quantum_shield_status: " Estado del Quantum Shield",
    receive_drops_step1: "Comparte tu GaiaID (por ejemplo, con el botón copiar de arriba) con fuentes externas.",
    receive_drops_step2: "Ellos abren la página de inicio de sesión de tu instancia de GaiaCOM, cambian a la pestaña",
    receive_drops_step3: "y envían su mensaje cifrado a tu dirección allí.",
    receiver_gaia: "Receptor GaiaCOM",
    receiver_smtp: "Destinatario SMTP",
    records_stored: "Registros guardados",
    refresh: "Actualizar",
    report_abuse_desc: "¿Quiere denunciar este mensaje y enviar evidencia criptográfica de abuso al servidor?",
    report_abuse_title: "Informar abuso",
    reputation_status: "Estado de reputación",
    room_chat_start_hint: "¡Comienza la conversación! Todos los mensajes en este canal de grupo están cifrados E2E de forma descentralizada y segura contra cuántica.",
    room_policy_audit: "Seguimiento de auditoría y rotación de claves activa.",
    room_policy_crisis: "sala de crisis",
    room_policy_e2ee: "Espacio de conocimiento cero. Caja fuerte cuántica E2EE.",
    room_policy_title: "Pautas de la habitación",
    room_policy_zero_knowledge: "Política",
    room_security_note_desc: "Todos los cambios clave se validan a través de Key Transparency. Utilice GaiaVault para registros de respaldo privados.",
    room_security_note_title: "Nota de seguridad fijada",
    save_profile: "Guardar Perfil",
    schluessel_entsperrt: "🔑 Bloquear llaves de nuevo",
    search_gaia_label: "Encuentra la dirección de Gaia",
    security_warning_title: "Advertencia de seguridad",
    select_channel_chat: "Selecciona un canal de la barra lateral izquierda para chatear.",
    select_contact_chat: "Selecciona un contacto del panel izquierdo para iniciar un chat E2E seguro cuántico.",
    select_mail_read: "Selecciona un correo de la lista para leer sus contenidos cuántico-seguros, o crea un mensaje nuevo.",
    senden: "Enviar",
    sender_signature: "Firma del remitente",
    server_log: "Log del servidor:",
    server_received: "Recibido por el servidor",
    session_lock: "Bloqueo de sesión",
    setup_address_keys: "Crear dirección y llaves",
    setup_profile: "Configurar en el Perfil",
    smtp_inbox_title: "Recepción SMTP",
    smtp_legacy_badge: "SMTP heredado/inseguro",
    smtp_mode_option: "Puente SMTP heredado",
    smtp_security_warning: "Este correo fue transmitido a través del protocolo clásico SMTP sin cifrar. El cifrado de extremo a extremo no está activo.",
    smtp_security_warning_desc: "Este mensaje sale de la sala de seguridad de GaiaCom. La entrega SMTP no proporciona garantía nativa de extremo a extremo de GaiaCom, ni garantía TrustMesh ni garantía Godmode desde la puerta de enlace.",
    spam_verdacht: "Spam/Sospecha",
    spam_warning_desc: "Este mensaje tiene señales de reputación sospechosas.",
    spam_warning_title: "Advertencia de spam",
    speichern: "Guardar",
    sperren: "Bloquear",
    standard_group_status: "Chat grupal estándar (cifrado E2EE)",
    status: "estado",
    subject: "Acerca de",
    suchen: "Buscar dirección Gaia...",
    tage: "Días",
    time_unknown: "Hora desconocida",
    transmission_mode: "Modo de transferencia",
    trust_age: "Edad de confianza",
    trust_passport_title: "Pasaporte de confianza",
    unbestaetigt: "No confirmado",
    unknown_sender: "Desconocido",
    unlock_btn: "Desbloquear",
    unlock_btn_profile: "Desbloquear",
    unlock_desc: "Su archivo de clave privada está almacenado de forma encriptada. Ingrese su contraseña para cargar las claves criptográficas solo en la memoria RAM.",
    unlock_logout: "Cerrar sesión y cerrar claves locales",
    unlock_title: "Desbloquear Identidad",
    untrusted: "No verificado",
    update_password: "Actualizar Contraseña",
    upload_avatar_btn: "Subir imagen (Desinfectada)",
    vault_btn_encrypt: "Encriptar Registro",
    vault_btn_lock: "Bloquear Caja Fuerte",
    vault_btn_unlock: "Desbloquear Caja Fuerte",
    vault_copied_success: "Copiado al portapapeles",
    vault_decrypted_content: "Contenido descifrado",
    vault_desc: "Caja fuerte encriptada local para copias de seguridad de recuperación, notas de identidad, credenciales de servidor, contactos de emergencia, notas legales, eventos de seguridad y registros privados.",
    vault_empty: "No hay registros seguros guardados aún.",
    vault_locked_pane_notice: "El baúl está bloqueado. Por favor, desbloquéalo a la derecha.",
    vault_new_record: "Nuevo registro seguro",
    vault_pwd_placeholder: "Introduce la contraseña de la caja fuerte...",
    vault_record_body: "Grabar contenido",
    vault_record_body_placeholder: "Introduce el contenido encriptado del registro...",
    vault_record_category: "categoría",
    vault_record_title: "Título del registro",
    vault_record_title_placeholder: "Título del registro",
    vault_title: "Caja Fuerte GaiaVault Secure Records",
    verify_new_fingerprint_hint: "Verifique la nueva huella digital antes de aceptar la clave.",
    vertrauenswuerdig: "Confiable",
    vision_gaia_technology: "VisionGaiaTechnology",
    von: "De",
    warnung: "Advertencia",
    wizard_address: "Dirección",
    wizard_back: "Atrás",
    wizard_check1: "He guardado de forma segura mi frase semilla.",
    wizard_custom_domain: "Usar dominio personalizado",
    wizard_desc1: "GaiaCOM no almacena claves privadas en el servidor. Sin la semilla mnemónica, nadie puede recuperar mensajes perdidos.",
    wizard_desc2: "Su dirección determina el nodo federado a través del cual se enrutan los sobres cifrados.",
    wizard_fallback: "Nodos de Respaldo",
    wizard_finish: "Finalizar Configuración",
    wizard_next: "Siguiente",
    wizard_server_domain: "Dominio del nodo del servidor",
    wizard_step1: "1. Copia de Semilla",
    wizard_step2: "2. Dirección y Servidor",
    wizard_title1: "Asegurar Claves de Recuperación",
    wizard_title2: "Seleccionar Dirección GaiaCOM",
    write_message_placeholder: "Escribe un mensaje seguro...",
    you: "Tú",
    zero_knowledge: "Conocimiento cero",
    zero_knowledge_encryption: "Cifrado de conocimiento cero",
    "Chat fuer alle geleert": "El chat se ha vaciado para todos los participantes.",
    "Chat geleert": "El chat se ha borrado de tu bandeja de entrada local.",
    "Nachricht fuer alle geloescht": "El mensaje ha sido eliminado para todos los participantes.",
    "Nachricht geloescht": "El mensaje de chat se eliminó localmente de su bandeja de entrada.",
    "anpinnen": "Alfiler",
    "chat_loeschen": "Eliminar chat",
    "confirm_delete_chat_desc": "¿Estás seguro de que deseas eliminar y ocultar el chat?",
    "confirm_leave_group_desc": "¿De verdad quieres dejar este grupo?",
    "entpinnen": "Desprender",
    "group_deleted": "Grupo eliminado exitosamente.",
    "group_left": "Abandona el grupo con éxito.",
    "gruppe_loeschen": "Eliminar grupo",
    "loeschen": "Borrar",
    "no_active_chats": "No hay chats activos. Busque contactos arriba para iniciar un chat.",
    "pinned": "Fijado",
    "wizard_check_credentials": "Soy responsable de mantener seguros mis datos de acceso.",
    "wizard_check_is_beta": "Entiendo que GaiaCom es un software beta.",
    "wizard_check_no_illegal": "No utilizaré GaiaCom con fines ilegales.",
    "wizard_check_no_uptime": "Entiendo que no hay garantía de disponibilidad.",
    "wizard_check_smtp_security": "Entiendo que los mensajes SMTP no brindan seguridad total a GaiaCom.",
    "wizard_check_terms_read": "He leído los Términos de servicio Beta.",
    "wizard_step_terms": "Condiciones de uso",
    "wizard_terms_text": "Términos de uso de GaiaCom y acuerdo de prueba beta (fase beta)\n\nProveedor: VisionGaiaTechnology (en adelante, “Proveedor”)\nEstado: fase de prueba beta pública\nVigencia: A partir del 21 de junio de 2026\n\n⚠️ LA NOTA MÁS IMPORTANTE POR ADELANTADO (LEA ATENTAMENTE)\nGaiaCom se encuentra en una fase de prueba beta pública. A pesar de las amplias medidas de seguridad, no se puede garantizar la ausencia de errores, la disponibilidad continua o la seguridad absoluta del software y de la infraestructura subyacente. Úselo bajo su propio riesgo. Los usuarios son responsables del almacenamiento seguro de sus datos de acceso (especialmente las claves de GaiaVault) y del cumplimiento de las leyes aplicables.\n\n1. Objeto y finalidad de la fase de prueba beta\n1.1. Finalidad de la prestación: GaiaCom es un novedoso servicio de correo electrónico y chat basado en criptografía poscuántica (PQC). La provisión durante la fase beta está destinada exclusivamente a pruebas técnicas, simulación de carga, búsqueda de errores del programa (bugs) y optimización de la facilidad de uso.\n1.2. Estado Beta: El usuario es consciente de que el software ofrecido es una versión preliminar (software beta). Esto aún no está completamente desarrollado técnicamente, no cumple con el estándar de un producto comercial final y puede causar errores, pérdida de datos, retrasos en la transmisión o fallas del sistema.\n1.3. Sin derecho de continuación: El proveedor tiene derecho en cualquier momento a interrumpir total o parcialmente el servicio, a cambiar o restringir funciones o a eliminarlas temporal o definitivamente sin necesidad de indicar los motivos.\n\n2. Disponibilidad y exención de responsabilidad de garantía\n2.1. Sin garantía de disponibilidad: GaiaCom se proporciona sin ninguna garantía de disponibilidad o tiempo de actividad. No existe ningún derecho a la disponibilidad ininterrumpida del servicio.\n2.2. Exclusión de garantía: El software se proporciona en su estado actual (“tal cual”) y sujeto a disponibilidad. En la medida en que lo permita la ley, quedan excluidos todos los derechos de garantía por defectos materiales y legales del software. En particular, no hay garantía de que el software esté libre de errores, de malware o de que sea adecuado para un propósito particular.\n\n3. Gestión de riesgos y obligaciones de los usuarios\n3.1. Prohibición de almacenamiento de datos críticos: El usuario se compromete a no almacenar ni transmitir exclusivamente a través de GaiaCom ningún dato crítico para el negocio, vital, operativamente necesario o legalmente particularmente sensible (como archivos de pacientes, datos financieros altamente sensibles o secretos regulados oficialmente). El servicio no se puede utilizar para infraestructura donde fallas imprevistas podrían provocar lesiones personales, daños a la propiedad o pérdidas financieras significativas.\n3.2. Copia de seguridad autorresponsable: El usuario es responsable de realizar una copia de seguridad de todos los datos recibidos o enviados a través de GaiaCom que necesite a largo plazo en sus propios sistemas independientes (copias de seguridad). El proveedor no garantiza el almacenamiento permanente ni la capacidad de restauración de los datos en sus servidores.\n\n4. Funciones criptográficas y GaiaVault\n4.1. Criptografía poscuántica (PQC): GaiaCom implementa procesos de cifrado de última generación orientados al futuro y diseñados para resistir ataques de futuras computadoras cuánticas. Sin embargo, el usuario es consciente de que se trata de un campo científico dinámico y nuevo. No se puede garantizar una seguridad absoluta e irrefutable basándose en el estado actual de la ciencia y la tecnología. Términos como “100% seguro”, “indescifrable” o “militarmente seguro” no están garantizados expresamente.\n4.2. Sin garantía de recuperación (GaiaVault): GaiaCom se basa en un concepto de seguridad consistente de conocimiento cero. Las cuñas de cifrado y los datos de acceso permanecen únicamente bajo el control del usuario (protegidos a través de GaiaVault).\nIMPORTANTE: Si el usuario pierde sus contraseñas, frases de contraseña, claves privadas o semillas de recuperación, el proveedor no tiene capacidad técnica para reconstruir o restablecer estos datos. La pérdida de estos datos de acceso conduce inevitablemente a la pérdida irrevocable del acceso a la cuenta de usuario y a todos los datos cifrados en ella.\n4.3. Aún no completamente auditado: el software está sujeto continuamente a controles de seguridad internos, pero en el momento de esta fase beta aún no se ha sometido a una auditoría de seguridad externa completa y final por parte de organismos de prueba independientes.\n\n5. Interfaces, protocolos heredados y federación\n5.1. Nota sobre el puente SMTP: GaiaCom ofrece la posibilidad de comunicarse a través de protocolos de correo electrónico clásicos (como SMTP). El usuario es consciente de que los mensajes que salen del área de seguridad nativa de GaiaCom (por ejemplo, cuando se envían a una dirección convencional @gmail.com o @gmx.de) se transportan a través de servidores no cifrados o de terceros. Las garantías de seguridad de extremo a extremo de GaiaCom se aplican solo de forma limitada o no se aplican en absoluto a dichos mensajes heredados salientes o entrantes externos.\n5.2. Nota sobre la federación: si GaiaCom opera en una red federada, los mensajes y los datos pueden pasar a través de servidores de terceros. Si bien el contenido de los mensajes permanece protegido mediante cifrado de extremo a extremo, los metadatos (como la hora de envío, las direcciones IP de los servidores involucrados y las direcciones de los destinatarios) pueden ser técnicamente visibles para los operadores de estos servidores federados. El proveedor no tiene influencia sobre las prácticas de protección de datos de terceros operadores de servidores en la red federada.\n\n6. Usos Aceptables y Actividades Prohibidas\nEl usuario se compromete a no utilizar el servicio de forma indebida o con fines ilícitos. En particular, quedan prohibidos:\n- Distribuir, enviar o alojar virus, malware, contenido de phishing u otro software malicioso.\n- Usar el Servicio para realizar ataques de denegación de servicio (DDoS) o envíos masivos de correo no solicitado (spam).\n- Abusar del sistema para cometer fraude.\n- La distribución o intercambio de contenido ilegal, en particular representaciones de abuso sexual infantil (CSAM), propaganda terrorista, llamados a la violencia u otro contenido criminalmente relevante.\n\n7. Sistema de denuncia de abusos\n7.1. Denunciar comportamientos abusivos: los usuarios tienen la oportunidad de denunciar comunicaciones abusivas o actividades ilegales a través del sistema de abuso integrado.\n7.2. Procesamiento de informes: para garantizar la protección contra el uso indebido, los informes entrantes se pueden analizar técnicamente (manteniendo los límites de privacidad y cifrado). Esto puede dar lugar a la suspensión temporal o permanente de cuentas de usuario o direcciones IP en caso de violaciones comprobadas de estos términos de uso.\n\n8. Limitación de responsabilidad\n8.1. Estándar de responsabilidad: El software beta se proporciona de forma gratuita. Por lo tanto, según las normas legales sobre donaciones o préstamos, el proveedor sólo es responsable de dolo (daño intencionado) y negligencia grave.\n8.2. Exclusión de responsabilidad por pérdida de datos: Se excluye la responsabilidad por la pérdida de datos a menos que la pérdida haya sido causada intencionalmente o por negligencia grave por parte del proveedor y el usuario haya cumplido con su obligación de mitigar el daño mediante copias de seguridad periódicas (fuera de GaiaCom).\n8.3. Límites legales: Las limitaciones de responsabilidad anteriores no se aplican a lesiones a la vida, el cuerpo o la salud ni a la responsabilidad según la Ley de Responsabilidad del Producto.\n\n9. Código abierto\nCiertos componentes, bibliotecas o aplicaciones cliente de GaiaCom pueden tener licencias de código abierto (por ejemplo, GPL, MIT, Apache). Los términos de licencia respectivos de estos componentes no se ven afectados por estos términos de uso y pueden verse en los repositorios de código fuente correspondientes.\n\n10. Control y cumplimiento de las exportaciones\nEl usuario es consciente de que el software criptográfico puede estar sujeto a estrictos controles de exportación y restricciones legales. El usuario es responsable de garantizar que el uso de GaiaCom no viole las leyes, restricciones de importación/exportación o regulaciones de criptografía de su respectivo país de residencia.\n\n11. Aviso de protección de datos (versión corta para la beta)\n11.1. Recopilación mínima de datos: como parte de la fase beta, el proveedor solo recopila los datos que son absolutamente necesarios para el funcionamiento técnico, la resolución de problemas y el desarrollo posterior (por ejemplo, archivos de registro del servidor para el diagnóstico de errores).\n11.2. Sin información sobre el contenido: gracias al constante conocimiento cero y al cifrado E2E, el proveedor nunca tiene acceso al contenido de sus chats, correos electrónicos o claves almacenadas en GaiaVault.\n11.3. Declaración detallada de protección de datos: Las normas detalladas de protección de datos están vinculadas por separado y también deben ser tenidas en cuenta por el usuario antes de registrarse.\n\n12. Disposiciones finales\n12.1. Ley aplicable: Se aplica la ley de la República Federal de Alemania, excluyendo la Convención de las Naciones Unidas sobre los Contratos de Compraventa Internacional de Mercaderías.\n12.2. Sujeto a cambios: Dado que GaiaCom se encuentra en desarrollo activo, el proveedor se reserva el derecho de adaptar estas condiciones en cualquier momento con efecto para el futuro. La versión actual está disponible en la aplicación.",
    "wizard_terms_title": "Términos de uso de GaiaCom y acuerdo de prueba beta (fase beta)",
    "node_operator": "Operador de nodo",
    "search_channels": "Buscar canales...",
    "senior_reviewer": "Revisor sénior",
    "trusted_reviewer": "Revisor confiable",
    "active_frequencies": "Frecuencias activas",
    "connected_rooms": "ESPACIOS CONECTADOS",
    "dashboard": "Panel",
    "empty_chats": "No hay chats activos disponibles.",
    "empty_messages": "No hay mensajes nuevos disponibles.",
    "encrypted": "cifrado",
    "gaiacom_uplink": "ENLACE ARRIBA GAIACOM",
    "install_app": "Instalar aplicación",
    "install_app_desc": "Para inicio rápido y modo fuera de línea",
    "kommandozentrale_alpha": "Centro de mando ALFA",
    "network_online": "RED: EN LÍNEA",
    "new_room": "Nuevo espacio",
    "no_frequencies_active": "No hay frecuencias activas. Crea una nueva sala para iniciar la comunicación.",
    "no_id": "Sin identificación",
    "open_chats": "abrir chats",
    "open_inbox": "Abrir bandeja de entrada",
    "primary_identity": "IDENTIDAD PRIMARIA",
    "recent_chats": "Nuevos chats",
    "recent_messages": "Últimas noticias",
    "session_encrypted": "Sesión cifrada: {nombre}",
    "session_secure": "ESTADO: SEGURO",
    "system_verlassen": "Sistema de salida",
    "write_message": "Escribe un mensaje",
  },
  fr: {
    sc_title: "Centre de sécurité",
    sc_subtitle: "Couche de sécurité intégrée GaiaShield",
    sc_tab_status: "🛡️ État de protection",
    sc_tab_events: "📋 Log de sécurité",
    sc_tab_node: "⚙️ Sécurité du nœud",
    sc_loading: "Chargement des données de sécurité...",
    sc_status_secured: "Statut du système : Compte protégé",
    sc_status_warning: "Statut du système : Avertissements actifs",
    sc_desc_secured: "Il n'y a pas d'avertissements de sécurité critiques actifs. GaiaShield surveille activement votre compte.",
    sc_desc_warning: "Attention : Il y a des événements de sécurité actifs qui nécessitent votre attention.",
    sc_account_protection: "Protection du compte",
    sc_message_protection: "Protection des messages",
    sc_audits: "Audits de sécurité",
    sc_active: "ACTIF",
    sc_failed_logins: "Connexions échouées",
    sc_tamper_checks: "Contrôles d'intégrité",
    sc_blocked_replays: "Replays bloqués",
    sc_last_check: "Dernier contrôle",
    sc_just_now: "À l'instant",
    sc_open_warnings: "Avertissements ouverts",
    sc_btn_acknowledge: "Confirmer",
    sc_filter_severity: "Gravité",
    sc_filter_category: "Catégorie",
    sc_filter_hide_ack: "Masquer confirmés",
    sc_btn_export: "Exporter",
    sc_col_details: "Détails",
    sc_col_time: "Heure",
    sc_col_status: "Statut",
    sc_col_action: "Action",
    sc_no_events: "Aucun événement de sécurité trouvé.",
    sc_node_title: "Console de sécurité de l'opérateur de nœud",
    sc_system_health: "Santé du système",
    sc_last_audit: "Dernier audit",
    sc_packed_logs: "Logs archivés",
    sc_unconfirmed_events: "Événements non confirmés",
    sc_operator_action: "Action de l'opérateur requise",
    sc_all_ok: "Tout va bien",
    sc_critical_events: "Événements système critiques",
    ac_title: "Centre de gouvernance et de signalement",
    ac_subtitle: "Consensus de gouvernance et d'abus GaiaCom",
    ac_tab_my_reports: "Mes signalements",
    ac_tab_queue: "File de révision",
    ac_tab_operator: "Opérateur de nœud",
    ac_tab_transparency: "Fédération et transparence",
    ac_loading: "Chargement des données...",
    ac_reported_cases: "Cas signalés",
    ac_no_reports: "Vous n'avez pas encore envoyé de signalement.",
    ac_case_details: "Détails du cas",
    ac_appeal_submit: "Faire appel",
    ac_appeal_status: "Statut de l'appel",
    ac_appeal_reason: "Motif de l'appel",
    ac_appeal_statement: "Déclaration",
    ac_btn_appeal: "Envoyer l'appel",
    ac_trusted_reviewer_queue: "File des réviseurs de confiance",
    ac_case_review: "Réviser le cas",
    ac_review_category: "Catégorie recommandée",
    ac_review_severity: "Gravité recommandée",
    ac_review_action: "Action recommandée",
    ac_review_reason: "Motif du réviseur",
    ac_btn_submit_review: "Soumettre la révision",
    ac_node_operator_dashboard: "Tableau de bord de l'opérateur de nœud",
    ac_apply_action: "Appliquer l'action (Ignorer)",
    ac_target_type: "Type de cible",
    ac_target_id: "ID cible (GaiaID ou ID canal)",
    ac_suspend: "Suspension active",
    ac_reason: "Motif officiel",
    ac_btn_apply: "Appliquer la mesure",
    ac_transparency_title: "Journal de consensus et de transparence",
    ac_transparency_desc: "Preuves de clichés visibles par le public de tous les canaux et identités modérés.",
    ac_btn_snapshot: "Créer un cliché de transparence",
    search_placeholder: "Rechercher des e-mails par objet, expéditeur, texte...",
    abuse_center_title: "Centre d'abus",
    abbrechen: "Annuler",
    active_identities: "Identités Actives",
    active_identity: "Identité Active",
    add_btn: "Ajouter",
    add_contact_title: "Ajouter un contact",
    admin: "Admin",
    adressbuch: "Carnet d'Adresses",
    aktiviert: "Activé",
    an: "À",
    anonymous_sender: "Expéditeur Anonyme",
    antworten: "Répondre",
    attachment_gaia_hint: "Les pièces jointes GaiaCOM restent cryptées de bout en bout.",
    attachment_smtp_hint: "L'ancien SMTP bloque les pièces jointes exécutables/de type script et enregistre les e-mails comme non sécurisés.",
    attachments: "Pièces jointes",
    auffaellig: "Suspect",
    auth_beta_notice: "Phase de test bêta : GaiaCOM est testé activement. Des bugs peuvent survenir ; sauvegardez vos seeds importantes et vérifiez soigneusement les usages sensibles.",
    auth_btn_login: "Charger l'identité & Se connecter",
    auth_btn_register: "S'inscrire & Créer la crypto",
    auth_copied: "Copié",
    auth_copy_seed: "Copier la graine",
    auth_generate_seed: "Générer la graine",
    auth_headline: "GaiaCOM est le premier protocole e-mail et système de communication sécurisé face au quantique, conçu pour l’humanité.",
    auth_kicker: "Communication post-quantique sécurisée",
    auth_mnemonic: "Phrase mnémotechnique",
    auth_mnemonic_placeholder: "12 mots séparés par des espaces...",
    auth_password: "Mot de passe",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "Les clés privées ne quittent jamais votre appareil. Seuls les destinataires prévus peuvent déchiffrer le contenu.",
    auth_proof_gaiadata_desc: "Zero-Knowledge : vous gardez le contrôle de vos données. Les métadonnées sont minimisées et ne deviennent pas un profil en clair.",
    auth_proof_gaiadrop_desc: "Des personnes externes peuvent envoyer des signalements confidentiels en texte seul à votre GaiaID sans compte.",
    auth_proof_gaiaproof_desc: "Les preuves de livraison et d’intégrité montrent que le texte chiffré, l’expéditeur et l’horodatage n’ont pas été manipulés.",
    auth_proof_gaiavault_desc: "Les notes privées, les indices de récupération et les dossiers de sécurité restent chiffrés localement.",
    auth_proof_hybrid_desc: "Quantum Shield : le chiffrement hybride avec ML-KEM et X25519 protège contre les attaques actuelles et le risque « stocker maintenant, déchiffrer plus tard ».",
    auth_secure_mail: "Courrier Fédéré Quantique Sécurisé",
    auth_subline: "GaiaCOM est un système de communication résistant au quantique pour le courrier, le chat, les salons de crise, GaiaDrop et les dossiers de sécurité locaux. Les clés privées restent sur votre appareil, le contenu est chiffré de bout en bout et les preuves peuvent être exportées sans révéler le texte clair.",
    auth_success_btn: "Se connecter maintenant",
    auth_success_text: "Votre compte GaiaCOM a été créé. Les clés ont été dérivées localement de votre graine et ne sont pas stockées sur le serveur.",
    auth_success_title: "Inscription réussie",
    auth_tab_drop: "GaiaDrop",
    auth_tab_login: "Connexion / compte",
    auth_toggle_login: "J'ai déjà un compte",
    auth_toggle_register: "Créer un nouveau compte",
    auth_usecase_text: "Adapté aux avocats, entreprises, administrations, journalistes, lanceurs d’alerte et cas de sécurité privés.",
    auth_usecase_title: "Conçu pour les communications sensibles",
    auth_username: "Nom d'utilisateur",
    auth_username_placeholder: "Entrez le nom...",
    auth_value_chat: "Chat E2E",
    auth_value_drop: "Secure Drop",
    auth_value_mail: "Courrier sécurisé",
    auth_value_rooms: "GaiaRooms",
    bestaetigen: "Confirmer",
    bestaetigt: "Confirmé",
    bio_status: "Biographie / Statut",
    biography: "Biographie",
    change_password_desc: "Modifie votre mot de passe de connexion côté serveur. Votre phrase de récupération locale reste stockée séparément protégée par votre mot de passe de coffre-fort.",
    change_password_menu_desc: "Mettez à jour le mot de passe de connexion GaiaCOM.",
    change_password_title: "Changer de mot de passe",
    channel_id: "ID de chaîne",
    channel_name_label: "Nom de la chaîne",
    chat_deleted_hidden: "Chat supprimé et masqué.",
    chat_input_placeholder: "Saisir un message sécurisé...",
    chat_start_hint: "Commencez la conversation ! Tous les messages de discussion sont chiffrés de bout en bout de manière quantique.",
    choose_avatar: "Choisir l'Avatar",
    ciphertext_hash: "Hash du texte chiffré",
    clear_chat: "Chat vide",
    clear_for_everyone: "Vide pour tout le monde",
    clear_for_me: "Vide juste pour moi",
    click_to_write_mail: "Cliquez pour écrire un e-mail",
    click_top_right: "Cliquez en haut à droite sur",
    close: "Fermer",
    code_kopieren: "Copier le code",
    code_kopieren_success: "Code copié",
    confirm_clear_channel_desc: "Voulez-vous supprimer cette chaîne de votre vue locale ?",
    confirm_clear_channel_title: "Canal vide",
    confirm_clear_chat: "Voulez-vous vider ce chat ?",
    confirm_clear_chat_desc: "Voulez-vous vider ce chat ?",
    confirm_clear_chat_title: "Chat vide",
    confirm_clear_everyone: "Voulez-vous vider ce chat pour les deux ? (OK = Pour tout le monde, Annuler = Seulement pour moi)",
    confirm_delete_everyone: "Voulez-vous supprimer ce message pour les deux ? (OK = Pour tout le monde, Annuler = Seulement pour moi)",
    confirm_delete_msg: "Voulez-vous supprimer ce message ?",
    confirm_delete_msg_desc: "Voulez-vous supprimer ce message de discussion ?",
    confirm_delete_msg_title: "Supprimer le message",
    confirm_new_password: "Confirmer le nouveau mot de passe",
    copy: "Copie",
    create_btn: "Créer",
    create_channel_title: "Créer une chaîne",
    create_group_is_crisis: "Marquer comme zone de crise",
    create_group_title: "Créer un nouveau groupe",
    crypto_lock_desc: "Contrôle quand GaiaCOM supprime les clés de chiffrement locales de la mémoire.",
    crypto_lock_menu_desc: "Contrôlez les minuteries de rechargement et d’inactivité.",
    crypto_lock_title: "Verrou cryptographique",
    crypto_session_duration: "Débloqué après rechargement",
    crypto_session_duration_desc: "Ne maintient la session crypto ouverte dans cet onglet du navigateur que pendant la durée sélectionnée.",
    cryptographic_fingerprint: "Empreinte cryptographique",
    current_password: "Mot de passe actuel",
    data_minimization: "Minimisation des données",
    decrypt_failed: "Non déchiffrable",
    delete: "Supprimer",
    delete_account_button: "Supprimer le compte irrévocablement",
    delete_account_confirm_label: "Entrez SUPPRIMER pour confirmer",
    delete_account_confirmation_error: "Le mot de passe et la confirmation DELETE sont requis.",
    delete_account_desc: "Ce mode détruit définitivement votre compte, vos identités, les sessions de votre appareil, les données GaiaDrop, les métadonnées de téléchargement et les messages attribuables côté serveur.",
    delete_account_done_desc: "Toutes les données GaiaCOM attribuables ont été supprimées.",
    delete_account_done_title: "Compte supprimé",
    delete_account_menu_desc: "Détruisez le compte et les données associées.",
    delete_account_not_authenticated: "Aucun compte actif.",
    delete_account_title: "Supprimer le compte",
    delete_for_everyone: "Supprimer pour tout le monde",
    delete_for_me: "Supprimer juste pour moi",
    device_current: "Cet appareil",
    device_last_seen: "Dernier",
    device_logout: "Se déconnecter",
    device_sessions_desc: "Vérifiez les sessions actives et désenregistrez les appareils auxquels vous ne faites plus confiance.",
    device_sessions_empty: "Aucun appareil trouvé.",
    device_sessions_menu_desc: "Gérez et terminez les sessions actives.",
    device_sessions_title: "Appareils enregistrés",
    device_since: "Depuis",
    display_name: "Nom d'Affichage",
    drop_address_copied: "Adresse GaiaDrop copiée.",
    drop_btn_decrypting: "Déchiffrement de la boîte...",
    drop_btn_load: "Charger GaiaDrop Inbox",
    drop_delete_desc: "Voulez-vous vraiment supprimer définitivement ce drop ?",
    drop_delete_title: "Supprimer GaiaDrop",
    drop_desc: "Canal de dépôt de texte anonyme sans connaissance pour les indices externes, la divulgation responsable et les rapports confidentiels. Les utilisateurs externes peuvent envoyer des messages à votre GaiaID sans compte.",
    drop_empty: "Aucun message GaiaDrop chargé pour le moment.",
    drop_id: "ID du Drop :",
    drop_own_address: "Votre adresse GaiaDrop",
    drop_proof: "DROP PROOF",
    drop_title: "Boîte de dépôt sécurisée GaiaDrop",
    dunkler_modus: " Mode Sombre",
    e2e_chat_room_open: "Ouvrir la salle de chat E2E",
    edit_profile: "Modifier le profil",
    edit_profile_desc: "Personnalisez le nom d'affichage, la biographie et l'avatar.",
    einladungscode: "Code d'invitation",
    enter_fingerprint_chars_confirm: "Saisissez les caractères d'empreinte digitale demandés pour confirmer.",
    envelope_hash: "Hash de l'enveloppe",
    erasability: "Effaçabilité",
    erfolg: "Succès",
    exclude_plaintext: "Exporter sans texte brut",
    export_disclosure: "Exporter le dossier de sécurité",
    export_package_desc: "N'incluez du texte brut que si cette divulgation est intentionnellement intentionnelle.",
    export_package_title: "Pack de sécurité à l'exportation",
    fehler: "Erreur",
    gaiacom_reader: "Lecteur GaiaCOM",
    gaiadrop_inbox_title: "Boîte de réception GaiaDrop",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM minimise les métadonnées, conserve les clés privées locales, crypte le contenu de bout en bout et permet la suppression complète du compte.",
    gdpr_home_title: "100% conforme au RGPD",
    gdpr_reason_delete: "La suppression du compte supprime le compte, les identités, les sessions locales et les données attribuables côté serveur.",
    gdpr_reason_e2ee: "Le contenu privé reste décryptable uniquement pour les destinataires prévus.",
    gdpr_reason_minimal: "Les métadonnées ne sont utilisées que pour les informations d'identification de routage, de livraison et de sécurité.",
    gdpr_reason_zero_knowledge: "Les clés privées et les données de récupération restent localement sous le contrôle de l'utilisateur.",
    gesendet: "Envoyés",
    gesperrt_verdaechtig: "Bloqué / Suspect",
    group_delete_desc: "Voulez-vous vraiment supprimer définitivement ce groupe ? Toutes les chaînes et messages de ce groupe seront supprimés.",
    group_delete_title: "Supprimer le groupe",
    group_description: "Description",
    group_icon_label: "Icône de groupe / avatar",
    group_name: "Nom du groupe",
    group_settings_avatar: "Avatar",
    group_settings_desc: "Description",
    group_settings_is_crisis: "Marquer comme zone de crise",
    group_settings_name: "Nom du Groupe",
    group_settings_title: "Paramètres du Groupe",
    groups_empty_desc: "Créez un espace de travail sécurisé pour les projets, les crises ou la communication d’équipe.",
    groups_empty_title: "Aucun chat de groupe pour le moment",
    gruppe_beitreten: "Groupe rejoint",
    gruppe_erstellen: "+ Créer un groupe",
    gruppe_verlassen: "Quitter le groupe",
    gruppen_chats: "Chats de Groupe",
    heller_modus: " Mode Clair",
    how_to_receive_drops: "Comment recevoir des Drops ?",
    identitaets_assistent: "Assistant d'Identité",
    inactivity_lock_duration: "Verrouiller lorsqu'il est inactif",
    inactivity_lock_duration_desc: "Après cette période de non-entrée, GaiaCOM sera automatiquement verrouillé cryptographiquement.",
    inactivity_lock_notice: "GaiaCOM a été bloqué cryptographiquement pour cause d'inactivité.",
    include_plaintext: "Inclure du texte brut",
    invite_code_label: "Code d'invitation",
    join_group_title: "Rejoindre le groupe",
    kanaele: "Canaux",
    kanal_erstellen: "+ Canal",
    kein_chat_ausgewaehlt: "Aucun chat sélectionné",
    kein_kanal_ausgewaehlt: "Aucun canal sélectionné",
    keine_gruppe_ausgewaehlt: "Aucun groupe sélectionné",
    keine_mails: "Aucun e-mail disponible.",
    key_change_warn_desc: "La clé publique de ce contact a changé. Vérifiez l'empreinte digitale avant de lui faire confiance.",
    key_change_warn_title: "Avertissement cryptographique",
    key_change_warning_changed: "a changé. Cela peut être le signe d’une attaque de l’homme du milieu !",
    key_change_warning_msg: "La clé d'identité pour le contact",
    key_transparency: "Transparence des clés (Historique des clés)",
    kopiert: "Copié",
    kryptographische_schluessel: "Clés cryptographiques",
    kryptographische_schluessel_desc: "Afficher les clés privées et la phrase de départ de sauvegarde.",
    laden: "Chargement...",
    leeren: "Vide",
    loading: "Charger...",
    local_key_vault: "Coffre de clés local",
    local_keys_label: "Clés locales",
    lock_on_reload: "Toujours verrouiller après le rechargement",
    logout: "Se déconnecter",
    mail_compose: "Ecrire un mail",
    mein_profil: "Mon Profil",
    melden: "Signaler",
    menu: "Menu",
    message: "Nouvelles",
    message_id: "ID du message",
    message_pin: "Épingle",
    message_pinned_title: "Messages épinglés",
    message_react: "Réagir",
    message_reply: "Répondre",
    message_replying_to: "Répondre à",
    message_save: "Sauvegarder",
    message_saved: "Enregistré",
    message_to_channel: "Message à",
    message_unpin: "Résoudre",
    message_unsave: "Ne sauvegardez pas",
    mitglied: "Membre",
    mitglieder: "Membres",
    ml_kem: "ML-KEM",
    neue_mail: "Nouvel e-mail",
    never_auto_lock: "Jamais automatiquement",
    new_fingerprint: "Nouvelle empreinte digitale",
    new_identity: "Nouvelle Identité",
    new_password: "Nouveau mot de passe",
    no_description: "Pas de description",
    no_key_history: "Aucun historique de clé enregistré.",
    no_specification: "Non spécifié",
    old_fingerprint: "Ancienne empreinte digitale",
    open_privacy_imprint: "Mentions légales ouvertes et protection des données",
    post_quantum_e2e: "E2E Post-Quantique",
    posteingang: "Boîte de réception",
    powered_by: "Propulsé par",
    privacy_imprint_menu_desc: "Afficher RGPD, protection des données et mentions légales.",
    privacy_imprint_profile_desc: "GaiaCOM traite le contenu des communications selon les principes de minimisation des données, de cryptage de bout en bout et de contrôle des clés locales.",
    privacy_imprint_title: "Protection des données et mentions légales",
    profil: "Profil",
    profile_details: "Détails du Profil",
    profile_settings_hint: "Les paramètres du profil sont affichés dans le panneau de droite.",
    profile_unlock_desc: "Pour des raisons de sécurité, vous devez saisir à nouveau votre mot de passe pour afficher vos clés cryptographiques privées.",
    proof_hash: "Hash de preuve :",
    public_drop_desc: "Secure Drop pour signalements externes en texte seul sans compte GaiaCOM.",
    public_drop_message: "Message",
    public_drop_message_placeholder: "Saisir un texte confidentiel...",
    public_drop_send: "Envoyer GaiaDrop",
    public_drop_sender: "Note expéditeur optionnelle",
    public_drop_sender_placeholder: "Nom, numéro de dossier ou anonyme",
    public_drop_target: "GaiaID cible",
    quanten_chat: "Chat Quantique",
    quantum_secure_exchange: "Échange quantique sécurisé via...",
    quantum_secure_net: "Réseau quantique sécurisé GaiaCOM (Ed25519 & ML-KEM)",
    quantum_shield_desc: "Le réseau GaiaCOM protège votre vie privée avec un protocole de chiffrement hybride externe multicouche sécurisé contre les attaques des futurs ordinateurs quantiques.",
    quantum_shield_l1_desc: "Utilise la norme FIPS 203 pour encapsuler une clé partagée symétrique. Empêche l'écoute passive et le déchiffrement ultérieur (\\\\\\",
    quantum_shield_l1_title: "1. Protection Post-Quantique (ML-KEM-1024)",
    quantum_shield_l2_desc: "Une méthode classique et ultra-rapide d'échange de clés Diffie-Hellman qui sert de couche de sécurité supplémentaire dans le schéma hybride.",
    quantum_shield_l2_title: "2. Cryptographie sur Courbe Elliptique (X25519)",
    quantum_shield_l3_desc: "Chaque message et enveloppe de fédération est signé cryptographiquement pour vérifier l'authenticité de l'expéditeur sans aucun doute.",
    quantum_shield_l3_title: "3. Signatures Numériques (Ed25519)",
    quantum_shield_l4_desc: "Chiffre le contenu du message de manière symétrique et lie fermement l'expéditeur, le destinataire et les métadonnées dans les Données Additionnelles Authentifiées (AAD) pour empêcher les attaques par rejeu.",
    quantum_shield_l4_title: "4. Authentification AAD (AES-256-GCM)",
    quantum_shield_status: " Statut du Quantum Shield",
    receive_drops_step1: "Partagez votre GaiaID (par exemple via le bouton copier ci-dessus) avec des sources externes.",
    receive_drops_step2: "Ils ouvrent la page de connexion de votre instance GaiaCOM, basculent sur l'onglet",
    receive_drops_step3: "et y envoient leur message chiffré à votre adresse.",
    receiver_gaia: "Récepteur GaiaCOM",
    receiver_smtp: "Destinataire SMTP",
    records_stored: "Enregistrements enregistrés",
    refresh: "Mise à jour",
    report_abuse_desc: "Souhaitez-vous signaler ce message et soumettre des preuves cryptographiques d'abus au serveur ?",
    report_abuse_title: "Signaler un abus",
    reputation_status: "Statut de réputation",
    room_chat_start_hint: "Commencez la conversation ! Tous les messages de ce canal de groupe sont décentralisés et chiffrés de bout en bout de manière quantique.",
    room_policy_audit: "Piste d’audit et rotation des clés actives.",
    room_policy_crisis: "Salle de crise",
    room_policy_e2ee: "Espace sans connaissance. Coffre-fort quantique E2EE.",
    room_policy_title: "Directives relatives aux chambres",
    room_policy_zero_knowledge: "Politique",
    room_security_note_desc: "Tous les changements clés sont validés via Key Transparency. Utilisez GaiaVault pour les journaux de sauvegarde privés.",
    room_security_note_title: "Note de sécurité épinglée",
    save_profile: "Sauvegarder le Profil",
    schluessel_entsperrt: "🔑 Re-verrouiller les clés",
    search_gaia_label: "Trouver l'adresse de Gaia",
    security_warning_title: "Avertissement de sécurité",
    select_channel_chat: "Sélectionnez un canal dans la barre latérale gauche pour discuter.",
    select_contact_chat: "Sélectionnez un contact du panneau de gauche pour démarrer une discussion quantique sécurisée E2E.",
    select_mail_read: "Sélectionnez un e-mail dans la liste pour lire son contenu quantique sécurisé, ou créez un nouveau message.",
    senden: "Envoyer",
    sender_signature: "Signature de l'expéditeur",
    server_log: "Log du serveur :",
    server_received: "Reçu par le serveur",
    session_lock: "Verrouillage de session",
    setup_address_keys: "Créer adresse et clés",
    setup_profile: "Configurer dans le Profil",
    smtp_inbox_title: "Réception SMTP",
    smtp_legacy_badge: "SMTP hérité/non sécurisé",
    smtp_mode_option: "Pont SMTP hérité",
    smtp_security_warning: "Ce message a été transmis via le provotole SMTP classique non chiffré. Aucun chiffrement de bout en bout actif.",
    smtp_security_warning_desc: "Ce message quitte la salle de sécurité de GaiaCom. La livraison SMTP ne fournit pas de garantie native de bout en bout de GaiaCom, aucune garantie TrustMesh et aucune garantie Godmode de la part de la passerelle.",
    spam_verdacht: "Spam/Suspect",
    spam_warning_desc: "Ce message contient des signaux de réputation suspects.",
    spam_warning_title: "Avertissement de spam",
    speichern: "Sauvegarder",
    sperren: "Verrouiller",
    standard_group_status: "Chat de groupe standard (crypté E2EE)",
    status: "statut",
    subject: "Concernant",
    suchen: "Rechercher une adresse Gaia...",
    tage: "Jours",
    time_unknown: "Heure inconnue",
    transmission_mode: "Mode de transfert",
    trust_age: "Âge de confiance",
    trust_passport_title: "Passeport de confiance",
    unbestaetigt: "Non confirmé",
    unknown_sender: "Inconnu",
    unlock_btn: "Déverrouiller",
    unlock_btn_profile: "Déverrouiller",
    unlock_desc: "Votre fichier de clé privée est stocké de manière chiffrée. Entrez votre mot de passe pour charger les clés cryptographiques uniquement en mémoire vive.",
    unlock_logout: "Se déconnecter et fermer les clés locales",
    unlock_title: "Déverrouiller l'identité",
    untrusted: "Non fiable",
    update_password: "Mettre à jour le mot de passe",
    upload_avatar_btn: "Télécharger une image (assainie)",
    vault_btn_encrypt: "Chiffrer l'enregistrement",
    vault_btn_lock: "Verrouiller le coffre-fort",
    vault_btn_unlock: "Déverrouiller le coffre-fort",
    vault_copied_success: "Copié dans le presse-papiers",
    vault_decrypted_content: "Contenu décrypté",
    vault_desc: "Coffre-fort local chiffré pour sauvegardes de récupération, notes d'identité, identifiants serveur, contacts d'urgence, notes légales, événements de sécurité et journaux privés.",
    vault_empty: "Aucun enregistrement sécurisé stocké pour le moment.",
    vault_locked_pane_notice: "Le coffre est verrouillé. Veuillez le déverrouiller à droite.",
    vault_new_record: "Nouveau dossier sécurisé",
    vault_pwd_placeholder: "Entrez le mot de passe du coffre-fort...",
    vault_record_body: "Enregistrer le contenu",
    vault_record_body_placeholder: "Saisir le contenu de l'enregistrement chiffré...",
    vault_record_category: "catégorie",
    vault_record_title: "Titre du disque",
    vault_record_title_placeholder: "Titre de l'enregistrement",
    vault_title: "Coffre-fort GaiaVault Secure Records",
    verify_new_fingerprint_hint: "Vérifiez la nouvelle empreinte digitale avant d'accepter la clé.",
    vertrauenswuerdig: "Fiable",
    vision_gaia_technology: "VisionGaiaTechnology",
    von: "De",
    warnung: "Avertissement",
    wizard_address: "Adresse",
    wizard_back: "Retour",
    wizard_check1: "J'ai sauvegardé ma phrase graine en toute sécurité.",
    wizard_custom_domain: "Utiliser son propre domaine",
    wizard_desc1: "GaiaCOM ne stocke pas les clés privées sur le serveur. Sans la graine mnémotechnique, personne ne peut récupérer les messages perdus.",
    wizard_desc2: "Votre adresse détermine le nœud fédéré par lequel les enveloppes chiffrées sont acheminées.",
    wizard_fallback: "Nœuds de secours",
    wizard_finish: "Terminer la configuration",
    wizard_next: "Suivant",
    wizard_server_domain: "Domaine du nœud de serveur",
    wizard_step1: "1. Sauvegarde de la graine",
    wizard_step2: "2. Adresse et Serveur",
    wizard_title1: "Sécuriser Clés de Récupération",
    wizard_title2: "Choisir Adresse GaiaCOM",
    write_message_placeholder: "Écrivez un message sécurisé...",
    you: "Toi",
    zero_knowledge: "Zéro connaissance",
    zero_knowledge_encryption: "Chiffrement sans connaissance",
    "Chat fuer alle geleert": "Le chat a été vidé pour tous les participants.",
    "Chat geleert": "Le chat a été effacé de votre boîte de réception locale.",
    "Nachricht fuer alle geloescht": "Le message a été supprimé pour tous les participants.",
    "Nachricht geloescht": "Le message de discussion a été supprimé localement de votre boîte de réception.",
    "anpinnen": "Épingle",
    "chat_loeschen": "Supprimer le chat",
    "confirm_delete_chat_desc": "Êtes-vous sûr de vouloir supprimer et masquer le chat ?",
    "confirm_leave_group_desc": "Voulez-vous vraiment quitter ce groupe ?",
    "entpinnen": "Détacher",
    "group_deleted": "Groupe supprimé avec succès.",
    "group_left": "Quittez le groupe avec succès.",
    "gruppe_loeschen": "Supprimer le groupe",
    "loeschen": "Supprimer",
    "no_active_chats": "Aucune discussion active. Recherchez les contacts ci-dessus pour démarrer une discussion.",
    "pinned": "Épinglé",
    "wizard_check_credentials": "Je suis responsable de la sécurité de mes données d'accès.",
    "wizard_check_is_beta": "Je comprends que GaiaCom est un logiciel bêta.",
    "wizard_check_no_illegal": "Je n'utiliserai pas GaiaCom à des fins illégales.",
    "wizard_check_no_uptime": "Je comprends qu'il n'y a aucune garantie de disponibilité.",
    "wizard_check_smtp_security": "Je comprends que les messages SMTP n'offrent pas une sécurité totale à GaiaCom.",
    "wizard_check_terms_read": "J'ai lu les conditions d'utilisation de la version bêta.",
    "wizard_step_terms": "Conditions d'utilisation",
    "wizard_terms_text": "Conditions d'utilisation de GaiaCom et accord de test bêta (phase bêta)\n\nFournisseur : VisionGaiaTechnology (ci-après dénommé « Fournisseur »)\nStatut : Phase de test bêta publique\nValidité : À partir du 21 juin 2026\n\n⚠️ LA NOTE LA PLUS IMPORTANTE À L'AVANCE (VEUILLEZ LIRE ATTENTIVEMENT)\nGaiaCom est en phase de test bêta public. Malgré des mesures de sécurité étendues, l'absence d'erreurs, la disponibilité continue ou la sécurité absolue du logiciel et de l'infrastructure sous-jacente ne peuvent être garanties. Utilisez à vos propres risques. Les utilisateurs sont responsables du stockage sécurisé de leurs données d'accès (en particulier des clés pour GaiaVault) et du respect des lois applicables.\n\n1. Objet et objectif de la phase de test bêta\n1.1. Objet de la fourniture : GaiaCom est un nouveau service de courrier électronique et de chat basé sur la cryptographie post-quantique (PQC). La mise à disposition pendant la phase bêta est exclusivement destinée aux tests techniques, à la simulation de charge, à la recherche d'erreurs de programme (bugs) et à l'optimisation de la convivialité.\n1.2. Statut bêta : L'utilisateur est conscient que le logiciel proposé est une version préliminaire (logiciel bêta). Celui-ci n'est pas encore complètement développé techniquement, ne répond pas aux normes d'un produit final commercial et peut provoquer des erreurs, des pertes de données, des retards de transmission ou des pannes du système.\n1.3. Pas de droit à la continuation : Le fournisseur a le droit à tout moment d'interrompre le service en tout ou en partie, de modifier ou de restreindre des fonctions ou de les supprimer temporairement ou définitivement sans indication de raisons.\n\n2. Disponibilité et exclusion de garantie\n2.1. Aucune garantie de disponibilité : GaiaCom est fourni sans aucune garantie de disponibilité ou de disponibilité. Il n'existe aucun droit à une disponibilité ininterrompue du service.\n2.2. Exclusion de garantie : Le logiciel est fourni dans son état actuel (« tel quel ») et sous réserve de disponibilité. Dans la mesure permise par la loi, toute demande de garantie pour défauts matériels et juridiques du logiciel est exclue. En particulier, il n'existe aucune garantie que le logiciel soit exempt d'erreurs, exempt de logiciels malveillants ou adapté à un usage particulier.\n\n3. Gestion des risques et obligations des utilisateurs\n3.1. Interdiction de stockage de données critiques : L'utilisateur s'engage à ne pas stocker ou transmettre exclusivement via GaiaCom des données critiques pour l'entreprise, vitales, nécessaires au fonctionnement ou particulièrement sensibles sur le plan juridique (telles que les dossiers des patients, les données financières hautement sensibles ou les secrets officiellement réglementés). Le service ne peut pas être utilisé pour des infrastructures où des pannes imprévues pourraient entraîner des blessures corporelles, des dommages matériels ou des pertes financières importantes.\n3.2. Sauvegarde autonome : L'utilisateur est responsable de la sauvegarde de toutes les données reçues ou envoyées via GaiaCom dont il a besoin à long terme sur ses propres systèmes indépendants (copies de sauvegarde). Le prestataire ne garantit pas le stockage permanent ni la restauabilité des données sur ses serveurs.\n\n4. Fonctionnalités cryptographiques et GaiaVault\n4.1. Cryptographie post-quantique (PQC) : GaiaCom met en œuvre des processus de cryptage de pointe et orientés vers l'avenir, conçus pour résister aux attaques des futurs ordinateurs quantiques. Cependant, l'utilisateur est conscient qu'il s'agit d'un domaine scientifique dynamique et nouveau. Une sécurité absolue et irréfutable ne peut être garantie sur la base de l’état actuel de la science et de la technologie. Les termes tels que « 100 % sécurisé », « incassable » ou « militaire sécurisé » ne sont expressément pas garantis.\n4.2. Aucune garantie de récupération (GaiaVault) : GaiaCom s'appuie sur un concept de sécurité cohérent sans connaissance. Les coins de chiffrement et les données d'accès restent uniquement sous le contrôle de l'utilisateur (sécurisés via GaiaVault).\nIMPORTANT : Si l'utilisateur perd ses mots de passe, phrases secrètes, clés privées ou graines de récupération, le fournisseur n'a aucune capacité technique pour reconstruire ou réinitialiser ces données. La perte de ces données d'accès entraîne inévitablement la perte irrévocable de l'accès au compte utilisateur et à toutes les données cryptées qui y sont chiffrées.\n4.3. Pas encore entièrement audité : le logiciel est soumis en permanence à des contrôles de sécurité internes, mais au moment de cette phase bêta, il n'a pas encore fait l'objet d'un audit de sécurité externe final et complet par des organismes de test indépendants.\n\n5. Interfaces, protocoles existants et fédération\n5.1. SMTP Bridge Remarque : GaiaCom offre la possibilité de communiquer via des protocoles de messagerie classiques (tels que SMTP). L'utilisateur est conscient que les messages qui quittent la zone de sécurité native de GaiaCom (par exemple lorsqu'ils sont envoyés à une adresse conventionnelle @gmail.com ou @gmx.de) sont transportés via des serveurs non cryptés ou tiers. Les garanties de sécurité de bout en bout de GaiaCom ne s'appliquent que dans une mesure limitée, voire pas du tout, à ces messages existants sortants ou entrants de l'extérieur.\n5.2. Remarque sur la fédération : Si GaiaCom fonctionne sur un réseau fédéré, les messages et les données peuvent passer par des serveurs tiers. Si le contenu des messages reste protégé par un cryptage de bout en bout, les métadonnées (telles que l'heure d'envoi, les adresses IP des serveurs concernés et les adresses des destinataires) peuvent être techniquement visibles par les opérateurs de ces serveurs fédérés. Le fournisseur n'a aucune influence sur les pratiques de protection des données des opérateurs de serveurs tiers dans le réseau fédéré.\n\n6. Utilisations acceptables et activités interdites\nL'utilisateur s'engage à ne pas utiliser le service de manière inappropriée ou à des fins illégales. Sont notamment interdits :\n- Distribuer, envoyer ou héberger des virus, des logiciels malveillants, du contenu de phishing ou d'autres logiciels malveillants.\n- Utiliser le Service pour mener des attaques par déni de service (DDoS) ou des envois de masse non sollicités (spam).\n- Abuser du système pour commettre une fraude.\n- La distribution ou l'échange de contenus illégaux, en particulier des représentations d'abus sexuels sur des enfants (CSAM), de la propagande terroriste, des appels à la violence ou d'autres contenus à caractère criminel.\n\n7. Système de signalement des abus\n7.1. Signalement d'un comportement abusif : les utilisateurs ont la possibilité de signaler des communications abusives ou des activités illégales via le système d'abus intégré.\n7.2. Traitement des rapports : Afin d'assurer la protection contre toute utilisation abusive, les rapports entrants peuvent être analysés techniquement (tout en respectant les limites de confidentialité et de cryptage). Cela peut entraîner la suspension temporaire ou définitive des comptes d'utilisateurs ou des adresses IP en cas de violations avérées des présentes conditions d'utilisation.\n\n8. Limitation de responsabilité\n8.1. Norme de responsabilité : Le logiciel bêta est fourni gratuitement. Conformément aux règles légales en matière de dons ou de prêts, le prestataire n'est donc responsable que des fautes intentionnelles (dommages intentionnels) et des négligences graves.\n8.2. Exclusion de responsabilité en cas de perte de données : la responsabilité en cas de perte de données est exclue, sauf si la perte a été causée intentionnellement ou par une négligence grave de la part du fournisseur et si l'utilisateur a rempli son obligation d'atténuer les dommages par des sauvegardes régulières (en dehors de GaiaCom).\n8.3. Limites légales : Les limitations de responsabilité ci-dessus ne s'appliquent pas aux atteintes à la vie, au corps ou à la santé ni à la responsabilité en vertu de la loi sur la responsabilité du fait des produits.\n\n9. Ouvrir la source\nCertains composants, bibliothèques ou applications client de GaiaCom peuvent être concédés sous licence open source (par exemple GPL, MIT, Apache). Les conditions de licence respectives de ces composants ne sont pas affectées par ces conditions d'utilisation et peuvent être consultées dans les référentiels de codes sources correspondants.\n\n10. Contrôle et conformité des exportations\nL'utilisateur est conscient que les logiciels cryptographiques peuvent être soumis à des contrôles d'exportation stricts et à des restrictions légales. L'utilisateur est responsable de s'assurer que l'utilisation de GaiaCom ne viole pas les lois, les restrictions d'importation/exportation ou les réglementations en matière de cryptographie de leur pays de résidence respectif.\n\n11. Avis de protection des données (version courte pour la version bêta)\n11.1. Collecte minimale de données : dans le cadre de la phase bêta, le fournisseur collecte uniquement les données absolument nécessaires au fonctionnement technique, au dépannage et au développement ultérieur (par exemple, les fichiers journaux du serveur pour le diagnostic des erreurs).\n11.2. Aucun aperçu du contenu : Grâce au zéro connaissance cohérent et au cryptage E2E, le fournisseur n'a jamais accès au contenu de vos discussions, e-mails ou clés stockées dans GaiaVault.\n11.3. Déclaration détaillée sur la protection des données : Les règles détaillées sur la protection des données sont liées séparément et doivent également être prises en compte par l'utilisateur avant de s'inscrire.\n\n12. Dispositions finales\n12.1. Droit applicable : Le droit de la République fédérale d'Allemagne s'applique, à l'exclusion de la Convention des Nations Unies sur les contrats de vente internationale de marchandises.\n12.2. Sous réserve de modifications : GaiaCom étant en développement actif, le fournisseur se réserve le droit d'adapter ces conditions à tout moment avec effet pour l'avenir. La version actuelle est disponible dans l'application.",
    "wizard_terms_title": "Conditions d'utilisation de GaiaCom et accord de test bêta (phase bêta)",
    "node_operator": "Opérateur de nœud",
    "search_channels": "Rechercher des chaînes...",
    "senior_reviewer": "Réviseur principal",
    "trusted_reviewer": "Évaluateur de confiance",
    "active_frequencies": "Fréquences actives",
    "connected_rooms": "ESPACES CONNECTÉS",
    "dashboard": "Tableau de bord",
    "empty_chats": "Aucun chat actif disponible.",
    "empty_messages": "Aucun nouveau message disponible.",
    "encrypted": "Crypté",
    "gaiacom_uplink": "LIAISON MONTANTE GAIACOM",
    "install_app": "Installer l'application",
    "install_app_desc": "Pour un démarrage rapide et le mode hors ligne",
    "kommandozentrale_alpha": "Centre de commandement ALPHA",
    "network_online": "RÉSEAU : EN LIGNE",
    "new_room": "Nouvel espace",
    "no_frequencies_active": "Aucune fréquence active. Créez une nouvelle salle pour démarrer la communication.",
    "no_id": "Pas de pièce d'identité",
    "open_chats": "Discussions ouvertes",
    "open_inbox": "Ouvrir la boîte de réception",
    "primary_identity": "IDENTITÉ PRIMAIRE",
    "recent_chats": "Nouvelles discussions",
    "recent_messages": "Dernières nouvelles",
    "session_encrypted": "Session chiffrée : {name}",
    "session_secure": "STATUT : SÉCURISÉ",
    "system_verlassen": "Système de sortie",
    "write_message": "Écrire un message",
  },
  fa: {
    sc_title: "مرکز امنیت",
    sc_subtitle: "لایه امنیتی یکپارچه GaiaShield",
    sc_tab_status: "🛡️ وضعیت حفاظت",
    sc_tab_events: "📋 گزارش امنیتی",
    sc_tab_node: "⚙️ امنیت گره",
    sc_loading: "در حال بارگذاری داده‌های امنیتی...",
    sc_status_secured: "وضعیت سیستم: حساب محافظت شده است",
    sc_status_warning: "وضعیت سیستم: هشدارهای فعال",
    sc_desc_secured: "هیچ هشدار امنیتی بحرانی فعالی وجود ندارد. GaiaShield به طور فعال حساب شما را نظارت می کند.",
    sc_desc_warning: "توجه: رویدادهای امنیتی فعالی وجود دارند که نیاز به توجه شما دارند.",
    sc_account_protection: "محافظت از حساب",
    sc_message_protection: "محافظت از پیام",
    sc_audits: "ممیزی های امنیتی",
    sc_active: "فعال",
    sc_failed_logins: "ورودهای ناموفق",
    sc_tamper_checks: "بررسی دستکاری",
    sc_blocked_replays: "پخش های مجدد مسدود شده",
    sc_last_check: "آخرین بررسی",
    sc_just_now: "همین الان",
    sc_open_warnings: "هشدارهای باز",
    sc_btn_acknowledge: "تایید کردن",
    sc_filter_severity: "شدت",
    sc_filter_category: "دسته بندی",
    sc_filter_hide_ack: "پنهان کردن تایید شده ها",
    sc_btn_export: "خروجی گرفتن",
    sc_col_details: "جزئیات",
    sc_col_time: "زمان",
    sc_col_status: "وضعیت",
    sc_col_action: "عملیات",
    sc_no_events: "هیچ رویداد امنیتی پیدا نشد.",
    sc_node_title: "کنسول امنیتی اپراتور گره",
    sc_system_health: "سلامت سیستم",
    sc_last_audit: "آخرین حسابرسی",
    sc_packed_logs: "گزارش های فشرده شده",
    sc_unconfirmed_events: "رویدادهای تایید نشده",
    sc_operator_action: "عملیات اپراتور مورد نیاز است",
    sc_all_ok: "همه چیز مرتب است",
    sc_critical_events: "رویدادهای بحرانی سیستم",
    ac_title: "مرکز حاکمیت و گزارش سوء استفاده",
    ac_subtitle: "اجماع حاکمیت و سوء استفاده GaiaCom",
    ac_tab_my_reports: "گزارش های من",
    ac_tab_queue: "صف بازبینی",
    ac_tab_operator: "اپراتور گره",
    ac_tab_transparency: "فدراسیون و شفافیت",
    ac_loading: "در حال بارگذاری داده‌ها...",
    ac_reported_cases: "موارد گزارش شده",
    ac_no_reports: "شما هنوز هیچ گزارشی ارسال نکرده اید.",
    ac_case_details: "جزئیات پرونده",
    ac_appeal_submit: "ارائه درخواست تجدید نظر",
    ac_appeal_status: "وضعیت درخواست تجدید نظر",
    ac_appeal_reason: "دلیل درخواست تجدید نظر",
    ac_appeal_statement: "اظهارات",
    ac_btn_appeal: "ارسال درخواست تجدید نظر",
    ac_trusted_reviewer_queue: "صف بازبین های مورد اعتماد",
    ac_case_review: "بررسی پرونده",
    ac_review_category: "دسته بندی پیشنهادی",
    ac_review_severity: "شدت پیشنهادی",
    ac_review_action: "اقدام پیشنهادی",
    ac_review_reason: "دلیل بازبین",
    ac_btn_submit_review: "ارسال بازبینی",
    ac_node_operator_dashboard: "داشبورد اپراتور گره",
    ac_apply_action: "اعمال اقدام (لغو کردن)",
    ac_target_type: "نوع هدف",
    ac_target_id: "شناسه هدف (GaiaID یا شناسه کانال)",
    ac_suspend: "تعلیق فعال",
    ac_reason: "دلیل رسمی",
    ac_btn_apply: "اجرای اقدام",
    ac_transparency_title: "دفترچه ثبت اجماع و شفافیت",
    ac_transparency_desc: "اثبات های عکس فوری به صورت عمومی برای همه کانال ها و هویت های تعدیل شده قابل مشاهده است.",
    ac_btn_snapshot: "ایجاد عکس فوری شفافیت",
    search_placeholder: "جستجوی ایمیل‌ها بر اساس موضوع، فرستنده، متن...",
    abuse_center_title: "مرکز سوء استفاده",
    abbrechen: "لغو کنید",
    active_identities: "هویت های فعال",
    active_identity: "هویت فعال",
    add_btn: "اضافه کنید",
    add_contact_title: "افزودن مخاطب",
    admin: "مدیر",
    adressbuch: "دایرکتوری",
    aktiviert: "فعال شد",
    an: "به",
    anonymous_sender: "فرستنده ناشناس",
    antworten: "پاسخ دهید",
    attachment_gaia_hint: "پیوست های GaiaCOM رمزگذاری شده باقی می مانند.",
    attachment_smtp_hint: "SMTP قدیمی پیوست های اجرایی/اسکریپت مانند را مسدود می کند و ایمیل ها را به عنوان ناامن ذخیره می کند.",
    attachments: "پیوست ها",
    auffaellig: "مشکوک",
    auth_beta_notice: "مرحله آزمایشی بتا: GaiaCOM به‌طور فعال در حال آزمایش است. ممکن است خطا رخ دهد; seedهای مهم را پشتیبان بگیرید و جریان‌های حساس را با دقت بررسی کنید.",
    auth_btn_login: "بارگیری هویت و ورود به سیستم",
    auth_btn_register: "ثبت نام و ایجاد رمزارز",
    auth_copied: "کپی شده است",
    auth_copy_seed: "Seed را کپی کنید",
    auth_generate_seed: "بذر تولید کنید",
    auth_headline: "GaiaCOM اولین پروتکل ایمیل و سیستم ارتباطی ایمن کوانتومی است که برای بشریت ساخته شده است.",
    auth_kicker: "ارتباطات ایمن پس از کوانتومی",
    auth_mnemonic: "عبارت یادگاری",
    auth_mnemonic_placeholder: "12 کلمه جدا شده با فاصله...",
    auth_password: "رمز عبور",
    auth_password_placeholder: "•••••••••••••",
    auth_proof_e2ee_desc: "کلیدهای خصوصی از دستگاه شما خارج نمی شوند. فقط گیرندگان مورد نظر می توانند محتوا را رمزگشایی کنند.",
    auth_proof_gaiadata_desc: "Zero-knowledge: شما همچنان کنترل داده های خود را در دست دارید. فراداده به حداقل می رسد و به عنوان یک نمایه متن ساده استفاده نمی شود.",
    auth_proof_gaiadrop_desc: "افراد خارجی می توانند پیام های متنی محرمانه را بدون حساب به GaiaID شما ارسال کنند.",
    auth_proof_gaiaproof_desc: "شواهد تحویل و یکپارچگی نشان می دهد که متن رمز، فرستنده و مهر زمانی دستکاری نشده اند.",
    auth_proof_gaiavault_desc: "یادداشت های خصوصی، یادداشت های بازیابی و سوابق امنیتی به صورت محلی رمزگذاری شده باقی می مانند.",
    auth_proof_hybrid_desc: "سپر کوانتومی: رمزگذاری ترکیبی با ML-KEM و X25519 از حملات امروزی محافظت می کند و خطرات بعدی را ذخیره می کند.",
    auth_secure_mail: "ایمیل فدرال کوانتومی ایمن",
    auth_subline: "GaiaCOM یک سیستم ارتباطی امن کوانتومی برای ایمیل، چت، اتاق بحران، GaiaDrop و فایل های امنیتی محلی است. کلیدهای خصوصی در دستگاه شما باقی می مانند، محتوا رمزگذاری شده است، و شواهد را می توان بدون متن ساده صادر کرد.",
    auth_success_btn: "اکنون وارد شوید",
    auth_success_text: "حساب GaiaCOM شما ایجاد شده است. کلیدها به صورت محلی از seed شما مشتق شده اند و در سرور ذخیره نشده اند.",
    auth_success_title: "ثبت نام با موفقیت انجام شد",
    auth_tab_drop: "GaiaDrop",
    auth_tab_login: "ورود/حساب",
    auth_toggle_login: "حساب از قبل وجود دارد",
    auth_toggle_register: "ایجاد حساب کاربری جدید",
    auth_usecase_text: "مناسب برای وکلا، شرکت ها، مقامات، روزنامه نگاران، افشاگران و پرونده های امنیتی خصوصی.",
    auth_usecase_title: "برای ارتباطات حساس ساخته شده است",
    auth_username: "نام کاربری",
    auth_username_placeholder: "نام را وارد کنید...",
    auth_value_chat: "چت E2E",
    auth_value_drop: "سقوط امن",
    auth_value_mail: "نامه امن",
    auth_value_rooms: "GaiaRooms",
    bestaetigen: "تایید کنید",
    bestaetigt: "تایید شده",
    bio_status: "بیوگرافی/وضعیت",
    biography: "بیوگرافی",
    change_password_desc: "رمز ورود سمت سرور شما را تغییر می دهد. عبارت بازیابی محلی شما به طور جداگانه توسط رمز عبور طاق/باز کردن قفل محافظت می شود.",
    change_password_menu_desc: "رمز ورود GaiaCOM را به روز کنید.",
    change_password_title: "رمز عبور را تغییر دهید",
    channel_id: "آیدی کانال",
    channel_name_label: "نام کانال",
    chat_deleted_hidden: "چت حذف و پنهان شد.",
    chat_input_placeholder: "پیام امن را وارد کنید...",
    chat_start_hint: "گفتگو را شروع کنید! همه پیام های چت دارای رمزگذاری E2E ایمن کوانتومی هستند.",
    choose_avatar: "آواتار را انتخاب کنید",
    ciphertext_hash: "هش متن رمزنگاری شده",
    clear_chat: "چت خالی",
    clear_for_everyone: "برای همه خالی",
    clear_for_me: "فقط واسه من خالیه",
    click_to_write_mail: "برای نوشتن ایمیل کلیک کنید",
    click_top_right: "در بالا سمت راست کلیک کنید روی",
    close: "بستن",
    code_kopieren: "کد را کپی کنید",
    code_kopieren_success: "کد کپی شد",
    confirm_clear_channel_desc: "آیا می خواهید این کانال را از نمای محلی خود پاک کنید؟",
    confirm_clear_channel_title: "کانال خالی",
    confirm_clear_chat: "آیا می خواهید این چت را خالی کنید؟",
    confirm_clear_chat_desc: "آیا می خواهید این چت را خالی کنید؟",
    confirm_clear_chat_title: "چت خالی",
    confirm_clear_everyone: "آیا می خواهید چت را برای هر دو شریک خالی کنید؟ (OK = برای همه، لغو = فقط برای من)",
    confirm_delete_everyone: "آیا می خواهید پیام هر دو شریک را حذف کنید؟ (OK = برای همه، لغو = فقط برای من)",
    confirm_delete_msg: "آیا می خواهید این پیام را حذف کنید؟",
    confirm_delete_msg_desc: "آیا می خواهید این پیام چت را حذف کنید؟",
    confirm_delete_msg_title: "حذف پیام",
    confirm_new_password: "رمز عبور جدید را تایید کنید",
    copy: "کپی کنید",
    create_btn: "ایجاد کنید",
    create_channel_title: "ایجاد کانال",
    create_group_is_crisis: "علامت گذاری به عنوان منطقه بحران",
    create_group_title: "ایجاد گروه جدید",
    crypto_lock_desc: "زمانی که GaiaCOM کلیدهای رمزنگاری محلی را از حافظه حذف می کند، کنترل می کند.",
    crypto_lock_menu_desc: "تایمرهای بارگذاری مجدد و عدم فعالیت را کنترل کنید.",
    crypto_lock_title: "قفل رمزنگاری",
    crypto_session_duration: "پس از بارگذاری مجدد باز شد",
    crypto_session_duration_desc: "جلسه کریپتو را فقط برای مدت زمان انتخاب شده در این برگه مرورگر باز نگه می دارد.",
    cryptographic_fingerprint: "اثر انگشت رمزنگاری شده",
    current_password: "رمز عبور فعلی",
    data_minimization: "به حداقل رساندن داده‌ها",
    decrypt_failed: "قابل رمزگشایی نیست",
    delete: "حذف کنید",
    delete_account_button: "حذف اکانت به صورت غیرقابل برگشت",
    delete_account_confirm_label: "برای تایید، DELETE را وارد کنید",
    delete_account_confirmation_error: "رمز عبور و تایید DELETE مورد نیاز است.",
    delete_account_desc: "این حالت حساب، هویت، جلسات دستگاه، داده‌های GaiaDrop، ابرداده‌های آپلود و پیام‌های قابل انتساب سمت سرور را برای همیشه از بین می‌برد.",
    delete_account_done_desc: "تمام داده‌های قابل تخصیص GaiaCOM حذف شده است.",
    delete_account_done_title: "اکانت حذف شد",
    delete_account_menu_desc: "حساب کاربری و داده های مرتبط را از بین ببرید.",
    delete_account_not_authenticated: "هیچ حساب کاربری فعالی وجود ندارد.",
    delete_account_title: "حذف اکانت",
    delete_for_everyone: "حذف برای همه",
    delete_for_me: "حذف فقط برای من",
    device_current: "این دستگاه",
    device_last_seen: "آخرین",
    device_logout: "از سیستم خارج شوید",
    device_sessions_desc: "جلسات فعال را بررسی کنید و دستگاه‌هایی را که دیگر به آن‌ها اعتماد ندارید لغو ثبت کنید.",
    device_sessions_empty: "دستگاهی پیدا نشد",
    device_sessions_menu_desc: "جلسات فعال را مدیریت و پایان دهید.",
    device_sessions_title: "دستگاه های ثبت شده",
    device_since: "از آنجایی که",
    display_name: "نام نمایشی",
    drop_address_copied: "آدرس GaiaDrop کپی شد.",
    drop_btn_decrypting: "صندوق ورودی در حال رمزگشایی است...",
    drop_btn_load: "صندوق ورودی GaiaDrop را بارگیری کنید",
    drop_delete_desc: "آیا واقعاً می خواهید این قطره را برای همیشه حذف کنید؟",
    drop_delete_title: "GaiaDrop را حذف کنید",
    drop_desc: "کانال کاهش دانش صفر فقط متنی برای اعلامیه های خارجی، افشای مسئولانه و گزارش های محرمانه. احزاب خارجی می توانند بدون حساب با استفاده از GaiaID شما پیام ارسال کنند.",
    drop_empty: "هنوز هیچ پیام GaiaDrop بارگیری نشده است.",
    drop_id: "شناسه دراپ:",
    drop_own_address: "آدرس GaiaDrop شما",
    drop_proof: "DROP PROOF",
    drop_title: "صندوق ورودی امن GaiaDrop",
    dunkler_modus: "حالت تاریک",
    e2e_chat_room_open: "اتاق چت E2E را باز کنید",
    edit_profile: "ویرایش نمایه",
    edit_profile_desc: "نام نمایشی، بیو و آواتار را سفارشی کنید.",
    einladungscode: "کد دعوت",
    enter_fingerprint_chars_confirm: "برای تایید، کاراکترهای اثر انگشت درخواستی را وارد کنید.",
    envelope_hash: "هش پاکت نامه",
    erasability: "قابلیت حذف",
    erfolg: "موفقیت",
    exclude_plaintext: "صادرات بدون متن ساده",
    export_disclosure: "مورد امنیتی صادرات",
    export_package_desc: "فقط در صورتی متن ساده را درج کنید که این افشای عمدی باشد.",
    export_package_title: "بسته امنیتی صادراتی",
    fehler: "اشتباه",
    gaiacom_reader: "خواننده GaiaCOM",
    gaiadrop_inbox_title: "صندوق ورودی GaiaDrop",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM ابرداده‌ها را به حداقل می‌رساند، کلیدهای خصوصی را محلی نگه می‌دارد، محتوا را سرتاسر رمزگذاری می‌کند و حذف کامل حساب را فعال می‌کند.",
    gdpr_home_title: "100٪ مطابق با GDPR",
    gdpr_reason_delete: "حذف حساب، حساب، هویت، جلسات محلی و داده های قابل تخصیص سمت سرور را حذف می کند.",
    gdpr_reason_e2ee: "محتوای خصوصی فقط برای گیرندگان مورد نظر قابل رمزگشایی است.",
    gdpr_reason_minimal: "فراداده فقط برای مسیریابی، تحویل و اعتبارنامه های امنیتی استفاده می شود.",
    gdpr_reason_zero_knowledge: "کلیدهای خصوصی و داده های بازیابی به صورت محلی تحت کنترل کاربر باقی می مانند.",
    gesendet: "ارسال شد",
    gesperrt_verdaechtig: "مسدود شده / مشکوک",
    group_delete_desc: "آیا واقعاً می خواهید این گروه را برای همیشه حذف کنید؟ همه کانال ها و پیام های این گروه حذف خواهند شد.",
    group_delete_title: "حذف گروه",
    group_description: "توضیحات",
    group_icon_label: "نماد / آواتار گروه",
    group_name: "نام گروه",
    group_settings_avatar: "آواتار",
    group_settings_desc: "توضیحات",
    group_settings_is_crisis: "علامت گذاری به عنوان منطقه بحران",
    group_settings_name: "نام گروه",
    group_settings_title: "تنظیمات گروه",
    groups_empty_desc: "یک فضای کاری امن برای پروژه، بحران یا ارتباطات تیمی ایجاد کنید.",
    groups_empty_title: "هنوز چت گروهی وجود ندارد",
    gruppe_beitreten: "به گروه پیوست",
    gruppe_erstellen: "+ ایجاد گروه",
    gruppe_verlassen: "گروه رو ترک کن",
    gruppen_chats: "چت های گروهی",
    heller_modus: "حالت روشن",
    how_to_receive_drops: "چگونه دراپ دریافت کنم؟",
    identitaets_assistent: "دستیار هویت",
    inactivity_lock_duration: "در صورت غیر فعال بودن قفل شود",
    inactivity_lock_duration_desc: "پس از این دوره بدون ورودی، GaiaCOM به طور خودکار از نظر رمزنگاری قفل می شود.",
    inactivity_lock_notice: "GaiaCOM به دلیل عدم فعالیت رمزنگاری مسدود شده است.",
    include_plaintext: "شامل متن ساده",
    invite_code_label: "کد دعوت",
    join_group_title: "به گروه بپیوندید",
    kanaele: "کانال ها",
    kanal_erstellen: "+ کانال",
    kein_chat_ausgewaehlt: "هیچ گپی انتخاب نشده است",
    kein_kanal_ausgewaehlt: "کانالی انتخاب نشده است",
    keine_gruppe_ausgewaehlt: "هیچ گروهی انتخاب نشده است",
    keine_mails: "هیچ ایمیلی در دسترس نیست.",
    key_change_warn_desc: "کلید عمومی این مخاطب تغییر کرده است. قبل از اعتماد به اثر انگشت آن را بررسی کنید.",
    key_change_warn_title: "هشدار رمزنگاری",
    key_change_warning_changed: "تغییر کرده است. این ممکن است نشانه حمله مرد میانی باشد!",
    key_change_warning_msg: "کلید هویت برای مخاطب",
    key_transparency: "شفافیت کلید (تاریخچه کلید)",
    kopiert: "کپی شده است",
    kryptographische_schluessel: "کلیدهای رمزنگاری",
    kryptographische_schluessel_desc: "نمایش کلیدهای خصوصی و عبارت seed پشتیبان.",
    laden: "بارگذاری...",
    leeren: "خالی",
    loading: "بارگذاری...",
    local_key_vault: "طاق کلید محلی",
    local_keys_label: "کلیدهای محلی",
    lock_on_reload: "همیشه بعد از بارگیری مجدد قفل کنید",
    logout: "از سیستم خارج شوید",
    mail_compose: "نوشتن ایمیل",
    mein_profil: "پروفایل من",
    melden: "گزارش دهید",
    menu: "منو",
    message: "اخبار",
    message_id: "شناسه پیام",
    message_pin: "سنجاق",
    message_pinned_title: "پیام های پین شده",
    message_react: "واکنش نشان دهید",
    message_reply: "پاسخ دهید",
    message_replying_to: "پاسخ به",
    message_save: "ذخیره کنید",
    message_saved: "ذخیره شد",
    message_to_channel: "پیام به",
    message_unpin: "حل کنید",
    message_unsave: "پس انداز نکن",
    mitglied: "عضو",
    mitglieder: "اعضا",
    ml_kem: "ML-KEM",
    neue_mail: "ایمیل جدید",
    never_auto_lock: "هرگز به صورت خودکار",
    new_fingerprint: "اثر انگشت جدید",
    new_identity: "هویت جدید",
    new_password: "رمز عبور جدید",
    no_description: "بدون شرح",
    no_key_history: "هیچ تاریخچه کلیدی ثبت نشده است.",
    no_specification: "مشخص نشده است",
    old_fingerprint: "اثر انگشت قدیمی",
    open_privacy_imprint: "حفاظت از چاپ و اطلاعات را باز کنید",
    post_quantum_e2e: "E2E پس کوانتومی",
    posteingang: "صندوق ورودی",
    powered_by: "قدرتمند شده توسط",
    privacy_imprint_menu_desc: "نمایش GDPR، حفاظت از داده ها و اطلاعیه قانونی.",
    privacy_imprint_profile_desc: "GaiaCOM محتوای ارتباطی را بر اساس اصول کمینه سازی داده ها، رمزگذاری سرتاسر و کنترل کلید محلی پردازش می کند.",
    privacy_imprint_title: "حفاظت از داده ها و اطلاعیه قانونی",
    profil: "نمایه",
    profile_details: "جزئیات پروفایل",
    profile_settings_hint: "تنظیمات پروفایل در پنل سمت راست نمایش داده می شود.",
    profile_unlock_desc: "به دلایل امنیتی، برای مشاهده کلیدهای رمزنگاری خصوصی خود باید رمز عبور خود را دوباره وارد کنید.",
    proof_hash: "هش اثبات:",
    public_drop_desc: "ارسال امن برای اطلاعات متنی خارجی بدون حساب GaiaCOM.",
    public_drop_message: "اخبار",
    public_drop_message_placeholder: "متن محرمانه را وارد کنید...",
    public_drop_send: "GaiaDrop را ارسال کنید",
    public_drop_sender: "یادداشت فرستنده اختیاری است",
    public_drop_sender_placeholder: "نام، شماره پرونده یا ناشناس",
    public_drop_target: "GaiaID را هدف بگیرید",
    quanten_chat: "چت کوانتومی",
    quantum_secure_exchange: "تبادل امن کوانتومی از طریق...",
    quantum_secure_net: "GaiaCOM Quantum Secure Network (Ed25519 & ML-KEM)",
    quantum_shield_desc: "شبکه GaiaCOM از حریم خصوصی شما با یک پروتکل رمزگذاری چند لایه و ترکیبی محافظت می کند که در برابر حملات رایانه های کوانتومی آینده محافظت می شود.",
    quantum_shield_l1_desc: "از استاندارد FIPS 203 برای کپسوله کردن یک کلید مشترک متقارن استفاده می کند. از ضبط غیرفعال و رمزگشایی بعدی (\\",
    quantum_shield_l1_title: "1. حفاظت پس از کوانتومی (ML-KEM-1024)",
    quantum_shield_l2_desc: "یک روش کلاسیک و بسیار سریع تعویض کلید Diffie-Hellman که به عنوان یک لایه امنیتی اضافی در رویه ترکیبی عمل می کند.",
    quantum_shield_l2_title: "2. رمزنگاری منحنی بیضوی (X25519)",
    quantum_shield_l3_desc: "هر پیام و هر پاکت فدراسیون به صورت رمزنگاری امضا می شود تا صحت صحت فرستنده را صریحاً تأیید کند.",
    quantum_shield_l3_title: "3. امضاهای دیجیتال (Ed25519)",
    quantum_shield_l4_desc: "محتوای پیام را به صورت متقارن رمزگذاری می کند و فرستنده، گیرنده و ابرداده را به داده های اضافی تأیید شده (AAD) متصل می کند تا از حملات مجدد جلوگیری کند.",
    quantum_shield_l4_title: "4. احراز هویت AAD (AES-256-GCM)",
    quantum_shield_status: "وضعیت سپر کوانتومی",
    receive_drops_step1: "GaiaID خود را (مثلاً از طریق دکمه کپی در بالا) با منابع خارجی به اشتراک بگذارید.",
    receive_drops_step2: "آن‌ها صفحه ورود نمونه GaiaCOM شما را باز می‌کنند، به برگه می‌روند",
    receive_drops_step3: "و پیام رمزگذاری شده خود را به آدرس شما در آنجا ارسال می‌کنند.",
    receiver_gaia: "گیرنده GaiaCOM",
    receiver_smtp: "گیرنده SMTP",
    records_stored: "سوابق ذخیره شد",
    refresh: "به روز رسانی",
    report_abuse_desc: "آیا می خواهید این پیام را گزارش کنید و شواهد رمزنگاری سوء استفاده را به سرور ارسال کنید؟",
    report_abuse_title: "گزارش تخلف",
    reputation_status: "وضعیت اعتبار",
    room_chat_start_hint: "گفتگو را شروع کنید! همه پیام‌های این کانال گروهی E2E غیرمتمرکز و ایمن با رمزگذاری کوانتومی هستند.",
    room_policy_audit: "دنباله حسابرسی و چرخش کلید فعال است.",
    room_policy_crisis: "اتاق بحران",
    room_policy_e2ee: "فضای صفر دانش ایمن کوانتومی E2EE",
    room_policy_title: "دستورالعمل های اتاق",
    room_policy_zero_knowledge: "سیاست",
    room_security_note_desc: "همه تغییرات کلیدی از طریق کلید شفافیت تایید می شوند. از GaiaVault برای گزارش‌های پشتیبان خصوصی استفاده کنید.",
    room_security_note_title: "یادداشت امنیتی پین شده",
    save_profile: "ذخیره نمایه",
    schluessel_entsperrt: "🔑 دوباره کلید را قفل کنید",
    search_gaia_label: "آدرس گایا را پیدا کنید",
    security_warning_title: "هشدار امنیتی",
    select_channel_chat: "یک کانال را از نوار کناری سمت چپ برای چت انتخاب کنید.",
    select_contact_chat: "یک مخاطب را از پانل سمت چپ برای شروع یک چت E2E ایمن کوانتومی انتخاب کنید.",
    select_mail_read: "ایمیلی را از لیست انتخاب کنید تا محتوای کوانتومی آن را بخوانید یا پیام جدیدی ایجاد کنید.",
    senden: "ارسال کنید",
    sender_signature: "امضای فرستنده",
    server_log: "لاگ سرور:",
    server_received: "سرور دریافت کرد",
    session_lock: "قفل جلسه",
    setup_address_keys: "ایجاد آدرس و مجموعه کلید",
    setup_profile: "در نمایه تنظیم کنید",
    smtp_inbox_title: "دریافت SMTP",
    smtp_legacy_badge: "SMTP قدیمی / ناامن",
    smtp_mode_option: "پل قدیمی SMTP",
    smtp_security_warning: "این ایمیل از طریق پروتکل کلاسیک و رمزگذاری نشده SMTP ارسال شده است. هیچ رمزگذاری سرتاسری فعال نیست.",
    smtp_security_warning_desc: "این پیام از اتاق امنیتی GaiaCom خارج می شود. تحویل SMTP گارانتی انتها به انتها بومی GaiaCom، ضمانت TrustMesh و تضمین Godmode از دروازه ارائه نمی دهد.",
    spam_verdacht: "هرزنامه / مشکوک",
    spam_warning_desc: "این پیام دارای سیگنال های شهرت مشکوکی است.",
    spam_warning_title: "هشدار هرزنامه",
    speichern: "ذخیره کنید",
    sperren: "قفل کردن",
    standard_group_status: "چت گروهی استاندارد (E2EE رمزگذاری شده)",
    status: "وضعیت",
    subject: "در رابطه با",
    suchen: "یک آدرس جدید Gaia پیدا کنید...",
    tage: "روزها",
    time_unknown: "زمان نامعلوم",
    transmission_mode: "حالت انتقال",
    trust_age: "سن اعتماد",
    trust_passport_title: "پاسپورت اعتماد",
    unbestaetigt: "تایید نشده",
    unknown_sender: "ناشناس",
    unlock_btn: "باز کردن قفل",
    unlock_btn_profile: "باز کردن قفل",
    unlock_desc: "فایل کلید خصوصی شما به صورت رمزگذاری شده ذخیره می شود. رمز عبور خود را وارد کنید تا کلیدهای رمزنگاری فقط در حافظه بارگیری شوند.",
    unlock_logout: "از سیستم خارج شوید و کلیدهای محلی را ببندید",
    unlock_title: "باز کردن قفل هویت",
    untrusted: "نامعتبر",
    update_password: "رمز عبور را به روز کنید",
    upload_avatar_btn: "آپلود تصویر (عفونی شده)",
    vault_btn_encrypt: "رکورد را رمزگذاری کنید",
    vault_btn_lock: "گاوصندوق را قفل کنید",
    vault_btn_unlock: "گاوصندوق را باز کنید",
    vault_copied_success: "در کلیپ بورد کپی شد",
    vault_decrypted_content: "محتوای رمزگشایی شده",
    vault_desc: "طاق رمزگذاری شده محلی برای پشتیبان‌گیری بازیابی، یادداشت‌های هویت، دسترسی به سرور، مخاطبین اضطراری، یادداشت‌های قانونی، رویدادهای امنیتی و گزارش‌های خصوصی.",
    vault_empty: "هیچ سابقه ایمن هنوز ذخیره نشده است.",
    vault_locked_pane_notice: "صندوق قفل است. لطفا از سمت راست باز کنید.",
    vault_new_record: "رکورد جدید امن",
    vault_pwd_placeholder: "رمز عبور Vault را وارد کنید...",
    vault_record_body: "ضبط محتوا",
    vault_record_body_placeholder: "محتوای رکورد رمزگذاری شده را وارد کنید...",
    vault_record_category: "دسته بندی",
    vault_record_title: "عنوان رکورد",
    vault_record_title_placeholder: "عنوان سابقه امن",
    vault_title: "GaiaVault Secure Records",
    verify_new_fingerprint_hint: "قبل از پذیرش کلید، اثر انگشت جدید را بررسی کنید.",
    vertrauenswuerdig: "قابل اعتماد",
    vision_gaia_technology: "VisionGaiaTechnology",
    von: "از",
    warnung: "هشدار",
    wizard_address: "آدرس",
    wizard_back: "برگشت",
    wizard_check1: "من بذرم را با خیال راحت نجات داده ام.",
    wizard_custom_domain: "از دامنه خود استفاده کنید",
    wizard_desc1: "GaiaCOM کلیدهای خصوصی را در سمت سرور ذخیره نمی کند. بدون Mnemonic Seed، هیچ کس نمی تواند پیام های از دست رفته را بازیابی کند.",
    wizard_desc2: "آدرس شما گره فدرالی را تعیین می کند که پاکت های رمزگذاری شده از طریق آن مسیریابی می شوند.",
    wizard_fallback: "گره های بازگشتی",
    wizard_finish: "راه اندازی کامل",
    wizard_next: "بیشتر",
    wizard_server_domain: "دامنه گره سرور",
    wizard_step1: "1. Backup Seed",
    wizard_step2: "2. آدرس و سرور",
    wizard_title1: "از کلید بازیابی نسخه پشتیبان تهیه کنید",
    wizard_title2: "آدرس GaiaCOM را انتخاب کنید",
    write_message_placeholder: "یک پیام امن بنویسید...",
    you: "شما",
    zero_knowledge: "دانش صفر",
    zero_knowledge_encryption: "رمزگذاری دانش صفر",
    "Chat fuer alle geleert": "چت برای همه شرکت کنندگان خالی شده است.",
    "Chat geleert": "چت برای صندوق ورودی محلی شما پاک شده است.",
    "Nachricht fuer alle geloescht": "پیام برای همه شرکت کنندگان حذف شده است.",
    "Nachricht geloescht": "پیام چت به صورت محلی از صندوق ورودی شما حذف شده است.",
    "anpinnen": "سنجاق",
    "chat_loeschen": "حذف چت",
    "confirm_delete_chat_desc": "آیا مطمئن هستید که می خواهید چت را حذف و پنهان کنید؟",
    "confirm_leave_group_desc": "آیا واقعاً می خواهید این گروه را ترک کنید؟",
    "entpinnen": "پین را بردارید",
    "group_deleted": "گروه با موفقیت حذف شد.",
    "group_left": "با موفقیت گروه را ترک کنید",
    "gruppe_loeschen": "حذف گروه",
    "loeschen": "حذف کنید",
    "no_active_chats": "بدون چت فعال برای شروع یک چت، مخاطبین بالا را جستجو کنید.",
    "pinned": "پین شده",
    "wizard_check_credentials": "من مسئول حفظ امنیت اطلاعات دسترسی خود هستم.",
    "wizard_check_is_beta": "من می دانم که GaiaCom یک نرم افزار بتا است.",
    "wizard_check_no_illegal": "من از GaiaCom برای مقاصد غیرقانونی استفاده نخواهم کرد.",
    "wizard_check_no_uptime": "من می دانم که هیچ تضمینی برای در دسترس بودن وجود ندارد.",
    "wizard_check_smtp_security": "من می دانم که پیام های SMTP امنیت کامل GaiaCom را فراهم نمی کنند.",
    "wizard_check_terms_read": "من شرایط خدمات بتا را خوانده ام.",
    "wizard_step_terms": "شرایط استفاده",
    "wizard_terms_text": "شرایط استفاده از GaiaCom و توافقنامه آزمایش بتا (فاز بتا)\n\nارائه دهنده: VisionGaiaTechnology (از این پس \"ارائه دهنده\" نامیده می شود)\nوضعیت: مرحله آزمایش بتا عمومی\nاعتبار: از 21 ژوئن 2026\n\n⚠️ مهم ترین نکته از قبل (لطفا با دقت بخوانید)\nGaiaCom در مرحله آزمایش عمومی بتا است. علیرغم اقدامات امنیتی گسترده، رهایی از خطا، در دسترس بودن مداوم یا امنیت مطلق نرم افزار و زیرساخت های زیربنایی را نمی توان تضمین کرد. با مسئولیت خود استفاده کنید. کاربران مسئول ذخیره ایمن داده های دسترسی خود (به ویژه کلیدهای GaiaVault) و رعایت قوانین قابل اجرا هستند.\n\n1. موضوع و هدف مرحله آزمایش بتا\n1.1. هدف از ارائه: GaiaCom یک سرویس ایمیل و چت جدید مبتنی بر رمزنگاری پس کوانتومی (PQC) است. ارائه در مرحله بتا منحصراً برای آزمایش فنی، شبیه‌سازی بار، یافتن خطاهای برنامه (باگ‌ها) و بهینه‌سازی کاربرپسندی در نظر گرفته شده است.\n1.2. وضعیت بتا: کاربر آگاه است که نرم افزار ارائه شده یک نسخه اولیه (نرم افزار بتا) است. این هنوز از نظر فنی به طور کامل توسعه نیافته است، استانداردهای یک محصول تجاری نهایی را برآورده نمی کند و می تواند باعث خطا، از دست دادن داده، تاخیر در انتقال یا خرابی سیستم شود.\n1.3. بدون حق ادامه: ارائه دهنده حق دارد در هر زمان خدمات را به طور کامل یا جزئی قطع کند، عملکردها را تغییر یا محدود کند یا آنها را به طور موقت یا دائم بدون ذکر دلیل حذف کند.\n\n2. در دسترس بودن و سلب مسئولیت از گارانتی\n2.1. بدون ضمانت در دسترس بودن: GaiaCom بدون هیچ ضمانتی در مورد در دسترس بودن یا آپتایم ارائه می شود. حق دسترسی بدون وقفه خدمات وجود ندارد.\n2.2. محرومیت از گارانتی: نرم افزار در وضعیت فعلی (\"همانطور که هست\") و مشروط به در دسترس بودن ارائه می شود. تا جایی که قانون اجازه دهد، هرگونه ادعای ضمانت برای نقص مادی و قانونی در نرم افزار مستثنی است. به طور خاص، هیچ تضمینی وجود ندارد که نرم افزار بدون خطا، عاری از بدافزار یا مناسب برای یک هدف خاص باشد.\n\n3. مدیریت ریسک و تعهدات کاربر\n3.1. ممنوعیت ذخیره سازی داده های حیاتی: کاربر متعهد می شود که به طور انحصاری اطلاعات مهم تجاری، حیاتی، عملیاتی ضروری یا از نظر قانونی خاص حساس (مانند پرونده های بیمار، داده های مالی بسیار حساس یا اسرار رسمی تنظیم شده) را ذخیره یا از طریق GaiaCom منتقل نکند. این سرویس نمی‌تواند برای زیرساخت‌هایی استفاده شود که خرابی‌های پیش‌بینی‌نشده می‌تواند منجر به صدمات شخصی، آسیب مالی یا ضرر مالی قابل توجه شود.\n3.2. تهیه نسخه پشتیبان با مسئولیت شخصی: کاربر مسئول تهیه نسخه پشتیبان از کلیه داده های دریافت یا ارسال شده از طریق GaiaCom است که در درازمدت به آنها در سیستم های مستقل و مستقل خود (نسخه های پشتیبان) نیاز دارد. ارائه دهنده ذخیره سازی یا بازیابی دائمی داده ها در سرورهای خود را تضمین نمی کند.\n\n4. ویژگی های رمزنگاری و GaiaVault\n4.1. رمزنگاری پس کوانتومی (PQC): GaiaCom فرآیندهای رمزگذاری پیشرفته و آینده‌گرا را پیاده‌سازی می‌کند که برای مقاومت در برابر حملات رایانه‌های کوانتومی آینده طراحی شده‌اند. با این حال، کاربر آگاه است که این یک زمینه علمی پویا و جدید است. امنیت مطلق و غیرقابل انکار را نمی توان بر اساس وضعیت فعلی علم و فناوری تضمین کرد. عباراتی مانند \"100% ایمن\"، \"غیرقابل شکست\" یا \"امن نظامی\" به صراحت تضمین نمی شوند.\n4.2. بدون ضمانت بازیابی (GaiaVault): GaiaCom بر یک مفهوم امنیتی با دانش صفر متکی است. گوه های رمزگذاری و داده های دسترسی فقط در کنترل کاربر باقی می مانند (از طریق GaiaVault ایمن می شوند).\nمهم: اگر کاربر رمز عبور، عبارات عبور، کلیدهای خصوصی یا دانه‌های بازیابی خود را گم کند، ارائه‌دهنده هیچ توانایی فنی برای بازسازی یا بازنشانی این داده‌ها ندارد. از دست دادن این داده های دسترسی به ناچار منجر به از دست دادن غیرقابل برگشت دسترسی به حساب کاربری و تمام داده های رمزگذاری شده در آن می شود.\n4.3. هنوز به طور کامل ممیزی نشده است: این نرم افزار به طور مداوم تحت بررسی های امنیتی داخلی قرار می گیرد، اما در زمان این مرحله بتا هنوز مورد بازرسی نهایی و جامع امنیت خارجی توسط نهادهای آزمایش مستقل قرار نگرفته است.\n\n5. رابط ها، پروتکل های قدیمی و فدراسیون\n5.1. SMTP Bridge توجه: GaiaCom امکان برقراری ارتباط از طریق پروتکل های ایمیل کلاسیک (مانند SMTP) را ارائه می دهد. کاربر می‌داند که پیام‌هایی که از ناحیه امنیتی GaiaCom خارج می‌شوند (مثلاً زمانی که به آدرس @gmail.com یا @gmx.de مرسوم ارسال می‌شوند) از طریق سرورهای رمزگذاری نشده یا شخص ثالث منتقل می‌شوند. ضمانت‌های امنیتی سرتاسر GaiaCom فقط به میزان محدودی اعمال می‌شود یا اصلاً در مورد پیام‌های قدیمی خروجی یا ورودی خارجی اعمال نمی‌شود.\n5.2. توجه فدراسیون: اگر GaiaCom در یک شبکه فدرال کار می کند، پیام ها و داده ها ممکن است از طریق سرورهای شخص ثالث منتقل شوند. در حالی که محتویات پیام‌ها با رمزگذاری سرتاسر محافظت می‌شوند، ابرداده‌ها (مانند زمان ارسال، آدرس‌های IP سرورهای درگیر و آدرس‌های گیرنده) ممکن است از نظر فنی برای اپراتورهای این سرورهای فدرال قابل مشاهده باشند. ارائه‌دهنده هیچ تأثیری بر رویه‌های حفاظت از داده‌های اپراتورهای سرور شخص ثالث در شبکه فدرال ندارد.\n\n6. استفاده های قابل قبول و فعالیت های ممنوع\nکاربر متعهد می شود که از خدمات به صورت نادرست یا برای مقاصد غیرقانونی استفاده نکند. به ویژه موارد زیر ممنوع است:\n- توزیع، ارسال یا میزبانی ویروس ها، بدافزارها، محتوای فیشینگ یا سایر نرم افزارهای مخرب.\n- استفاده از سرویس برای انجام حملات انکار سرویس (DDoS) یا ارسال نامه های انبوه ناخواسته (هرزنامه).\n- سوء استفاده از سیستم برای ارتکاب کلاهبرداری.\n- توزیع یا مبادله محتوای غیرقانونی، به ویژه تصاویر سوء استفاده جنسی از کودکان (CSAM)، تبلیغات تروریستی، دعوت به خشونت یا سایر محتوای مرتبط با جنایت.\n\n7. سیستم گزارش تخلف\n7.1. گزارش رفتار توهین آمیز: کاربران این فرصت را دارند که از طریق سیستم یکپارچه سوء استفاده، ارتباطات توهین آمیز یا فعالیت های غیرقانونی را گزارش کنند.\n7.2. پردازش گزارش‌ها: به منظور اطمینان از محافظت در برابر سوء استفاده، گزارش‌های دریافتی را می‌توان از نظر فنی تحلیل کرد (با حفظ حریم خصوصی و محدودیت‌های رمزگذاری). این امر می تواند منجر به تعلیق موقت یا دائمی حساب های کاربری یا آدرس های IP در صورت نقض اثبات شده این شرایط استفاده شود.\n\n8. محدودیت مسئولیت\n8.1. استاندارد مسئولیت: نرم افزار بتا به صورت رایگان ارائه می شود. بر اساس قوانین قانونی برای اهدا یا وام، ارائه دهنده تنها در قبال عمد (خسارت عمدی) و سهل انگاری فاحش مسئولیت دارد.\n8.2. محرومیت از مسئولیت از دست دادن داده ها: مسئولیت از دست دادن داده ها مستثنی است، مگر اینکه از دست دادن به عمد یا در اثر سهل انگاری فاحش توسط ارائه دهنده ایجاد شده باشد و کاربر تعهد خود را برای کاهش خسارت از طریق پشتیبان گیری منظم (خارج از GaiaCom) انجام داده باشد.\n8.3. محدودیت های قانونی: محدودیت های مسئولیت فوق در مورد آسیب به جان، بدن یا سلامتی یا مسئولیت تحت قانون مسئولیت محصول اعمال نمی شود.\n\n9. متن باز\nبرخی از مؤلفه‌ها، کتابخانه‌ها یا برنامه‌های سرویس گیرنده GaiaCom ممکن است تحت مجوزهای منبع باز مجوز داشته باشند (مانند GPL، MIT، Apache). شرایط مجوز مربوطه این مؤلفه‌ها تحت تأثیر این شرایط استفاده قرار نگرفته و می‌توانند در مخازن کد منبع مربوطه مشاهده شوند.\n\n10. کنترل صادرات و انطباق\nکاربر می‌داند که نرم‌افزار رمزنگاری ممکن است تحت کنترل‌های سخت‌گیرانه صادرات و محدودیت‌های قانونی باشد. کاربر مسئول اطمینان از این است که استفاده از GaiaCom قوانین، محدودیت‌های واردات/صادرات یا مقررات رمزنگاری کشور محل اقامت خود را نقض نمی‌کند.\n\n11. اطلاعیه حفاظت از داده ها (نسخه کوتاه برای نسخه بتا)\n11.1. جمع‌آوری حداقل داده‌ها: به عنوان بخشی از مرحله بتا، ارائه‌دهنده تنها داده‌هایی را جمع‌آوری می‌کند که برای عملیات فنی، عیب‌یابی و توسعه بیشتر ضروری است (مانند فایل‌های گزارش سرور برای تشخیص خطا).\n11.2. بدون بینش در مورد محتوا: به لطف دانش صفر و رمزگذاری E2E، ارائه‌دهنده هرگز به محتوای چت‌ها، ایمیل‌ها یا کلیدهای ذخیره شده در GaiaVault دسترسی ندارد.\n11.3. اعلامیه دقیق حفاظت از داده ها: مقررات دقیق حفاظت از داده ها به طور جداگانه پیوند داده شده است و همچنین باید قبل از ثبت نام توسط کاربر در نظر گرفته شود.\n\n12. مقررات نهایی\n12.1. قانون قابل اجرا: قانون جمهوری فدرال آلمان، به استثنای کنوانسیون سازمان ملل متحد در مورد قراردادهای فروش بین المللی کالا، اعمال می شود.\n12.2. مشروط به تغییر: از آنجایی که GaiaCom در حال توسعه فعال است، ارائه‌دهنده این حق را برای خود محفوظ می‌دارد که در هر زمان این شرایط را با اثرگذاری برای آینده تطبیق دهد. نسخه فعلی در برنامه موجود است.",
    "wizard_terms_title": "شرایط استفاده از GaiaCom و توافقنامه آزمایش بتا (فاز بتا)",
    "node_operator": "اپراتور گره",
    "search_channels": "جستجوی کانال ها...",
    "senior_reviewer": "داور ارشد",
    "trusted_reviewer": "داور مورد اعتماد",
    "active_frequencies": "فرکانس های فعال",
    "connected_rooms": "فضاهای متصل",
    "dashboard": "داشبورد",
    "empty_chats": "هیچ چت فعالی در دسترس نیست.",
    "empty_messages": "هیچ پیام جدیدی در دسترس نیست.",
    "encrypted": "رمزگذاری شده است",
    "gaiacom_uplink": "GAIACOM UPLINK",
    "install_app": "برنامه را نصب کنید",
    "install_app_desc": "برای شروع سریع و حالت آفلاین",
    "kommandozentrale_alpha": "مرکز فرماندهی ALPHA",
    "network_online": "شبکه: آنلاین",
    "new_room": "فضای جدید",
    "no_frequencies_active": "هیچ فرکانس فعالی نیست یک اتاق جدید برای شروع ارتباط ایجاد کنید.",
    "no_id": "بدون شناسه",
    "open_chats": "چت ها را باز کنید",
    "open_inbox": "صندوق ورودی را باز کنید",
    "primary_identity": "هویت اولیه",
    "recent_chats": "چت های جدید",
    "recent_messages": "آخرین اخبار",
    "session_encrypted": "جلسه رمزگذاری شده: {name}",
    "session_secure": "وضعیت: امن",
    "system_verlassen": "سیستم خروج",
    "write_message": "پیام بنویس",
  },
  ja: {
    sc_title: "セキュリティセンター",
    sc_subtitle: "GaiaShield統合セキュリティレイヤー",
    sc_tab_status: "🛡️ 保護ステータス",
    sc_tab_events: "📋 セキュリティログ",
    sc_tab_node: "⚙️ ノードセキュリティ",
    sc_loading: "セキュリティデータを読み込み中...",
    sc_status_secured: "システムステータス: アカウントは保護されています",
    sc_status_warning: "システムステータス: 警告がアクティブです",
    sc_desc_secured: "アクティブな重大なセキュリティ警告はありません。GaiaShieldはアカウントをアクティブに監視しています。",
    sc_desc_warning: "注意: 注意が必要なアクティブなセキュリティイベントがあります。",
    sc_account_protection: "アカウント保護",
    sc_message_protection: "メッセージ保護",
    sc_audits: "セキュリティ監査",
    sc_active: "アクティブ",
    sc_failed_logins: "ログイン失敗",
    sc_tamper_checks: "改ざんチェック",
    sc_blocked_replays: "ブロックされたリプレイ",
    sc_last_check: "最終チェック",
    sc_just_now: "たった今",
    sc_open_warnings: "未確認の警告",
    sc_btn_acknowledge: "確認する",
    sc_filter_severity: "重要度",
    sc_filter_category: "カテゴリ",
    sc_filter_hide_ack: "確認済みを非表示",
    sc_btn_export: "エクスポート",
    sc_col_details: "詳細",
    sc_col_time: "時間",
    sc_col_status: "ステータス",
    sc_col_action: "アクション",
    sc_no_events: "セキュリティイベントは見つかりませんでした。",
    sc_node_title: "ノードオペレーターセキュリティコンソール",
    sc_system_health: "システムヘルス",
    sc_last_audit: "最終監査",
    sc_packed_logs: "アーカイブされたログ",
    sc_unconfirmed_events: "未確認イベント",
    sc_operator_action: "オペレーターのアクションが必要です",
    sc_all_ok: "すべて正常",
    sc_critical_events: "重大なシステムイベント",
    ac_title: "ガバナンス＆報告センター",
    ac_subtitle: "GaiaComガバナンス＆アビューズコンセンサス",
    ac_tab_my_reports: "マイレポート",
    ac_tab_queue: "レビュー待ち",
    ac_tab_operator: "ノードオペレーター",
    ac_tab_transparency: "フェデレーション＆透明性",
    ac_loading: "データを読み込み中...",
    ac_reported_cases: "報告されたケース",
    ac_no_reports: "報告書はまだ送信されていません。",
    ac_case_details: "ケース詳細",
    ac_appeal_submit: "異議申し立てを送信する",
    ac_appeal_status: "異議申し立てのステータス",
    ac_appeal_reason: "異議申し立ての理由",
    ac_appeal_statement: "声明・説明",
    ac_btn_appeal: "異議申し立てを送信する",
    ac_trusted_reviewer_queue: "信頼されたレビュー担当者キュー",
    ac_case_review: "ケースのレビュー",
    ac_review_category: "推奨カテゴリ",
    ac_review_severity: "推奨重要度",
    ac_review_action: "推奨アクション",
    ac_review_reason: "レビュー担当者の理由",
    ac_btn_submit_review: "レビューを送信する",
    ac_node_operator_dashboard: "ノードオペレーターダッシュボード",
    ac_apply_action: "アクションを適用する (オーバーライド)",
    ac_target_type: "ターゲットタイプ",
    ac_target_id: "ターゲットID (GaiaIDまたはチャンネルID)",
    ac_suspend: "サスペンド有効",
    ac_reason: "公式の理由",
    ac_btn_apply: "アクションを強制する",
    ac_transparency_title: "コンセンサス＆透明性ログブック",
    ac_transparency_desc: "モデレートされたすべてのチャネルおよびIDの公開可能なスナップショット証明。",
    ac_btn_snapshot: "透明性スナップショットを作成する",
    search_placeholder: "件名、送信者、本文でメールを検索...",
    abuse_center_title: "不正報告センター",
    abbrechen: "キャンセル",
    active_identities: "アクティブなアイデンティティ",
    active_identity: "アクティブなアイデンティティ",
    add_btn: "追加",
    add_contact_title: "連絡先を追加",
    admin: "管理者",
    adressbuch: "ディレクトリ",
    aktiviert: "有効",
    an: "宛先",
    anonymous_sender: "匿名の送信者",
    antworten: "答え",
    attachment_gaia_hint: "GaiaCOM の添付ファイルはエンドツーエンドで暗号化されたままになります。",
    attachment_smtp_hint: "従来の SMTP は、実行可能ファイルやスクリプトのような添付ファイルをブロックし、電子メールを安全でないものとして保存します。",
    attachments: "添付ファイル",
    auffaellig: "不審",
    auth_beta_notice: "ベータ テスト段階: GaiaCOM は積極的にテストされています。エラーが発生する可能性があります。重要なシードを確保し、機密ワークフローを慎重にレビューします。",
    auth_btn_login: "ID をロードしてログインする",
    auth_btn_register: "暗号通貨の登録と作成",
    auth_copied: "コピーされました",
    auth_copy_seed: "シードをコピーする",
    auth_generate_seed: "シードを生成する",
    auth_headline: "GaiaCOM は、人類のために構築された初の量子安全電子メール プロトコルおよび通信システムです。",
    auth_kicker: "ポスト量子セキュア通信",
    auth_mnemonic: "ニーモニックフレーズ",
    auth_mnemonic_placeholder: "スペースで区切られた 12 個の単語...",
    auth_password: "パスワード",
    auth_password_placeholder: "",
    auth_proof_e2ee_desc: "秘密キーはデバイスから流出しません。意図された受信者のみがコンテンツを復号化できます。",
    auth_proof_gaiadata_desc: "ゼロ知識: データは自分で管理できます。メタデータは最小化され、プレーン テキスト プロファイルとしては使用されません。",
    auth_proof_gaiadrop_desc: "外部の人は、アカウントなしであなたの GaiaID に機密テキスト メッセージを送信できます。",
    auth_proof_gaiaproof_desc: "配信と完全性の証拠は、暗号文、送信者、タイムスタンプが改ざんされていないことを示しています。",
    auth_proof_gaiavault_desc: "プライベートメモ、リカバリメモ、セキュリティレコードはローカルで暗号化されたままになります。",
    auth_proof_hybrid_desc: "Quantum Shield: ML-KEM と X25519 を使用したハイブリッド暗号化は、今日の攻撃と、保存して後で復号化するリスクから保護します。",
    auth_secure_mail: "安全な量子連携メール",
    auth_subline: "GaiaCOM は、電子メール、チャット、危機管理室、GaiaDrop、ローカル セキュリティ ファイル用の量子安全通信システムです。秘密キーはデバイス上に残り、コンテンツはエンドツーエンドで暗号化され、証拠は平文なしでエクスポートできます。",
    auth_success_btn: "今すぐログインしてください",
    auth_success_text: "GaiaCOM アカウントが作成されました。キーはシードからローカルに派生され、サーバーには保存されませんでした。",
    auth_success_title: "登録が成功しました",
    auth_tab_drop: "ガイアドロップ",
    auth_tab_login: "ログイン/アカウント",
    auth_toggle_login: "アカウントはすでに存在します",
    auth_toggle_register: "新しいアカウントを作成する",
    auth_usecase_text: "弁護士、企業、当局、ジャーナリスト、内部告発者、個人のセキュリティ事件に適しています。",
    auth_usecase_title: "機密性の高いコミュニケーションのために構築",
    auth_username: "ユーザー名",
    auth_username_placeholder: "名前を入力してください...",
    auth_value_chat: "E2E チャット",
    auth_value_drop: "セキュアドロップ",
    auth_value_mail: "安全なメール",
    auth_value_rooms: "ガイアルームズ",
    bestaetigen: "確認する",
    bestaetigt: "確認済み",
    bio_status: "略歴・地位",
    biography: "バイオグラフィー",
    change_password_desc: "サーバー側のログインパスワードを変更します。ローカルの回復フレーズは、保管庫/ロック解除パスワードによって個別に保護されたままになります。",
    change_password_menu_desc: "GaiaCOM ログイン パスワードを更新します。",
    change_password_title: "パスワードを変更する",
    channel_id: "チャンネルID",
    channel_name_label: "チャンネル名",
    chat_deleted_hidden: "チャットが削除され、非表示になりました。",
    chat_input_placeholder: "安全なメッセージを入力してください...",
    chat_start_hint: "会話を始めましょう！すべてのチャット メッセージは量子セキュア E2E 暗号化されています。",
    choose_avatar: "アバターを選択してください",
    ciphertext_hash: "暗号文ハッシュ",
    clear_chat: "空のチャット",
    clear_for_everyone: "誰にとっても空です",
    clear_for_me: "私だけのための空",
    click_to_write_mail: "クリックしてメールを書く",
    click_top_right: "右上をクリックしてください",
    close: "近い",
    code_kopieren: "コードをコピーする",
    code_kopieren_success: "コードをコピーしました",
    confirm_clear_channel_desc: "このチャンネルをローカルビューから消去しますか?",
    confirm_clear_channel_title: "空のチャンネル",
    confirm_clear_chat: "このチャットを空にしますか?",
    confirm_clear_chat_desc: "このチャットを空にしますか?",
    confirm_clear_chat_title: "空のチャット",
    confirm_clear_everyone: "両方のパートナーのチャットを空にしますか? (OK = 全員、キャンセル = 私だけ)",
    confirm_delete_everyone: "両方のパートナーへのメッセージを削除しますか? (OK = 全員、キャンセル = 私だけ)",
    confirm_delete_msg: "このメッセージを削除しますか?",
    confirm_delete_msg_desc: "このチャット メッセージを削除しますか?",
    confirm_delete_msg_title: "メッセージを削除する",
    confirm_new_password: "新しいパスワードを確認します",
    copy: "コピー",
    create_btn: "作成する",
    create_channel_title: "チャンネルの作成",
    create_group_is_crisis: "危機地域としてマークする",
    create_group_title: "新しいグループを作成する",
    crypto_lock_desc: "GaiaCOM がメモリからローカル暗号キーを削除するタイミングを制御します。",
    crypto_lock_menu_desc: "リロードタイマーと非アクティブタイマーを制御します。",
    crypto_lock_title: "暗号ロック",
    crypto_session_duration: "リロード後にロック解除される",
    crypto_session_duration_desc: "選択した期間だけ、このブラウザ タブで暗号化セッションを開いたままにします。",
    cryptographic_fingerprint: "暗号化指紋",
    current_password: "現在のパスワード",
    data_minimization: "データ最小化",
    decrypt_failed: "解読不能",
    delete: "消去",
    delete_account_button: "アカウントを取り消し不能に削除する",
    delete_account_confirm_label: "「DELETE」と入力して確認します",
    delete_account_confirmation_error: "パスワードと削除の確認が必要です。",
    delete_account_desc: "このモードでは、アカウント、ID、デバイス セッション、GaiaDrop データ、アップロード メタデータ、およびサーバー側に起因するメッセージが永久に破壊されます。",
    delete_account_done_desc: "割り当て可能なすべての GaiaCOM データが削除されました。",
    delete_account_done_title: "アカウントが削除されました",
    delete_account_menu_desc: "アカウントと関連データを破棄します。",
    delete_account_not_authenticated: "アクティブなアカウントはありません。",
    delete_account_title: "アカウントを削除する",
    delete_for_everyone: "全員に削除",
    delete_for_me: "私だけに削除してください",
    device_current: "このデバイス",
    device_last_seen: "最後",
    device_logout: "ログアウト",
    device_sessions_desc: "アクティブなセッションを確認し、信頼できなくなったデバイスの登録を解除します。",
    device_sessions_empty: "デバイスが見つかりませんでした。",
    device_sessions_menu_desc: "アクティブなセッションを管理および終了します。",
    device_sessions_title: "登録済みのデバイス",
    device_since: "以来",
    display_name: "表示名",
    drop_address_copied: "GaiaDrop アドレスがコピーされました。",
    drop_btn_decrypting: "受信トレイを復号化しています...",
    drop_btn_load: "GaiaDrop 受信箱をロードする",
    drop_delete_desc: "このドロップを完全に削除してもよろしいですか?",
    drop_delete_title: "GaiaDropを削除する",
    drop_desc: "外部通知、責任ある開示、機密報告のためのテキストのみのゼロ知識ドロップ チャネル。外部の関係者は、GaiaID を使用してアカウントなしでメッセージを送信できます。",
    drop_empty: "GaiaDrop メッセージはまだロードされていません。",
    drop_id: "ドロップID:",
    drop_own_address: "GaiaDrop アドレス",
    drop_proof: "DROP PROOF",
    drop_title: "GaiaDrop 安全な受信箱",
    dunkler_modus: "ダークモード",
    e2e_chat_room_open: "E2E チャット ルームを開く",
    edit_profile: "プロフィールの編集",
    edit_profile_desc: "表示名、プロフィール、アバターをカスタマイズします。",
    einladungscode: "招待コード",
    enter_fingerprint_chars_confirm: "要求された指紋文字を入力して確認します。",
    envelope_hash: "エンベロープハッシュ",
    erasability: "消去可能性",
    erfolg: "成功",
    exclude_plaintext: "プレーンテキストなしでエクスポート",
    export_disclosure: "セキュリティケースのエクスポート",
    export_package_desc: "この開示が意図されている場合は、プレーン テキストのみを含めてください。",
    export_package_title: "セキュリティパッケージのエクスポート",
    fehler: "間違い",
    gaiacom_reader: "GaiaCOMリーダー",
    gaiadrop_inbox_title: "GaiaDropインボックス",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM はメタデータを最小限に抑え、秘密キーをローカルに保持し、コンテンツをエンドツーエンドで暗号化し、アカウントの完全な削除を可能にします。",
    gdpr_home_title: "100% GDPR 準拠",
    gdpr_reason_delete: "アカウントを削除すると、アカウント、ID、ローカル セッション、およびサーバー側で割り当て可能なデータが削除されます。",
    gdpr_reason_e2ee: "プライベート コンテンツは、意図された受信者のみが復号化できます。",
    gdpr_reason_minimal: "メタデータは、ルーティング、配信、およびセキュリティ認証情報にのみ使用されます。",
    gdpr_reason_zero_knowledge: "秘密キーと回復データはローカルでユーザーの管理下に残ります。",
    gesendet: "送信済み",
    gesperrt_verdaechtig: "ブロック中 / 不審",
    group_delete_desc: "このグループを完全に削除してもよろしいですか?このグループ内のすべてのチャンネルとメッセージが削除されます。",
    group_delete_title: "グループの削除",
    group_description: "説明",
    group_icon_label: "グループアイコン/アバター",
    group_name: "グループ名",
    group_settings_avatar: "アバター",
    group_settings_desc: "説明",
    group_settings_is_crisis: "危機地域としてマークする",
    group_settings_name: "グループ名",
    group_settings_title: "グループ設定",
    groups_empty_desc: "プロジェクト、危機、チームのコミュニケーションのための安全なワークスペースを作成します。",
    groups_empty_title: "グループチャットはまだありません",
    gruppe_beitreten: "参加したグループ",
    gruppe_erstellen: "+ グループの作成",
    gruppe_verlassen: "グループを離れる",
    gruppen_chats: "グループチャット",
    heller_modus: "ブライトモード",
    how_to_receive_drops: "ドロップの受信方法は？",
    identitaets_assistent: "ID アシスタント",
    inactivity_lock_duration: "非アクティブ時にロックする",
    inactivity_lock_duration_desc: "この期間入力がない場合、GaiaCOM は自動的に暗号的にロックされます。",
    inactivity_lock_notice: "GaiaCOM は、非アクティブのため暗号的にブロックされました。",
    include_plaintext: "プレーンテキストを含める",
    invite_code_label: "招待コード",
    join_group_title: "グループに参加する",
    kanaele: "チャンネル",
    kanal_erstellen: "+チャンネル",
    kein_chat_ausgewaehlt: "チャットが選択されていません",
    kein_kanal_ausgewaehlt: "チャンネルが選択されていません",
    keine_gruppe_ausgewaehlt: "グループが選択されていません",
    keine_mails: "利用できる電子メールはありません。",
    key_change_warn_desc: "この連絡先の公開キーが変更されました。指紋を信頼する前に確認してください。",
    key_change_warn_title: "暗号化に関する警告",
    key_change_warning_changed: "変わりました。これは中間者攻撃の兆候である可能性があります。",
    key_change_warning_msg: "連絡先の公開鍵",
    key_transparency: "鍵の透明性（鍵履歴）",
    kopiert: "コピーされました",
    kryptographische_schluessel: "暗号キー",
    kryptographische_schluessel_desc: "秘密キーとバックアップ シード フレーズを表示します。",
    laden: "負荷...",
    leeren: "空の",
    loading: "負荷...",
    local_key_vault: "ローカルキーコンテナー",
    local_keys_label: "ローカルキー",
    lock_on_reload: "リロード後は必ずロックする",
    logout: "ログアウト",
    mail_compose: "メールを書く",
    mein_profil: "私のプロフィール",
    melden: "報告",
    menu: "メニュー",
    message: "ニュース",
    message_id: "メッセージID",
    message_pin: "ピン",
    message_pinned_title: "固定メッセージ",
    message_react: "反応する",
    message_reply: "答え",
    message_replying_to: "への回答",
    message_save: "保存",
    message_saved: "保存されました",
    message_to_channel: "へのメッセージ",
    message_unpin: "解決する",
    message_unsave: "保存しないでください",
    mitglied: "メンバー",
    mitglieder: "メンバー",
    ml_kem: "ML-KEM",
    neue_mail: "新しいメール",
    never_auto_lock: "決して自動的には行わない",
    new_fingerprint: "新しい指紋",
    new_identity: "新しいアイデンティティ",
    new_password: "新しいパスワード",
    no_description: "説明なし",
    no_key_history: "鍵の履歴は記録されていません。",
    no_specification: "指定されていない",
    old_fingerprint: "古い指紋",
    open_privacy_imprint: "オープンインプリントとデータ保護",
    post_quantum_e2e: "ポスト量子 E2E",
    posteingang: "受信箱",
    powered_by: "Powered by",
    privacy_imprint_menu_desc: "GDPR、データ保護、法的通知を表示します。",
    privacy_imprint_profile_desc: "GaiaCOM は、データの最小化、エンドツーエンドの暗号化、およびローカル鍵制御の原則に従って通信コンテンツを処理します。",
    privacy_imprint_title: "データ保護と法的通知",
    profil: "プロフィール",
    profile_details: "プロフィールの詳細",
    profile_settings_hint: "プロファイル設定が右側のパネルに表示されます。",
    profile_unlock_desc: "セキュリティ上の理由から、秘密暗号キーを表示するにはパスワードを再入力する必要があります。",
    proof_hash: "証明ハッシュ:",
    public_drop_desc: "GaiaCOM アカウントを持たない外部テキスト情報の Secure Drop。",
    public_drop_message: "ニュース",
    public_drop_message_placeholder: "機密テキストを入力してください...",
    public_drop_send: "ガイアドロップを送信する",
    public_drop_sender: "送信者のメモはオプションです",
    public_drop_sender_placeholder: "名前、ファイル番号、または匿名",
    public_drop_target: "対象のGaiaID",
    quanten_chat: "量子チャット",
    quantum_secure_exchange: "...を介した量子安全交換",
    quantum_secure_net: "GaiaCOM 量子セキュア ネットワーク (Ed25519 & ML-KEM)",
    quantum_shield_desc: "GaiaCOM ネットワークは、将来の量子コンピューターからの攻撃から保護される多層ハイブリッド暗号化プロトコルを使用してプライバシーを保護します。",
    quantum_shield_l1_desc: "FIPS 203 標準を使用して対称共有キーをカプセル化します。量子コンピューターによる受動的記録とその後の復号化 (「今保存し、後で復号化」) を防止します。",
    quantum_shield_l1_title: "1.量子後保護 (ML-KEM-1024)",
    quantum_shield_l2_desc: "古典的な非常に高速な Diffie-Hellman 鍵交換手順。ハイブリッド手順における追加のセキュリティ層として機能します。",
    quantum_shield_l2_title: "2. 楕円曲線暗号 (X25519)",
    quantum_shield_l3_desc: "すべてのメッセージとすべてのフェデレーション エンベロープは、送信者の信頼性を明確に検証するために暗号的に署名されます。",
    quantum_shield_l3_title: "3. デジタル署名 (Ed25519)",
    quantum_shield_l4_desc: "メッセージ コンテンツを対称的に暗号化し、送信者、受信者、メタデータを認証済み追加データ (AAD) に緊密にバインドして、リプレイ攻撃を防ぎます。",
    quantum_shield_l4_title: "4.AAD認証(AES-256-GCM)",
    quantum_shield_status: "クオンタムシールドのステータス",
    receive_drops_step1: "あなたのGaiaIDを外部ソースと共有します（例：上記のコピーボタン）。",
    receive_drops_step2: "彼らはあなたのGaiaCOMインスタンスのログインページを開き、タブを切り替えます",
    receive_drops_step3: "そしてそこで暗号化されたメッセージをあなたの住所に送信します。",
    receiver_gaia: "GaiaCOM受信機",
    receiver_smtp: "SMTP受信者",
    records_stored: "保存された記録",
    refresh: "アップデート",
    report_abuse_desc: "このメッセージを報告し、悪用の暗号証拠をサーバーに送信しますか?",
    report_abuse_title: "不正行為を報告する",
    reputation_status: "レピュテーションステータス",
    room_chat_start_hint: "会話を始めましょう！このグループ チャネル内のすべてのメッセージは、分散型量子安全な E2E 暗号化されています。",
    room_policy_audit: "監査証跡とキーローテーションがアクティブです。",
    room_policy_crisis: "危機管理室",
    room_policy_e2ee: "ゼロ知識空間。 E2EE 量子安全。",
    room_policy_title: "部屋のガイドライン",
    room_policy_zero_knowledge: "ポリシー",
    room_security_note_desc: "すべてのキーの変更は、Key Transparency によって検証されます。プライベート バックアップ ログには GaiaVault を使用します。",
    room_security_note_title: "固定されたセキュリティメモ",
    save_profile: "プロファイルの保存",
    schluessel_entsperrt: "🔑 再度キーをロックします",
    search_gaia_label: "ガイアのアドレスを探す",
    security_warning_title: "セキュリティ警告",
    select_channel_chat: "左側のサイドバーからチャンネルを選択してチャットします。",
    select_contact_chat: "左側のパネルから連絡先を選択して、量子安全な E2E チャットを開始します。",
    select_mail_read: "リストから電子メールを選択して、その量子安全なコンテンツを読むか、新しいメッセージを作成します。",
    senden: "送信",
    sender_signature: "送信者署名",
    server_log: "サーバーログ:",
    server_received: "サーバー受信日時",
    session_lock: "セッションロック",
    setup_address_keys: "アドレスとキーセットの作成",
    setup_profile: "プロフィールで設定する",
    smtp_inbox_title: "SMTP受信",
    smtp_legacy_badge: "レガシー SMTP / 安全ではない",
    smtp_mode_option: "レガシー SMTP ブリッジ",
    smtp_security_warning: "この電子メールは、従来の暗号化されていない SMTP プロトコルを介して送信されました。有効なエンドツーエンド暗号化はありません。",
    smtp_security_warning_desc: "このメッセージは GaiaCom セキュリティ ルームから出ています。 SMTP 配信では、GaiaCom ネイティブのエンドツーエンド保証、TrustMesh 保証、ゲートウェイからの Godmode 保証は提供されません。",
    spam_verdacht: "スパム/疑惑",
    spam_warning_desc: "このメッセージには疑わしい評判シグナルが含まれています。",
    spam_warning_title: "スパム警告",
    speichern: "保存",
    sperren: "ロックアウト",
    standard_group_status: "標準グループチャット（E2EE暗号化）",
    status: "状態",
    subject: "に関して",
    suchen: "新しい Gaia アドレスを見つけてください...",
    tage: "日",
    time_unknown: "時間不明",
    transmission_mode: "転送モード",
    trust_age: "信頼期間",
    trust_passport_title: "トラストパスポート",
    unbestaetigt: "未確認",
    unknown_sender: "未知",
    unlock_btn: "ロックを解除する",
    unlock_btn_profile: "ロックを解除する",
    unlock_desc: "秘密キー ファイルは暗号化されて保存されます。パスワードを入力すると、暗号化キーがメモリのみにロードされます。",
    unlock_logout: "ログアウトしてローカルキーを閉じる",
    unlock_title: "アイデンティティのロックを解除する",
    untrusted: "非信頼",
    update_password: "パスワードを更新する",
    upload_avatar_btn: "画像をアップロード（サニタイズ済み）",
    vault_btn_encrypt: "レコードの暗号化",
    vault_btn_lock: "金庫をロックする",
    vault_btn_unlock: "金庫のロックを解除する",
    vault_copied_success: "クリップボードにコピーされました",
    vault_decrypted_content: "復号化されたコンテンツ",
    vault_desc: "リカバリ バックアップ、ID メモ、サーバー アクセス、緊急連絡先、法的メモ、セキュリティ イベント、プライベート ログ用のローカル暗号化保管庫。",
    vault_empty: "安全な記録はまだ保存されていません。",
    vault_locked_pane_notice: "保管庫はロックされています。右側でロックを解除してください。",
    vault_new_record: "新しい安全な記録",
    vault_pwd_placeholder: "ボールトのパスワードを入力してください...",
    vault_record_body: "記録内容",
    vault_record_body_placeholder: "暗号化されたレコードの内容を入力してください...",
    vault_record_category: "カテゴリ",
    vault_record_title: "レコードタイトル",
    vault_record_title_placeholder: "セキュアレコードのタイトル",
    vault_title: "GaiaVault の安全な記録",
    verify_new_fingerprint_hint: "キーを受け入れる前に、新しい指紋を確認してください。",
    vertrauenswuerdig: "信頼できる",
    vision_gaia_technology: "VisionGaiaTechnology",
    von: "から",
    warnung: "警告",
    wizard_address: "住所",
    wizard_back: "戻る",
    wizard_check1: "無事に種を保存できました。",
    wizard_custom_domain: "独自のドメインを使用する",
    wizard_desc1: "GaiaCOM はサーバー側に秘密鍵を保管しません。ニーモニック シードがなければ、失われたメッセージを回復することはできません。",
    wizard_desc2: "アドレスによって、暗号化されたエンベロープがルーティングされるフェデレーテッド ノードが決まります。",
    wizard_fallback: "フォールバックノード",
    wizard_finish: "セットアップを完了する",
    wizard_next: "さらに遠く",
    wizard_server_domain: "サーバーノードドメイン",
    wizard_step1: "1. バックアップシード",
    wizard_step2: "2. アドレスとサーバー",
    wizard_title1: "バックアップ回復キー",
    wizard_title2: "GaiaCOM アドレスを選択してください",
    write_message_placeholder: "安全なメッセージを書いてください...",
    you: "あなた",
    zero_knowledge: "ゼロ知識",
    zero_knowledge_encryption: "ゼロ知識暗号化",
    "Chat fuer alle geleert": "チャットはすべての参加者に対して空になりました。",
    "Chat geleert": "チャットはローカルの受信トレイから消去されました。",
    "Nachricht fuer alle geloescht": "メッセージは参加者全員に対して削除されました。",
    "Nachricht geloescht": "チャット メッセージは受信トレイからローカルに削除されました。",
    "anpinnen": "ピン",
    "chat_loeschen": "チャットを削除する",
    "confirm_delete_chat_desc": "チャットを削除して非表示にしてもよろしいですか?",
    "confirm_leave_group_desc": "本当にこのグループを離れたいですか?",
    "entpinnen": "固定を解除する",
    "group_deleted": "グループは正常に削除されました。",
    "group_left": "グループから正常に脱退しました。",
    "gruppe_loeschen": "グループの削除",
    "loeschen": "消去",
    "no_active_chats": "アクティブなチャットはありません。チャットを開始するには、上で連絡先を検索してください。",
    "pinned": "固定された",
    "wizard_check_credentials": "私にはアクセスデータを安全に保つ責任があります。",
    "wizard_check_is_beta": "GaiaCom はベータ版ソフトウェアであることを理解しています。",
    "wizard_check_no_illegal": "私は GaiaCom を違法な目的で使用しません。",
    "wizard_check_no_uptime": "利用可能であるという保証はないことを理解しています。",
    "wizard_check_smtp_security": "SMTP メッセージでは完全な GaiaCom セキュリティが提供されないことを理解しています。",
    "wizard_check_terms_read": "ベータ版の利用規約を読みました。",
    "wizard_step_terms": "利用規約",
    "wizard_terms_text": "GaiaCom の利用規約とベータ テスト契約 (ベータ段階)\n\n提供者：VisionGaiaTechnology（以下「提供者」といいます）\nステータス: パブリックベータテスト段階\n有効期限：2026年6月21日から\n\n⚠️事前に最も重要な注意事項（よくお読みください）\nGaiaCom はパブリック ベータ テスト段階にあります。広範なセキュリティ対策が講じられているにもかかわらず、エラーがないこと、ソフトウェアと基盤となるインフラストラクチャの継続的な可用性、または絶対的なセキュリティを保証することはできません。ご自身の責任でご使用ください。ユーザーは、アクセス データ (特に GaiaVault のキー) を安全に保管し、適用される法律を遵守する責任があります。\n\n1. ベータテストフェーズの主題と目的\n1.1.提供目的：GaiaComはポスト量子暗号（PQC）をベースとした斬新なメール・チャットサービスです。ベータ段階での提供は、技術テスト、負荷シミュレーション、プログラム エラー (バグ) の発見、およびユーザー フレンドリーの最適化のみを目的としています。\n1.2.ベータ ステータス: ユーザーは、提供されているソフトウェアが暫定バージョン (ベータ ソフトウェア) であることを認識しています。これは技術的にまだ完全に開発されておらず、最終的な商用製品の基準を満たしておらず、エラー、データ損失、伝送遅延、システムクラッシュを引き起こす可能性があります。\n1.3.継続権なし: プロバイダーはいつでも、理由を提示することなく、サービスの全部または一部を中止したり、機能を変更または制限したり、一時的または永久に削除したりする権利を有します。\n\n2. 保証の利用可能性と免責事項\n2.1.可用性の保証なし: GaiaCom は、可用性または稼働時間の保証なしで提供されます。サービスを中断なく利用できる権利はありません。\n2.2.保証の除外: ソフトウェアは現在の状態 (「現状のまま」) で提供され、入手可能な場合に限ります。法律で認められる範囲で、ソフトウェアの重大な法的欠陥に対する保証請求は除外されます。特に、ソフトウェアにエラーがないこと、マルウェアがないこと、または特定の目的に適していることは保証されません。\n\n3. リスク管理とユーザーの義務\n3.1.重要なデータの保管の禁止: ユーザーは、ビジネス上重要なデータ、重要なデータ、運用上必要なデータ、または法的に特に機密性の高いデータ (患者ファイル、非常に機密性の高い財務データ、公的に規制されている秘密など) を独占的に保管したり、GaiaCom 経由で送信したりしないことを約束します。このサービスは、予期せぬ障害が人身傷害、物的損害、または重大な経済的損失を引き起こす可能性があるインフラストラクチャには使用できません。\n3.2.自己責任のバックアップ: ユーザーは、長期的に必要となる GaiaCom 経由で送受信されるすべてのデータを、自分の独立したシステムにバックアップする責任があります (バックアップ コピー)。プロバイダーは、サーバー上のデータの永続的な保存や復元可能性を保証しません。\n\n4. 暗号化機能と GaiaVault\n4.1.ポスト量子暗号 (PQC): GaiaCom は、将来の量子コンピューターからの攻撃に耐えるように設計された、最先端の未来志向の暗号化プロセスを実装しています。ただし、ユーザーは、これが動的で新しい科学分野であることを認識しています。現在の科学技術の現状では、絶対的、反駁の余地のない安全性は保証されません。 「100% 安全」、「解読不可能」、または「軍事的安全」などの用語は明示的に保証されていません。\n4.2.回復保証なし (GaiaVault): GaiaCom は、一貫したゼロ知識セキュリティ概念に依存しています。暗号化ウェッジとアクセス データは、ユーザーのみが管理できます (GaiaVault 経由で保護されています)。\n重要: ユーザーがパスワード、パスフレーズ、秘密キー、または回復シードを紛失した場合、プロバイダーにはこのデータを再構築またはリセットする技術的能力がありません。これらのアクセス データが失われると、必然的にユーザー アカウントとその中で暗号化されているすべてのデータへのアクセスが取り消せなくなります。\n4.3.まだ完全に監査されていない: ソフトウェアは継続的に内部セキュリティ チェックを受けていますが、このベータ段階の時点では、独立したテスト機関による最終的な包括的な外部セキュリティ監査はまだ受けていません。\n\n5. インターフェース、レガシープロトコル、フェデレーション\n5.1. SMTP ブリッジ 注: GaiaCom は、従来の電子メール プロトコル (SMTP など) を介して通信する機能を提供します。ユーザーは、ネイティブの GaiaCom セキュリティ領域を離れるメッセージ (従来の @gmail.com または @gmx.de アドレスに送信される場合など) が、暗号化されていないサーバーまたはサードパーティのサーバーを介して転送されることを認識しています。 GaiaCom のエンドツーエンドのセキュリティ保証は、そのような送信または外部から受信するレガシー メッセージには、限られた範囲でのみ適用されるか、まったく適用されません。\n5.2.フェデレーションに関する注意: GaiaCom がフェデレーション ネットワーク上で動作している場合、メッセージとデータはサードパーティのサーバーを通過する可能性があります。メッセージの内容はエンドツーエンドの暗号化によって保護されたままですが、メタデータ (送信時刻、関係するサーバーの IP アドレス、受信者のアドレスなど) は、技術的にはこれらのフェデレーション サーバーのオペレーターに見える可能性があります。プロバイダーは、フェデレーション ネットワーク内のサードパーティ サーバー オペレーターのデータ保護慣行に影響を与えません。\n\n6. 許容される使用と禁止される行為\nユーザーは、サービスを不正または違法な目的で使用しないことを約束します。特に、以下のことは禁止されています。\n- ウイルス、マルウェア、フィッシング コンテンツ、またはその他の悪意のあるソフトウェアを配布、送信、またはホストすること。\n- サービス拒否攻撃 (DDoS) または迷惑な大量メール (スパム) を実行するために本サービスを使用する。\n- システムを悪用して詐欺を行うこと。\n- 違法なコンテンツ、特に児童性的虐待 (CSAM) の描写、テロリストのプロパガンダ、暴力またはその他の犯罪に関連するコンテンツの配布または交換。\n\n7. 不正行為報告制度\n7.1.不正行為の報告: ユーザーには、統合された不正行為システムを介して不正な通信や違法行為を報告する機会があります。\n7.2.レポートの処理: 悪用から確実に保護するために、(プライバシーと暗号化の制限を維持しながら) 受信レポートを技術的に分析できます。これらの利用規約への違反が判明した場合、ユーザー アカウントまたは IP アドレスが一時的または永久に停止される可能性があります。\n\n8. 責任の制限\n8.1.責任基準: ベータ版ソフトウェアは無料で提供されます。したがって、寄付や融資に関する法的規則によれば、提供者は故意（故意の損害）と重過失に対してのみ責任を負います。\n8.2.データ損失に対する責任の除外: データ損失に対する責任は、損失がプロバイダーの故意または重大な過失によって生じたものであり、ユーザーが定期的なバックアップ (GaiaCom 外部) を通じて損害を軽減する義務を履行していない限り、除外されます。\n8.3.法的制限: 上記の責任制限は、生命、身体、健康に対する損害、または製造物責任法に基づく責任には適用されません。\n\n9. オープンソース\n特定の GaiaCom コンポーネント、ライブラリ、またはクライアント アプリケーションは、オープン ソース ライセンス (GPL、MIT、Apache など) に基づいてライセンス供与される場合があります。これらのコンポーネントのそれぞれのライセンス条項は、これらの使用条件の影響を受けず、対応するソース コード リポジトリで参照できます。\n\n10. 輸出管理とコンプライアンス\nユーザーは、暗号化ソフトウェアが厳格な輸出規制および法的制限の対象となる可能性があることを認識しています。ユーザーは、GaiaCom の使用がそれぞれの居住国の法律、輸出入制限、または暗号化規制に違反しないことを確認する責任があります。\n\n11. データ保護に関する通知 (ベータ版の短縮版)\n11.1.最小限のデータ収集: ベータ段階の一環として、プロバイダーは技術的な運用、トラブルシューティング、さらなる開発に絶対に必要なデータのみを収集します (例: エラー診断用のサーバー ログ ファイル)。\n11.2.コンテンツに対する洞察がありません: 一貫したゼロ知識と E2E 暗号化のおかげで、プロバイダーはチャット、電子メール、または GaiaVault に保存されているキーのコンテンツにアクセスすることはありません。\n11.3.詳細なデータ保護宣言: 詳細なデータ保護規則は個別にリンクされており、ユーザーは登録する前にこれも考慮する必要があります。\n\n12. 最終条項\n12.1.適用法: 国際物品売買契約に関する国連条約を除き、ドイツ連邦共和国の法律が適用されます。\n12.2.変更される可能性があります: GaiaCom は現在開発中であるため、プロバイダーは将来にわたってこれらの条件をいつでも適応させる権利を留保します。現在のバージョンはアプリケーションで利用できます。",
    "wizard_terms_title": "GaiaCom の利用規約とベータ テスト契約 (ベータ段階)",
    "node_operator": "ノードオペレーター",
    "search_channels": "チャンネルを検索...",
    "senior_reviewer": "上級査読者",
    "trusted_reviewer": "信頼できるレビュアー",
    "active_frequencies": "アクティブ周波数",
    "connected_rooms": "つながった空間",
    "dashboard": "ダッシュボード",
    "empty_chats": "利用可能なアクティブなチャットはありません。",
    "empty_messages": "新しいメッセージはありません。",
    "encrypted": "暗号化された",
    "gaiacom_uplink": "ガイアコムアップリンク",
    "install_app": "アプリをインストールする",
    "install_app_desc": "クイックスタートとオフラインモードの場合",
    "kommandozentrale_alpha": "ALPHAコマンドセンター",
    "network_online": "ネットワーク: オンライン",
    "new_room": "新しい空間",
    "no_frequencies_active": "アクティブな周波数はありません。新しいルームを作成してコミュニケーションを開始します。",
    "no_id": "身分証明書なし",
    "open_chats": "オープンチャット",
    "open_inbox": "受信箱を開く",
    "primary_identity": "主要なアイデンティティ",
    "recent_chats": "新しいチャット",
    "recent_messages": "最新ニュース",
    "session_encrypted": "セッションが暗号化されました: {name}",
    "session_secure": "ステータス: 安全",
    "system_verlassen": "出口システム",
    "write_message": "メッセージを書く",
  },
  pt: {
    sc_title: "Centro de segurança",
    sc_subtitle: "Camada de segurança integrada GaiaShield",
    sc_tab_status: "🛡️ Status de proteção",
    sc_tab_events: "📋 Log de segurança",
    sc_tab_node: "⚙️ Segurança do nó",
    sc_loading: "Carregando dados de segurança...",
    sc_status_secured: "Status do sistema: Conta protegida",
    sc_status_warning: "Status do sistema: Avisos ativos",
    sc_desc_secured: "Não há avisos de segurança críticos ativos. O GaiaShield está monitorando ativamente sua conta.",
    sc_desc_warning: "Atenção: Existem eventos de segurança ativos que requerem sua atenção.",
    sc_account_protection: "Proteção de conta",
    sc_message_protection: "Proteção de mensagens",
    sc_audits: "Auditorias de segurança",
    sc_active: "ATIVO",
    sc_failed_logins: "Logins falhados",
    sc_tamper_checks: "Verificações de adulteração",
    sc_blocked_replays: "Replays bloqueados",
    sc_last_check: "Última verificação",
    sc_just_now: "Agora mesmo",
    sc_open_warnings: "Avisos abertos",
    sc_btn_acknowledge: "Confirmar",
    sc_filter_severity: "Gravidade",
    sc_filter_category: "Categoria",
    sc_filter_hide_ack: "Ocultar confirmados",
    sc_btn_export: "Exportar",
    sc_col_details: "Detalhes",
    sc_col_time: "Hora",
    sc_col_status: "Status",
    sc_col_action: "Ação",
    sc_no_events: "Nenhum evento de segurança encontrado.",
    sc_node_title: "Consola de segurança do operador de nó",
    sc_system_health: "Saúde do sistema",
    sc_last_audit: "Última auditoria",
    sc_packed_logs: "Logs compactados",
    sc_unconfirmed_events: "Eventos não confirmados",
    sc_operator_action: "Ação do operador requerida",
    sc_all_ok: "Tudo ok",
    sc_critical_events: "Eventos críticos do sistema",
    ac_title: "Centro de governança e denúncias",
    ac_subtitle: "Consenso de governança e abuso do GaiaCom",
    ac_tab_my_reports: "Minhas denúncias",
    ac_tab_queue: "Fila de revisão",
    ac_tab_operator: "Operador de nó",
    ac_tab_transparency: "Federação e transparência",
    ac_loading: "Carregando dados...",
    ac_reported_cases: "Casos relatados",
    ac_no_reports: "Ainda não submeteu nenhuma denúncia.",
    ac_case_details: "Detalhes do caso",
    ac_appeal_submit: "Apresentar apelação",
    ac_appeal_status: "Status do recurso",
    ac_appeal_reason: "Motivo do recurso",
    ac_appeal_statement: "Declaração",
    ac_btn_appeal: "Enviar recurso",
    ac_trusted_reviewer_queue: "Fila de revisores confiáveis",
    ac_case_review: "Revisar caso",
    ac_review_category: "Categoria recomendada",
    ac_review_severity: "Gravidade recomendada",
    ac_review_action: "Ação recomendada",
    ac_review_reason: "Motivo do revisor",
    ac_btn_submit_review: "Enviar revisão",
    ac_node_operator_dashboard: "Painel do operador de nó",
    ac_apply_action: "Aplicar ação (Override)",
    ac_target_type: "Tipo de alvo",
    ac_target_id: "ID do alvo (GaiaID ou ID do canal)",
    ac_suspend: "Suspensão ativa",
    ac_reason: "Motivo oficial",
    ac_btn_apply: "Impor ação",
    ac_transparency_title: "Registro de consenso e transparência",
    ac_transparency_desc: "Provas de snapshots visíveis publicamente de todos os canais e identidades moderados.",
    ac_btn_snapshot: "Criar snapshot de transparência",
    search_placeholder: "Pesquisar e-mails por assunto, remetente, texto...",
    abuse_center_title: "Centro de abuso",
    abbrechen: "Cancelar",
    active_identities: "Identidades ativas",
    active_identity: "Identidade ativa",
    add_btn: "Adicionar",
    add_contact_title: "Adicionar contato",
    admin: "Administrador",
    adressbuch: "diretório",
    aktiviert: "Habilitado",
    an: "Para",
    anonymous_sender: "Remetente anônimo",
    antworten: "Responder",
    attachment_gaia_hint: "Os anexos do GaiaCOM permanecem criptografados de ponta a ponta.",
    attachment_smtp_hint: "O SMTP legado bloqueia anexos executáveis/semelhantes a scripts e salva e-mails como inseguros.",
    attachments: "Anexos",
    auffaellig: "Perceptível",
    auth_beta_notice: "Fase de teste beta: GaiaCOM está sendo testado ativamente. Podem ocorrer erros; proteja sementes importantes e analise cuidadosamente os fluxos de trabalho confidenciais.",
    auth_btn_login: "Carregar identidade e fazer login",
    auth_btn_register: "Registre-se e crie criptografia",
    auth_copied: "Copiado",
    auth_copy_seed: "Copiar semente",
    auth_generate_seed: "Gerar sementes",
    auth_headline: "GaiaCOM é o primeiro protocolo de e-mail e sistema de comunicação com segurança quântica construído para a humanidade.",
    auth_kicker: "Comunicação segura pós-quântica",
    auth_mnemonic: "Frase mnemônica",
    auth_mnemonic_placeholder: "12 palavras separadas por espaços...",
    auth_password: "senha",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "As chaves privadas não saem do seu dispositivo. Somente os destinatários pretendidos podem descriptografar o conteúdo.",
    auth_proof_gaiadata_desc: "Conhecimento Zero: Você permanece no controle de seus dados. Os metadados são minimizados e não são usados ​​como um perfil de texto simples.",
    auth_proof_gaiadrop_desc: "Pessoas externas podem enviar mensagens de texto confidenciais para o seu GaiaID sem uma conta.",
    auth_proof_gaiaproof_desc: "Evidências de entrega e integridade mostram que o texto cifrado, o remetente e o carimbo de data/hora não foram adulterados.",
    auth_proof_gaiavault_desc: "Notas privadas, notas de recuperação e registros de segurança permanecem criptografados localmente.",
    auth_proof_hybrid_desc: "Quantum Shield: A criptografia híbrida com ML-KEM e X25519 protege contra os ataques atuais e os riscos de armazenar agora, descriptografar mais tarde.",
    auth_secure_mail: "Correio federado seguro do Quantum",
    auth_subline: "GaiaCOM é um sistema de comunicação quântica segura para e-mail, chat, salas de crise, GaiaDrop e arquivos de segurança locais. As chaves privadas permanecem no seu dispositivo, o conteúdo é criptografado de ponta a ponta e as evidências podem ser exportadas sem texto simples.",
    auth_success_btn: "Faça login agora",
    auth_success_text: "Sua conta GaiaCOM foi criada. As chaves foram derivadas localmente da sua semente e não foram armazenadas no servidor.",
    auth_success_title: "Registro realizado com sucesso",
    auth_tab_drop: "GaiaDrop",
    auth_tab_login: "Login/Conta",
    auth_toggle_login: "A conta já existe",
    auth_toggle_register: "Criar nova conta",
    auth_usecase_text: "Adequado para advogados, empresas, autoridades, jornalistas, denunciantes e casos de segurança privada.",
    auth_usecase_title: "Construído para comunicação sensível",
    auth_username: "nome de usuário",
    auth_username_placeholder: "Digite o nome...",
    auth_value_chat: "Bate-papo E2E",
    auth_value_drop: "Queda segura",
    auth_value_mail: "Correio seguro",
    auth_value_rooms: "GaiaQuartos",
    bestaetigen: "Confirmar",
    bestaetigt: "Confirmado",
    bio_status: "Biografia/Status",
    biography: "biografia",
    change_password_desc: "Altera sua senha de login do lado do servidor. Sua frase de recuperação local permanece protegida separadamente pela sua senha de cofre/desbloqueio.",
    change_password_menu_desc: "Atualize a senha de login do GaiaCOM.",
    change_password_title: "Alterar a senha",
    channel_id: "ID do canal",
    channel_name_label: "Nome do canal",
    chat_deleted_hidden: "Bate-papo excluído e oculto.",
    chat_input_placeholder: "Digite mensagem segura...",
    chat_start_hint: "Comece a conversa! Todas as mensagens de bate-papo são criptografadas E2E com segurança quântica.",
    choose_avatar: "Escolha o avatar",
    ciphertext_hash: "Hash de texto cifrado",
    clear_chat: "Bate-papo vazio",
    clear_for_everyone: "Vazio para todos",
    clear_for_me: "Vazio só para mim",
    click_to_write_mail: "Clique para escrever um e-mail",
    click_top_right: "Clique no canto superior direito",
    close: "Fechar",
    code_kopieren: "Copiar código",
    code_kopieren_success: "Código copiado",
    confirm_clear_channel_desc: "Deseja limpar este canal da sua visualização local?",
    confirm_clear_channel_title: "Canal vazio",
    confirm_clear_chat: "Quer esvaziar este chat?",
    confirm_clear_chat_desc: "Quer esvaziar este chat?",
    confirm_clear_chat_title: "Bate-papo vazio",
    confirm_clear_everyone: "Quer esvaziar o chat para ambos os parceiros? (OK = Para todos, Cancelar = Só para mim)",
    confirm_delete_everyone: "Deseja excluir a mensagem de ambos os parceiros? (OK = Para todos, Cancelar = Só para mim)",
    confirm_delete_msg: "Deseja excluir esta mensagem?",
    confirm_delete_msg_desc: "Deseja excluir esta mensagem de bate-papo?",
    confirm_delete_msg_title: "Excluir mensagem",
    confirm_new_password: "Confirme a nova senha",
    copy: "Cópia",
    create_btn: "Criar",
    create_channel_title: "Criar canal",
    create_group_is_crisis: "Marcar como uma área de crise",
    create_group_title: "Criar novo grupo",
    crypto_lock_desc: "Controla quando o GaiaCOM remove chaves criptográficas locais da memória.",
    crypto_lock_menu_desc: "Controle os temporizadores de recarga e inatividade.",
    crypto_lock_title: "Bloqueio criptográfico",
    crypto_session_duration: "Desbloqueado após recarregar",
    crypto_session_duration_desc: "Mantém a sessão criptográfica aberta apenas nesta guia do navegador durante o período selecionado.",
    cryptographic_fingerprint: "Impressão digital criptográfica",
    current_password: "Senha atual",
    data_minimization: "Minimização de dados",
    decrypt_failed: "Não decifrável",
    delete: "Excluir",
    delete_account_button: "Excluir conta irrevogavelmente",
    delete_account_confirm_label: "Digite DELETE para confirmar",
    delete_account_confirmation_error: "Senha e confirmação DELETE são necessárias.",
    delete_account_desc: "Este modo destrói permanentemente sua conta, identidades, sessões de dispositivos, dados do GaiaDrop, metadados de upload e mensagens atribuíveis do lado do servidor.",
    delete_account_done_desc: "Todos os dados atribuíveis do GaiaCOM foram excluídos.",
    delete_account_done_title: "Conta excluída",
    delete_account_menu_desc: "Destrua a conta e os dados associados.",
    delete_account_not_authenticated: "Nenhuma conta ativa.",
    delete_account_title: "Excluir conta",
    delete_for_everyone: "Excluir para todos",
    delete_for_me: "Excluir só para mim",
    device_current: "Este dispositivo",
    device_last_seen: "Durar",
    device_logout: "Sair",
    device_sessions_desc: "Verifique as sessões ativas e cancele o registro dos dispositivos nos quais você não confia mais.",
    device_sessions_empty: "Nenhum dispositivo encontrado.",
    device_sessions_menu_desc: "Gerenciar e encerrar sessões ativas.",
    device_sessions_title: "Dispositivos registrados",
    device_since: "Desde",
    display_name: "Nome de exibição",
    drop_address_copied: "Endereço GaiaDrop copiado.",
    drop_btn_decrypting: "A caixa de entrada está sendo descriptografada...",
    drop_btn_load: "Carregar caixa de entrada do GaiaDrop",
    drop_delete_desc: "Você realmente deseja excluir permanentemente este drop?",
    drop_delete_title: "Excluir GaiaDrop",
    drop_desc: "Canal de envio de conhecimento zero somente texto para avisos externos, divulgação responsável e relatórios confidenciais. Partes externas podem enviar mensagens sem uma conta usando seu GaiaID.",
    drop_empty: "Nenhuma mensagem do GaiaDrop foi carregada ainda.",
    drop_id: "ID de descarte:",
    drop_own_address: "Seu endereço GaiaDrop",
    drop_proof: "À PROVA DE QUEDA",
    drop_title: "Caixa de entrada segura GaiaDrop",
    dunkler_modus: "Modo escuro",
    e2e_chat_room_open: "Abra a sala de bate-papo E2E",
    edit_profile: "Editar perfil",
    edit_profile_desc: "Personalize o nome de exibição, biografia e avatar.",
    einladungscode: "Código de convite",
    enter_fingerprint_chars_confirm: "Insira os caracteres de impressão digital solicitados para confirmar.",
    envelope_hash: "Hash de envelope",
    erasability: "Apagabilidade",
    erfolg: "Sucesso",
    exclude_plaintext: "Exportar sem texto simples",
    export_disclosure: "Exportar caso de segurança",
    export_package_desc: "Inclua apenas texto simples se esta divulgação for intencional.",
    export_package_title: "Exportar pacote de segurança",
    fehler: "Erro",
    gaiacom_reader: "Leitor GaiaCOM",
    gaiadrop_inbox_title: "Caixa de entrada do GaiaDrop",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM minimiza metadados, mantém chaves privadas locais, criptografa conteúdo de ponta a ponta e permite a exclusão completa da conta.",
    gdpr_home_title: "100% compatível com GDPR",
    gdpr_reason_delete: "A exclusão da conta remove contas, identidades, sessões locais e dados atribuíveis do lado do servidor.",
    gdpr_reason_e2ee: "O conteúdo privado permanece descriptografável apenas para os destinatários pretendidos.",
    gdpr_reason_minimal: "Os metadados são usados ​​apenas para credenciais de roteamento, entrega e segurança.",
    gdpr_reason_zero_knowledge: "As chaves privadas e os dados de recuperação permanecem localmente sob controle do usuário.",
    gesendet: "Enviado",
    gesperrt_verdaechtig: "Banido / Suspeito",
    group_delete_desc: "Você realmente deseja excluir permanentemente este grupo? Todos os canais e mensagens deste grupo serão excluídos.",
    group_delete_title: "Excluir grupo",
    group_description: "Descrição",
    group_icon_label: "Ícone/avatar do grupo",
    group_name: "Nome do grupo",
    group_settings_avatar: "avatar",
    group_settings_desc: "Descrição",
    group_settings_is_crisis: "Marcar como uma área de crise",
    group_settings_name: "Nome do grupo",
    group_settings_title: "Configurações de grupo",
    groups_empty_desc: "Crie um espaço de trabalho seguro para comunicação de projetos, crises ou equipes.",
    groups_empty_title: "Ainda não há bate-papos em grupo",
    gruppe_beitreten: "Entrou no grupo",
    gruppe_erstellen: "+ Criar grupo",
    gruppe_verlassen: "Sair do grupo",
    gruppen_chats: "Bate-papos em grupo",
    heller_modus: "Modo brilhante",
    how_to_receive_drops: "Como recebo gotas?",
    identitaets_assistent: "Assistente de Identidade",
    inactivity_lock_duration: "Bloquear quando inativo",
    inactivity_lock_duration_desc: "Após este período sem entrada, o GaiaCOM será automaticamente bloqueado criptograficamente.",
    inactivity_lock_notice: "GaiaCOM foi bloqueado criptograficamente devido à inatividade.",
    include_plaintext: "Incluir texto simples",
    invite_code_label: "Código de convite",
    join_group_title: "Junte-se ao grupo",
    kanaele: "Canais",
    kanal_erstellen: "+ canal",
    kein_chat_ausgewaehlt: "Nenhum bate-papo selecionado",
    kein_kanal_ausgewaehlt: "Nenhum canal selecionado",
    keine_gruppe_ausgewaehlt: "Nenhum grupo selecionado",
    keine_mails: "Nenhum e-mail disponível.",
    key_change_warn_desc: "A chave pública deste contato foi alterada. Verifique a impressão digital antes de confiar nela.",
    key_change_warn_title: "Aviso criptográfico",
    key_change_warning_changed: "mudou. Isso pode ser um sinal de um ataque man-in-the-middle!",
    key_change_warning_msg: "A chave de identidade do contato",
    key_transparency: "Transparência Chave",
    kopiert: "Copiado",
    kryptographische_schluessel: "Chaves criptográficas",
    kryptographische_schluessel_desc: "Mostrar chaves privadas e frase inicial de backup.",
    laden: "Carregar...",
    leeren: "Vazio",
    loading: "Carregar...",
    local_key_vault: "Cofre de chaves local",
    local_keys_label: "Chaves locais",
    lock_on_reload: "Sempre bloqueie após recarregar",
    logout: "Sair",
    mail_compose: "Escrever e-mail",
    mein_profil: "Meu perfil",
    melden: "Relatório",
    menu: "menu",
    message: "Notícias",
    message_id: "ID da mensagem",
    message_pin: "Alfinete",
    message_pinned_title: "Mensagens fixadas",
    message_react: "Reagir",
    message_reply: "Responder",
    message_replying_to: "Responder a",
    message_save: "Salvar",
    message_saved: "Salvo",
    message_to_channel: "Mensagem para",
    message_unpin: "Resolver",
    message_unsave: "Não salve",
    mitglied: "Membro",
    mitglieder: "membros",
    ml_kem: "ML-KEM",
    neue_mail: "Novo e-mail",
    never_auto_lock: "Nunca automaticamente",
    new_fingerprint: "Nova impressão digital",
    new_identity: "Nova identidade",
    new_password: "Nova Senha",
    no_description: "Sem descrição",
    no_key_history: "Nenhum histórico de chave registrado.",
    no_specification: "Não especificado",
    old_fingerprint: "Impressão digital antiga",
    open_privacy_imprint: "Impressão aberta e proteção de dados",
    post_quantum_e2e: "E2E pós-quântico",
    posteingang: "Caixa de entrada",
    powered_by: "Distribuído por",
    privacy_imprint_menu_desc: "Mostrar GDPR, proteção de dados e aviso legal.",
    privacy_imprint_profile_desc: "GaiaCOM processa o conteúdo da comunicação de acordo com os princípios de minimização de dados, criptografia ponta a ponta e controle de chave local.",
    privacy_imprint_title: "Proteção de dados e aviso legal",
    profil: "perfil",
    profile_details: "Detalhes do perfil",
    profile_settings_hint: "As configurações do perfil são exibidas no painel direito.",
    profile_unlock_desc: "Por motivos de segurança, você deve digitar novamente sua senha para visualizar suas chaves criptográficas privadas.",
    proof_hash: "Hash de prova:",
    public_drop_desc: "Secure Drop para informações de texto externas sem uma conta GaiaCOM.",
    public_drop_message: "Notícias",
    public_drop_message_placeholder: "Digite um texto confidencial...",
    public_drop_send: "Enviar GaiaDrop",
    public_drop_sender: "Nota do remetente opcional",
    public_drop_sender_placeholder: "Nome, número do arquivo ou anônimo",
    public_drop_target: "Alvo GaiaID",
    quanten_chat: "Bate-papo Quântico",
    quantum_secure_exchange: "Troca segura Quantum via...",
    quantum_secure_net: "Rede segura GaiaCOM Quantum (Ed25519 e ML-KEM)",
    quantum_shield_desc: "A rede GaiaCOM protege sua privacidade com um protocolo de criptografia híbrida multicamadas que é protegido contra ataques de futuros computadores quânticos.",
    quantum_shield_l1_desc: "Usa o padrão FIPS 203 para encapsular uma chave compartilhada simétrica. Impede a gravação passiva e a descriptografia posterior (“Armazenar agora, descriptografar mais tarde”) por computadores quânticos.",
    quantum_shield_l1_title: "1. Proteção Pós-Quantum (ML-KEM-1024)",
    quantum_shield_l2_desc: "Um procedimento clássico e extremamente rápido de troca de chaves Diffie-Hellman que serve como uma camada adicional de segurança no procedimento híbrido.",
    quantum_shield_l2_title: "2. Criptografia de curva elíptica (X25519)",
    quantum_shield_l3_desc: "Cada mensagem e cada envelope da Federação são assinados criptograficamente para verificar inequivocamente a autenticidade do remetente.",
    quantum_shield_l3_title: "3. Assinaturas Digitais (Ed25519)",
    quantum_shield_l4_desc: "Criptografa o conteúdo da mensagem de forma simétrica e vincula firmemente o remetente, o destinatário e os metadados aos Dados Adicionais Autenticados (AAD) para evitar ataques de repetição.",
    quantum_shield_l4_title: "4. Autenticação AAD (AES-256-GCM)",
    quantum_shield_status: "Status do Escudo Quântico",
    receive_drops_step1: "Compartilhe seu GaiaID (por exemplo, usando o botão copiar acima) com fontes externas.",
    receive_drops_step2: "Eles acessam a página de login da sua instância do GaiaCOM e mudam para a aba",
    receive_drops_step3: "e envie a mensagem criptografada para o seu endereço.",
    receiver_gaia: "Receptor GaiaCOM",
    receiver_smtp: "Destinatário SMTP",
    records_stored: "Registros salvos",
    refresh: "Atualizar",
    report_abuse_desc: "Deseja denunciar esta mensagem e enviar evidências criptográficas de abuso ao servidor?",
    report_abuse_title: "Denunciar abuso",
    reputation_status: "Status de reputação",
    room_chat_start_hint: "Comece a conversa! Todas as mensagens neste canal de grupo são criptografadas E2E descentralizadas e seguras para quantum.",
    room_policy_audit: "Trilha de auditoria e rotação de chaves ativas.",
    room_policy_crisis: "Sala de crise",
    room_policy_e2ee: "Espaço de conhecimento zero. E2EE quântico seguro.",
    room_policy_title: "Diretrizes da sala",
    room_policy_zero_knowledge: "Política",
    room_security_note_desc: "Todas as principais alterações são validadas por meio do Key Transparency. Use GaiaVault para logs de backup privados.",
    room_security_note_title: "Nota de segurança fixada",
    save_profile: "Salvar perfil",
    schluessel_entsperrt: "🔑 Bloqueie a chave novamente",
    search_gaia_label: "Encontre o endereço de Gaia",
    security_warning_title: "Aviso de segurança",
    select_channel_chat: "Selecione um canal na barra lateral esquerda para conversar.",
    select_contact_chat: "Selecione um contato no painel esquerdo para iniciar um bate-papo E2E seguro quântico.",
    select_mail_read: "Selecione um e-mail da lista para ler seu conteúdo seguro para quantum ou criar uma nova mensagem.",
    senden: "Enviar",
    sender_signature: "Assinatura do remetente",
    server_log: "Registro do servidor:",
    server_received: "Servidor recebido",
    session_lock: "Bloqueio de sessão",
    setup_address_keys: "Criar endereço e conjunto de chaves",
    setup_profile: "Configurar no perfil",
    smtp_inbox_title: "Recepção SMTP",
    smtp_legacy_badge: "SMTP legado/inseguro",
    smtp_mode_option: "Ponte SMTP herdada",
    smtp_security_warning: "Este e-mail foi transmitido através do protocolo SMTP clássico e não criptografado. Nenhuma criptografia ponta a ponta ativa.",
    smtp_security_warning_desc: "Esta mensagem está saindo da sala de segurança do GaiaCom. A entrega SMTP não fornece garantia ponta a ponta nativa da GaiaCom, nenhuma garantia TrustMesh e nenhuma garantia Godmode do gateway.",
    spam_verdacht: "Spam/suspeita",
    spam_warning_desc: "Esta mensagem contém sinais de reputação suspeitos.",
    spam_warning_title: "Aviso de spam",
    speichern: "Salvar",
    sperren: "Bloquear",
    standard_group_status: "Bate-papo em grupo padrão (criptografado E2EE)",
    status: "status",
    subject: "A respeito de",
    suchen: "Encontre um novo endereço em Gaia...",
    tage: "dias",
    time_unknown: "Hora desconhecida",
    transmission_mode: "Modo de transferência",
    trust_age: "Idade de confiança",
    trust_passport_title: "Passaporte de confiança",
    unbestaetigt: "Não confirmado",
    unknown_sender: "Desconhecido",
    unlock_btn: "Desbloquear",
    unlock_btn_profile: "Desbloquear",
    unlock_desc: "Seu arquivo de chave privada é armazenado criptografado. Digite sua senha para carregar as chaves criptográficas apenas na memória.",
    unlock_logout: "Saia e feche as chaves locais",
    unlock_title: "Desbloquear identidade",
    untrusted: "Não é confiável",
    update_password: "Atualizar senha",
    upload_avatar_btn: "Carregar imagem (higienizada)",
    vault_btn_encrypt: "Criptografar registro",
    vault_btn_lock: "Bloquear seguro",
    vault_btn_unlock: "Desbloquear com segurança",
    vault_copied_success: "Copiado para a área de transferência",
    vault_decrypted_content: "Conteúdo descriptografado",
    vault_desc: "Cofre criptografado local para backups de recuperação, notas de identidade, acesso ao servidor, contatos de emergência, notas legais, eventos de segurança e registros privados.",
    vault_empty: "Nenhum registro seguro salvo ainda.",
    vault_locked_pane_notice: "O cofre está trancado. Por favor, desbloqueie à direita.",
    vault_new_record: "Novo registro seguro",
    vault_pwd_placeholder: "Digite a senha do cofre...",
    vault_record_body: "Gravar conteúdo",
    vault_record_body_placeholder: "Insira o conteúdo do registro criptografado...",
    vault_record_category: "categoria",
    vault_record_title: "Título do recorde",
    vault_record_title_placeholder: "Título do registro seguro",
    vault_title: "Registros seguros do GaiaVault",
    verify_new_fingerprint_hint: "Verifique a nova impressão digital antes de aceitar a chave.",
    vertrauenswuerdig: "Confiável",
    vision_gaia_technology: "VisionGaiaTecnologia",
    von: "De",
    warnung: "aviso",
    wizard_address: "endereço",
    wizard_back: "Voltar",
    wizard_check1: "Eu salvei minha semente com segurança.",
    wizard_custom_domain: "Use seu próprio domínio",
    wizard_desc1: "GaiaCOM não armazena chaves privadas no lado do servidor. Sem Mnemonic Seed, ninguém pode recuperar mensagens perdidas.",
    wizard_desc2: "Seu endereço determina o nó federado através do qual os envelopes criptografados são roteados.",
    wizard_fallback: "Nós substitutos",
    wizard_finish: "Configuração completa",
    wizard_next: "Avançar",
    wizard_server_domain: "Domínio do nó do servidor",
    wizard_step1: "1. Semente de backup",
    wizard_step2: "2. Endereço e servidor",
    wizard_title1: "Chave de recuperação de backup",
    wizard_title2: "Selecione o endereço GaiaCOM",
    write_message_placeholder: "Escreva uma mensagem segura...",
    you: "Você",
    zero_knowledge: "Conhecimento zero",
    zero_knowledge_encryption: "Criptografia de conhecimento zero",
    "Chat fuer alle geleert": "O chat foi esvaziado para todos os participantes.",
    "Chat geleert": "O bate-papo foi limpo em sua caixa de entrada local.",
    "Nachricht fuer alle geloescht": "A mensagem foi excluída para todos os participantes.",
    "Nachricht geloescht": "A mensagem de bate-papo foi removida localmente da sua caixa de entrada.",
    "anpinnen": "Alfinete",
    "chat_loeschen": "Excluir bate-papo",
    "confirm_delete_chat_desc": "Tem certeza de que deseja excluir e ocultar o bate-papo?",
    "confirm_leave_group_desc": "Você realmente quer sair deste grupo?",
    "entpinnen": "Liberar",
    "group_deleted": "Grupo excluído com sucesso.",
    "group_left": "Saia do grupo com sucesso.",
    "gruppe_loeschen": "Excluir grupo",
    "loeschen": "Excluir",
    "no_active_chats": "Nenhum bate-papo ativo. Procure os contatos acima para iniciar um bate-papo.",
    "pinned": "Fixado",
    "wizard_check_credentials": "Sou responsável por manter meus dados de acesso seguros.",
    "wizard_check_is_beta": "Entendo que GaiaCom é um software beta.",
    "wizard_check_no_illegal": "Não utilizarei o GaiaCom para fins ilícitos.",
    "wizard_check_no_uptime": "Entendo que não há garantia de disponibilidade.",
    "wizard_check_smtp_security": "Entendo que as mensagens SMTP não oferecem segurança total ao GaiaCom.",
    "wizard_check_terms_read": "Eu li os Termos de Serviço do Beta.",
    "wizard_step_terms": "Termos de Uso",
    "wizard_terms_text": "Termos de uso e contrato de teste beta da GaiaCom (fase beta)\n\nProvedor: VisionGaiaTechnology (doravante denominado “Provedor”)\nStatus: fase de testes beta públicos\nValidade: A partir de 21 de junho de 2026\n\n⚠️ A NOTA MAIS IMPORTANTE ANTECIPADAMENTE (LEIA COM ATENÇÃO)\nGaiaCom está em fase de testes beta públicos. Apesar das extensas medidas de segurança, a ausência de erros, a disponibilidade contínua ou a segurança absoluta do software e da infraestrutura subjacente não podem ser garantidas. Use por sua conta e risco. Os usuários são responsáveis ​​pelo armazenamento seguro de seus dados de acesso (especialmente chaves do GaiaVault) e pelo cumprimento das leis aplicáveis.\n\n1. Objecto e finalidade da fase de teste beta\n1.1. Objetivo do fornecimento: GaiaCom é um novo serviço de e-mail e chat baseado em criptografia pós-quântica (PQC). A disponibilização durante a fase beta destina-se exclusivamente a testes técnicos, simulação de carga, localização de erros de programa (bugs) e otimização da facilidade de utilização.\n1.2. Status beta: O usuário está ciente de que o software oferecido é uma versão preliminar (software beta). Isso ainda não está totalmente desenvolvido tecnicamente, não atende aos padrões de um produto comercial final e pode causar erros, perda de dados, atrasos na transmissão ou falhas no sistema.\n1.3. Sem direito à continuação: O fornecedor tem o direito de, a qualquer momento, interromper total ou parcialmente o serviço, alterar ou restringir funções ou removê-las temporária ou permanentemente sem indicar motivos.\n\n2. Disponibilidade e Isenção de Garantia\n2.1. Sem garantia de disponibilidade: GaiaCom é fornecido sem qualquer garantia de disponibilidade ou tempo de atividade. Não há direito à disponibilidade ininterrupta do serviço.\n2.2. Exclusão de garantia: O software é fornecido no seu estado atual (“como está”) e sujeito à disponibilidade. Na medida permitida por lei, quaisquer reclamações de garantia por defeitos materiais e legais no software serão excluídas. Em particular, não há garantia de que o software esteja livre de erros, de malware ou adequado para uma finalidade específica.\n\n3. Gestão de riscos e obrigações dos usuários\n3.1. Proibição de armazenamento de dados críticos: O usuário compromete-se a não armazenar ou transmitir exclusivamente através do GaiaCom quaisquer dados críticos para o negócio, vitais, operacionalmente necessários ou legalmente particularmente sensíveis (como arquivos de pacientes, dados financeiros altamente sensíveis ou segredos oficialmente regulamentados). O serviço não pode ser utilizado em infraestruturas onde falhas imprevistas possam resultar em ferimentos pessoais, danos materiais ou perdas financeiras significativas.\n3.2. Backup auto-responsável: O usuário é responsável por fazer backup de todos os dados recebidos ou enviados via GaiaCom que necessite a longo prazo em sistemas próprios e independentes (cópias de backup). O provedor não garante o armazenamento permanente ou a capacidade de restauração dos dados em seus servidores.\n\n4. Recursos criptográficos e GaiaVault\n4.1. Criptografia pós-quântica (PQC): GaiaCom implementa processos de criptografia de última geração orientados para o futuro, projetados para resistir a ataques de futuros computadores quânticos. No entanto, o usuário está ciente de que este é um campo científico novo e dinâmico. A segurança absoluta e irrefutável não pode ser garantida com base no estado actual da ciência e da tecnologia. Termos como “100% seguro”, “inquebrável” ou “militarmente seguro” não são expressamente garantidos.\n4.2. Sem garantia de recuperação (GaiaVault): GaiaCom depende de um conceito consistente de segurança de conhecimento zero. As cunhas de criptografia e os dados de acesso permanecem sob controle exclusivo do usuário (protegidos via GaiaVault).\nIMPORTANTE: Se o usuário perder suas senhas, senhas, chaves privadas ou sementes de recuperação, o provedor não terá capacidade técnica para reconstruir ou redefinir esses dados. A perda destes dados de acesso conduz inevitavelmente à perda irrevogável de acesso à conta do utilizador e a todos os dados nela encriptados.\n4.3. Ainda não totalmente auditado: O software é continuamente submetido a verificações de segurança internas, mas no momento desta fase beta ainda não foi submetido a uma auditoria de segurança externa final e abrangente por organismos de testes independentes.\n\n5. Interfaces, protocolos legados e federação\n5.1. Nota sobre SMTP Bridge: GaiaCom oferece a capacidade de comunicação através de protocolos de e-mail clássicos (como SMTP). O usuário está ciente de que as mensagens que saem da área de segurança nativa do GaiaCom (por exemplo, quando enviadas para um endereço convencional @gmail.com ou @gmx.de) são transportadas através de servidores não criptografados ou de terceiros. As garantias de segurança ponta a ponta da GaiaCom se aplicam apenas até certo ponto ou não se aplicam a essas mensagens legadas enviadas ou recebidas externamente.\n5.2. Nota da Federação: Se a GaiaCom operar em uma rede federada, mensagens e dados poderão passar por servidores de terceiros. Embora o conteúdo das mensagens permaneça protegido por criptografia de ponta a ponta, os metadados (como hora do envio, endereços IP dos servidores envolvidos e endereços dos destinatários) podem ser tecnicamente visíveis para os operadores desses servidores federados. O provedor não tem influência nas práticas de proteção de dados de operadores de servidores terceirizados na rede federada.\n\n6. Usos aceitáveis e atividades proibidas\nO utilizador compromete-se a não utilizar o serviço de forma indevida ou para fins ilegais. Em particular, são proibidos:\n- Distribuir, enviar ou hospedar vírus, malware, conteúdo de phishing ou outro software malicioso.\n- Utilizar o Serviço para realizar ataques de negação de serviço (DDoS) ou envio de correspondência em massa não solicitada (spam).\n- Abusar do sistema para cometer fraudes.\n- A distribuição ou troca de conteúdos ilegais, em particular representações de abuso sexual infantil (CSAM), propaganda terrorista, apelos à violência ou outros conteúdos criminalmente relevantes.\n\n7. Sistema de denúncia de abusos\n7.1. Denunciar comportamento abusivo: Os usuários têm a oportunidade de denunciar comunicações abusivas ou atividades ilegais por meio do sistema integrado de abuso.\n7.2. Processamento de relatórios: Para garantir proteção contra uso indevido, os relatórios recebidos podem ser analisados ​​tecnicamente (mantendo os limites de privacidade e criptografia). Isto pode levar à suspensão temporária ou permanente de contas de usuários ou endereços IP em caso de violações comprovadas destes termos de uso.\n\n8. Limitação de Responsabilidade\n8.1. Padrão de responsabilidade: O software beta é fornecido gratuitamente. De acordo com as regras legais para doações ou empréstimos, o fornecedor só é responsável por dolo (dano intencional) e negligência grave.\n8.2. Exclusão de responsabilidade pela perda de dados: A responsabilidade pela perda de dados está excluída, a menos que a perda tenha sido causada intencionalmente ou por negligência grave do fornecedor e o utilizador tenha cumprido a sua obrigação de mitigar os danos através de backups regulares (fora da GaiaCom).\n8.3. Limites legais: As limitações de responsabilidade acima não se aplicam a danos à vida, ao corpo ou à saúde ou à responsabilidade sob a Lei de Responsabilidade do Produto.\n\n9. Código aberto\nCertos componentes, bibliotecas ou aplicativos clientes da GaiaCom podem ser licenciados sob licenças de código aberto (por exemplo, GPL, MIT, Apache). Os respectivos termos de licença desses componentes não são afetados por estes termos de uso e podem ser visualizados nos repositórios de código-fonte correspondentes.\n\n10. Controle de Exportação e Conformidade\nO usuário está ciente de que o software criptográfico pode estar sujeito a rígidos controles de exportação e restrições legais. O usuário é responsável por garantir que o uso do GaiaCom não viole as leis, restrições de importação/exportação ou regulamentos de criptografia do seu respectivo país de residência.\n\n11. Aviso de proteção de dados (versão resumida para beta)\n11.1. Coleta mínima de dados: Como parte da fase beta, o provedor coleta apenas dados absolutamente necessários para operação técnica, solução de problemas e desenvolvimento adicional (por exemplo, arquivos de log do servidor para diagnóstico de erros).\n11.2. Nenhuma visão do conteúdo: Graças ao conhecimento zero consistente e à criptografia E2E, o provedor nunca tem acesso ao conteúdo de seus chats, e-mails ou chaves armazenadas no GaiaVault.\n11.3. Declaração detalhada de proteção de dados: Os regulamentos detalhados de proteção de dados estão vinculados separadamente e também devem ser levados em consideração pelo usuário antes do registro.\n\n12. Disposições finais\n12.1. Lei aplicável: Aplica-se a lei da República Federal da Alemanha, excluindo a Convenção das Nações Unidas sobre Contratos para a Venda Internacional de Mercadorias.\n12.2. Sujeito a alterações: Dado que GaiaCom está em desenvolvimento ativo, o fornecedor reserva-se o direito de adaptar estas condições a qualquer momento com efeitos para o futuro. A versão atual está disponível no aplicativo.",
    "wizard_terms_title": "Termos de uso e contrato de teste beta da GaiaCom (fase beta)",
    "node_operator": "Operador de nó",
    "search_channels": "Pesquisar canais...",
    "senior_reviewer": "Revisor Sênior",
    "trusted_reviewer": "Revisor confiável",
    "active_frequencies": "Frequências ativas",
    "connected_rooms": "ESPAÇOS CONECTADOS",
    "dashboard": "Painel",
    "empty_chats": "Nenhum bate-papo ativo disponível.",
    "empty_messages": "Nenhuma nova mensagem disponível.",
    "encrypted": "Criptografado",
    "gaiacom_uplink": "LINK GAIACOM",
    "install_app": "Instalar aplicativo",
    "install_app_desc": "Para início rápido e modo offline",
    "kommandozentrale_alpha": "Centro de comando ALPHA",
    "network_online": "REDE: ON-LINE",
    "new_room": "Novo espaço",
    "no_frequencies_active": "Nenhuma frequência ativa. Crie uma nova sala para iniciar a comunicação.",
    "no_id": "Sem identificação",
    "open_chats": "Bate-papos abertos",
    "open_inbox": "Abrir caixa de entrada",
    "primary_identity": "IDENTIDADE PRIMÁRIA",
    "recent_chats": "Novos bate-papos",
    "recent_messages": "Últimas notícias",
    "session_encrypted": "Sessão criptografada: {nome}",
    "session_secure": "ESTADO: SEGURO",
    "system_verlassen": "Sistema de saída",
    "write_message": "Escreva uma mensagem",
  },
  ar: {
    sc_title: "مركز الأمن",
    sc_subtitle: "طبقة أمان مدمجة GaiaShield",
    sc_tab_status: "🛡️ حالة الحماية",
    sc_tab_events: "📋 سجل الأمن",
    sc_tab_node: "⚙️ أمن العقدة",
    sc_loading: "جاري تحميل بيانات الأمان...",
    sc_status_secured: "حالة النظام: الحساب محمي",
    sc_status_warning: "حالة النظام: تحذيرات نشطة",
    sc_desc_secured: "لا توجد تحذيرات أمنية حرجة نشطة. GaiaShield يراقب حسابك بنشاط.",
    sc_desc_warning: "تنبيه: هناك أحداث أمنية نشطة تتطلب انتباهك.",
    sc_account_protection: "حماية الحساب",
    sc_message_protection: "حماية الرسائل",
    sc_audits: "تدقيق الأمن",
    sc_active: "نشط",
    sc_failed_logins: "تسجيلات دخول فشلت",
    sc_tamper_checks: "فحوصات التلاعب",
    sc_blocked_replays: "عمليات إعادة التشغيل المحظورة",
    sc_last_check: "آخر فحص",
    sc_just_now: "الآن فقط",
    sc_open_warnings: "تحذيرات مفتوحة",
    sc_btn_acknowledge: "تأكيد",
    sc_filter_severity: "الخطورة",
    sc_filter_category: "الفئة",
    sc_filter_hide_ack: "إخفاء المؤكدة",
    sc_btn_export: "تصدير",
    sc_col_details: "التفاصيل",
    sc_col_time: "الوقت",
    sc_col_status: "الحالة",
    sc_col_action: "الإجراء",
    sc_no_events: "لم يتم العثور على أحداث أمنية.",
    sc_node_title: "لوحة تحكم أمن مشغل العقدة",
    sc_system_health: "صحة النظام",
    sc_last_audit: "آخر تدقيق",
    sc_packed_logs: "السجلات المجمعة",
    sc_unconfirmed_events: "الأحداث غير المؤكدة",
    sc_operator_action: "مطلوب إجراء من المشغل",
    sc_all_ok: "كل شيء على ما يرام",
    sc_critical_events: "أحداث النظام الحرجة",
    ac_title: "مركز الحوكمة والإبلاغ عن المخالفات",
    ac_subtitle: "إجماع الحوكمة وإساءة الاستخدام في GaiaCom",
    ac_tab_my_reports: "بلاغاتي",
    ac_tab_queue: "قائمة الانتظار للمراجعة",
    ac_tab_operator: "مشغل العقدة",
    ac_tab_transparency: "الاتحاد والشفافية",
    ac_loading: "جاري تحميل البيانات...",
    ac_reported_cases: "الحالات المبلغ عنها",
    ac_no_reports: "لم تقم بتقديم أي بلاغات بعد.",
    ac_case_details: "تفاصيل الحالة",
    ac_appeal_submit: "تقديم استئناف",
    ac_appeal_status: "حالة الاستئناف",
    ac_appeal_reason: "سبب الاستئناف",
    ac_appeal_statement: "بيان",
    ac_btn_appeal: "إرسال الاستئناف",
    ac_trusted_reviewer_queue: "قائمة مراجعي الحسابات الموثوق بهم",
    ac_case_review: "مراجعة الحالة",
    ac_review_category: "الفئة الموصى بها",
    ac_review_severity: "الخطورة الموصى بها",
    ac_review_action: "الإجراء الموصى به",
    ac_review_reason: "سبب المراجع",
    ac_btn_submit_review: "تقديم المراجعة",
    ac_node_operator_dashboard: "لوحة مشغل العقدة",
    ac_apply_action: "تطبيق الإجراء (تجاوز)",
    ac_target_type: "نوع الهدف",
    ac_target_id: "معرف الهدف (معرف العقدة أو معرف القناة)",
    ac_suspend: "التعليق نشط",
    ac_reason: "السبب الرسمي",
    ac_btn_apply: "فرض الإجراء",
    ac_transparency_title: "سجل التوافق والشفافية",
    ac_transparency_desc: "إثباتات لقطات قابلة للعرض العام لجميع القنوات والهويات الخاضعة للإشراف.",
    ac_btn_snapshot: "إنشاء لقطة للشفافية",
    search_placeholder: "البحث في الرسائل حسب الموضوع، المرسل، النص...",
    abuse_center_title: "مركز الإساءة",
    abbrechen: "يلغي",
    active_identities: "الهويات النشطة",
    active_identity: "الهوية النشطة",
    add_btn: "يضيف",
    add_contact_title: "أضف جهة اتصال",
    admin: "مسؤل",
    adressbuch: "دليل",
    aktiviert: "ممكّن",
    an: "ل",
    anonymous_sender: "مرسل مجهول",
    antworten: "إجابة",
    attachment_gaia_hint: "تظل مرفقات GaiaCOM مشفرة من طرف إلى طرف.",
    attachment_smtp_hint: "يحظر SMTP القديم المرفقات القابلة للتنفيذ/الشبيهة بالبرنامج النصي ويحفظ رسائل البريد الإلكتروني باعتبارها غير آمنة.",
    attachments: "المرفقات",
    auffaellig: "ملحوظ",
    auth_beta_notice: "مرحلة الاختبار التجريبي: يتم اختبار GaiaCOM بشكل نشط. قد تحدث أخطاء. تأمين البذور المهمة ومراجعة سير العمل السري بعناية.",
    auth_btn_login: "تحميل الهوية وتسجيل الدخول",
    auth_btn_register: "تسجيل وإنشاء التشفير",
    auth_copied: "منقول",
    auth_copy_seed: "نسخ البذور",
    auth_generate_seed: "توليد البذور",
    auth_headline: "GaiaCOM هو أول بروتوكول بريد إلكتروني ونظام اتصالات آمن الكم مصمم للبشرية.",
    auth_kicker: "الاتصالات الآمنة بعد الكم",
    auth_mnemonic: "عبارة ذاكري",
    auth_mnemonic_placeholder: "12 كلمة مفصولة بمسافات...",
    auth_password: "كلمة المرور",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "المفاتيح الخاصة لا تترك جهازك. يمكن للمستلمين المقصودين فقط فك تشفير المحتوى.",
    auth_proof_gaiadata_desc: "المعرفة الصفرية: ستظل متحكمًا في بياناتك. يتم تصغير بيانات التعريف ولا يتم استخدامها كملف تعريف نص عادي.",
    auth_proof_gaiadrop_desc: "يمكن للأشخاص الخارجيين إرسال رسائل نصية سرية إلى GaiaID الخاص بك بدون حساب.",
    auth_proof_gaiaproof_desc: "تُظهر أدلة التسليم والنزاهة أنه لم يتم التلاعب بالنص المشفر والمرسل والطابع الزمني.",
    auth_proof_gaiavault_desc: "تظل الملاحظات الخاصة وملاحظات الاسترداد وسجلات الأمان مشفرة محليًا.",
    auth_proof_hybrid_desc: "Quantum Shield: التشفير المختلط مع ML-KEM وX25519 يحمي من هجمات اليوم ومخاطر التخزين الآن وفك التشفير لاحقًا.",
    auth_secure_mail: "تأمين البريد الفيدرالي الكمي",
    auth_subline: "GaiaCOM هو نظام اتصالات كمي آمن للبريد الإلكتروني والدردشة وغرف الأزمات وGaiaDrop وملفات الأمان المحلية. تبقى المفاتيح الخاصة على جهازك، ويتم تشفير المحتوى من طرف إلى طرف، ويمكن تصدير الأدلة بدون نص عادي.",
    auth_success_btn: "قم بتسجيل الدخول الآن",
    auth_success_text: "تم إنشاء حساب GaiaCOM الخاص بك. تم اشتقاق المفاتيح محليًا من البذور الخاصة بك ولم يتم تخزينها على الخادم.",
    auth_success_title: "تم التسجيل بنجاح",
    auth_tab_drop: "جايا دروب",
    auth_tab_login: "تسجيل الدخول / الحساب",
    auth_toggle_login: "الحساب موجود بالفعل",
    auth_toggle_register: "إنشاء حساب جديد",
    auth_usecase_text: "مناسب للمحامين والشركات والسلطات والصحفيين والمبلغين والقضايا الأمنية الخاصة.",
    auth_usecase_title: "مصممة للاتصالات الحساسة",
    auth_username: "اسم المستخدم",
    auth_username_placeholder: "أدخل الاسم...",
    auth_value_chat: "دردشة E2E",
    auth_value_drop: "إسقاط آمن",
    auth_value_mail: "البريد الآمن",
    auth_value_rooms: "غرف جايا",
    bestaetigen: "يتأكد",
    bestaetigt: "مؤكد",
    bio_status: "السيرة الذاتية / الحالة",
    biography: "سيرة",
    change_password_desc: "يغير كلمة مرور تسجيل الدخول من جانب الخادم. تظل عبارة الاسترداد المحلية الخاصة بك محمية بشكل منفصل بواسطة كلمة مرور المخزن/فتح القفل.",
    change_password_menu_desc: "قم بتحديث كلمة مرور تسجيل الدخول إلى GaiaCOM.",
    change_password_title: "تغيير كلمة المرور",
    channel_id: "معرف القناة",
    channel_name_label: "اسم القناة",
    chat_deleted_hidden: "الدردشة محذوفة ومخفية.",
    chat_input_placeholder: "أدخل رسالة آمنة...",
    chat_start_hint: "ابدأ المحادثة! جميع رسائل الدردشة محمية كميًا ومشفرة بتقنية E2E.",
    choose_avatar: "اختر الصورة الرمزية",
    ciphertext_hash: "تجزئة النص المشفر",
    clear_chat: "دردشة فارغة",
    clear_for_everyone: "فارغة للجميع",
    clear_for_me: "فارغة بالنسبة لي فقط",
    click_to_write_mail: "انقر لكتابة بريد إلكتروني",
    click_top_right: "انقر في أعلى اليمين",
    close: "يغلق",
    code_kopieren: "نسخ الرمز",
    code_kopieren_success: "تم نسخ الكود",
    confirm_clear_channel_desc: "هل تريد مسح هذه القناة من العرض المحلي الخاص بك؟",
    confirm_clear_channel_title: "قناة فارغة",
    confirm_clear_chat: "هل تريد إفراغ هذه الدردشة؟",
    confirm_clear_chat_desc: "هل تريد إفراغ هذه الدردشة؟",
    confirm_clear_chat_title: "دردشة فارغة",
    confirm_clear_everyone: "هل تريد إفراغ الدردشة لكلا الشريكين؟ (موافق = للجميع، إلغاء = لي فقط)",
    confirm_delete_everyone: "هل تريد حذف الرسالة لكلا الشريكين؟ (موافق = للجميع، إلغاء = لي فقط)",
    confirm_delete_msg: "هل تريد حذف هذه الرسالة؟",
    confirm_delete_msg_desc: "هل تريد حذف رسالة الدردشة هذه؟",
    confirm_delete_msg_title: "حذف الرسالة",
    confirm_new_password: "تأكيد كلمة المرور الجديدة",
    copy: "ينسخ",
    create_btn: "يخلق",
    create_channel_title: "إنشاء قناة",
    create_group_is_crisis: "وضع علامة كمنطقة أزمة",
    create_group_title: "إنشاء مجموعة جديدة",
    crypto_lock_desc: "التحكم عندما يقوم GaiaCOM بإزالة مفاتيح التشفير المحلية من الذاكرة.",
    crypto_lock_menu_desc: "التحكم في إعادة التحميل ومؤقتات عدم النشاط.",
    crypto_lock_title: "قفل التشفير",
    crypto_session_duration: "مقفلة بعد إعادة التحميل",
    crypto_session_duration_desc: "يُبقي جلسة التشفير مفتوحة في علامة تبويب المتصفح هذه فقط للمدة المحددة.",
    cryptographic_fingerprint: "بصمة التشفير",
    current_password: "كلمة المرور الحالية",
    data_minimization: "التقليل من البيانات",
    decrypt_failed: "غير قابلة للفك",
    delete: "يمسح",
    delete_account_button: "حذف الحساب بشكل نهائي",
    delete_account_confirm_label: "أدخل حذف للتأكيد",
    delete_account_confirmation_error: "مطلوب كلمة المرور وتأكيد الحذف.",
    delete_account_desc: "يقوم هذا الوضع بتدمير حسابك وهوياتك وجلسات جهازك وبيانات GaiaDrop وتحميل البيانات التعريفية والرسائل المنسوبة من جانب الخادم بشكل دائم.",
    delete_account_done_desc: "تم حذف جميع بيانات GaiaCOM القابلة للتخصيص.",
    delete_account_done_title: "تم حذف الحساب",
    delete_account_menu_desc: "تدمير الحساب والبيانات المرتبطة به.",
    delete_account_not_authenticated: "لا يوجد حساب نشط.",
    delete_account_title: "حذف الحساب",
    delete_for_everyone: "الحذف للجميع",
    delete_for_me: "حذف فقط بالنسبة لي",
    device_current: "هذا الجهاز",
    device_last_seen: "آخر",
    device_logout: "تسجيل الخروج",
    device_sessions_desc: "تحقق من الجلسات النشطة وقم بإلغاء تسجيل الأجهزة التي لم تعد تثق بها.",
    device_sessions_empty: "لم يتم العثور على أي أجهزة.",
    device_sessions_menu_desc: "إدارة وإنهاء الجلسات النشطة.",
    device_sessions_title: "الأجهزة المسجلة",
    device_since: "منذ",
    display_name: "اسم العرض",
    drop_address_copied: "تم نسخ عنوان GaiaDrop.",
    drop_btn_decrypting: "جارٍ فك تشفير البريد الوارد...",
    drop_btn_load: "قم بتحميل صندوق الوارد لـ GaiaDrop",
    drop_delete_desc: "هل تريد حقًا حذف هذا الإسقاط نهائيًا؟",
    drop_delete_title: "حذف جايا دروب",
    drop_desc: "قناة إسقاط المعرفة الصفرية النصية فقط للإشعارات الخارجية والإفصاح المسؤول والتقارير السرية. يمكن للأطراف الخارجية إرسال رسائل بدون حساب باستخدام GaiaID الخاص بك.",
    drop_empty: "لم يتم تحميل رسائل GaiaDrop حتى الآن.",
    drop_id: "معرف الإسقاط:",
    drop_own_address: "عنوان GaiaDrop الخاص بك",
    drop_proof: "مقاومة للسقوط",
    drop_title: "GaiaDrop صندوق الوارد الآمن",
    dunkler_modus: "الوضع المظلم",
    e2e_chat_room_open: "افتح غرفة الدردشة E2E",
    edit_profile: "تحرير الملف الشخصي",
    edit_profile_desc: "تخصيص اسم العرض والسيرة الذاتية والصورة الرمزية.",
    einladungscode: "رمز الدعوة",
    enter_fingerprint_chars_confirm: "أدخل أحرف بصمة الإصبع المطلوبة للتأكيد.",
    envelope_hash: "تجزئة المغلف",
    erasability: "قابلية المسح",
    erfolg: "نجاح",
    exclude_plaintext: "تصدير بدون نص عادي",
    export_disclosure: "حالة أمان التصدير",
    export_package_desc: "قم بتضمين نص عادي فقط إذا كان هذا الكشف مقصودًا عن قصد.",
    export_package_title: "حزمة أمان التصدير",
    fehler: "خطأ",
    gaiacom_reader: "قارئ جاياكوم",
    gaiadrop_inbox_title: "غايا دروب البريد الوارد",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "يقوم GaiaCOM بتقليل البيانات التعريفية، والحفاظ على المفاتيح الخاصة محليًا، وتشفير المحتوى من البداية إلى النهاية، وتمكين الحذف الكامل للحساب.",
    gdpr_home_title: "متوافق مع اللائحة العامة لحماية البيانات بنسبة 100%",
    gdpr_reason_delete: "يؤدي حذف الحساب إلى إزالة الحساب والهويات والجلسات المحلية والبيانات القابلة للتخصيص من جانب الخادم.",
    gdpr_reason_e2ee: "يظل المحتوى الخاص قابلاً لفك التشفير للمستلمين المقصودين فقط.",
    gdpr_reason_minimal: "يتم استخدام البيانات التعريفية فقط للتوجيه والتسليم وبيانات اعتماد الأمان.",
    gdpr_reason_zero_knowledge: "تظل المفاتيح الخاصة وبيانات الاسترداد تحت سيطرة المستخدم محليًا.",
    gesendet: "مرسل",
    gesperrt_verdaechtig: "محظور / مشبوه",
    group_delete_desc: "هل تريد حقًا حذف هذه المجموعة نهائيًا؟ سيتم حذف جميع القنوات والرسائل في هذه المجموعة.",
    group_delete_title: "حذف المجموعة",
    group_description: "وصف",
    group_icon_label: "رمز المجموعة / الصورة الرمزية",
    group_name: "اسم المجموعة",
    group_settings_avatar: "الصورة الرمزية",
    group_settings_desc: "وصف",
    group_settings_is_crisis: "وضع علامة كمنطقة أزمة",
    group_settings_name: "اسم المجموعة",
    group_settings_title: "إعدادات المجموعة",
    groups_empty_desc: "قم بإنشاء مساحة عمل آمنة للمشروع أو الأزمات أو التواصل مع الفريق.",
    groups_empty_title: "لا توجد محادثات جماعية حتى الآن",
    gruppe_beitreten: "انضمت للمجموعة",
    gruppe_erstellen: "+ إنشاء مجموعة",
    gruppe_verlassen: "اترك المجموعة",
    gruppen_chats: "محادثات جماعية",
    heller_modus: "وضع مشرق",
    how_to_receive_drops: "كيف يمكنني الحصول على قطرات؟",
    identitaets_assistent: "مساعد الهوية",
    inactivity_lock_duration: "القفل عندما يكون غير نشط",
    inactivity_lock_duration_desc: "بعد هذه الفترة من عدم الإدخال، سيتم قفل GaiaCOM تلقائيًا بالتشفير.",
    inactivity_lock_notice: "تم حظر GaiaCOM تشفيرًا بسبب عدم النشاط.",
    include_plaintext: "تضمين نص عادي",
    invite_code_label: "رمز الدعوة",
    join_group_title: "انضم إلى المجموعة",
    kanaele: "القنوات",
    kanal_erstellen: "+ قناة",
    kein_chat_ausgewaehlt: "لم يتم تحديد أي دردشة",
    kein_kanal_ausgewaehlt: "لم يتم تحديد أي قناة",
    keine_gruppe_ausgewaehlt: "لم يتم تحديد أي مجموعة",
    keine_mails: "لا توجد رسائل بريد إلكتروني متاحة.",
    key_change_warn_desc: "لقد تغير المفتاح العام لجهة الاتصال هذه. تحقق من بصمة الإصبع قبل الوثوق بها.",
    key_change_warn_title: "تحذير التشفير",
    key_change_warning_changed: "لقد تغير. قد يكون هذا علامة على هجوم رجل في الوسط!",
    key_change_warning_msg: "مفتاح الهوية لجهة الاتصال",
    key_transparency: "الشفافية الرئيسية",
    kopiert: "منقول",
    kryptographische_schluessel: "مفاتيح التشفير",
    kryptographische_schluessel_desc: "إظهار المفاتيح الخاصة والعبارة الأولية الاحتياطية.",
    laden: "حمولة...",
    leeren: "فارغ",
    loading: "حمولة...",
    local_key_vault: "قبو المفتاح المحلي",
    local_keys_label: "المفاتيح المحلية",
    lock_on_reload: "القفل دائمًا بعد إعادة التحميل",
    logout: "تسجيل الخروج",
    mail_compose: "اكتب البريد الإلكتروني",
    mein_profil: "ملفي الشخصي",
    melden: "تقرير",
    menu: "قائمة طعام",
    message: "أخبار",
    message_id: "معرف الرسالة",
    message_pin: "دبوس",
    message_pinned_title: "الرسائل المثبتة",
    message_react: "رد فعل",
    message_reply: "إجابة",
    message_replying_to: "الإجابة على",
    message_save: "يحفظ",
    message_saved: "أنقذ",
    message_to_channel: "رسالة إلى",
    message_unpin: "يحل",
    message_unsave: "لا تحفظ",
    mitglied: "عضو",
    mitglieder: "أعضاء",
    ml_kem: "مل-كيم",
    neue_mail: "البريد الإلكتروني الجديد",
    never_auto_lock: "أبدا تلقائيا",
    new_fingerprint: "بصمة جديدة",
    new_identity: "هوية جديدة",
    new_password: "كلمة المرور الجديدة",
    no_description: "لا يوجد وصف",
    no_key_history: "لم يتم تسجيل أي سجل رئيسي.",
    no_specification: "غير محدد",
    old_fingerprint: "بصمة قديمة",
    open_privacy_imprint: "فتح بصمة وحماية البيانات",
    post_quantum_e2e: "ما بعد الكم E2E",
    posteingang: "البريد الوارد",
    powered_by: "مدعوم من",
    privacy_imprint_menu_desc: "عرض اللائحة العامة لحماية البيانات وحماية البيانات والإشعار القانوني.",
    privacy_imprint_profile_desc: "تقوم GaiaCOM بمعالجة محتوى الاتصال وفقًا لمبادئ تقليل البيانات والتشفير الشامل والتحكم في المفاتيح المحلية.",
    privacy_imprint_title: "حماية البيانات والإشعار القانوني",
    profil: "حساب تعريفي",
    profile_details: "تفاصيل الملف الشخصي",
    profile_settings_hint: "يتم عرض إعدادات الملف الشخصي في اللوحة اليمنى.",
    profile_unlock_desc: "لأسباب أمنية، يجب عليك إعادة إدخال كلمة المرور الخاصة بك لعرض مفاتيح التشفير الخاصة بك.",
    proof_hash: "تجزئة الإثبات:",
    public_drop_desc: "Secure Drop للحصول على معلومات نصية خارجية بدون حساب GaiaCOM.",
    public_drop_message: "أخبار",
    public_drop_message_placeholder: "أدخل نصًا سريًا...",
    public_drop_send: "أرسل غايا دروب",
    public_drop_sender: "ملاحظة المرسل اختيارية",
    public_drop_sender_placeholder: "الاسم ورقم الملف أو مجهول",
    public_drop_target: "الهدف GaiaID",
    quanten_chat: "الدردشة الكمومية",
    quantum_secure_exchange: "التبادل الكمي الآمن عبر...",
    quantum_secure_net: "الشبكة الآمنة الكمومية GaiaCOM (Ed25519 وML-KEM)",
    quantum_shield_desc: "تحمي شبكة GaiaCOM خصوصيتك من خلال بروتوكول تشفير هجين متعدد الطبقات محمي ضد الهجمات من أجهزة الكمبيوتر الكمومية المستقبلية.",
    quantum_shield_l1_desc: "يستخدم معيار FIPS 203 لتغليف مفتاح مشترك متماثل. يمنع التسجيل السلبي وفك التشفير لاحقًا (\\",
    quantum_shield_l1_title: "1. الحماية بعد الكم (ML-KEM-1024)",
    quantum_shield_l2_desc: "إجراء تبادل مفاتيح Diffie-Hellman كلاسيكي وسريع للغاية يعمل كطبقة إضافية من الأمان في الإجراء المختلط.",
    quantum_shield_l2_title: "2. تشفير المنحنى الإهليلجي (X25519)",
    quantum_shield_l3_desc: "يتم توقيع كل رسالة وكل مظروف اتحادي بشكل مشفر للتحقق بشكل لا لبس فيه من صحة المرسل.",
    quantum_shield_l3_title: "3. التوقيعات الرقمية (Ed25519)",
    quantum_shield_l4_desc: "يقوم بتشفير محتوى الرسالة بشكل متماثل وربط المرسل والمستلم وبيانات التعريف بشكل متماثل وإحكام في البيانات الإضافية المصادق عليها (AAD) لمنع هجمات إعادة التشغيل.",
    quantum_shield_l4_title: "4. مصادقة AAD (AES-256-GCM)",
    quantum_shield_status: "حالة الدرع الكمي",
    receive_drops_step1: "قم بمشاركة GaiaID الخاص بك (على سبيل المثال، باستخدام زر النسخ أعلاه) مع مصادر خارجية.",
    receive_drops_step2: "يقوم ذلك باستدعاء صفحة تسجيل الدخول الخاصة بمثيل GaiaCOM الخاص بك والتبديل إلى علامة التبويب",
    receive_drops_step3: "وإرسال رسالتهم المشفرة إلى عنوانك.",
    receiver_gaia: "جهاز استقبال جاياكوم",
    receiver_smtp: "مستلم SMTP",
    records_stored: "تم حفظ السجلات",
    refresh: "تحديث",
    report_abuse_desc: "هل تريد الإبلاغ عن هذه الرسالة وإرسال دليل مشفر لإساءة الاستخدام إلى الخادم؟",
    report_abuse_title: "الإبلاغ عن إساءة الاستخدام",
    reputation_status: "حالة السمعة",
    room_chat_start_hint: "ابدأ المحادثة! جميع الرسائل في قناة المجموعة هذه مشفرة بتقنية E2E لا مركزية وآمنة كميًا.",
    room_policy_audit: "مسار التدقيق وتناوب المفاتيح نشط.",
    room_policy_crisis: "غرفة الأزمات",
    room_policy_e2ee: "مساحة المعرفة صفر. E2EE آمن الكم.",
    room_policy_title: "إرشادات الغرفة",
    room_policy_zero_knowledge: "سياسة",
    room_security_note_desc: "يتم التحقق من صحة جميع التغييرات الرئيسية عبر Key Transparency. استخدم GaiaVault لسجلات النسخ الاحتياطي الخاصة.",
    room_security_note_title: "مذكرة أمنية مثبتة",
    save_profile: "حفظ الملف الشخصي",
    schluessel_entsperrt: "🔑 قفل المفتاح مرة أخرى",
    search_gaia_label: "ابحث عن عنوان غايا",
    security_warning_title: "تحذير أمني",
    select_channel_chat: "حدد قناة من الشريط الجانبي الأيسر للدردشة.",
    select_contact_chat: "حدد جهة اتصال من اللوحة اليمنى لبدء محادثة E2E آمنة الكم.",
    select_mail_read: "حدد بريدًا إلكترونيًا من القائمة لقراءة محتواه الآمن أو إنشاء رسالة جديدة.",
    senden: "يرسل",
    sender_signature: "توقيع المرسل",
    server_log: "سجل الخادم:",
    server_received: "تم استلام الخادم",
    session_lock: "قفل الجلسة",
    setup_address_keys: "إنشاء عنوان ومجموعة المفاتيح",
    setup_profile: "إعداد في الملف الشخصي",
    smtp_inbox_title: "استقبال SMTP",
    smtp_legacy_badge: "SMTP قديم/غير آمن",
    smtp_mode_option: "جسر SMTP القديم",
    smtp_security_warning: "تم إرسال هذا البريد الإلكتروني عبر بروتوكول SMTP الكلاسيكي غير المشفر. لا يوجد تشفير شامل نشط.",
    smtp_security_warning_desc: "هذه الرسالة تغادر غرفة أمان GaiaCom. لا يوفر تسليم SMTP ضمان GaiaCom الأصلي الشامل، ولا ضمان TrustMesh ولا ضمان Godmode من البوابة.",
    spam_verdacht: "البريد المزعج / الشك",
    spam_warning_desc: "تحتوي هذه الرسالة على إشارات سمعة مشبوهة.",
    spam_warning_title: "تحذير من البريد العشوائي",
    speichern: "يحفظ",
    sperren: "قفل",
    standard_group_status: "دردشة جماعية قياسية (مشفرة E2EE)",
    status: "حالة",
    subject: "متعلق",
    suchen: "ابحث عن عنوان Gaia جديد...",
    tage: "أيام",
    time_unknown: "الوقت غير معروف",
    transmission_mode: "وضع النقل",
    trust_age: "عمر الثقة",
    trust_passport_title: "جواز سفر الثقة",
    unbestaetigt: "غير مؤكد",
    unknown_sender: "مجهول",
    unlock_btn: "فتح",
    unlock_btn_profile: "فتح",
    unlock_desc: "يتم تخزين ملف المفتاح الخاص الخاص بك بشكل مشفر. أدخل كلمة المرور الخاصة بك لتحميل مفاتيح التشفير في الذاكرة فقط.",
    unlock_logout: "تسجيل الخروج وإغلاق المفاتيح المحلية",
    unlock_title: "فتح الهوية",
    untrusted: "غير جدير بالثقة",
    update_password: "تحديث كلمة المرور",
    upload_avatar_btn: "تحميل الصورة (معقمة)",
    vault_btn_encrypt: "تشفير السجل",
    vault_btn_lock: "قفل آمن",
    vault_btn_unlock: "فتح آمنة",
    vault_copied_success: "تم النسخ إلى الحافظة",
    vault_decrypted_content: "المحتوى الذي تم فك تشفيره",
    vault_desc: "قبو محلي مشفر للنسخ الاحتياطية للاسترداد وملاحظات الهوية والوصول إلى الخادم وجهات اتصال الطوارئ والملاحظات القانونية والأحداث الأمنية والسجلات الخاصة.",
    vault_empty: "لم يتم حفظ أي سجلات آمنة حتى الآن.",
    vault_locked_pane_notice: "آمنة مقفلة. يرجى فتح على اليمين.",
    vault_new_record: "سجل آمن جديد",
    vault_pwd_placeholder: "أدخل كلمة مرور المخزن...",
    vault_record_body: "سجل المحتوى",
    vault_record_body_placeholder: "أدخل محتوى السجل المشفر...",
    vault_record_category: "فئة",
    vault_record_title: "عنوان السجل",
    vault_record_title_placeholder: "عنوان السجل الآمن",
    vault_title: "سجلات GaiaVault الآمنة",
    verify_new_fingerprint_hint: "تحقق من بصمة الإصبع الجديدة قبل قبول المفتاح.",
    vertrauenswuerdig: "جدير بالثقة",
    vision_gaia_technology: "VisionGaiaTechnology",
    von: "من",
    warnung: "تحذير",
    wizard_address: "عنوان",
    wizard_back: "خلف",
    wizard_check1: "لقد أنقذت بذوري بأمان.",
    wizard_custom_domain: "استخدم المجال الخاص بك",
    wizard_desc1: "لا يقوم GaiaCOM بتخزين المفاتيح الخاصة على جانب الخادم. بدون بذور ذاكري، لا يمكن لأحد استعادة الرسائل المفقودة.",
    wizard_desc2: "يحدد عنوانك العقدة الموحدة التي يتم من خلالها توجيه المغلفات المشفرة.",
    wizard_fallback: "العقد الاحتياطية",
    wizard_finish: "الإعداد الكامل",
    wizard_next: "إضافي",
    wizard_server_domain: "مجال عقدة الخادم",
    wizard_step1: "1. البذور الاحتياطية",
    wizard_step2: "2. العنوان والخادم",
    wizard_title1: "عمل نسخة احتياطية من مفتاح الاسترداد",
    wizard_title2: "حدد عنوان GaiaCOM",
    write_message_placeholder: "اكتب رسالة آمنة...",
    you: "أنت",
    zero_knowledge: "المعرفة صفر",
    zero_knowledge_encryption: "تشفير المعرفة الصفرية",
    "Chat fuer alle geleert": "Der Chat wurde für alle Teilnehmer geleert.",
    "Chat geleert": "Der Chat wurde für deine lokale Inbox geleert.",
    "Nachricht fuer alle geloescht": "Die Nachricht wurde für alle Teilnehmer gelöscht.",
    "Nachricht geloescht": "Die Chat-Nachricht wurde lokal aus deiner Inbox entfernt.",
    "anpinnen": "Anpinnen",
    "chat_loeschen": "Chat löschen",
    "confirm_delete_chat_desc": "Möchtest du den Chat wirklich löschen und ausblenden?",
    "confirm_leave_group_desc": "Möchtest du diese Gruppe wirklich verlassen?",
    "entpinnen": "Entpinnen",
    "group_deleted": "Gruppe erfolgreich gelöscht.",
    "group_left": "Gruppe erfolgreich verlassen.",
    "gruppe_loeschen": "Gruppe löschen",
    "loeschen": "Löschen",
    "no_active_chats": "Keine aktiven Chats. Suche oben nach Kontakten, um einen Chat zu starten.",
    "pinned": "Angepinnt",
    "wizard_check_credentials": "أنا مسؤول عن الحفاظ على أمان بيانات الوصول الخاصة بي.",
    "wizard_check_is_beta": "أدرك أن GaiaCom هو برنامج تجريبي.",
    "wizard_check_no_illegal": "لن أستخدم GaiaCom لأغراض غير قانونية.",
    "wizard_check_no_uptime": "أنا أفهم أنه لا يوجد ضمان للتوافر.",
    "wizard_check_smtp_security": "أدرك أن رسائل SMTP لا توفر الأمان الكامل لـ GaiaCom.",
    "wizard_check_terms_read": "لقد قرأت شروط خدمة النسخة التجريبية.",
    "wizard_step_terms": "شروط الاستخدام",
    "wizard_terms_text": "شروط استخدام GaiaCom واتفاقية الاختبار التجريبي (المرحلة التجريبية)\n\nالموفر: VisionGaiaTechnology (يشار إليه فيما يلي باسم \"المزود\")\nالحالة: مرحلة الاختبار التجريبي العام\nالصلاحية: من 21 يونيو 2026\n\n⚠️ أهم ملاحظة مقدمًا (يرجى القراءة بعناية)\nGaiaCom في مرحلة الاختبار التجريبي العام. على الرغم من التدابير الأمنية الشاملة، لا يمكن ضمان التحرر من الأخطاء أو التوفر المستمر أو الأمان المطلق للبرنامج والبنية التحتية الأساسية. استخدم على مسؤوليتك الخاصة. يتحمل المستخدمون مسؤولية التخزين الآمن لبيانات الوصول الخاصة بهم (خاصة مفاتيح GaiaVault) والالتزام بالقوانين المعمول بها.\n\n1. موضوع وغرض مرحلة الاختبار التجريبي\n1.1. الغرض من توفيرها: GaiaCom هي خدمة بريد إلكتروني ودردشة جديدة تعتمد على التشفير ما بعد الكمي (PQC). إن التوفير أثناء المرحلة التجريبية مخصص حصريًا للاختبار الفني ومحاكاة التحميل والعثور على أخطاء البرنامج (الأخطاء) وتحسين سهولة الاستخدام.\n1.2. حالة النسخة التجريبية: يدرك المستخدم أن البرنامج المعروض هو إصدار أولي (برنامج تجريبي). لم يتم تطوير هذا بشكل كامل من الناحية الفنية بعد، ولا يفي بمعايير المنتج النهائي التجاري ويمكن أن يسبب أخطاء أو فقدان البيانات أو تأخير الإرسال أو تعطل النظام.\n1.3. عدم الحق في الاستمرار: يحق للمزود في أي وقت إيقاف الخدمة كليًا أو جزئيًا، أو تغيير الوظائف أو تقييدها أو إزالتها بشكل مؤقت أو دائم دون إبداء الأسباب.\n\n2. التوفر وإخلاء المسؤولية عن الضمان\n2.1. ضمان عدم التوفر: يتم توفير GaiaCom دون أي ضمان للتوفر أو وقت التشغيل. ليس هناك حق في توفر الخدمة دون انقطاع.\n2.2. استبعاد الضمان: يتم توفير البرنامج في حالته الحالية (\"كما هو\") ويخضع لمدى توفره. إلى الحد الذي يسمح به القانون، يتم استبعاد أي مطالبات ضمان بخصوص العيوب المادية والقانونية في البرنامج. وعلى وجه الخصوص، ليس هناك ما يضمن أن البرنامج خالٍ من الأخطاء أو البرامج الضارة أو مناسب لغرض معين.\n\n3. إدارة المخاطر والتزامات المستخدم\n3.1. حظر تخزين البيانات الهامة: يتعهد المستخدم بعدم تخزين أو نقل أي بيانات مهمة للأعمال أو حيوية أو ضرورية من الناحية التشغيلية أو حساسة بشكل خاص من الناحية القانونية عبر GaiaCom حصريًا (مثل ملفات المرضى أو البيانات المالية شديدة الحساسية أو الأسرار المنظمة رسميًا). لا يجوز استخدام الخدمة للبنية التحتية حيث يمكن أن تؤدي حالات الفشل غير المتوقعة إلى إصابة شخصية أو تلف في الممتلكات أو خسارة مالية كبيرة.\n3.2. النسخ الاحتياطي المسؤول ذاتيًا: يكون المستخدم مسؤولاً عن النسخ الاحتياطي لجميع البيانات الواردة أو المرسلة عبر GaiaCom والتي يحتاجها على المدى الطويل على أنظمته المستقلة (النسخ الاحتياطية). لا يضمن المزود التخزين الدائم أو إمكانية استعادة البيانات على خوادمه.\n\n4. ميزات التشفير وGaiaVault\n4.1. التشفير ما بعد الكمي (PQC): تطبق GaiaCom أحدث عمليات التشفير الموجهة نحو المستقبل والتي تم تصميمها لمقاومة الهجمات من أجهزة الكمبيوتر الكمومية المستقبلية. ومع ذلك، يدرك المستخدم أن هذا مجال علمي ديناميكي وجديد. ولا يمكن ضمان الأمن المطلق الذي لا يمكن دحضه على أساس الحالة الراهنة للعلم والتكنولوجيا. المصطلحات مثل \"آمن بنسبة 100%\" أو \"غير قابل للاختراق\" أو \"آمن عسكريًا\" غير مضمونة صراحةً.\n4.2. لا يوجد ضمان استرداد (GaiaVault): تعتمد GaiaCom على مفهوم أمان ثابت للمعرفة الصفرية. تظل شرائح التشفير وبيانات الوصول تحت سيطرة المستخدم فقط (مؤمنة عبر GaiaVault).\nهام: إذا فقد المستخدم كلمات المرور أو عبارات المرور أو المفاتيح الخاصة أو بذور الاسترداد، فلن يكون لدى الموفر القدرة الفنية على إعادة بناء هذه البيانات أو إعادة تعيينها. يؤدي فقدان بيانات الوصول هذه حتماً إلى فقدان الوصول إلى حساب المستخدم وجميع البيانات المشفرة فيه بشكل لا رجعة فيه.\n4.3. لم يتم تدقيقه بالكامل بعد: يخضع البرنامج بشكل مستمر لفحوصات الأمان الداخلية، ولكن في وقت هذه المرحلة التجريبية، لم يخضع بعد لتدقيق أمني خارجي نهائي وشامل من قبل هيئات اختبار مستقلة.\n\n5. الواجهات والبروتوكولات القديمة والاتحاد\n5.1. ملاحظة على جسر SMTP: يوفر GaiaCom القدرة على الاتصال عبر بروتوكولات البريد الإلكتروني الكلاسيكية (مثل SMTP). يدرك المستخدم أن الرسائل التي تغادر منطقة أمان GaiaCom الأصلية (على سبيل المثال عند إرسالها إلى عنوان @gmail.com أو @gmx.de تقليدي) يتم نقلها عبر خوادم غير مشفرة أو خوادم تابعة لجهات خارجية. تنطبق ضمانات GaiaCom الأمنية الشاملة على نطاق محدود فقط أو لا تنطبق على الإطلاق على هذه الرسائل القديمة الصادرة أو الواردة خارجيًا.\n5.2. ملاحظة اتحادية: إذا كانت GaiaCom تعمل على شبكة اتحادية، فقد تمر الرسائل والبيانات عبر خوادم خارجية. بينما تظل محتويات الرسائل محمية بالتشفير الشامل، فإن البيانات الوصفية (مثل وقت الإرسال وعناوين IP للخوادم المعنية وعناوين المستلمين) قد تكون مرئية تقنيًا لمشغلي هذه الخوادم الموحدة. ليس للموفر أي تأثير على ممارسات حماية البيانات لمشغلي خوادم الطرف الثالث في الشبكة الموحدة.\n\n6. الاستخدامات المقبولة والأنشطة المحظورة\nيتعهد المستخدم بعدم استخدام الخدمة بشكل غير صحيح أو لأغراض غير قانونية. ويحظر على وجه الخصوص ما يلي:\n- توزيع أو إرسال أو استضافة الفيروسات أو البرامج الضارة أو محتوى التصيد أو البرامج الضارة الأخرى.\n- استخدام الخدمة لتنفيذ هجمات رفض الخدمة (DDoS) أو إرسال بريد جماعي غير مرغوب فيه (البريد العشوائي).\n- إساءة استخدام النظام لارتكاب عمليات احتيال.\n- توزيع أو تبادل محتوى غير قانوني، ولا سيما تصوير الاعتداء الجنسي على الأطفال (CSAM)، أو الدعاية الإرهابية، أو الدعوات إلى العنف أو أي محتوى آخر ذي صلة جنائية.\n\n7. نظام الإبلاغ عن إساءة الاستخدام\n7.1. الإبلاغ عن السلوك المسيء: لدى المستخدمين الفرصة للإبلاغ عن الاتصالات المسيئة أو الأنشطة غير القانونية عبر نظام الإساءة المتكامل.\n7.2. معالجة التقارير: من أجل ضمان الحماية ضد سوء الاستخدام، يمكن تحليل التقارير الواردة تقنيًا (مع الحفاظ على حدود الخصوصية والتشفير). يمكن أن يؤدي ذلك إلى تعليق مؤقت أو دائم لحسابات المستخدمين أو عناوين IP في حالة ثبوت حدوث انتهاكات لشروط الاستخدام هذه.\n\n8. حدود المسؤولية\n8.1. معيار المسؤولية: يتم توفير البرنامج التجريبي مجانًا. وفقا للقواعد القانونية للتبرعات أو القروض، فإن مقدم الخدمة مسؤول فقط عن النية (الضرر المتعمد) والإهمال الجسيم.\n8.2. استبعاد المسؤولية عن فقدان البيانات: يتم استبعاد المسؤولية عن فقدان البيانات ما لم تكن الخسارة ناجمة عن قصد أو من خلال الإهمال الجسيم من جانب المزود وكان المستخدم قد أوفى بالتزامه بتخفيف الضرر من خلال النسخ الاحتياطية المنتظمة (خارج GaiaCom).\n8.3. الحدود القانونية: لا تنطبق حدود المسؤولية المذكورة أعلاه على الضرر الذي يلحق بالحياة أو الجسد أو الصحة أو المسؤولية بموجب قانون المسؤولية عن المنتج.\n\n9. المصدر المفتوح\nقد يتم ترخيص بعض مكونات GaiaCom أو مكتباتها أو تطبيقات العميل بموجب تراخيص مفتوحة المصدر (مثل GPL وMIT وApache). تظل شروط الترخيص الخاصة بهذه المكونات غير متأثرة بشروط الاستخدام هذه ويمكن الاطلاع عليها في مستودعات التعليمات البرمجية المصدر المقابلة.\n\n10. مراقبة الصادرات والامتثال\nيدرك المستخدم أن برامج التشفير قد تخضع لضوابط التصدير الصارمة والقيود القانونية. يتحمل المستخدم مسؤولية ضمان أن استخدام GaiaCom لا ينتهك القوانين أو قيود الاستيراد/التصدير أو لوائح التشفير الخاصة ببلد إقامته.\n\n11. إشعار حماية البيانات (نسخة قصيرة للنسخة التجريبية)\n11.1. الحد الأدنى من جمع البيانات: كجزء من المرحلة التجريبية، يقوم الموفر فقط بجمع البيانات الضرورية للغاية للتشغيل الفني واستكشاف الأخطاء وإصلاحها ومواصلة التطوير (مثل ملفات سجل الخادم لتشخيص الأخطاء).\n11.2. لا توجد رؤية واضحة للمحتوى: بفضل المعرفة الصفرية المتسقة وتشفير E2E، لا يستطيع الموفر أبدًا الوصول إلى محتويات الدردشات أو رسائل البريد الإلكتروني أو المفاتيح المخزنة في GaiaVault.\n11.3. إعلان تفصيلي لحماية البيانات: ترتبط اللوائح التفصيلية لحماية البيانات بشكل منفصل ويجب أن يأخذها المستخدم أيضًا في الاعتبار قبل التسجيل.\n\n12. أحكام ختامية\n12.1. القانون المطبق: ينطبق قانون جمهورية ألمانيا الاتحادية، باستثناء اتفاقية الأمم المتحدة بشأن عقود البيع الدولي للبضائع.\n12.2. عرضة للتغيير: نظرًا لأن GaiaCom قيد التطوير النشط، يحتفظ المزود بالحق في تكييف هذه الشروط في أي وقت مع سريانه في المستقبل. الإصدار الحالي متاح في التطبيق.",
    "wizard_terms_title": "شروط استخدام GaiaCom واتفاقية الاختبار التجريبي (المرحلة التجريبية)",
    "node_operator": "مشغل العقدة",
    "search_channels": "بحث في القنوات...",
    "senior_reviewer": "كبار المراجعين",
    "trusted_reviewer": "مراجع موثوق",
    "active_frequencies": "الترددات النشطة",
    "connected_rooms": "مساحات متصلة",
    "dashboard": "لوحة القيادة",
    "empty_chats": "لا توجد محادثات نشطة متاحة.",
    "empty_messages": "لا توجد رسائل جديدة متاحة.",
    "encrypted": "مشفرة",
    "gaiacom_uplink": "جاياكوم الإرسال",
    "install_app": "تثبيت التطبيق",
    "install_app_desc": "لبدء سريع ووضع غير متصل بالشبكة",
    "kommandozentrale_alpha": "مركز قيادة ألفا",
    "network_online": "الشبكة: عبر الإنترنت",
    "new_room": "مساحة جديدة",
    "no_frequencies_active": "لا توجد ترددات نشطة. قم بإنشاء غرفة جديدة لبدء التواصل.",
    "no_id": "لا معرف",
    "open_chats": "فتح الدردشات",
    "open_inbox": "افتح البريد الوارد",
    "primary_identity": "الهوية الأساسية",
    "recent_chats": "محادثات جديدة",
    "recent_messages": "آخر الأخبار",
    "session_encrypted": "الجلسة مشفرة: {name}",
    "session_secure": "الحالة: آمن",
    "system_verlassen": "نظام الخروج",
    "write_message": "اكتب رسالة",
  },
  zh: {
    sc_title: "安全中心",
    sc_subtitle: "GaiaShield集成安全层",
    sc_tab_status: "🛡️ 保护状态",
    sc_tab_events: "📋 安全日志",
    sc_tab_node: "⚙️ 节点安全",
    sc_loading: "正在加载安全数据...",
    sc_status_secured: "系统状态：账户已受保护",
    sc_status_warning: "系统状态：警告激活",
    sc_desc_secured: "没有活动的严重安全警告。GaiaShield正在积极监控您的账户。",
    sc_desc_warning: "注意：有活动的安全事件需要您的关注。",
    sc_account_protection: "账户保护",
    sc_message_protection: "消息保护",
    sc_audits: "安全 Center 审计",
    sc_active: "活动",
    sc_failed_logins: "登录失败",
    sc_tamper_checks: "篡改检查",
    sc_blocked_replays: "阻止的重放",
    sc_last_check: "上次检查",
    sc_just_now: "刚刚",
    sc_open_warnings: "未处理警告",
    sc_btn_acknowledge: "确认",
    sc_filter_severity: "严重程度",
    sc_filter_category: "类别",
    sc_filter_hide_ack: "隐藏已确认",
    sc_btn_export: "导出",
    sc_col_details: "详情",
    sc_col_time: "时间",
    sc_col_status: "状态",
    sc_col_action: "操作",
    sc_no_events: "未找到安全事件。",
    sc_node_title: "节点运营商安全控制台",
    sc_system_health: "系统健康",
    sc_last_audit: "上次审计",
    sc_packed_logs: "打包日志",
    sc_unconfirmed_events: "未确认事件",
    sc_operator_action: "需要运营商操作",
    sc_all_ok: "全部正常",
    sc_critical_events: "严重系统事件",
    ac_title: "治理与滥用举报中心",
    ac_subtitle: "GaiaCom 治理与滥用共识",
    ac_tab_my_reports: "我的举报",
    ac_tab_queue: "审核队列",
    ac_tab_operator: "节点运营商",
    ac_tab_transparency: "邦联与透明度",
    ac_loading: "正在加载数据...",
    ac_reported_cases: "举报的案例",
    ac_no_reports: "您尚未提交任何举报。",
    ac_case_details: "案例详情",
    ac_appeal_submit: "提交申诉",
    ac_appeal_status: "申诉状态",
    ac_appeal_reason: "申诉原因",
    ac_appeal_statement: "申诉陈述",
    ac_btn_appeal: "发送申诉",
    ac_trusted_reviewer_queue: "受信任审核员队列",
    ac_case_review: "审查案例",
    ac_review_category: "推荐类别",
    ac_review_severity: "推荐严重程度",
    ac_review_action: "推荐操作",
    ac_review_reason: "审核员意见",
    ac_btn_submit_review: "提交审核",
    ac_node_operator_dashboard: "节点运营商仪表板",
    ac_apply_action: "执行操作（重写）",
    ac_target_type: "目标类型",
    ac_target_id: "目标ID（GaiaID或频道ID）",
    ac_suspend: "暂停活动",
    ac_reason: "官方原因",
    ac_btn_apply: "强制执行操作",
    ac_transparency_title: "共识与透明日志",
    ac_transparency_desc: "所有受监管频道和身份的公开可查看快照证明。",
    ac_btn_snapshot: "创建透明度快照",
    search_placeholder: "按主题、发件人、正文搜索邮件...",
    abuse_center_title: "滥用申诉中心",
    abbrechen: "取消",
    active_identities: "主动身份",
    active_identity: "主动身份",
    add_btn: "添加",
    add_contact_title: "添加联系人",
    admin: "行政",
    adressbuch: "目录",
    aktiviert: "启用",
    an: "到",
    anonymous_sender: "匿名发件人",
    antworten: "回答",
    attachment_gaia_hint: "GaiaCOM 附件保持端到端加密。",
    attachment_smtp_hint: "旧版 SMTP 会阻止可执行/类似脚本的附件，并将电子邮件保存为不安全的。",
    attachments: "附件",
    auffaellig: "显",
    auth_beta_notice: "Beta 测试阶段：GaiaCOM 正在积极测试。可能会出现错误；确保重要种子的安全并仔细审查机密工作流程。",
    auth_btn_login: "加载身份并登录",
    auth_btn_register: "注册并创建加密货币",
    auth_copied: "已复制",
    auth_copy_seed: "复制种子",
    auth_generate_seed: "生成种子",
    auth_headline: "GaiaCOM 是第一个为人类构建的量子安全电子邮件协议和通信系统。",
    auth_kicker: "后量子安全通信",
    auth_mnemonic: "助记词",
    auth_mnemonic_placeholder: "12个单词，中间用空格隔开...",
    auth_password: "密码",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "私钥不会离开您的设备。只有预期的接收者才能解密内容。",
    auth_proof_gaiadata_desc: "零知识：您仍然可以控制自己的数据。元数据被最小化并且不用作纯文本配置文件。",
    auth_proof_gaiadrop_desc: "外部人员无需帐户即可向您的 GaiaID 发送机密短信。",
    auth_proof_gaiaproof_desc: "传送和完整性证据表明密文、发送者和时间戳未被篡改。",
    auth_proof_gaiavault_desc: "私人笔记、恢复笔记和安全记录保持本地加密。",
    auth_proof_hybrid_desc: "Quantum Shield：使用 ML-KEM 和 X25519 的混合加密可防御当今的攻击和“先存储后解密”的风险。",
    auth_secure_mail: "安全的量子联合邮件",
    auth_subline: "GaiaCOM 是一个用于电子邮件、聊天、危机室、GaiaDrop 和本地安全文件的量子安全通信系统。私钥保留在您的设备上，内容经过端到端加密，并且无需纯文本即可导出证据。",
    auth_success_btn: "立即登录",
    auth_success_text: "您的 GaiaCOM 帐户已创建。密钥是从您的种子本地派生的，并未存储在服务器上。",
    auth_success_title: "注册成功",
    auth_tab_drop: "盖亚水滴",
    auth_tab_login: "登录/帐户",
    auth_toggle_login: "帐户已存在",
    auth_toggle_register: "创建新帐户",
    auth_usecase_text: "适用于律师、公司、当局、记者、举报人和私人保安案件。",
    auth_usecase_title: "专为敏感通信而打造",
    auth_username: "用户名",
    auth_username_placeholder: "输入姓名...",
    auth_value_chat: "端到端聊天",
    auth_value_drop: "安全投递",
    auth_value_mail: "安全邮件",
    auth_value_rooms: "盖亚客房",
    bestaetigen: "确认",
    bestaetigt: "确认的",
    bio_status: "传记/现状",
    biography: "传",
    change_password_desc: "更改您的服务器端登录密码。您的本地恢复短语仍然受到保管库/解锁密码的单独保护。",
    change_password_menu_desc: "更新 GaiaCOM 登录密码。",
    change_password_title: "更改密码",
    channel_id: "通道号",
    channel_name_label: "频道名称",
    chat_deleted_hidden: "聊天记录已删除并隐藏。",
    chat_input_placeholder: "输入安全消息...",
    chat_start_hint: "开始对话！所有聊天消息均经过量子安全端到端加密。",
    choose_avatar: "选择头像",
    ciphertext_hash: "密文哈希",
    clear_chat: "空聊",
    clear_for_everyone: "给大家空着",
    clear_for_me: "只为我而空",
    click_to_write_mail: "点击写一封电子邮件",
    click_top_right: "点击右上角",
    close: "关闭",
    code_kopieren: "复制代码",
    code_kopieren_success: "复制代码",
    confirm_clear_channel_desc: "您想从本地视图中清除该频道吗？",
    confirm_clear_channel_title: "空通道",
    confirm_clear_chat: "您想清空此聊天记录吗？",
    confirm_clear_chat_desc: "您想清空此聊天记录吗？",
    confirm_clear_chat_title: "空聊",
    confirm_clear_everyone: "您想清空双方的聊天吗？ （确定=适用于所有人，取消=仅适用于我）",
    confirm_delete_everyone: "您想删除双方的消息吗？ （确定=适用于所有人，取消=仅适用于我）",
    confirm_delete_msg: "您想删除此消息吗？",
    confirm_delete_msg_desc: "您想删除这条聊天消息吗？",
    confirm_delete_msg_title: "删除留言",
    confirm_new_password: "确认新密码",
    copy: "复制",
    create_btn: "创造",
    create_channel_title: "创建频道",
    create_group_is_crisis: "标记为危机区域",
    create_group_title: "创建新组",
    crypto_lock_desc: "控制 GaiaCOM 何时从内存中删除本地加密密钥。",
    crypto_lock_menu_desc: "控制重新加载和不活动计时器。",
    crypto_lock_title: "密码锁",
    crypto_session_duration: "重新加载后解锁",
    crypto_session_duration_desc: "仅在选定的持续时间内在此浏览器选项卡中保持加密会话打开。",
    cryptographic_fingerprint: "密码指纹",
    current_password: "当前密码",
    data_minimization: "数据最小化",
    decrypt_failed: "无法破译",
    delete: "删除",
    delete_account_button: "不可撤销地删除帐户",
    delete_account_confirm_label: "输入 DELETE 确认",
    delete_account_confirmation_error: "需要密码和删除确认。",
    delete_account_desc: "此模式会永久销毁您的帐户、身份、设备会话、GaiaDrop 数据、上传元数据和服务器端归因消息。",
    delete_account_done_desc: "所有可分配的 GaiaCOM 数据均已删除。",
    delete_account_done_title: "帐户已删除",
    delete_account_menu_desc: "销毁帐户和相关数据。",
    delete_account_not_authenticated: "没有活跃帐户。",
    delete_account_title: "删除帐户",
    delete_for_everyone: "为大家删除",
    delete_for_me: "只为我删除",
    device_current: "这个装置",
    device_last_seen: "最后的",
    device_logout: "退出",
    device_sessions_desc: "检查活动会话并取消注册您不再信任的设备。",
    device_sessions_empty: "未找到设备。",
    device_sessions_menu_desc: "管理和结束活动会话。",
    device_sessions_title: "注册设备",
    device_since: "自从",
    display_name: "显示名称",
    drop_address_copied: "GaiaDrop 地址已复制。",
    drop_btn_decrypting: "收件箱正在解密...",
    drop_btn_load: "加载 GaiaDrop 收件箱",
    drop_delete_desc: "您真的要永久删除此掉落吗？",
    drop_delete_title: "删除 GaiaDrop",
    drop_desc: "用于外部通知、负责任的披露和机密报告的纯文本零知识下降通道。外部各方无需使用您的 GaiaID 帐户即可发送消息。",
    drop_empty: "尚未加载 GaiaDrop 消息。",
    drop_id: "掉落ID：",
    drop_own_address: "您的 GaiaDrop 地址",
    drop_proof: "防摔",
    drop_title: "GaiaDrop 安全收件箱",
    dunkler_modus: "深色模式",
    e2e_chat_room_open: "开通端到端聊天室",
    edit_profile: "编辑个人资料",
    edit_profile_desc: "自定义显示名称、简介和头像。",
    einladungscode: "邀请码",
    enter_fingerprint_chars_confirm: "输入要求的指纹字符进行确认。",
    envelope_hash: "信封哈希",
    erasability: "可擦除性",
    erfolg: "成功",
    exclude_plaintext: "导出无纯文本",
    export_disclosure: "出口安全案例",
    export_package_desc: "仅当有意公开时才包含纯文本。",
    export_package_title: "出口安全包",
    fehler: "错误",
    gaiacom_reader: "盖亚COM阅读器",
    gaiadrop_inbox_title: "GaiaDrop 收件箱",
    gaiavault: "盖亚金库",
    gdpr_home_desc: "GaiaCOM 最大限度地减少元数据、将私钥保留在本地、端到端加密内容并实现完整帐户删除。",
    gdpr_home_title: "100% 符合 GDPR",
    gdpr_reason_delete: "帐户删除会删除帐户、身份、本地会话和服务器端可分配数据。",
    gdpr_reason_e2ee: "私有内容仅对目标接收者是可解密的。",
    gdpr_reason_minimal: "元数据仅用于路由、传递和安全凭证。",
    gdpr_reason_zero_knowledge: "私钥和恢复数据仍由用户控制在本地。",
    gesendet: "发送",
    gesperrt_verdaechtig: "禁止/可疑",
    group_delete_desc: "您真的要永久删除该群组吗？该组中的所有频道和消息都将被删除。",
    group_delete_title: "删除群组",
    group_description: "描述",
    group_icon_label: "组图标/头像",
    group_name: "团体名称",
    group_settings_avatar: "阿凡达",
    group_settings_desc: "描述",
    group_settings_is_crisis: "标记为危机区域",
    group_settings_name: "团体名称",
    group_settings_title: "群组设置",
    groups_empty_desc: "为项目、危机或团队沟通创建一个安全的工作空间。",
    groups_empty_title: "还没有群聊",
    gruppe_beitreten: "已加入群组",
    gruppe_erstellen: "+ 创建群组",
    gruppe_verlassen: "离开群组",
    gruppen_chats: "群聊",
    heller_modus: "明亮模式",
    how_to_receive_drops: "我如何接收掉落物？",
    identitaets_assistent: "身份助理",
    inactivity_lock_duration: "不活动时锁定",
    inactivity_lock_duration_desc: "在这段时间没有输入之后，GaiaCOM 将自动被加密锁定。",
    inactivity_lock_notice: "GaiaCOM 由于不活动而被加密封锁。",
    include_plaintext: "包含纯文本",
    invite_code_label: "邀请码",
    join_group_title: "加入群组",
    kanaele: "渠道",
    kanal_erstellen: "+ 频道",
    kein_chat_ausgewaehlt: "未选择聊天",
    kein_kanal_ausgewaehlt: "未选择频道",
    keine_gruppe_ausgewaehlt: "未选择任何组",
    keine_mails: "没有可用的电子邮件。",
    key_change_warn_desc: "此联系人的公钥已更改。在信任指纹之前先检查指纹。",
    key_change_warn_title: "密码警告",
    key_change_warning_changed: "已经改变了。这可能是中间人攻击的迹象！",
    key_change_warning_msg: "联系人的身份密钥",
    key_transparency: "关键透明度",
    kopiert: "已复制",
    kryptographische_schluessel: "加密密钥",
    kryptographische_schluessel_desc: "显示私钥和备份种子短语。",
    laden: "加载...",
    leeren: "空的",
    loading: "加载...",
    local_key_vault: "本地密钥库",
    local_keys_label: "本地键",
    lock_on_reload: "重新加载后始终锁定",
    logout: "退出",
    mail_compose: "写电子邮件",
    mein_profil: "我的个人资料",
    melden: "报告",
    menu: "菜单",
    message: "消息",
    message_id: "消息ID",
    message_pin: "别针",
    message_pinned_title: "固定消息",
    message_react: "反应",
    message_reply: "回答",
    message_replying_to: "回答",
    message_save: "节省",
    message_saved: "已保存",
    message_to_channel: "留言至",
    message_unpin: "解决",
    message_unsave: "不保存",
    mitglied: "成员",
    mitglieder: "会员",
    ml_kem: "ML-KEM",
    neue_mail: "新电子邮件",
    never_auto_lock: "永远不会自动",
    new_fingerprint: "新指纹",
    new_identity: "新身份",
    new_password: "新密码",
    no_description: "无描述",
    no_key_history: "没有记录关键历史记录。",
    no_specification: "未指定",
    old_fingerprint: "旧指纹",
    open_privacy_imprint: "开放印记和数据保护",
    post_quantum_e2e: "后量子E2E",
    posteingang: "收件箱",
    powered_by: "供电",
    privacy_imprint_menu_desc: "显示 GDPR、数据保护和法律声明。",
    privacy_imprint_profile_desc: "GaiaCOM按照数据最小化、端到端加密和本地密钥控制的原则处理通信内容。",
    privacy_imprint_title: "数据保护和法律声明",
    profil: "轮廓",
    profile_details: "个人资料详情",
    profile_settings_hint: "配置文件设置显示在右侧面板中。",
    profile_unlock_desc: "出于安全原因，您必须重新输入密码才能查看您的私有密钥。",
    proof_hash: "证明哈希：",
    public_drop_desc: "无需 GaiaCOM 帐户即可安全投递外部文本信息。",
    public_drop_message: "消息",
    public_drop_message_placeholder: "输入机密文本...",
    public_drop_send: "发送 GaiaDrop",
    public_drop_sender: "发件人备注可选",
    public_drop_sender_placeholder: "姓名、档案号或匿名",
    public_drop_target: "目标GaiaID",
    quanten_chat: "量子聊天",
    quantum_secure_exchange: "量子安全交换通过...",
    quantum_secure_net: "GaiaCOM 量子安全网络（Ed25519 和 ML-KEM）",
    quantum_shield_desc: "GaiaCOM 网络通过多层混合加密协议保护您的隐私，防止未来量子计算机的攻击。",
    quantum_shield_l1_desc: "使用FIPS 203标准封装对称共享密钥。防止量子计算机进行被动记录和稍后解密（“立即存储，稍后解密”）。",
    quantum_shield_l1_title: "1. 后量子保护（ML-KEM-1024）",
    quantum_shield_l2_desc: "经典、极快的 Diffie-Hellman 密钥交换过程，可作为混合过程中的附加安全层。",
    quantum_shield_l2_title: "2.椭圆曲线密码学（X25519）",
    quantum_shield_l3_desc: "每条消息和每个联邦信封都经过加密签名，以明确验证发件人的真实性。",
    quantum_shield_l3_title: "3. 数字签名 (Ed25519)",
    quantum_shield_l4_desc: "对称加密消息内容，并将发送者、接收者和元数据紧密绑定到经过身份验证的附加数据 (AAD)，以防止重放攻击。",
    quantum_shield_l4_title: "4.AAD认证（AES-256-GCM）",
    quantum_shield_status: "量子护盾状态",
    receive_drops_step1: "与外部来源共享您的 GaiaID（例如使用上面的复制按钮）。",
    receive_drops_step2: "这些会调用 GaiaCOM 实例的登录页面并切换到选项卡",
    receive_drops_step3: "并将他们的加密消息发送到您的地址。",
    receiver_gaia: "GaiaCOM接收器",
    receiver_smtp: "SMTP 收件人",
    records_stored: "已保存记录",
    refresh: "更新",
    report_abuse_desc: "您想报告此消息并向服务器提交滥用的加密证据吗？",
    report_abuse_title: "举报滥用行为",
    reputation_status: "声誉状况",
    room_chat_start_hint: "开始对话！该群组通道中的所有消息均经过去中心化量子安全端到端加密。",
    room_policy_audit: "审计跟踪和密钥轮换处于活动状态。",
    room_policy_crisis: "危机室",
    room_policy_e2ee: "零知识空间。 E2EE量子安全。",
    room_policy_title: "房间指南",
    room_policy_zero_knowledge: "政策",
    room_security_note_desc: "所有关键更改均通过关键透明度进行验证。使用 GaiaVault 进行私人备份日志。",
    room_security_note_title: "固定的安全说明",
    save_profile: "保存个人资料",
    schluessel_entsperrt: "🔑 再次锁定钥匙",
    search_gaia_label: "查找盖亚地址",
    security_warning_title: "安全警告",
    select_channel_chat: "从左侧边栏中选择一个频道进行聊天。",
    select_contact_chat: "从左侧面板中选择联系人以开始量子安全的端到端聊天。",
    select_mail_read: "从列表中选择一封电子邮件以阅读其量子安全内容或创建新消息。",
    senden: "发送",
    sender_signature: "发件人签名",
    server_log: "服务器日志：",
    server_received: "服务器已收到",
    session_lock: "会话锁定",
    setup_address_keys: "创建地址和密钥集",
    setup_profile: "在个人资料中设置",
    smtp_inbox_title: "SMTP接收",
    smtp_legacy_badge: "旧版 SMTP/不安全",
    smtp_mode_option: "旧版 SMTP 桥",
    smtp_security_warning: "这封电子邮件是通过经典的、未加密的 SMTP 协议传输的。没有启用端到端加密。",
    smtp_security_warning_desc: "此消息正在离开 GaiaCom 安全室。 SMTP 传送不提供 GaiaCom 本地端到端保证，没有 TrustMesh 保证，也没有来自网关的 Godmode 保证。",
    spam_verdacht: "垃圾邮件/可疑邮件",
    spam_warning_desc: "此消息具有可疑的信誉信号。",
    spam_warning_title: "垃圾邮件警告",
    speichern: "节省",
    sperren: "锁定",
    standard_group_status: "标准群聊（E2EE加密）",
    status: "地位",
    subject: "关于",
    suchen: "寻找新的盖亚地址...",
    tage: "天",
    time_unknown: "时间未知",
    transmission_mode: "传输方式",
    trust_age: "信托年龄",
    trust_passport_title: "信托护照",
    unbestaetigt: "未证实",
    unknown_sender: "未知",
    unlock_btn: "开锁",
    unlock_btn_profile: "开锁",
    unlock_desc: "您的私钥文件是加密存储的。输入您的密码以仅将加密密钥加载到内存中。",
    unlock_logout: "注销并关闭本地密钥",
    unlock_title: "解锁身份",
    untrusted: "不值得信赖",
    update_password: "更新密码",
    upload_avatar_btn: "上传图片（已消毒）",
    vault_btn_encrypt: "加密记录",
    vault_btn_lock: "锁保险箱",
    vault_btn_unlock: "解锁保险箱",
    vault_copied_success: "已复制到剪贴板",
    vault_decrypted_content: "解密内容",
    vault_desc: "用于恢复备份、身份说明、服务器访问、紧急联系人、法律说明、安全事件和私人日志的本地加密保管库。",
    vault_empty: "尚未保存安全记录。",
    vault_locked_pane_notice: "保险箱已锁。请在右侧解锁。",
    vault_new_record: "新的安全记录",
    vault_pwd_placeholder: "输入保管库密码...",
    vault_record_body: "记录内容",
    vault_record_body_placeholder: "输入加密的记录内容...",
    vault_record_category: "类别",
    vault_record_title: "记录标题",
    vault_record_title_placeholder: "安全记录的标题",
    vault_title: "GaiaVault 安全记录",
    verify_new_fingerprint_hint: "在接受密钥之前检查新指纹。",
    vertrauenswuerdig: "值得信赖",
    vision_gaia_technology: "愿景盖亚科技",
    von: "从",
    warnung: "警告",
    wizard_address: "地址",
    wizard_back: "后退",
    wizard_check1: "我已经安全地保存了我的种子。",
    wizard_custom_domain: "使用您自己的域名",
    wizard_desc1: "GaiaCOM 不在服务器端存储私钥。如果没有助记词种子，任何人都无法恢复丢失的消息。",
    wizard_desc2: "您的地址决定了加密信封通过的联合节点的路由。",
    wizard_fallback: "后备节点",
    wizard_finish: "完成设置",
    wizard_next: "更远",
    wizard_server_domain: "服务器节点域",
    wizard_step1: "1. 备份种子",
    wizard_step2: "2. 地址及服务器",
    wizard_title1: "备份恢复密钥",
    wizard_title2: "选择GaiaCOM地址",
    write_message_placeholder: "写一条安全消息...",
    you: "你",
    zero_knowledge: "零知识",
    zero_knowledge_encryption: "零知识加密",
    "Chat fuer alle geleert": "Der Chat wurde für alle Teilnehmer geleert.",
    "Chat geleert": "Der Chat wurde für deine lokale Inbox geleert.",
    "Nachricht fuer alle geloescht": "Die Nachricht wurde für alle Teilnehmer gelöscht.",
    "Nachricht geloescht": "Die Chat-Nachricht wurde lokal aus deiner Inbox entfernt.",
    "anpinnen": "Anpinnen",
    "chat_loeschen": "Chat löschen",
    "confirm_delete_chat_desc": "Möchtest du den Chat wirklich löschen und ausblenden?",
    "confirm_leave_group_desc": "Möchtest du diese Gruppe wirklich verlassen?",
    "entpinnen": "Entpinnen",
    "group_deleted": "Gruppe erfolgreich gelöscht.",
    "group_left": "Gruppe erfolgreich verlassen.",
    "gruppe_loeschen": "Gruppe löschen",
    "loeschen": "Löschen",
    "no_active_chats": "Keine aktiven Chats. Suche oben nach Kontakten, um einen Chat zu starten.",
    "pinned": "Angepinnt",
    "wizard_check_credentials": "我有责任保证我的访问数据的安全。",
    "wizard_check_is_beta": "据我所知，GaiaCom 是测试版软件。",
    "wizard_check_no_illegal": "我不会将 GaiaCom 用于非法目的。",
    "wizard_check_no_uptime": "我了解无法保证可用性。",
    "wizard_check_smtp_security": "我了解 SMTP 消息不提供完整的 GaiaCom 安全性。",
    "wizard_check_terms_read": "我已阅读 Beta 服务条款。",
    "wizard_step_terms": "使用条款",
    "wizard_terms_text": "GaiaCom 使用条款和 Beta 测试协议（Beta 阶段）\n\n提供商：VisionGaiaTechnology（以下简称“提供商”）\n状态：公开 Beta 测试阶段\n有效期：2026年6月21日起\n\n⚠️ 最重要的提前说明（请仔细阅读）\nGaiaCom 正处于公开 Beta 测试阶段。尽管采取了广泛的安全措施，但仍无法保证软件和底层基础设施的无错误、持续可用性或绝对安全。使用风险自负。用户有责任安全存储其访问数据（尤其是 GaiaVault 的密钥）并遵守适用的法律。\n\n1. Beta测试阶段的主题和目的\n1.1.提供目的：GaiaCom 是一种基于后量子密码学 (PQC) 的新型电子邮件和聊天服务。测试阶段的规定专门用于技术测试、负载模拟、查找程序错误（bug）和优化用户友好性。\n1.2.测试版状态：用户知道所提供的软件是初步版本（测试版软件）。这在技术上尚未完全开发，不符合最终商业产品的标准，并且可能导致错误、数据丢失、传输延迟或系统崩溃。\n1.3.无继续权利：提供商有权随时全部或部分中断服务、更改或限制功能或暂时或永久删除服务，而无需说明理由。\n\n2. 可用性和免责声明\n2.1.无可用性保证：GaiaCom 不提供任何可用性或正常运行时间保证。没有权利不间断地提供服务。\n2.2.保修排除：软件按当前状态（“原样”）提供，并视供应情况而定。在法律允许的范围内，不对软件中的材料和法律缺陷提出任何保修索赔。特别是，无法保证该软件没有错误、没有恶意软件或适合特定用途。\n\n3. 风险管理和用户义务\n3.1.禁止存储关键数据：用户承诺不专门通过 GaiaCom 存储或传输任何业务关键、重要、操作必需或法律上特别敏感的数据（例如患者档案、高度敏感的财务数据或官方监管的秘密）。该服务不得用于不可预见的故障可能导致人身伤害、财产损失或重大财务损失的基础设施。\n3.2.自行负责的备份：用户负责在自己的独立系统上备份他长期需要的通过 GaiaCom 接收或发送的所有数据（备份副本）。提供商不保证其服务器上数据的永久存储或可恢复性。\n\n4. 加密功能和GaiaVault\n4.1.后量子密码学 (PQC)：GaiaCom 实施最先进的、面向未来的加密流程，旨在抵御未来量子计算机的攻击。然而，用户意识到这是一个充满活力的新科学领域。以目前的科学技术水平无法保证绝对的、无可辩驳的安全。明确不保证“100% 安全”、“不可破解”或“军事安全”等术语。\n4.2.无恢复保证（GaiaVault）：GaiaCom 依赖一致的零知识安全概念。加密楔子和访问数据仅由用户控制（通过 GaiaVault 保护）。\n重要提示：如果用户丢失密码、密码、私钥或恢复种子，提供商没有技术能力重建或重置此数据。这些访问数据的丢失将不可避免地导致用户帐户及其中所有加密数据的访问权限不可挽回地丢失。\n4.3.尚未全面审核：该软件持续接受内部安全检查，但在测试阶段尚未接受独立测试机构最终、全面的外部安全审核。\n\n5. 接口、遗留协议和联合\n5.1. SMTP 桥 注意：GaiaCom 提供通过经典电子邮件协议（例如 SMTP）进行通信的能力。用户知道离开本地 GaiaCom 安全区域的消息（例如，当发送到传统的 @gmail.com 或 @gmx.de 地址时）是通过未加密的或第三方服务器传输的。 GaiaCom 的端到端安全保证仅在有限范围内适用或根本不适用于此类传出或外部传入的旧消息。\n5.2.联盟注意：如果 GaiaCom 在联盟网络上运行，消息和数据可能会通过第三方服务器传递。虽然消息内容仍然受到端到端加密的保护，但元数据（例如发送时间、所涉及服务器的 IP 地址和收件人地址）在技术上可能对这些联合服务器的运营商可见。提供商对联合网络中第三方服务器运营商的数据保护实践没有影响。\n\n6. 可接受的用途和禁止的活动\n用户承诺不以不当或非法目的使用本服务。特别禁止以下行为：\n- 分发、发送或托管病毒、恶意软件、网络钓鱼内容或其他恶意软件。\n- 使用本服务进行拒绝服务攻击 (DDoS) 或未经请求的批量邮件（垃圾邮件）。\n- 滥用系统进行欺诈。\n- 传播或交换非法内容，特别是对儿童性虐待 (CSAM) 的描述、恐怖主义宣传、呼吁暴力或其他与犯罪相关的内容。\n\n7. 滥用举报系统\n7.1.举报滥用行为：用户有机会通过综合滥用系统举报滥用通信或非法活动。\n7.2.报告处理：为了确保防止滥用，可以对传入的报告进行技术分析（同时保持隐私和加密限制）。如果经证实违反这些使用条款，这可能会导致用户帐户或 IP 地址暂时或永久暂停。\n\n8. 责任限制\n8.1.责任标准：测试版软件免费提供。因此，根据捐赠或贷款的法律规则，提供者仅对故意（故意损害）和重大过失承担责任。\n8.2.数据丢失责任的免除：除非丢失是由提供商故意或重大过失造成的，并且用户已履行通过定期备份（GaiaCom 之外）减轻损害的义务，否则不承担数据丢失的责任。\n8.3.法律限制：上述责任限制不适用于对生命、身体或健康的伤害或《产品责任法》规定的责任。\n\n9. 开源\n某些 GaiaCom 组件、库或客户端应用程序可能会根据开源许可证（例如 GPL、MIT、Apache）获得许可。这些组件各自的许可条款不受这些使用条款的影响，并且可以在相应的源代码存储库中查看。\n\n10. 出口管制和合规\n用户知道加密软件可能受到严格的出口管制和法律限制。用户有责任确保 GaiaCom 的使用不违反其各自居住国的法律、进出口限制或密码法规。\n\n11. 数据保护声明（测试版简短版本）\n11.1.最少的数据收集：作为测试阶段的一部分，提供商仅收集技术操作、故障排除和进一步开发绝对必要的数据（例如用于错误诊断的服务器日志文件）。\n11.2.无法洞察内容：由于一致的零知识和端到端加密，提供商永远无法访问您存储在 GaiaVault 中的聊天内容、电子邮件或密钥。\n11.3。详细的数据保护声明：详细的数据保护规定单独链接，用户在注册前也必须考虑。\n\n12. 最终条款\n12.1。适用法律：适用德意志联邦共和国法律，但不包括《联合国国际货物销售合同公约》。\n12.2.可能会发生变化：由于 GaiaCom 正在积极开发中，提供商保留随时调整这些条件并在未来生效的权利。当前版本可在应用程序中找到。",
    "wizard_terms_title": "GaiaCom 使用条款和 Beta 测试协议（Beta 阶段）",
    "node_operator": "节点运营商",
    "search_channels": "搜索频道...",
    "senior_reviewer": "高级审稿人",
    "trusted_reviewer": "值得信赖的审稿人",
    "active_frequencies": "活动频率",
    "connected_rooms": "互联空间",
    "dashboard": "仪表板",
    "empty_chats": "没有可用的活跃聊天。",
    "empty_messages": "没有新消息可用。",
    "encrypted": "加密的",
    "gaiacom_uplink": "盖亚康上行链路",
    "install_app": "安装应用程序",
    "install_app_desc": "用于快速启动和离线模式",
    "kommandozentrale_alpha": "阿尔法指挥中心",
    "network_online": "网络：在线",
    "new_room": "新空间",
    "no_frequencies_active": "没有活动频率。创建一个新房间开始沟通。",
    "no_id": "无身份证件",
    "open_chats": "打开聊天室",
    "open_inbox": "打开收件箱",
    "primary_identity": "主要身份",
    "recent_chats": "新聊天记录",
    "recent_messages": "最新消息",
    "session_encrypted": "会话已加密：{name}",
    "session_secure": "状态：安全",
    "system_verlassen": "退出系统",
    "write_message": "写留言",
  },
  hi: {
    sc_title: "सुरक्षा केंद्र",
    sc_subtitle: "GaiaShield एकीकृत सुरक्षा परत",
    sc_tab_status: "🛡️ सुरक्षा स्थिति",
    sc_tab_events: "📋 सुरक्षा लॉग",
    sc_tab_node: "⚙️ नोड सुरक्षा",
    sc_loading: "सुरक्षा डेटा लोड हो रहा है...",
    sc_status_secured: "सिस्टम स्थिति: खाता सुरक्षित है",
    sc_status_warning: "सिस्टम स्थिति: चेतावनियाँ सक्रिय हैं",
    sc_desc_secured: "कोई सक्रिय महत्वपूर्ण सुरक्षा चेतावनी नहीं है। GaiaShield सक्रिय रूप से आपके खाते की निगरानी कर रहा है।",
    sc_desc_warning: "ध्यान दें: सक्रिय सुरक्षा घटनाएँ हैं जिन पर आपका ध्यान आवश्यक है।",
    sc_account_protection: "खाता सुरक्षा",
    sc_message_protection: "संदेश सुरक्षा",
    sc_audits: "सुरक्षा ऑडिट",
    sc_active: "सक्रिय",
    sc_failed_logins: "विफल लॉगिन",
    sc_tamper_checks: "छेड़छाड़ की जाँच",
    sc_blocked_replays: "अवरुद्ध रीप्ले",
    sc_last_check: "अंतिम जाँच",
    sc_just_now: "अभी-अभी",
    sc_open_warnings: "खुली चेतावनियाँ",
    sc_btn_acknowledge: "स्वीकार करें",
    sc_filter_severity: "तीव्रता",
    sc_filter_category: "श्रेणी",
    sc_filter_hide_ack: "पुष्टि किए गए को छिपाएं",
    sc_btn_export: "निर्यात करें",
    sc_col_details: "विवरण",
    sc_col_time: "समय",
    sc_col_status: "स्थिति",
    sc_col_action: "कार्रवाई",
    sc_no_events: "कोई सुरक्षा घटना नहीं मिली।",
    sc_node_title: "नोड ऑपरेटर सुरक्षा कंसोल",
    sc_system_health: "सिस्टम स्वास्थ्य",
    sc_last_audit: "अंतिम ऑडिट",
    sc_packed_logs: "पैक किए गए लॉग",
    sc_unconfirmed_events: "अपुष्ट घटनाएं",
    sc_operator_action: "ऑपरेटर कार्रवाई की आवश्यकता है",
    sc_all_ok: "सब ठीक है",
    sc_critical_events: "महत्वपूर्ण सिस्टम घटनाएं",
    ac_title: "शासन और दुर्व्यवहार रिपोर्ट केंद्र",
    ac_subtitle: "GaiaCom शासन और दुर्व्यवहार आम सहमति",
    ac_tab_my_reports: "मेरी रिपोर्ट",
    ac_tab_queue: "समीक्षा कतार",
    ac_tab_operator: "नोड ऑपरेटर",
    ac_tab_transparency: "फेडरेशन और पारदर्शिता",
    ac_loading: "डेटा लोड हो रहा है...",
    ac_reported_cases: "रिपोर्ट किए गए मामले",
    ac_no_reports: "आपने अभी तक कोई रिपोर्ट जमा नहीं की है।",
    ac_case_details: "मामले का विवरण",
    ac_appeal_submit: "अपील जमा करें",
    ac_appeal_status: "अपील की स्थिति",
    ac_appeal_reason: "अपील का कारण",
    ac_appeal_statement: "बयान",
    ac_btn_appeal: "अपील भेजें",
    ac_trusted_reviewer_queue: "विश्वसनीय समीक्षक कतार",
    ac_case_review: "मामले की समीक्षा",
    ac_review_category: "अनुशंसित श्रेणी",
    ac_review_severity: "अनुशंसित तीव्रता",
    ac_review_action: "अनुशंसित कार्रवाई",
    ac_review_reason: "समीक्षक का कारण",
    ac_btn_submit_review: "समीक्षा सबमिट करें",
    ac_node_operator_dashboard: "नोड ऑपरेटर डैशबोर्ड",
    ac_apply_action: "कार्रवाई लागू करें (ओवरराइड)",
    ac_target_type: "लक्ष्य प्रकार",
    ac_target_id: "लक्ष्य आईडी (GaiaID या चैनल आईडी)",
    ac_suspend: "निलंबन सक्रिय",
    ac_reason: "आधिकारिक कारण",
    ac_btn_apply: "कार्रवाई लागू करें",
    ac_transparency_title: "आम सहमति और पारदर्शिता लॉगबुक",
    ac_transparency_desc: "सभी मॉडरेट किए गए चैनलों और पहचानों के सार्वजनिक रूप से देखने योग्य स्ナップशॉट प्रमाण।",
    ac_btn_snapshot: "पारदर्शिता स्नैपशॉट बनाएं",
    search_placeholder: "विषय, प्रेषक, पाठ द्वारा मेल खोजें...",
    abuse_center_title: "दुरुपयोग केंद्र",
    abbrechen: "रद्द करना",
    active_identities: "सक्रिय पहचान",
    active_identity: "सक्रिय पहचान",
    add_btn: "जोड़ना",
    add_contact_title: "संपर्क जोड़ें",
    admin: "व्यवस्थापक",
    adressbuch: "निर्देशिका",
    aktiviert: "सक्रिय",
    an: "को",
    anonymous_sender: "अज्ञात प्रेषक",
    antworten: "उत्तर",
    attachment_gaia_hint: "GaiaCOM अटैचमेंट एंड-टू-एंड एन्क्रिप्टेड रहते हैं।",
    attachment_smtp_hint: "लीगेसी एसएमटीपी निष्पादन योग्य/स्क्रिप्ट-जैसे अनुलग्नकों को ब्लॉक करता है और ईमेल को असुरक्षित के रूप में सहेजता है।",
    attachments: "संलग्नक",
    auffaellig: "ध्यान देने योग्य",
    auth_beta_notice: "बीटा परीक्षण चरण: GaiaCOM का सक्रिय रूप से परीक्षण किया जा रहा है। त्रुटियाँ हो सकती हैं; महत्वपूर्ण बीज सुरक्षित करें और गोपनीय कार्यप्रवाह की सावधानीपूर्वक समीक्षा करें।",
    auth_btn_login: "पहचान लोड करें और लॉग इन करें",
    auth_btn_register: "रजिस्टर करें और क्रिप्टो बनाएं",
    auth_copied: "कॉपी किया गया",
    auth_copy_seed: "प्रतिलिपि बीज",
    auth_generate_seed: "बीज उत्पन्न करें",
    auth_headline: "GaiaCOM मानवता के लिए निर्मित पहला क्वांटम-सुरक्षित ईमेल प्रोटोकॉल और संचार प्रणाली है।",
    auth_kicker: "पोस्ट-क्वांटम सुरक्षित संचार",
    auth_mnemonic: "स्मरणीय वाक्यांश",
    auth_mnemonic_placeholder: "रिक्त स्थान से अलग किए गए 12 शब्द...",
    auth_password: "पासवर्ड",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "निजी कुंजियाँ आपके डिवाइस को नहीं छोड़तीं। केवल इच्छित प्राप्तकर्ता ही सामग्री को डिक्रिप्ट कर सकते हैं।",
    auth_proof_gaiadata_desc: "शून्य-ज्ञान: आप अपने डेटा पर नियंत्रण में रहते हैं। मेटाडेटा को छोटा कर दिया गया है और सादे पाठ प्रोफ़ाइल के रूप में उपयोग नहीं किया गया है।",
    auth_proof_gaiadrop_desc: "बाहरी लोग बिना किसी खाते के आपके GaiaID पर गोपनीय पाठ संदेश भेज सकते हैं।",
    auth_proof_gaiaproof_desc: "वितरण और अखंडता साक्ष्य से पता चलता है कि सिफरटेक्स्ट, प्रेषक और टाइमस्टैम्प के साथ छेड़छाड़ नहीं की गई है।",
    auth_proof_gaiavault_desc: "निजी नोट, पुनर्प्राप्ति नोट और सुरक्षा रिकॉर्ड स्थानीय रूप से एन्क्रिप्टेड रहते हैं।",
    auth_proof_hybrid_desc: "क्वांटम शील्ड: ML-KEM और X25519 के साथ हाइब्रिड एन्क्रिप्शन आज के हमलों और स्टोर-अभी-डिक्रिप्ट-बाद के जोखिमों से बचाता है।",
    auth_secure_mail: "सुरक्षित क्वांटम फ़ेडरेटेड मेल",
    auth_subline: "GaiaCOM ईमेल, चैट, संकट कक्ष, GaiaDrop और स्थानीय सुरक्षा फ़ाइलों के लिए एक क्वांटम सुरक्षित संचार प्रणाली है। निजी कुंजियाँ आपके डिवाइस पर रहती हैं, सामग्री एंड-टू-एंड एन्क्रिप्टेड होती है, और साक्ष्य को सादे पाठ के बिना निर्यात किया जा सकता है।",
    auth_success_btn: "अभी लॉगिन करें",
    auth_success_text: "आपका GaiaCOM खाता बन गया है. कुंजियाँ आपके बीज से स्थानीय रूप से प्राप्त की गई थीं और सर्वर पर संग्रहीत नहीं थीं।",
    auth_success_title: "सफल पंजीकरण",
    auth_tab_drop: "गैयाड्रॉप",
    auth_tab_login: "लॉगिन खाता",
    auth_toggle_login: "खाता पहले से मौजूद है",
    auth_toggle_register: "नया खाता बनाएँ",
    auth_usecase_text: "वकीलों, कंपनियों, अधिकारियों, पत्रकारों, मुखबिरों और निजी सुरक्षा मामलों के लिए उपयुक्त।",
    auth_usecase_title: "संवेदनशील संचार के लिए निर्मित",
    auth_username: "उपयोगकर्ता नाम",
    auth_username_placeholder: "नाम दर्ज करें...",
    auth_value_chat: "E2E चैट",
    auth_value_drop: "सुरक्षित ड्रॉप",
    auth_value_mail: "सुरक्षित मेल",
    auth_value_rooms: "गैयारूम्स",
    bestaetigen: "पुष्टि करना",
    bestaetigt: "की पुष्टि",
    bio_status: "जीवनी/स्थिति",
    biography: "जीवनी",
    change_password_desc: "आपका सर्वर-साइड लॉगिन पासवर्ड बदलता है। आपका स्थानीय पुनर्प्राप्ति वाक्यांश आपके वॉल्ट/अनलॉक पासवर्ड द्वारा अलग से सुरक्षित रहता है।",
    change_password_menu_desc: "GaiaCOM लॉगिन पासवर्ड अपडेट करें।",
    change_password_title: "पासवर्ड बदलें",
    channel_id: "चैनल आईडी",
    channel_name_label: "चैनल का नाम",
    chat_deleted_hidden: "चैट हटा दी गई और छिपा दी गई.",
    chat_input_placeholder: "सुरक्षित संदेश दर्ज करें...",
    chat_start_hint: "बातचीत शुरू करें! सभी चैट संदेश क्वांटम सुरक्षित E2E एन्क्रिप्टेड हैं।",
    choose_avatar: "अवतार चुनें",
    ciphertext_hash: "सिफरटेक्स्ट हैश",
    clear_chat: "खाली चैट",
    clear_for_everyone: "सबके लिए खाली",
    clear_for_me: "सिर्फ मेरे लिए खाली",
    click_to_write_mail: "ईमेल लिखने के लिए क्लिक करें",
    click_top_right: "ऊपर दाईं ओर क्लिक करें",
    close: "बंद करना",
    code_kopieren: "कोड कॉपी करें",
    code_kopieren_success: "कोड कॉपी किया गया",
    confirm_clear_channel_desc: "क्या आप इस चैनल को अपने स्थानीय दृश्य से साफ़ करना चाहते हैं?",
    confirm_clear_channel_title: "खाली चैनल",
    confirm_clear_chat: "क्या आप इस चैट को खाली करना चाहते हैं?",
    confirm_clear_chat_desc: "क्या आप इस चैट को खाली करना चाहते हैं?",
    confirm_clear_chat_title: "खाली चैट",
    confirm_clear_everyone: "क्या आप दोनों भागीदारों के लिए चैट खाली करना चाहते हैं? (ठीक है = सभी के लिए, रद्द करें = सिर्फ मेरे लिए)",
    confirm_delete_everyone: "क्या आप दोनों भागीदारों के लिए संदेश हटाना चाहते हैं? (ठीक है = सभी के लिए, रद्द करें = सिर्फ मेरे लिए)",
    confirm_delete_msg: "क्या आप यह संदेश हटाना चाहते हैं?",
    confirm_delete_msg_desc: "क्या आप इस चैट संदेश को हटाना चाहते हैं?",
    confirm_delete_msg_title: "संदेश को हटाएं",
    confirm_new_password: "नए पासवर्ड की पुष्टि करें",
    copy: "प्रतिलिपि",
    create_btn: "बनाएं",
    create_channel_title: "चैनल बनाएं",
    create_group_is_crisis: "संकटग्रस्त क्षेत्र के रूप में चिह्नित करें",
    create_group_title: "नया समूह बनाएं",
    crypto_lock_desc: "यह नियंत्रित करता है कि GaiaCOM मेमोरी से स्थानीय क्रिप्टो कुंजियाँ कब हटाता है।",
    crypto_lock_menu_desc: "पुनः लोड और निष्क्रियता टाइमर को नियंत्रित करें।",
    crypto_lock_title: "क्रिप्टोग्राफ़िक लॉक",
    crypto_session_duration: "पुनः लोड करने के बाद अनलॉक किया गया",
    crypto_session_duration_desc: "इस ब्राउज़र टैब में क्रिप्टो सत्र को केवल चयनित अवधि के लिए खुला रखता है।",
    cryptographic_fingerprint: "क्रिप्टोग्राफ़िक फ़िंगरप्रिंट",
    current_password: "वर्तमान पासवर्ड",
    data_minimization: "डेटा न्यूनीकरण",
    decrypt_failed: "समझने योग्य नहीं",
    delete: "मिटाना",
    delete_account_button: "खाते को अपरिवर्तनीय रूप से हटाएँ",
    delete_account_confirm_label: "पुष्टि करने के लिए DELETE दर्ज करें",
    delete_account_confirmation_error: "पासवर्ड और DELETE पुष्टिकरण आवश्यक है।",
    delete_account_desc: "यह मोड आपके खाते, पहचान, डिवाइस सत्र, गैयाड्रॉप डेटा, अपलोड मेटाडेटा और सर्वर-साइड जिम्मेदार संदेशों को स्थायी रूप से नष्ट कर देता है।",
    delete_account_done_desc: "सभी असाइन करने योग्य GaiaCOM डेटा हटा दिया गया है।",
    delete_account_done_title: "खाता हटा दिया गया",
    delete_account_menu_desc: "खाता और संबंधित डेटा नष्ट करें.",
    delete_account_not_authenticated: "कोई सक्रिय खाता नहीं.",
    delete_account_title: "खाता हटा दो",
    delete_for_everyone: "सभी के लिए हटाएँ",
    delete_for_me: "केवल मेरे लिए हटाएं",
    device_current: "यह डिवाइस",
    device_last_seen: "अंतिम",
    device_logout: "लॉग आउट",
    device_sessions_desc: "सक्रिय सत्रों की जाँच करें और उन डिवाइसों का पंजीकरण रद्द करें जिन पर अब आपको भरोसा नहीं है।",
    device_sessions_empty: "कोई यंत्र नहीं मिले।",
    device_sessions_menu_desc: "सक्रिय सत्र प्रबंधित करें और समाप्त करें.",
    device_sessions_title: "पंजीकृत उपकरण",
    device_since: "तब से",
    display_name: "प्रदर्शित होने वाला नाम",
    drop_address_copied: "गैयाड्रॉप पता कॉपी किया गया।",
    drop_btn_decrypting: "इनबॉक्स को डिक्रिप्ट किया जा रहा है...",
    drop_btn_load: "गैयाड्रॉप इनबॉक्स लोड करें",
    drop_delete_desc: "क्या आप सचमुच इस ड्रॉप को स्थायी रूप से हटाना चाहते हैं?",
    drop_delete_title: "गैयाड्रॉप हटाएं",
    drop_desc: "बाहरी नोटिस, जिम्मेदार प्रकटीकरण और गोपनीय रिपोर्ट के लिए केवल टेक्स्ट शून्य-ज्ञान ड्रॉप चैनल। बाहरी पार्टियाँ आपके GaiaID का उपयोग करके बिना किसी खाते के संदेश भेज सकती हैं।",
    drop_empty: "अभी तक कोई GaiaDrop संदेश लोड नहीं हुआ है.",
    drop_id: "ड्रॉप आईडी:",
    drop_own_address: "आपका गैयाड्रॉप पता",
    drop_proof: "ड्रॉप प्रूफ",
    drop_title: "गैयाड्रॉप सिक्योर इनबॉक्स",
    dunkler_modus: "डार्क मोड",
    e2e_chat_room_open: "E2E चैट रूम खोलें",
    edit_profile: "प्रोफ़ाइल संपादित करें",
    edit_profile_desc: "प्रदर्शन नाम, जीवनी और अवतार को अनुकूलित करें।",
    einladungscode: "आमंत्रण कोड",
    enter_fingerprint_chars_confirm: "पुष्टि करने के लिए अनुरोधित फ़िंगरप्रिंट वर्ण दर्ज करें।",
    envelope_hash: "लिफाफा हैश",
    erasability: "erasability",
    erfolg: "सफलता",
    exclude_plaintext: "सादे पाठ के बिना निर्यात करें",
    export_disclosure: "निर्यात सुरक्षा मामला",
    export_package_desc: "यदि यह प्रकटीकरण जानबूझकर किया गया है तो केवल सादा पाठ शामिल करें।",
    export_package_title: "सुरक्षा पैकेज निर्यात करें",
    fehler: "गलती",
    gaiacom_reader: "गैयाकॉम रीडर",
    gaiadrop_inbox_title: "गैयाड्रॉप इनबॉक्स",
    gaiavault: "गैयावॉल्ट",
    gdpr_home_desc: "GaiaCOM मेटाडेटा को न्यूनतम करता है, निजी कुंजी को स्थानीय रखता है, सामग्री को शुरू से अंत तक एन्क्रिप्ट करता है और पूर्ण खाता हटाने में सक्षम बनाता है।",
    gdpr_home_title: "100% जीडीपीआर अनुरूप",
    gdpr_reason_delete: "खाता हटाने से खाता, पहचान, स्थानीय सत्र और सर्वर-साइड असाइन करने योग्य डेटा हटा दिया जाता है।",
    gdpr_reason_e2ee: "निजी सामग्री केवल इच्छित प्राप्तकर्ताओं के लिए डिक्रिप्ट योग्य रहती है।",
    gdpr_reason_minimal: "मेटाडेटा का उपयोग केवल रूटिंग, डिलीवरी और सुरक्षा क्रेडेंशियल के लिए किया जाता है।",
    gdpr_reason_zero_knowledge: "निजी कुंजियाँ और पुनर्प्राप्ति डेटा स्थानीय रूप से उपयोगकर्ता के नियंत्रण में रहते हैं।",
    gesendet: "भेजा",
    gesperrt_verdaechtig: "प्रतिबंधित/संदिग्ध",
    group_delete_desc: "क्या आप सचमुच इस समूह को स्थायी रूप से हटाना चाहते हैं? इस समूह के सभी चैनल और संदेश हटा दिए जाएंगे.",
    group_delete_title: "समूह हटाएँ",
    group_description: "विवरण",
    group_icon_label: "समूह चिह्न/अवतार",
    group_name: "समूह नाम",
    group_settings_avatar: "अवतार",
    group_settings_desc: "विवरण",
    group_settings_is_crisis: "संकटग्रस्त क्षेत्र के रूप में चिह्नित करें",
    group_settings_name: "समूह नाम",
    group_settings_title: "समूह सेटिंग",
    groups_empty_desc: "परियोजना, संकट या टीम संचार के लिए एक सुरक्षित कार्यक्षेत्र बनाएं।",
    groups_empty_title: "अभी तक कोई समूह चैट नहीं",
    gruppe_beitreten: "समूह में शामिल हो गए",
    gruppe_erstellen: "+ समूह बनाएँ",
    gruppe_verlassen: "समूह छोड़ें",
    gruppen_chats: "समूह चैट",
    heller_modus: "उज्ज्वल मोड",
    how_to_receive_drops: "मुझे बूँदें कैसे प्राप्त होंगी?",
    identitaets_assistent: "पहचान सहायक",
    inactivity_lock_duration: "निष्क्रिय होने पर लॉक करें",
    inactivity_lock_duration_desc: "बिना किसी इनपुट की इस अवधि के बाद, GaiaCOM स्वचालित रूप से क्रिप्टोग्राफ़िक रूप से लॉक हो जाएगा।",
    inactivity_lock_notice: "निष्क्रियता के कारण GaiaCOM को क्रिप्टोग्राफ़िक रूप से अवरुद्ध कर दिया गया है।",
    include_plaintext: "सादा पाठ शामिल करें",
    invite_code_label: "आमंत्रण कोड",
    join_group_title: "समूह में शामिल",
    kanaele: "चैनल",
    kanal_erstellen: "+ चैनल",
    kein_chat_ausgewaehlt: "कोई चैट चयनित नहीं",
    kein_kanal_ausgewaehlt: "कोई चैनल चयनित नहीं",
    keine_gruppe_ausgewaehlt: "कोई समूह चयनित नहीं",
    keine_mails: "कोई ईमेल उपलब्ध नहीं.",
    key_change_warn_desc: "इस संपर्क की सार्वजनिक कुंजी बदल गई है. इस पर भरोसा करने से पहले फिंगरप्रिंट की जांच कर लें.",
    key_change_warn_title: "क्रिप्टोग्राफ़िक चेतावनी",
    key_change_warning_changed: "बदल गया है। यह बीच-बीच में किसी व्यक्ति द्वारा किए गए हमले का संकेत हो सकता है!",
    key_change_warning_msg: "संपर्क के लिए पहचान कुंजी",
    key_transparency: "मुख्य पारदर्शिता",
    kopiert: "कॉपी किया गया",
    kryptographische_schluessel: "क्रिप्टोग्राफ़िक कुंजियाँ",
    kryptographische_schluessel_desc: "निजी कुंजियाँ और बैकअप बीज वाक्यांश दिखाएँ।",
    laden: "भार...",
    leeren: "खाली",
    loading: "भार...",
    local_key_vault: "स्थानीय कुंजी वॉल्ट",
    local_keys_label: "स्थानीय कुंजियाँ",
    lock_on_reload: "पुनः लोड करने के बाद हमेशा लॉक करें",
    logout: "लॉग आउट",
    mail_compose: "ईमेल लिखें",
    mein_profil: "मेरी प्रोफाइल",
    melden: "प्रतिवेदन",
    menu: "मेनू",
    message: "समाचार",
    message_id: "संदेश आईडी",
    message_pin: "नत्थी करना",
    message_pinned_title: "पिन किए गए संदेश",
    message_react: "प्रतिक्रिया",
    message_reply: "उत्तर",
    message_replying_to: "को उत्तर",
    message_save: "बचाना",
    message_saved: "सहेजा गया",
    message_to_channel: "को संदेश",
    message_unpin: "हल करना",
    message_unsave: "बचाओ मत",
    mitglied: "सदस्य",
    mitglieder: "सदस्यों",
    ml_kem: "एमएल-केईएम",
    neue_mail: "नया ईमेल",
    never_auto_lock: "स्वचालित रूप से कभी नहीं",
    new_fingerprint: "नया फ़िंगरप्रिंट",
    new_identity: "नई पहचान",
    new_password: "नया पासवर्ड",
    no_description: "कोई विवरण नहीं",
    no_key_history: "कोई प्रमुख इतिहास दर्ज नहीं किया गया.",
    no_specification: "निर्दिष्ट नहीं है",
    old_fingerprint: "पुराना फ़िंगरप्रिंट",
    open_privacy_imprint: "खुली छाप और डेटा सुरक्षा",
    post_quantum_e2e: "पोस्ट-क्वांटम E2E",
    posteingang: "इनबॉक्स",
    powered_by: "द्वारा संचालित",
    privacy_imprint_menu_desc: "जीडीपीआर, डेटा सुरक्षा और कानूनी नोटिस दिखाएं।",
    privacy_imprint_profile_desc: "GaiaCOM संचार सामग्री को डेटा न्यूनतमकरण, एंड-टू-एंड एन्क्रिप्शन और स्थानीय कुंजी नियंत्रण के सिद्धांतों के अनुसार संसाधित करता है।",
    privacy_imprint_title: "डेटा सुरक्षा एवं कानूनी नोटिस",
    profil: "प्रोफ़ाइल",
    profile_details: "प्रोफ़ाइल विवरण",
    profile_settings_hint: "प्रोफ़ाइल सेटिंग्स दाएँ पैनल में प्रदर्शित होती हैं।",
    profile_unlock_desc: "सुरक्षा कारणों से, आपको अपनी निजी क्रिप्टोग्राफ़िक कुंजियाँ देखने के लिए अपना पासवर्ड दोबारा दर्ज करना होगा।",
    proof_hash: "प्रमाण हैश:",
    public_drop_desc: "गैयाकॉम खाते के बिना बाहरी पाठ जानकारी के लिए सुरक्षित ड्रॉप।",
    public_drop_message: "समाचार",
    public_drop_message_placeholder: "गोपनीय पाठ दर्ज करें...",
    public_drop_send: "गैयाड्रॉप भेजें",
    public_drop_sender: "प्रेषक नोट वैकल्पिक",
    public_drop_sender_placeholder: "नाम, फ़ाइल नंबर या गुमनाम",
    public_drop_target: "GaiaID को लक्ष्य करें",
    quanten_chat: "क्वांटम चैट",
    quantum_secure_exchange: "क्वांटम सुरक्षित विनिमय के माध्यम से...",
    quantum_secure_net: "GaiaCOM क्वांटम सिक्योर नेटवर्क (Ed25519 और ML-KEM)",
    quantum_shield_desc: "GaiaCOM नेटवर्क एक बहु-परत, हाइब्रिड एन्क्रिप्शन प्रोटोकॉल के साथ आपकी गोपनीयता की रक्षा करता है जो भविष्य के क्वांटम कंप्यूटरों के हमलों से सुरक्षित है।",
    quantum_shield_l1_desc: "सममित साझा कुंजी को एनकैप्सुलेट करने के लिए FIPS 203 मानक का उपयोग करता है। क्वांटम कंप्यूटर द्वारा निष्क्रिय रिकॉर्डिंग और बाद में डिक्रिप्शन (\\",
    quantum_shield_l1_title: "1. पोस्ट-क्वांटम सुरक्षा (ML-KEM-1024)",
    quantum_shield_l2_desc: "एक क्लासिक, बेहद तेज़ डिफी-हेलमैन कुंजी विनिमय प्रक्रिया जो हाइब्रिड प्रक्रिया में सुरक्षा की एक अतिरिक्त परत के रूप में कार्य करती है।",
    quantum_shield_l2_title: "2. अण्डाकार वक्र क्रिप्टोग्राफी (X25519)",
    quantum_shield_l3_desc: "प्रेषक की प्रामाणिकता को स्पष्ट रूप से सत्यापित करने के लिए प्रत्येक संदेश और प्रत्येक फेडरेशन लिफाफे पर क्रिप्टोग्राफ़िक रूप से हस्ताक्षर किए जाते हैं।",
    quantum_shield_l3_title: "3. डिजिटल हस्ताक्षर (Ed25519)",
    quantum_shield_l4_desc: "संदेश सामग्री को सममित रूप से एन्क्रिप्ट करता है और रीप्ले हमलों को रोकने के लिए प्रेषक, प्राप्तकर्ता और मेटाडेटा को प्रमाणित अतिरिक्त डेटा (एएडी) में कसकर बांधता है।",
    quantum_shield_l4_title: "4. एएडी प्रमाणीकरण (एईएस-256-जीसीएम)",
    quantum_shield_status: "क्वांटम शील्ड स्थिति",
    receive_drops_step1: "अपनी GaiaID को बाहरी स्रोतों के साथ साझा करें (उदाहरण के लिए ऊपर दिए गए कॉपी बटन का उपयोग करके)।",
    receive_drops_step2: "ये आपके GaiaCOM इंस्टेंस के लॉगिन पेज को कॉल करते हैं और टैब पर स्विच करते हैं",
    receive_drops_step3: "और उनका एन्क्रिप्टेड संदेश आपके पते पर भेजें।",
    receiver_gaia: "गैयाकॉम रिसीवर",
    receiver_smtp: "एसएमटीपी प्राप्तकर्ता",
    records_stored: "रिकॉर्ड सहेजे गए",
    refresh: "अद्यतन",
    report_abuse_desc: "क्या आप इस संदेश की रिपोर्ट करना चाहते हैं और सर्वर पर दुरुपयोग के क्रिप्टोग्राफ़िक साक्ष्य जमा करना चाहते हैं?",
    report_abuse_title: "दुरुपयोग होने की सूचना दें",
    reputation_status: "प्रतिष्ठा स्थिति",
    room_chat_start_hint: "बातचीत शुरू करें! इस समूह चैनल के सभी संदेश विकेंद्रीकृत क्वांटम-सुरक्षित E2E एन्क्रिप्टेड हैं।",
    room_policy_audit: "ऑडिट ट्रेल और कुंजी रोटेशन सक्रिय।",
    room_policy_crisis: "संकट कक्ष",
    room_policy_e2ee: "शून्य-ज्ञान स्थान. E2EE क्वांटम सुरक्षित।",
    room_policy_title: "कक्ष दिशानिर्देश",
    room_policy_zero_knowledge: "नीति",
    room_security_note_desc: "सभी प्रमुख परिवर्तन कुंजी पारदर्शिता के माध्यम से मान्य किए जाते हैं। निजी बैकअप लॉग के लिए GaiaVault का उपयोग करें।",
    room_security_note_title: "पिन किया गया सुरक्षा नोट",
    save_profile: "प्रोफ़ाइल बचा",
    schluessel_entsperrt: "🔑 चाबी को फिर से लॉक करें",
    search_gaia_label: "गैया का पता खोजें",
    security_warning_title: "सुरक्षा चेतावनी",
    select_channel_chat: "चैट करने के लिए बाएं साइडबार से एक चैनल चुनें।",
    select_contact_chat: "क्वांटम-सुरक्षित E2E चैट शुरू करने के लिए बाएं पैनल से एक संपर्क चुनें।",
    select_mail_read: "इसकी क्वांटम-सुरक्षित सामग्री को पढ़ने या एक नया संदेश बनाने के लिए सूची से एक ईमेल का चयन करें।",
    senden: "भेजना",
    sender_signature: "प्रेषक के हस्ताक्षर",
    server_log: "सर्वर लॉग:",
    server_received: "सर्वर प्राप्त हुआ",
    session_lock: "सत्र ताला",
    setup_address_keys: "पता और कुंजी सेट बनाएं",
    setup_profile: "प्रोफ़ाइल में सेट करें",
    smtp_inbox_title: "एसएमटीपी रिसेप्शन",
    smtp_legacy_badge: "लीगेसी एसएमटीपी/असुरक्षित",
    smtp_mode_option: "विरासत एसएमटीपी पुल",
    smtp_security_warning: "यह ईमेल क्लासिक, अनएन्क्रिप्टेड एसएमटीपी प्रोटोकॉल के माध्यम से प्रेषित किया गया था। कोई एंड-टू-एंड एन्क्रिप्शन सक्रिय नहीं है.",
    smtp_security_warning_desc: "यह संदेश GaiaCom सुरक्षा कक्ष से निकल रहा है। एसएमटीपी डिलीवरी GaiaCom की मूल एंड-टू-एंड गारंटी, कोई ट्रस्टमेश गारंटी और गेटवे से कोई गॉडमोड गारंटी प्रदान नहीं करती है।",
    spam_verdacht: "स्पैम/संदेह",
    spam_warning_desc: "इस संदेश में संदिग्ध प्रतिष्ठा संकेत हैं.",
    spam_warning_title: "स्पैम चेतावनी",
    speichern: "बचाना",
    sperren: "ताला लगाओ",
    standard_group_status: "मानक समूह चैट (E2EE एन्क्रिप्टेड)",
    status: "स्थिति",
    subject: "के बारे में",
    suchen: "एक नया गैया पता खोजें...",
    tage: "दिन",
    time_unknown: "समय अज्ञात",
    transmission_mode: "रीति का अंतरण करें",
    trust_age: "उम्र पर भरोसा रखें",
    trust_passport_title: "पासपोर्ट पर भरोसा करें",
    unbestaetigt: "अपुष्ट",
    unknown_sender: "अज्ञात",
    unlock_btn: "अनलॉक",
    unlock_btn_profile: "अनलॉक",
    unlock_desc: "आपकी निजी कुंजी फ़ाइल एन्क्रिप्टेड संग्रहीत है। क्रिप्टोग्राफ़िक कुंजियों को केवल मेमोरी में लोड करने के लिए अपना पासवर्ड दर्ज करें।",
    unlock_logout: "लॉग आउट करें और स्थानीय कुंजियाँ बंद करें",
    unlock_title: "पहचान अनलॉक करें",
    untrusted: "भरोसेमंद नहीं",
    update_password: "पासवर्ड अपडेट करें",
    upload_avatar_btn: "छवि अपलोड करें (स्वच्छतायुक्त)",
    vault_btn_encrypt: "रिकॉर्ड एन्क्रिप्ट करें",
    vault_btn_lock: "सुरक्षित ताला",
    vault_btn_unlock: "सुरक्षित रूप से अनलॉक करें",
    vault_copied_success: "क्लिपबोर्ड पर कॉपी किया गया",
    vault_decrypted_content: "डिक्रिप्ट की गई सामग्री",
    vault_desc: "पुनर्प्राप्ति बैकअप, पहचान नोट, सर्वर पहुंच, आपातकालीन संपर्क, कानूनी नोट्स, सुरक्षा घटनाओं और निजी लॉग के लिए स्थानीय एन्क्रिप्टेड वॉल्ट।",
    vault_empty: "अभी तक कोई सुरक्षित रिकॉर्ड सहेजा नहीं गया.",
    vault_locked_pane_notice: "तिजोरी बंद है. कृपया दाईं ओर अनलॉक करें.",
    vault_new_record: "नया सुरक्षित रिकॉर्ड",
    vault_pwd_placeholder: "वॉल्ट पासवर्ड दर्ज करें...",
    vault_record_body: "सामग्री रिकॉर्ड करें",
    vault_record_body_placeholder: "एन्क्रिप्टेड रिकॉर्ड सामग्री दर्ज करें...",
    vault_record_category: "वर्ग",
    vault_record_title: "रिकॉर्ड शीर्षक",
    vault_record_title_placeholder: "सुरक्षित रिकॉर्ड का शीर्षक",
    vault_title: "गैयावॉल्ट सिक्योर रिकॉर्ड्स",
    verify_new_fingerprint_hint: "कुंजी स्वीकार करने से पहले नए फ़िंगरप्रिंट की जाँच करें।",
    vertrauenswuerdig: "भरोसेमंद",
    vision_gaia_technology: "विज़नगैया टेक्नोलॉजी",
    von: "से",
    warnung: "चेतावनी",
    wizard_address: "पता",
    wizard_back: "पीछे",
    wizard_check1: "मैंने अपना बीज सुरक्षित रख लिया है.",
    wizard_custom_domain: "अपने स्वयं के डोमेन का उपयोग करें",
    wizard_desc1: "GaiaCOM सर्वर साइड पर निजी कुंजी संग्रहीत नहीं करता है। निमोनिक सीड के बिना, कोई भी खोए हुए संदेशों को पुनर्प्राप्त नहीं कर सकता है।",
    wizard_desc2: "आपका पता फ़ेडरेटेड नोड निर्धारित करता है जिसके माध्यम से एन्क्रिप्टेड लिफ़ाफ़े रूट किए जाते हैं।",
    wizard_fallback: "फ़ॉलबैक नोड्स",
    wizard_finish: "पूरा सेटअप",
    wizard_next: "आगे",
    wizard_server_domain: "सर्वर नोड डोमेन",
    wizard_step1: "1. बैकअप बीज",
    wizard_step2: "2. पता एवं सर्वर",
    wizard_title1: "पुनर्प्राप्ति कुंजी का बैकअप लें",
    wizard_title2: "GaiaCOM पता चुनें",
    write_message_placeholder: "एक सुरक्षित संदेश लिखें...",
    you: "आप",
    zero_knowledge: "शून्य ज्ञान",
    zero_knowledge_encryption: "शून्य-ज्ञान एन्क्रिप्शन",
    "Chat fuer alle geleert": "Der Chat wurde für alle Teilnehmer geleert.",
    "Chat geleert": "Der Chat wurde für deine lokale Inbox geleert.",
    "Nachricht fuer alle geloescht": "Die Nachricht wurde für alle Teilnehmer gelöscht.",
    "Nachricht geloescht": "चैट संदेश आपके इनबॉक्स से स्थानीय रूप से हटा दिया गया है।",
    "anpinnen": "Anpinnen",
    "chat_loeschen": "Chat löschen",
    "confirm_delete_chat_desc": "Möchtest du den Chat wirklich löschen und ausblenden?",
    "confirm_leave_group_desc": "Möchtest du diese Gruppe wirklich verlassen?",
    "entpinnen": "Entpinnen",
    "group_deleted": "Gruppe erfolgreich gelöscht.",
    "group_left": "Gruppe erfolgreich verlassen.",
    "gruppe_loeschen": "Gruppe löschen",
    "loeschen": "Löschen",
    "no_active_chats": "Keine aktiven Chats. Suche oben nach Kontakten, um einen Chat zu starten.",
    "pinned": "Angepinnt",
    "wizard_check_credentials": "मैं अपने एक्सेस डेटा को सुरक्षित रखने के लिए जिम्मेदार हूं।",
    "wizard_check_is_beta": "मैं समझता हूं कि GaiaCom बीटा सॉफ़्टवेयर है।",
    "wizard_check_no_illegal": "मैं गैयाकॉम का उपयोग गैरकानूनी उद्देश्यों के लिए नहीं करूंगा।",
    "wizard_check_no_uptime": "मैं समझता हूं कि उपलब्धता की कोई गारंटी नहीं है।",
    "wizard_check_smtp_security": "मैं समझता हूं कि एसएमटीपी संदेश पूर्ण GaiaCom सुरक्षा प्रदान नहीं करते हैं।",
    "wizard_check_terms_read": "मैंने सेवा की बीटा शर्तें पढ़ ली हैं.",
    "wizard_step_terms": "उपयोग की शर्तें",
    "wizard_terms_text": "गैयाकॉम उपयोग की शर्तें और बीटा परीक्षण समझौता (बीटा चरण)\n\nप्रदाता: VisionGaiaTechnology (इसके बाद \"प्रदाता\" के रूप में संदर्भित)\nस्थिति: सार्वजनिक बीटा परीक्षण चरण\nवैधता: 21 जून 2026 से\n\n⚠️ अग्रिम में सबसे महत्वपूर्ण नोट (कृपया ध्यान से पढ़ें)\nGaiaCom सार्वजनिक बीटा परीक्षण चरण में है। व्यापक सुरक्षा उपायों के बावजूद, त्रुटियों से मुक्ति, सॉफ़्टवेयर और अंतर्निहित बुनियादी ढांचे की निरंतर उपलब्धता या पूर्ण सुरक्षा की गारंटी नहीं दी जा सकती है। अपने जोखिम पर उपयोग करें। उपयोगकर्ता अपने एक्सेस डेटा (विशेष रूप से गैयावॉल्ट के लिए कुंजी) के सुरक्षित भंडारण और लागू कानूनों के अनुपालन के लिए जिम्मेदार हैं।\n\n1. बीटा परीक्षण चरण का विषय और उद्देश्य\n1.1. प्रावधान का उद्देश्य: GaiaCom पोस्ट-क्वांटम क्रिप्टोग्राफी (PQC) पर आधारित एक नवीन ईमेल और चैट सेवा है। बीटा चरण के दौरान प्रावधान विशेष रूप से तकनीकी परीक्षण, लोड सिमुलेशन, प्रोग्राम त्रुटियों (बग) को खोजने और उपयोगकर्ता-मित्रता को अनुकूलित करने के लिए है।\n1.2. बीटा स्थिति: उपयोगकर्ता को पता है कि पेश किया गया सॉफ़्टवेयर प्रारंभिक संस्करण (बीटा सॉफ़्टवेयर) है। यह अभी तक तकनीकी रूप से पूरी तरह से विकसित नहीं हुआ है, अंतिम, वाणिज्यिक उत्पाद के मानक को पूरा नहीं करता है और त्रुटियों, डेटा हानि, ट्रांसमिशन देरी या सिस्टम क्रैश का कारण बन सकता है।\n1.3. जारी रखने का कोई अधिकार नहीं: प्रदाता किसी भी समय सेवा को पूर्ण या आंशिक रूप से बंद करने, कार्यों को बदलने या प्रतिबंधित करने या उन्हें बिना कारण बताए अस्थायी या स्थायी रूप से हटाने का हकदार है।\n\n2. वारंटी की उपलब्धता और अस्वीकरण\n2.1. उपलब्धता की कोई गारंटी नहीं: GaiaCom उपलब्धता या अपटाइम की किसी गारंटी के बिना प्रदान किया जाता है। सेवा की निर्बाध उपलब्धता का कोई अधिकार नहीं है.\n2.2. वारंटी का बहिष्करण: सॉफ़्टवेयर अपनी वर्तमान स्थिति (\"जैसा है\") और उपलब्धता के अधीन प्रदान किया जाता है। कानून द्वारा अनुमत सीमा तक, सॉफ़्टवेयर में सामग्री और कानूनी दोषों के लिए किसी भी वारंटी दावे को बाहर रखा गया है। विशेष रूप से, इस बात की कोई गारंटी नहीं है कि सॉफ़्टवेयर त्रुटि-मुक्त है, मैलवेयर से मुक्त है या किसी विशेष उद्देश्य के लिए उपयुक्त है।\n\n3. जोखिम प्रबंधन और उपयोगकर्ता दायित्व\n3.1. महत्वपूर्ण डेटा के भंडारण पर प्रतिबंध: उपयोगकर्ता GaiaCom के माध्यम से किसी भी व्यवसाय-महत्वपूर्ण, महत्वपूर्ण, परिचालन रूप से आवश्यक या कानूनी रूप से विशेष रूप से संवेदनशील डेटा (जैसे रोगी फ़ाइलें, अत्यधिक संवेदनशील वित्तीय डेटा या आधिकारिक तौर पर विनियमित रहस्य) को विशेष रूप से संग्रहीत या प्रसारित नहीं करने का वचन देता है। इस सेवा का उपयोग बुनियादी ढांचे के लिए नहीं किया जा सकता है जहां अप्रत्याशित विफलताओं के परिणामस्वरूप व्यक्तिगत चोट, संपत्ति की क्षति या महत्वपूर्ण वित्तीय हानि हो सकती है।\n3.2. स्व-जिम्मेदार बैकअप: उपयोगकर्ता गैयाकॉम के माध्यम से प्राप्त या भेजे गए सभी डेटा का बैकअप लेने के लिए जिम्मेदार है, जिसकी उसे लंबी अवधि में अपने स्वतंत्र सिस्टम (बैकअप प्रतियां) पर आवश्यकता होती है। प्रदाता अपने सर्वर पर डेटा के स्थायी भंडारण या पुनर्स्थापना की गारंटी नहीं देता है।\n\n4. क्रिप्टोग्राफ़िक सुविधाएँ और गैयावॉल्ट\n4.1. पोस्ट-क्वांटम क्रिप्टोग्राफी (पीक्यूसी): गैयाकॉम अत्याधुनिक, भविष्य-उन्मुख एन्क्रिप्शन प्रक्रियाओं को लागू करता है जो भविष्य के क्वांटम कंप्यूटरों से हमलों का सामना करने के लिए डिज़ाइन किए गए हैं। हालाँकि, उपयोगकर्ता जानता है कि यह एक गतिशील और नया वैज्ञानिक क्षेत्र है। विज्ञान और प्रौद्योगिकी की वर्तमान स्थिति के आधार पर पूर्ण, अकाट्य सुरक्षा की गारंटी नहीं दी जा सकती। \"100% सुरक्षित\", \"अनक्रैकेबल\" या \"सैन्य सुरक्षित\" जैसे शब्दों की स्पष्ट रूप से गारंटी नहीं है।\n4.2. कोई पुनर्प्राप्ति गारंटी नहीं (GaiaVault): GaiaCom लगातार शून्य-ज्ञान सुरक्षा अवधारणा पर निर्भर करता है। एन्क्रिप्शन वेजेज और एक्सेस डेटा पूरी तरह से उपयोगकर्ता के नियंत्रण में रहता है (GaiaVault के माध्यम से सुरक्षित)।\nमहत्वपूर्ण: यदि उपयोगकर्ता अपने पासवर्ड, पासफ़्रेज़, निजी कुंजी या पुनर्प्राप्ति बीज खो देता है, तो प्रदाता के पास इस डेटा को पुनर्निर्माण या रीसेट करने की कोई तकनीकी क्षमता नहीं है। इन एक्सेस डेटा के खोने से अनिवार्य रूप से उपयोगकर्ता खाते और उसमें एन्क्रिप्ट किए गए सभी डेटा तक पहुंच की अपरिवर्तनीय हानि होती है।\n4.3. अभी तक पूरी तरह से ऑडिट नहीं किया गया है: सॉफ़्टवेयर को लगातार आंतरिक सुरक्षा जांच के अधीन किया जाता है, लेकिन इस बीटा चरण के समय यह अभी तक स्वतंत्र परीक्षण निकायों द्वारा अंतिम, व्यापक बाहरी सुरक्षा ऑडिट से नहीं गुजरा है।\n\n5. इंटरफेस, लीगेसी प्रोटोकॉल और फेडरेशन\n5.1. एसएमटीपी ब्रिज नोट: गैयाकॉम क्लासिक ईमेल प्रोटोकॉल (जैसे एसएमटीपी) के माध्यम से संचार करने की क्षमता प्रदान करता है। उपयोगकर्ता को पता है कि जो संदेश मूल GaiaCom सुरक्षा क्षेत्र को छोड़ते हैं (उदाहरण के लिए जब पारंपरिक @gmail.com या @gmx.de पते पर भेजे जाते हैं) अनएन्क्रिप्टेड या तृतीय-पक्ष सर्वर के माध्यम से भेजे जाते हैं। GaiaCom की एंड-टू-एंड सुरक्षा गारंटी केवल एक सीमित सीमा तक ही लागू होती है या ऐसे आउटगोइंग या बाहरी रूप से आने वाले विरासत संदेशों पर बिल्कुल भी लागू नहीं होती है।\n5.2. फ़ेडरेशन नोट: यदि GaiaCom फ़ेडरेटेड नेटवर्क पर काम करता है, तो संदेश और डेटा तृतीय-पक्ष सर्वर से गुज़र सकते हैं। जबकि संदेशों की सामग्री एंड-टू-एंड एन्क्रिप्शन द्वारा संरक्षित रहती है, मेटाडेटा (जैसे भेजने का समय, शामिल सर्वर के आईपी पते और प्राप्तकर्ता पते) तकनीकी रूप से इन फ़ेडरेटेड सर्वर के ऑपरेटरों को दिखाई दे सकते हैं। फ़ेडरेटेड नेटवर्क में तृतीय-पक्ष सर्वर ऑपरेटरों की डेटा सुरक्षा प्रथाओं पर प्रदाता का कोई प्रभाव नहीं है।\n\n6. स्वीकार्य उपयोग और निषिद्ध गतिविधियाँ\nउपयोगकर्ता यह वचन देता है कि वह सेवा का अनुचित तरीके से या अवैध उद्देश्यों के लिए उपयोग नहीं करेगा। विशेष रूप से, निम्नलिखित निषिद्ध हैं:\n- वायरस, मैलवेयर, फ़िशिंग सामग्री या अन्य दुर्भावनापूर्ण सॉफ़्टवेयर वितरित करना, भेजना या होस्ट करना।\n- सेवा से इनकार करने वाले हमलों (डीडीओएस) या अवांछित बल्क मेलिंग (स्पैम) का संचालन करने के लिए सेवा का उपयोग करना।\n- धोखाधड़ी करने के लिए सिस्टम का दुरुपयोग करना।\n- अवैध सामग्री का वितरण या आदान-प्रदान, विशेष रूप से बाल यौन शोषण (सीएसएएम), आतंकवादी प्रचार, हिंसा का आह्वान या अन्य आपराधिक रूप से प्रासंगिक सामग्री का चित्रण।\n\n7. दुरुपयोग रिपोर्टिंग प्रणाली\n7.1. अपमानजनक व्यवहार की रिपोर्ट करना: उपयोगकर्ताओं के पास एकीकृत दुर्व्यवहार प्रणाली के माध्यम से अपमानजनक संचार या अवैध गतिविधियों की रिपोर्ट करने का अवसर है।\n7.2. रिपोर्ट का प्रसंस्करण: दुरुपयोग के खिलाफ सुरक्षा सुनिश्चित करने के लिए, आने वाली रिपोर्ट का तकनीकी रूप से विश्लेषण किया जा सकता है (गोपनीयता और एन्क्रिप्शन सीमा बनाए रखते हुए)। इससे उपयोग की इन शर्तों के सिद्ध उल्लंघन की स्थिति में उपयोगकर्ता खातों या आईपी पते को अस्थायी या स्थायी रूप से निलंबित किया जा सकता है।\n\n8. दायित्व की सीमा\n8.1. दायित्व का मानक: बीटा सॉफ़्टवेयर निःशुल्क प्रदान किया जाता है। दान या ऋण के कानूनी नियमों के अनुसार, प्रदाता केवल इरादे (जानबूझकर क्षति) और घोर लापरवाही के लिए उत्तरदायी है।\n8.2. डेटा हानि के लिए दायित्व का बहिष्कार: डेटा की हानि के लिए दायित्व को तब तक बाहर रखा जाता है जब तक कि हानि जानबूझकर या प्रदाता द्वारा घोर लापरवाही के कारण नहीं हुई हो और उपयोगकर्ता ने नियमित बैकअप (GaiaCom के बाहर) के माध्यम से क्षति को कम करने के अपने दायित्व को पूरा किया हो।\n8.3. कानूनी सीमाएँ: उपरोक्त दायित्व सीमाएँ जीवन, शरीर या स्वास्थ्य पर चोट या उत्पाद दायित्व अधिनियम के तहत दायित्व पर लागू नहीं होती हैं।\n\n9. खुला स्रोत\nकुछ गैयाकॉम घटकों, पुस्तकालयों या क्लाइंट अनुप्रयोगों को ओपन सोर्स लाइसेंस (जैसे जीपीएल, एमआईटी, अपाचे) के तहत लाइसेंस दिया जा सकता है। इन घटकों की संबंधित लाइसेंस शर्तें उपयोग की इन शर्तों से अप्रभावित रहती हैं और इन्हें संबंधित स्रोत कोड रिपॉजिटरी में देखा जा सकता है।\n\n10. निर्यात नियंत्रण और अनुपालन\nउपयोगकर्ता को पता है कि क्रिप्टोग्राफ़िक सॉफ़्टवेयर सख्त निर्यात नियंत्रण और कानूनी प्रतिबंधों के अधीन हो सकता है। उपयोगकर्ता यह सुनिश्चित करने के लिए ज़िम्मेदार है कि GaiaCom का उपयोग उनके संबंधित देश के कानूनों, आयात/निर्यात प्रतिबंधों या क्रिप्टोग्राफी नियमों का उल्लंघन नहीं करता है।\n\n11. डेटा सुरक्षा सूचना (बीटा के लिए लघु संस्करण)\n11.1. न्यूनतम डेटा संग्रह: बीटा चरण के भाग के रूप में, प्रदाता केवल वह डेटा एकत्र करता है जो तकनीकी संचालन, समस्या निवारण और आगे के विकास के लिए बिल्कुल आवश्यक है (उदाहरण के लिए त्रुटि निदान के लिए सर्वर लॉग फ़ाइलें)।\n11.2. सामग्री के बारे में कोई जानकारी नहीं: निरंतर शून्य-ज्ञान और E2E एन्क्रिप्शन के लिए धन्यवाद, प्रदाता के पास GaiaVault में संग्रहीत आपकी चैट, ईमेल या कुंजियों की सामग्री तक कभी पहुंच नहीं होती है।\n11.3. विस्तृत डेटा सुरक्षा घोषणा: विस्तृत डेटा सुरक्षा नियम अलग से जुड़े हुए हैं और पंजीकरण से पहले उपयोगकर्ता द्वारा इसे भी ध्यान में रखा जाना चाहिए।\n\n12. अंतिम प्रावधान\n12.1. लागू कानून: माल की अंतर्राष्ट्रीय बिक्री के लिए अनुबंधों पर संयुक्त राष्ट्र कन्वेंशन को छोड़कर, जर्मनी के संघीय गणराज्य का कानून लागू होता है।\n12.2. परिवर्तन के अधीन: चूँकि GaiaCom सक्रिय विकास में है, प्रदाता भविष्य के लिए किसी भी समय इन स्थितियों को अनुकूलित करने का अधिकार सुरक्षित रखता है। वर्तमान संस्करण एप्लिकेशन में उपलब्ध है.",
    "wizard_terms_title": "गैयाकॉम उपयोग की शर्तें और बीटा परीक्षण समझौता (बीटा चरण)",
    "node_operator": "नोड ऑपरेटर",
    "search_channels": "चैनल खोजें...",
    "senior_reviewer": "वरिष्ठ समीक्षक",
    "trusted_reviewer": "विश्वसनीय समीक्षक",
    "active_frequencies": "सक्रिय आवृत्तियाँ",
    "connected_rooms": "जुड़े हुए स्थान",
    "dashboard": "डैशबोर्ड",
    "empty_chats": "कोई सक्रिय चैट उपलब्ध नहीं है.",
    "empty_messages": "कोई नया संदेश उपलब्ध नहीं है.",
    "encrypted": "कूट रूप दिया गया",
    "gaiacom_uplink": "गैयाकॉम अपलिंक",
    "install_app": "एप्लिकेशन इंस्टॉल करो",
    "install_app_desc": "त्वरित शुरुआत और ऑफ़लाइन मोड के लिए",
    "kommandozentrale_alpha": "अल्फा कमांड सेंटर",
    "network_online": "नेटवर्क: ऑनलाइन",
    "new_room": "नई जगह",
    "no_frequencies_active": "कोई फ़्रीक्वेंसी सक्रिय नहीं. संचार शुरू करने के लिए एक नया कमरा बनाएं.",
    "no_id": "कोई आईडी नहीं",
    "open_chats": "चैट खोलें",
    "open_inbox": "इनबॉक्स खोलें",
    "primary_identity": "प्राथमिक पहचान",
    "recent_chats": "नई चैट",
    "recent_messages": "ताजा खबर",
    "session_encrypted": "सत्र एन्क्रिप्टेड: {नाम}",
    "session_secure": "स्थिति: सुरक्षित",
    "system_verlassen": "निकास प्रणाली",
    "write_message": "एक सन्देश लिखिए",
  },
  tr: {
    sc_title: "Güvenlik Merkezi",
    sc_subtitle: "GaiaShield Entegre Güvenlik Katmanı",
    sc_tab_status: "🛡️ Koruma Durumu",
    sc_tab_events: "📋 Güvenlik Günlüğü",
    sc_tab_node: "⚙️ Düğüm Güvenliği",
    sc_loading: "Güvenlik verileri yükleniyor...",
    sc_status_secured: "Sistem Durumu: Hesap korunuyor",
    sc_status_warning: "Sistem Durumu: Uyarılar aktif",
    sc_desc_secured: "Aktif kritik güvenlik uyarısı yok. GaiaShield hesabınızı aktif olarak izliyor.",
    sc_desc_warning: "Dikkat: Dikkatinizi gerektiren aktif güvenlik olayları var.",
    sc_account_protection: "Hesap Koruması",
    sc_message_protection: "Mesaj Koruması",
    sc_audits: "Güvenlik Denetimleri",
    sc_active: "AKTİF",
    sc_failed_logins: "Başarısız Girişler",
    sc_tamper_checks: "Müdahale Kontrolleri",
    sc_blocked_replays: "Engellenen Yeniden Oynatmalar",
    sc_last_check: "Son Kontrol",
    sc_just_now: "Az Önce",
    sc_open_warnings: "Açık Uyarılar",
    sc_btn_acknowledge: "Onayla",
    sc_filter_severity: "Önem Derecesi",
    sc_filter_category: "Kategori",
    sc_filter_hide_ack: "Onaylananları Gizle",
    sc_btn_export: "Dışa Aktar",
    sc_col_details: "Detaylar",
    sc_col_time: "Zaman",
    sc_col_status: "Durum",
    sc_col_action: "Eylem",
    sc_no_events: "Güvenlik olayı bulunamadı.",
    sc_node_title: "Düğüm Operatörü Güvenlik Konsolu",
    sc_system_health: "Sistem Sağlığı",
    sc_last_audit: "Son Denetim",
    sc_packed_logs: "Paketlenmiş Günlükler",
    sc_unconfirmed_events: "Onaylanmamış Olaylar",
    sc_operator_action: "Operatör Eylemi Gerekli",
    sc_all_ok: "Her Şey Yolunda",
    sc_critical_events: "Kritik Sistem Olayları",
    ac_title: "Yönetişim ve Şikayet Merkezi",
    ac_subtitle: "GaiaCom Yönetişim ve Kötüye Kullanım Mutabakatı",
    ac_tab_my_reports: "Şikayetlerim",
    ac_tab_queue: "İnceleme Sırası",
    ac_tab_operator: "Düğüm Operatörü",
    ac_tab_transparency: "Federasyon ve Şeffaflık",
    ac_loading: "Veriler yükleniyor...",
    ac_reported_cases: "Bildirilen Vakalar",
    ac_no_reports: "Henüz herhangi bir şikayet göndermediniz.",
    ac_case_details: "Vaka Detayları",
    ac_appeal_submit: "İtiraz Et",
    ac_appeal_status: "İtiraz Durumu",
    ac_appeal_reason: "İtiraz Nedeni",
    ac_appeal_statement: "Açıklama",
    ac_btn_appeal: "İtirazı Gönder",
    ac_trusted_reviewer_queue: "Güvenilir Hakem Sırası",
    ac_case_review: "Vakayı İncele",
    ac_review_category: "Önerilen Kategori",
    ac_review_severity: "Önerilen Önem Derecesi",
    ac_review_action: "Önerilen Eylem",
    ac_review_reason: "İncelemecinin Nedeni",
    ac_btn_submit_review: "İncelemeyi Gönder",
    ac_node_operator_dashboard: "Düğüm Operatörü Kontrol Paneli",
    ac_apply_action: "Eylemi Uygula (Geçersiz Kıl)",
    ac_target_type: "Hedef Türü",
    ac_target_id: "Hedef Kimliği (GaiaID veya Kanal Kimliği)",
    ac_suspend: "Askıya Alma Aktif",
    ac_reason: "Resmi Gerekçe",
    ac_btn_apply: "Eylemi Uygula",
    ac_transparency_title: "Mutabakat ve Şeffaflık Günlüğü",
    ac_transparency_desc: "Tüm denetlenen kanalların ve kimliklerin herkese açık anlık görüntü kanıtları.",
    ac_btn_snapshot: "Şeffaflık Anlık Görüntüsü Oluştur",
    search_placeholder: "E-postaları konuya, gönderene, metne göre ara...",
    abuse_center_title: "Kötüye Kullanım Merkezi",
    abbrechen: "İptal etmek",
    active_identities: "Aktif kimlikler",
    active_identity: "Aktif kimlik",
    add_btn: "Eklemek",
    add_contact_title: "Kişi ekle",
    admin: "Yönetici",
    adressbuch: "dizin",
    aktiviert: "Etkinleştirilmiş",
    an: "İle",
    anonymous_sender: "Anonim gönderen",
    antworten: "Cevap",
    attachment_gaia_hint: "GaiaCOM ekleri uçtan uca şifrelenmiş halde kalır.",
    attachment_smtp_hint: "Eski SMTP, yürütülebilir/komut dosyası benzeri ekleri engeller ve e-postaları güvensiz olarak kaydeder.",
    attachments: "Ekler",
    auffaellig: "Dikkat çekici",
    auth_beta_notice: "Beta test aşaması: GaiaCOM aktif olarak test ediliyor. Hatalar meydana gelebilir; Önemli tohumları güvence altına alın ve gizli iş akışlarını dikkatle inceleyin.",
    auth_btn_login: "Kimliği yükle ve giriş yap",
    auth_btn_register: "Kaydolun ve kripto oluşturun",
    auth_copied: "Kopyalandı",
    auth_copy_seed: "Tohumu kopyala",
    auth_generate_seed: "Tohum üret",
    auth_headline: "GaiaCOM, insanlık için oluşturulmuş ilk kuantum güvenli e-posta protokolü ve iletişim sistemidir.",
    auth_kicker: "Kuantum Sonrası Güvenli İletişim",
    auth_mnemonic: "Anımsatıcı ifade",
    auth_mnemonic_placeholder: "Boşluklarla ayrılmış 12 kelime...",
    auth_password: "şifre",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "Özel anahtarlar cihazınızdan ayrılmaz. Yalnızca amaçlanan alıcılar içeriğin şifresini çözebilir.",
    auth_proof_gaiadata_desc: "Sıfır Bilgi: Verilerinizin kontrolü sizde kalır. Meta veriler küçültülür ve düz metin profili olarak kullanılmaz.",
    auth_proof_gaiadrop_desc: "Harici kişiler, bir hesap olmadan GaiaID'nize gizli metin mesajları gönderebilir.",
    auth_proof_gaiaproof_desc: "Teslimat ve bütünlük kanıtları şifreli metin, gönderen ve zaman damgasının tahrif edilmediğini göstermektedir.",
    auth_proof_gaiavault_desc: "Özel notlar, kurtarma notları ve güvenlik kayıtları yerel olarak şifrelenmiş halde kalır.",
    auth_proof_hybrid_desc: "Kuantum Kalkanı: ML-KEM ve X25519 ile hibrit şifreleme, günümüzün saldırılarına ve şimdi sakla-daha sonra şifresini çöz risklerine karşı koruma sağlar.",
    auth_secure_mail: "Güvenli Kuantum Birleşik Posta",
    auth_subline: "GaiaCOM, e-posta, sohbet, kriz odaları, GaiaDrop ve yerel güvenlik dosyaları için kuantum güvenli bir iletişim sistemidir. Özel anahtarlar cihazınızda kalır, içerik uçtan uca şifrelenir ve kanıtlar düz metin olmadan dışa aktarılabilir.",
    auth_success_btn: "Şimdi oturum açın",
    auth_success_text: "GaiaCOM hesabınız oluşturuldu. Anahtarlar yerel olarak tohumunuzdan türetildi ve sunucuda saklanmadı.",
    auth_success_title: "Kayıt başarılı",
    auth_tab_drop: "GaiaDrop",
    auth_tab_login: "Giriş/Hesap",
    auth_toggle_login: "Hesap zaten mevcut",
    auth_toggle_register: "Yeni hesap oluştur",
    auth_usecase_text: "Avukatlar, şirketler, yetkililer, gazeteciler, ihbarcılar ve özel güvenlik davaları için uygundur.",
    auth_usecase_title: "Hassas iletişim için tasarlandı",
    auth_username: "kullanıcı adı",
    auth_username_placeholder: "Ad girin...",
    auth_value_chat: "E2E Sohbeti",
    auth_value_drop: "Güvenli Bırakma",
    auth_value_mail: "Güvenli posta",
    auth_value_rooms: "GaiaOdaları",
    bestaetigen: "Onaylamak",
    bestaetigt: "Onaylandı",
    bio_status: "Biyografi/Durum",
    biography: "biyografi",
    change_password_desc: "Sunucu tarafı oturum açma parolanızı değiştirir. Yerel kurtarma ifadeniz, kasa/kilit açma parolanız tarafından ayrı olarak korunmaya devam eder.",
    change_password_menu_desc: "GaiaCOM oturum açma parolasını güncelleyin.",
    change_password_title: "Şifre değiştir",
    channel_id: "Kanal kimliği",
    channel_name_label: "Kanal adı",
    chat_deleted_hidden: "Sohbet silindi ve gizlendi.",
    chat_input_placeholder: "Güvenli mesajı girin...",
    chat_start_hint: "Konuşmayı başlatın! Tüm sohbet mesajları kuantum güvenli E2E şifrelidir.",
    choose_avatar: "Avatar seç",
    ciphertext_hash: "Şifreli Metin Karması",
    clear_chat: "Sohbeti boşalt",
    clear_for_everyone: "Herkes için boş",
    clear_for_me: "Sadece benim için boş",
    click_to_write_mail: "E-posta yazmak için tıklayın",
    click_top_right: "Sağ üstteki tıklayın",
    close: "Kapalı",
    code_kopieren: "Kodu kopyala",
    code_kopieren_success: "Kod kopyalandı",
    confirm_clear_channel_desc: "Bu kanalı yerel görünümünüzden temizlemek istiyor musunuz?",
    confirm_clear_channel_title: "Boş kanal",
    confirm_clear_chat: "Bu sohbeti boşaltmak istiyor musunuz?",
    confirm_clear_chat_desc: "Bu sohbeti boşaltmak istiyor musunuz?",
    confirm_clear_chat_title: "Sohbeti boşalt",
    confirm_clear_everyone: "Her iki ortak için de sohbeti boşaltmak istiyor musunuz? (Tamam = Herkes için, İptal = Sadece benim için)",
    confirm_delete_everyone: "Mesajı her iki ortak için de silmek istiyor musunuz? (Tamam = Herkes için, İptal = Sadece benim için)",
    confirm_delete_msg: "Bu mesajı silmek istiyor musunuz?",
    confirm_delete_msg_desc: "Bu sohbet mesajını silmek istiyor musunuz?",
    confirm_delete_msg_title: "Mesajı sil",
    confirm_new_password: "Yeni şifreyi onayla",
    copy: "Kopyala",
    create_btn: "Yaratmak",
    create_channel_title: "Kanal oluştur",
    create_group_is_crisis: "Kriz alanı olarak işaretle",
    create_group_title: "Yeni grup oluştur",
    crypto_lock_desc: "GaiaCOM'un yerel kripto anahtarlarını bellekten ne zaman kaldıracağını kontrol eder.",
    crypto_lock_menu_desc: "Yeniden yükleme ve hareketsizlik zamanlayıcılarını kontrol edin.",
    crypto_lock_title: "Kriptografik kilit",
    crypto_session_duration: "Yeniden yükledikten sonra kilidi açıldı",
    crypto_session_duration_desc: "Kripto oturumunu bu tarayıcı sekmesinde yalnızca seçilen süre boyunca açık tutar.",
    cryptographic_fingerprint: "Kriptografik parmak izi",
    current_password: "Mevcut Şifre",
    data_minimization: "Veri minimizasyonu",
    decrypt_failed: "Deşifre edilemez",
    delete: "Silmek",
    delete_account_button: "Hesabı geri alınamayacak şekilde silin",
    delete_account_confirm_label: "Onaylamak için DELETE girin",
    delete_account_confirmation_error: "Şifre ve SİL onayı gereklidir.",
    delete_account_desc: "Bu mod, hesabınızı, kimliklerinizi, cihaz oturumlarınızı, GaiaDrop verilerinizi, yükleme meta verilerinizi ve sunucu tarafıyla ilişkilendirilebilir mesajlarınızı kalıcı olarak yok eder.",
    delete_account_done_desc: "Atanabilir tüm GaiaCOM verileri silindi.",
    delete_account_done_title: "Hesap silindi",
    delete_account_menu_desc: "Hesabı ve ilişkili verileri yok edin.",
    delete_account_not_authenticated: "Aktif hesap yok.",
    delete_account_title: "Hesabı sil",
    delete_for_everyone: "Herkes için sil",
    delete_for_me: "Sadece benim için sil",
    device_current: "Bu cihaz",
    device_last_seen: "Son",
    device_logout: "Oturumu kapat",
    device_sessions_desc: "Aktif oturumları kontrol edin ve artık güvenmediğiniz cihazların kaydını silin.",
    device_sessions_empty: "Hiçbir cihaz bulunamadı.",
    device_sessions_menu_desc: "Aktif oturumları yönetin ve sonlandırın.",
    device_sessions_title: "Kayıtlı cihazlar",
    device_since: "O zamandan beri",
    display_name: "Ekran adı",
    drop_address_copied: "GaiaDrop adresi kopyalandı.",
    drop_btn_decrypting: "Gelen kutusunun şifresi çözülüyor...",
    drop_btn_load: "GaiaDrop Gelen Kutusunu Yükle",
    drop_delete_desc: "Bu düşüşü gerçekten kalıcı olarak silmek istiyor musunuz?",
    drop_delete_title: "GaiaDrop'u Sil",
    drop_desc: "Harici bildirimler, sorumlu açıklamalar ve gizli raporlar için yalnızca metin içeren sıfır bilgi bırakma kanalı. Harici taraflar, GaiaID'nizi kullanarak hesap olmadan mesaj gönderebilir.",
    drop_empty: "Henüz GaiaDrop mesajı yüklenmedi.",
    drop_id: "Bırakma kimliği:",
    drop_own_address: "GaiaDrop adresiniz",
    drop_proof: "DÜŞMEYE DAYANIKLI",
    drop_title: "GaiaDrop Güvenli Gelen Kutusu",
    dunkler_modus: "Karanlık mod",
    e2e_chat_room_open: "E2E sohbet odasını aç",
    edit_profile: "Profili düzenle",
    edit_profile_desc: "Görünen adı, biyografiyi ve avatarı özelleştirin.",
    einladungscode: "Davetiye kodu",
    enter_fingerprint_chars_confirm: "Onaylamak için istenen parmak izi karakterlerini girin.",
    envelope_hash: "Zarf karması",
    erasability: "Silinebilirlik",
    erfolg: "Başarı",
    exclude_plaintext: "Düz metin olmadan dışa aktar",
    export_disclosure: "Güvenlik vakasını dışa aktar",
    export_package_desc: "Yalnızca bu açıklamanın kasıtlı olması durumunda düz metin ekleyin.",
    export_package_title: "Güvenlik paketini dışa aktar",
    fehler: "Hata",
    gaiacom_reader: "GaiaCOM Okuyucu",
    gaiadrop_inbox_title: "GaiaDrop Gelen Kutusu",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM meta verileri en aza indirir, özel anahtarları yerel tutar, içeriği uçtan uca şifreler ve hesabın tamamen silinmesini sağlar.",
    gdpr_home_title: "%100 GDPR uyumlu",
    gdpr_reason_delete: "Hesabın silinmesi hesabı, kimlikleri, yerel oturumları ve sunucu tarafı atanabilir verileri kaldırır.",
    gdpr_reason_e2ee: "Özel içeriğin şifresi yalnızca hedeflenen alıcılar için çözülebilir durumda kalır.",
    gdpr_reason_minimal: "Meta veriler yalnızca yönlendirme, teslimat ve güvenlik kimlik bilgileri için kullanılır.",
    gdpr_reason_zero_knowledge: "Özel anahtarlar ve kurtarma verileri yerel olarak kullanıcı kontrolü altında kalır.",
    gesendet: "Gönderilmiş",
    gesperrt_verdaechtig: "Yasaklandı / Şüpheli",
    group_delete_desc: "Bu grubu gerçekten kalıcı olarak silmek istiyor musunuz? Bu gruptaki tüm kanallar ve mesajlar silinecek.",
    group_delete_title: "Grubu sil",
    group_description: "Tanım",
    group_icon_label: "Grup simgesi / avatarı",
    group_name: "Grup adı",
    group_settings_avatar: "avatar",
    group_settings_desc: "Tanım",
    group_settings_is_crisis: "Kriz alanı olarak işaretle",
    group_settings_name: "Grup adı",
    group_settings_title: "Grup ayarları",
    groups_empty_desc: "Proje, kriz veya ekip iletişimi için güvenli bir çalışma alanı oluşturun.",
    groups_empty_title: "Henüz grup sohbeti yok",
    gruppe_beitreten: "Katılan grup",
    gruppe_erstellen: "+ Grup oluştur",
    gruppe_verlassen: "Gruptan ayrıl",
    gruppen_chats: "Grup sohbetleri",
    heller_modus: "Parlak mod",
    how_to_receive_drops: "Dropları nasıl alabilirim?",
    identitaets_assistent: "Kimlik Asistanı",
    inactivity_lock_duration: "Etkin olmadığında kilitle",
    inactivity_lock_duration_desc: "Giriş yapılmayan bu sürenin ardından GaiaCOM otomatik olarak kriptografik olarak kilitlenecektir.",
    inactivity_lock_notice: "GaiaCOM, etkinlik olmaması nedeniyle kriptografik olarak engellendi.",
    include_plaintext: "Düz metin ekle",
    invite_code_label: "Davetiye kodu",
    join_group_title: "Gruba katıl",
    kanaele: "Kanallar",
    kanal_erstellen: "+ kanal",
    kein_chat_ausgewaehlt: "Seçilen sohbet yok",
    kein_kanal_ausgewaehlt: "Hiçbir kanal seçilmedi",
    keine_gruppe_ausgewaehlt: "Grup seçilmedi",
    keine_mails: "E-posta yok.",
    key_change_warn_desc: "Bu kişinin genel anahtarı değişti. Güvenmeden önce parmak izini kontrol edin.",
    key_change_warn_title: "Şifreleme uyarısı",
    key_change_warning_changed: "değişti. Bu, ortadaki adam saldırısının işareti olabilir!",
    key_change_warning_msg: "Kişinin kimlik anahtarı",
    key_transparency: "Anahtar Şeffaflığı",
    kopiert: "Kopyalandı",
    kryptographische_schluessel: "Şifreleme anahtarları",
    kryptographische_schluessel_desc: "Özel anahtarları ve yedek tohum ifadesini gösterin.",
    laden: "Yük...",
    leeren: "Boş",
    loading: "Yük...",
    local_key_vault: "Yerel anahtar kasası",
    local_keys_label: "Yerel anahtarlar",
    lock_on_reload: "Yeniden yükledikten sonra daima kilitle",
    logout: "Oturumu kapat",
    mail_compose: "E-posta yaz",
    mein_profil: "Profilim",
    melden: "Rapor",
    menu: "menü",
    message: "Haberler",
    message_id: "Mesaj Kimliği",
    message_pin: "Sabitle",
    message_pinned_title: "Sabitlenmiş mesajlar",
    message_react: "Tepki ver",
    message_reply: "Cevap",
    message_replying_to: "Cevapla",
    message_save: "Kaydetmek",
    message_saved: "Kaydedildi",
    message_to_channel: "Mesaj gönder",
    message_unpin: "Çözmek",
    message_unsave: "Kaydetme",
    mitglied: "Üye",
    mitglieder: "üyeler",
    ml_kem: "ML-KEM",
    neue_mail: "Yeni e-posta",
    never_auto_lock: "Asla otomatik olarak",
    new_fingerprint: "Yeni parmak izi",
    new_identity: "Yeni kimlik",
    new_password: "Yeni Şifre",
    no_description: "Açıklama yok",
    no_key_history: "Hiçbir anahtar geçmişi kaydedilmedi.",
    no_specification: "Belirtilmedi",
    old_fingerprint: "Eski parmak izi",
    open_privacy_imprint: "Açık baskı ve veri koruması",
    post_quantum_e2e: "Kuantum sonrası E2E",
    posteingang: "Gelen kutusu",
    powered_by: "Tarafından desteklenmektedir",
    privacy_imprint_menu_desc: "GDPR'yi, veri korumayı ve yasal bildirimi gösterin.",
    privacy_imprint_profile_desc: "GaiaCOM iletişim içeriğini veri minimizasyonu, uçtan uca şifreleme ve yerel anahtar kontrolü ilkelerine göre işler.",
    privacy_imprint_title: "Veri koruma ve yasal bildirim",
    profil: "profil",
    profile_details: "Profil ayrıntıları",
    profile_settings_hint: "Profil ayarları sağ panelde görüntülenir.",
    profile_unlock_desc: "Güvenlik nedeniyle özel şifreleme anahtarlarınızı görüntülemek için şifrenizi yeniden girmeniz gerekir.",
    proof_hash: "Kanıt karma:",
    public_drop_desc: "GaiaCOM hesabı olmadan harici metin bilgileri için Güvenli Bırakma.",
    public_drop_message: "Haberler",
    public_drop_message_placeholder: "Gizli metni girin...",
    public_drop_send: "GaiaDrop'u gönder",
    public_drop_sender: "Gönderen notu isteğe bağlı",
    public_drop_sender_placeholder: "İsim, dosya numarası veya anonim",
    public_drop_target: "GaiaID'yi hedefle",
    quanten_chat: "Kuantum Sohbeti",
    quantum_secure_exchange: "Kuantum güvenli alışverişi...",
    quantum_secure_net: "GaiaCOM Kuantum Güvenli Ağı (Ed25519 ve ML-KEM)",
    quantum_shield_desc: "GaiaCOM ağı, geleceğin kuantum bilgisayarlarından gelebilecek saldırılara karşı korunan çok katmanlı, hibrit bir şifreleme protokolüyle gizliliğinizi korur.",
    quantum_shield_l1_desc: "Simetrik bir paylaşılan anahtarı kapsüllemek için FIPS 203 standardını kullanır. Kuantum bilgisayarların pasif kaydetmesini ve daha sonra şifre çözmesini (\\",
    quantum_shield_l1_title: "1. Kuantum Sonrası Koruma (ML-KEM-1024)",
    quantum_shield_l2_desc: "Hibrit prosedürde ek bir güvenlik katmanı görevi gören klasik, son derece hızlı bir Diffie-Hellman anahtar değişim prosedürü.",
    quantum_shield_l2_title: "2. Eliptik Eğri Şifrelemesi (X25519)",
    quantum_shield_l3_desc: "Gönderenin gerçekliğini kesin olarak doğrulamak için her mesaj ve her Federasyon zarfı kriptografik olarak imzalanır.",
    quantum_shield_l3_title: "3. Dijital İmzalar (Ed25519)",
    quantum_shield_l4_desc: "Mesaj içeriğini simetrik olarak şifreler ve tekrar gönderme saldırılarını önlemek için göndereni, alıcıyı ve meta verileri Kimliği Doğrulanmış Ek Verilere (AAD) sıkı bir şekilde bağlar.",
    quantum_shield_l4_title: "4. AAD kimlik doğrulaması (AES-256-GCM)",
    quantum_shield_status: "Kuantum Kalkanı durumu",
    receive_drops_step1: "GaiaID'nizi (örneğin yukarıdaki kopyala düğmesini kullanarak) harici kaynaklarla paylaşın.",
    receive_drops_step2: "Bunlar GaiaCOM örneğinizin oturum açma sayfasını çağırır ve sekmeye geçer",
    receive_drops_step3: "ve şifreli mesajlarını adresinize gönderin.",
    receiver_gaia: "GaiaCOM alıcısı",
    receiver_smtp: "SMTP alıcısı",
    records_stored: "Kayıtlar kaydedildi",
    refresh: "Güncelleme",
    report_abuse_desc: "Bu mesajı bildirmek ve kötüye kullanımın kriptografik kanıtını sunucuya göndermek istiyor musunuz?",
    report_abuse_title: "Kötüye kullanımı bildir",
    reputation_status: "İtibar Durumu",
    room_chat_start_hint: "Konuşmayı başlatın! Bu grup kanalındaki tüm mesajlar merkezi olmayan kuantum açısından güvenli E2E şifrelidir.",
    room_policy_audit: "Denetim takibi ve anahtar rotasyonu aktif.",
    room_policy_crisis: "Kriz odası",
    room_policy_e2ee: "Sıfır bilgi alanı. E2EE kuantum güvenli.",
    room_policy_title: "Oda kuralları",
    room_policy_zero_knowledge: "Politika",
    room_security_note_desc: "Tüm önemli değişiklikler Anahtar Şeffaflığı aracılığıyla doğrulanır. Özel yedekleme günlükleri için GaiaVault'u kullanın.",
    room_security_note_title: "Sabitlenmiş güvenlik notu",
    save_profile: "Profili kaydet",
    schluessel_entsperrt: "🔑 Anahtarı tekrar kilitle",
    search_gaia_label: "Gaia adresini bulun",
    security_warning_title: "Güvenlik uyarısı",
    select_channel_chat: "Sohbet etmek için sol kenar çubuğundan bir kanal seçin.",
    select_contact_chat: "Kuantum açısından güvenli bir E2E sohbeti başlatmak için sol panelden bir kişi seçin.",
    select_mail_read: "Kuantum açısından güvenli içeriğini okumak veya yeni bir mesaj oluşturmak için listeden bir e-posta seçin.",
    senden: "Göndermek",
    sender_signature: "Gönderenin İmzası",
    server_log: "Sunucu günlüğü:",
    server_received: "Sunucu Alındı",
    session_lock: "Oturum kilidi",
    setup_address_keys: "Adres ve anahtar seti oluştur",
    setup_profile: "Profilde ayarla",
    smtp_inbox_title: "SMTP alımı",
    smtp_legacy_badge: "Eski SMTP / Güvensiz",
    smtp_mode_option: "Eski SMTP köprüsü",
    smtp_security_warning: "Bu e-posta klasik, şifrelenmemiş SMTP protokolü aracılığıyla iletildi. Uçtan uca şifreleme etkin değil.",
    smtp_security_warning_desc: "Bu mesaj GaiaCom güvenlik odasından çıkıyor. SMTP teslimatı, GaiaCom yerel uçtan uca garantisi sağlamaz, TrustMesh garantisi vermez ve ağ geçidinden Godmode garantisi vermez.",
    spam_verdacht: "Spam/şüphe",
    spam_warning_desc: "Bu mesaj şüpheli itibar sinyalleri içeriyor.",
    spam_warning_title: "Spam uyarısı",
    speichern: "Kaydetmek",
    sperren: "Kilitle",
    standard_group_status: "Standart grup sohbeti (E2EE şifreli)",
    status: "durum",
    subject: "İlişkin",
    suchen: "Yeni bir Gaia adresi bulun...",
    tage: "günler",
    time_unknown: "Zaman bilinmiyor",
    transmission_mode: "Aktarım modu",
    trust_age: "Güven yaşı",
    trust_passport_title: "Güven Pasaportu",
    unbestaetigt: "Onaylanmadı",
    unknown_sender: "Bilinmiyor",
    unlock_btn: "Kilidi aç",
    unlock_btn_profile: "Kilidi aç",
    unlock_desc: "Özel anahtar dosyanız şifrelenmiş olarak saklanır. Şifreleme anahtarlarını yalnızca belleğe yüklemek için şifrenizi girin.",
    unlock_logout: "Oturumu kapatın ve yerel anahtarları kapatın",
    unlock_title: "Kimliğin Kilidini Aç",
    untrusted: "Güvenilir değil",
    update_password: "Şifreyi güncelle",
    upload_avatar_btn: "Resim yükle (Temizlenmiş)",
    vault_btn_encrypt: "Kaydı şifrele",
    vault_btn_lock: "Kasayı kilitle",
    vault_btn_unlock: "Kasanın kilidini aç",
    vault_copied_success: "Panoya kopyalandı",
    vault_decrypted_content: "Şifresi çözülmüş içerik",
    vault_desc: "Kurtarma yedeklemeleri, kimlik notları, sunucu erişimi, acil durum iletişim bilgileri, yasal notlar, güvenlik olayları ve özel günlükler için yerel şifreli kasa.",
    vault_empty: "Henüz kaydedilen güvenli kayıt yok.",
    vault_locked_pane_notice: "Kasa kilitli. Lütfen sağdaki kilidi açın.",
    vault_new_record: "Yeni güvenli kayıt",
    vault_pwd_placeholder: "Kasa Şifresini Girin...",
    vault_record_body: "İçeriği kaydet",
    vault_record_body_placeholder: "Şifrelenmiş kayıt içeriğini girin...",
    vault_record_category: "kategori",
    vault_record_title: "Kayıt başlığı",
    vault_record_title_placeholder: "Güvenli kaydın başlığı",
    vault_title: "GaiaVault Güvenli Kayıtları",
    verify_new_fingerprint_hint: "Anahtarı kabul etmeden önce yeni parmak izini kontrol edin.",
    vertrauenswuerdig: "Güvenilir",
    vision_gaia_technology: "VizyonGaiaTeknoloji",
    von: "İtibaren",
    warnung: "uyarı",
    wizard_address: "adres",
    wizard_back: "Geri",
    wizard_check1: "Tohumumu güvenle sakladım.",
    wizard_custom_domain: "Kendi alan adınızı kullanın",
    wizard_desc1: "GaiaCOM özel anahtarları sunucu tarafında saklamaz. Mnemonic Seed olmadan hiç kimse kayıp mesajları kurtaramaz.",
    wizard_desc2: "Adresiniz, şifrelenmiş zarfların yönlendirileceği birleştirilmiş düğümü belirler.",
    wizard_fallback: "Geri dönüş düğümleri",
    wizard_finish: "Kurulumu tamamla",
    wizard_next: "Daha öte",
    wizard_server_domain: "Sunucu düğüm alanı",
    wizard_step1: "1. Yedekleme Tohumu",
    wizard_step2: "2. Adres ve Sunucu",
    wizard_title1: "Kurtarma anahtarını yedekle",
    wizard_title2: "GaiaCOM adresini seçin",
    write_message_placeholder: "Güvenli bir mesaj yazın...",
    you: "Sen",
    zero_knowledge: "Sıfır bilgi",
    zero_knowledge_encryption: "Sıfır bilgi şifrelemesi",
    "Chat fuer alle geleert": "Sohbet tüm katılımcılar için boşaltıldı.",
    "Chat geleert": "Yerel gelen kutunuz için sohbet temizlendi.",
    "Nachricht fuer alle geloescht": "Mesaj tüm katılımcılar için silindi.",
    "Nachricht geloescht": "Sohbet mesajı yerel olarak gelen kutunuzdan kaldırıldı.",
    "anpinnen": "Sabitle",
    "chat_loeschen": "Sohbeti sil",
    "confirm_delete_chat_desc": "Sohbeti silmek ve gizlemek istediğinizden emin misiniz?",
    "confirm_leave_group_desc": "Gerçekten bu gruptan ayrılmak istiyor musun?",
    "entpinnen": "Sabitlemeyi kaldır",
    "group_deleted": "Grup başarıyla silindi.",
    "group_left": "Gruptan başarıyla ayrılın.",
    "gruppe_loeschen": "Grubu sil",
    "loeschen": "Silmek",
    "no_active_chats": "Aktif sohbet yok. Sohbet başlatmak için yukarıda kişileri arayın.",
    "pinned": "Sabitlendi",
    "wizard_check_credentials": "Erişim verilerimin güvende tutulmasından sorumluyum.",
    "wizard_check_is_beta": "GaiaCom'un beta yazılım olduğunu anlıyorum.",
    "wizard_check_no_illegal": "GaiaCom'u yasa dışı amaçlarla kullanmayacağım.",
    "wizard_check_no_uptime": "Kullanılabilirlik garantisinin olmadığını anlıyorum.",
    "wizard_check_smtp_security": "SMTP mesajlarının tam GaiaCom güvenliği sağlamadığını anlıyorum.",
    "wizard_check_terms_read": "Beta Hizmet Koşullarını okudum.",
    "wizard_step_terms": "Kullanım Koşulları",
    "wizard_terms_text": "GaiaCom Kullanım Koşulları ve Beta Test Sözleşmesi (Beta Aşaması)\n\nSağlayıcı: VisionGaiaTechnology (bundan sonra \"Sağlayıcı\" olarak anılacaktır)\nDurum: Herkese açık beta test aşaması\nGeçerlilik: 21 Haziran 2026'dan itibaren\n\n⚠️ŞİMDİDEN EN ÖNEMLİ NOT (LÜTFEN DİKKATLİCE OKUYUNUZ)\nGaiaCom halka açık beta test aşamasındadır. Kapsamlı güvenlik önlemlerine rağmen, yazılımın ve temel altyapının hatasız olması, sürekli kullanılabilirliği veya mutlak güvenliği garanti edilemez. Riski size ait olmak üzere kullanın. Erişim verilerinin (özellikle GaiaVault anahtarlarının) güvenli bir şekilde saklanmasından ve geçerli yasalara uygunluktan kullanıcılar sorumludur.\n\n1. Beta testi aşamasının konusu ve amacı\n1.1. Sağlanma amacı: GaiaCom, kuantum sonrası şifrelemeye (PQC) dayalı yeni bir e-posta ve sohbet hizmetidir. Beta aşamasındaki hüküm yalnızca teknik test, yük simülasyonu, program hatalarını (hataları) bulma ve kullanıcı dostu olma özelliğini optimize etme amaçlıdır.\n1.2. Beta durumu: Kullanıcı, sunulan yazılımın ön sürüm (beta yazılım) olduğunun bilincindedir. Bu henüz teknik olarak tam olarak geliştirilmemiştir, nihai ticari ürünün standardını karşılamamaktadır ve hatalara, veri kaybına, iletim gecikmelerine veya sistem çökmelerine neden olabilir.\n1.3. Devam etme hakkının olmaması: Sağlayıcı, herhangi bir zamanda herhangi bir gerekçe göstermeksizin hizmeti tamamen veya kısmen durdurma, işlevleri değiştirme veya kısıtlama veya bunları geçici veya kalıcı olarak kaldırma hakkına sahiptir.\n\n2. Garantinin Kullanılabilirliği ve Sorumluluk Reddi\n2.1. Kullanılabilirlik garantisi yok: GaiaCom, kullanılabilirlik veya çalışma süresi garantisi olmadan sağlanır. Hizmetin kesintisiz kullanılabilirliği hakkı yoktur.\n2.2. Garantinin hariç tutulması: Yazılım mevcut haliyle (“olduğu gibi”) sağlanır ve kullanılabilirliğe tabidir. Yasaların izin verdiği ölçüde, yazılımdaki maddi ve hukuki kusurlara ilişkin her türlü garanti talebi kapsam dışındadır. Özellikle yazılımın hatasız, kötü amaçlı yazılım içermediğine veya belirli bir amaca uygun olduğuna dair bir garanti yoktur.\n\n3. Risk yönetimi ve kullanıcı yükümlülükleri\n3.1. Kritik verilerin saklanmasının yasaklanması: Kullanıcı, iş açısından kritik, hayati, operasyonel açıdan gerekli veya yasal açıdan özellikle hassas verileri (hasta dosyaları, son derece hassas finansal veriler veya resmi olarak düzenlenmiş sırlar gibi) GaiaCom aracılığıyla münhasıran saklamamayı veya iletmemeyi taahhüt eder. Hizmet, öngörülemeyen arızaların kişisel yaralanma, mal hasarı veya önemli mali kayıpla sonuçlanabileceği altyapı için kullanılamaz.\n3.2. Kendinden sorumlu yedekleme: Kullanıcı, GaiaCom üzerinden aldığı veya gönderdiği, uzun vadede ihtiyaç duyduğu tüm verilerin kendi bağımsız sistemlerine (yedek kopyalar) yedeklenmesinden sorumludur. Sağlayıcı, verilerin sunucularında kalıcı olarak saklanacağını veya geri yüklenebilirliğini garanti etmez.\n\n4. Şifreleme özellikleri ve GaiaVault\n4.1. Kuantum sonrası kriptografi (PQC): GaiaCom, gelecekteki kuantum bilgisayarlardan gelecek saldırılara dayanacak şekilde tasarlanmış, son teknoloji ürünü, geleceğe yönelik şifreleme süreçlerini uygular. Ancak kullanıcı bunun dinamik ve yeni bir bilimsel alan olduğunun bilincindedir. Bilimin ve teknolojinin mevcut durumuna göre mutlak, reddedilemez güvenlik garanti edilemez. \"%100 güvenli\", \"kırılamaz\" veya \"askeri güvenli\" gibi terimler açıkça garanti edilmez.\n4.2. Kurtarma garantisi yoktur (GaiaVault): GaiaCom tutarlı bir sıfır bilgi güvenlik konseptine dayanır. Şifreleme takozları ve erişim verileri yalnızca kullanıcının kontrolünde kalır (GaiaVault aracılığıyla güvenliği sağlanır).\nÖNEMLİ: Kullanıcı parolalarını, parolalarını, özel anahtarlarını veya kurtarma tohumlarını kaybederse sağlayıcının bu verileri yeniden yapılandırma veya sıfırlama konusunda teknik yeteneği yoktur. Bu erişim verilerinin kaybı kaçınılmaz olarak kullanıcı hesabına ve burada şifrelenen tüm verilere geri dönülemez şekilde erişim kaybına yol açacaktır.\n4.3. Henüz tam olarak denetlenmemiş: Yazılım sürekli olarak dahili güvenlik kontrollerine tabi tutulmaktadır, ancak bu beta aşaması sırasında henüz bağımsız test kuruluşları tarafından nihai, kapsamlı bir harici güvenlik denetiminden geçmemiştir.\n\n5. Arayüzler, eski protokoller ve federasyon\n5.1. SMTP Köprüsü Not: GaiaCom, klasik e-posta protokolleri (SMTP gibi) aracılığıyla iletişim kurma olanağı sunar. Kullanıcı, yerel GaiaCom güvenlik alanını terk eden mesajların (örneğin geleneksel bir @gmail.com veya @gmx.de adresine gönderildiğinde) şifrelenmemiş veya üçüncü taraf sunucular aracılığıyla taşındığının bilincindedir. GaiaCom'un uçtan uca güvenlik garantileri, bu tür giden veya dışarıdan gelen eski mesajlar için yalnızca sınırlı bir ölçüde geçerlidir veya hiç geçerli değildir.\n5.2. Federasyon Notu: GaiaCom birleştirilmiş bir ağ üzerinde çalışıyorsa, mesajlar ve veriler üçüncü taraf sunucular üzerinden geçebilir. Mesajların içerikleri uçtan uca şifrelemeyle korunmaya devam ederken, meta veriler (gönderme zamanı, ilgili sunucuların IP adresleri ve alıcı adresleri gibi) bu birleştirilmiş sunucuların operatörleri tarafından teknik olarak görülebilir. Sağlayıcının, birleşik ağdaki üçüncü taraf sunucu operatörlerinin veri koruma uygulamaları üzerinde hiçbir etkisi yoktur.\n\n6. Kabul Edilebilir Kullanımlar ve Yasaklanan Faaliyetler\nKullanıcı, hizmeti uygunsuz veya yasa dışı amaçlarla kullanmamayı taahhüt eder. Özellikle aşağıdakiler yasaktır:\n- Virüs, kötü amaçlı yazılım, kimlik avı içeriği veya diğer kötü amaçlı yazılımları dağıtmak, göndermek veya barındırmak.\n- Hizmeti, hizmet reddi saldırıları (DDoS) veya istenmeyen toplu posta (spam) gerçekleştirmek için kullanmak.\n- Dolandırıcılık yapmak için sistemi kötüye kullanmak.\n- Özellikle çocukların cinsel istismarı (CSAM), terör propagandası, şiddet çağrıları veya suçla ilgili diğer içeriklerin tasvirleri olmak üzere yasa dışı içeriğin dağıtımı veya değişimi.\n\n7. Kötüye kullanım raporlama sistemi\n7.1. Kötüye kullanım içeren davranışların bildirilmesi: Kullanıcılar, kötü amaçlı iletişimleri veya yasa dışı faaliyetleri entegre kötüye kullanım sistemi aracılığıyla bildirme olanağına sahiptir.\n7.2. Raporların işlenmesi: Kötüye kullanıma karşı koruma sağlamak amacıyla, gelen raporlar teknik olarak analiz edilebilir (gizlilik ve şifreleme limitleri korunarak). Bu, bu kullanım koşullarının kanıtlanmış ihlalleri durumunda kullanıcı hesaplarının veya IP adreslerinin geçici veya kalıcı olarak askıya alınmasına yol açabilir.\n\n8. Sorumluluğun Sınırlandırılması\n8.1. Sorumluluk standardı: Beta yazılım ücretsiz olarak sağlanır. Bağış veya kredilere ilişkin yasal kurallara göre, sağlayıcı yalnızca kasıt (kasıtlı zarar) ve ağır ihmalden sorumludur.\n8.2. Veri kaybı sorumluluğunun hariç tutulması: Kaybın kasıtlı olarak veya sağlayıcının ağır ihmali nedeniyle meydana gelmediği ve kullanıcının düzenli yedeklemeler (GaiaCom dışında) yoluyla hasarı hafifletme yükümlülüğünü yerine getirmediği sürece, veri kaybı sorumluluğu hariçtir.\n8.3. Yasal sınırlar: Yukarıdaki sorumluluk sınırlamaları, yaşam, beden veya sağlığa yönelik yaralanmalar veya Ürün Sorumluluğu Yasası kapsamındaki yükümlülükler için geçerli değildir.\n\n9. Açık Kaynak\nBelirli GaiaCom bileşenleri, kitaplıkları veya istemci uygulamaları açık kaynak lisansları (örn. GPL, MIT, Apache) kapsamında lisanslanabilir. Bu bileşenlerin ilgili lisans koşulları, bu kullanım koşullarından etkilenmez ve ilgili kaynak kodu havuzlarında görüntülenebilir.\n\n10. İhracat Kontrolü ve Uyumluluk\nKullanıcı, şifreleme yazılımının sıkı ihracat kontrollerine ve yasal kısıtlamalara tabi olabileceğinin bilincindedir. Kullanıcı, GaiaCom kullanımının ikamet ettiği ülkenin yasalarını, ithalat/ihracat kısıtlamalarını veya kriptografi düzenlemelerini ihlal etmemesini sağlamaktan sorumludur.\n\n11. Veri koruma bildirimi (beta için kısa versiyon)\n11.1. Minimum veri toplama: Beta aşamasının bir parçası olarak, sağlayıcı yalnızca teknik operasyon, sorun giderme ve daha fazla geliştirme için kesinlikle gerekli olan verileri (örn. hata teşhisi için sunucu günlük dosyaları) toplar.\n11.2. İçerik hakkında bilgi yok: Tutarlı sıfır bilgi ve E2E şifrelemesi sayesinde sağlayıcı, GaiaVault'ta saklanan sohbetlerinizin, e-postalarınızın veya anahtarlarınızın içeriğine asla erişemez.\n11.3. Ayrıntılı veri koruma beyanı: Ayrıntılı veri koruma düzenlemeleri ayrı olarak bağlantılıdır ve kayıttan önce kullanıcı tarafından da dikkate alınmalıdır.\n\n12. Son hükümler\n12.1. Uygulanacak kanun: Uluslararası Mal Satışına İlişkin Sözleşmelere İlişkin BM Konvansiyonu hariç, Federal Almanya Cumhuriyeti kanunları geçerlidir.\n12.2. Değişiklik yapma hakkı saklıdır: GaiaCom aktif bir geliştirme aşamasında olduğundan, sağlayıcı bu koşulları geleceğe yönelik olarak herhangi bir zamanda uyarlama hakkını saklı tutar. Güncel sürüm uygulamada mevcuttur.",
    "wizard_terms_title": "GaiaCom Kullanım Koşulları ve Beta Test Sözleşmesi (Beta Aşaması)",
    "node_operator": "Düğüm operatörü",
    "search_channels": "Kanal ara...",
    "senior_reviewer": "Kıdemli İncelemeci",
    "trusted_reviewer": "Güvenilir İnceleyici",
    "active_frequencies": "Aktif frekanslar",
    "connected_rooms": "BAĞLANTILI ALANLAR",
    "dashboard": "Kontrol Paneli",
    "empty_chats": "Aktif sohbet yok.",
    "empty_messages": "Yeni mesaj yok.",
    "encrypted": "Şifreli",
    "gaiacom_uplink": "GAIACOM UPLINK",
    "install_app": "Uygulamayı yükle",
    "install_app_desc": "Hızlı başlangıç ​​ve çevrimdışı mod için",
    "kommandozentrale_alpha": "ALPHA komuta merkezi",
    "network_online": "AĞ: ÇEVRİMİÇİ",
    "new_room": "Yeni alan",
    "no_frequencies_active": "Aktif frekans yok. İletişimi başlatmak için yeni bir oda oluşturun.",
    "no_id": "Kimlik yok",
    "open_chats": "Sohbetleri aç",
    "open_inbox": "Gelen kutusunu aç",
    "primary_identity": "BİRİNCİL KİMLİK",
    "recent_chats": "Yeni sohbetler",
    "recent_messages": "En son haberler",
    "session_encrypted": "Oturum şifrelendi: {name}",
    "session_secure": "DURUM: GÜVENLİ",
    "system_verlassen": "Çıkış sistemi",
    "write_message": "Bir mesaj yaz",
  },
  it: {
    sc_title: "Centro di sicurezza",
    sc_subtitle: "Livello di sicurezza integrato GaiaShield",
    sc_tab_status: "🛡️ Stato protezione",
    sc_tab_events: "📋 Registro di sicurezza",
    sc_tab_node: "⚙️ Sicurezza del nodo",
    sc_loading: "Caricamento dati di sicurezza...",
    sc_status_secured: "Stato del sistema: Account protetto",
    sc_status_warning: "Stato del sistema: Avvisi attivi",
    sc_desc_secured: "Non ci sono avvisi di sicurezza critici attivi. GaiaShield sta monitorando attivamente il tuo account.",
    sc_desc_warning: "Attenzione: ci sono eventi di sicurezza attivi che richiedono la tua attenzione.",
    sc_account_protection: "Protezione account",
    sc_message_protection: "Protezione messaggi",
    sc_audits: "Controlli di sicurezza",
    sc_active: "ATTIVO",
    sc_failed_logins: "Accessi falliti",
    sc_tamper_checks: "Controlli manomissione",
    sc_blocked_replays: "Replay bloccati",
    sc_last_check: "Ultimo controllo",
    sc_just_now: "Proprio ora",
    sc_open_warnings: "Avvisi aperti",
    sc_btn_acknowledge: "Conferma",
    sc_filter_severity: "Gravità",
    sc_filter_category: "Categoria",
    sc_filter_hide_ack: "Nascondi confermati",
    sc_btn_export: "Esporta",
    sc_col_details: "Dettagli",
    sc_col_time: "Ora",
    sc_col_status: "Stato",
    sc_col_action: "Azione",
    sc_no_events: "Nessun evento di sicurezza trovato.",
    sc_node_title: "Console di sicurezza dell'operatore di nodo",
    sc_system_health: "Salute del sistema",
    sc_last_audit: "Ultimo audit",
    sc_packed_logs: "Log compressi",
    sc_unconfirmed_events: "Eventi non confermati",
    sc_operator_action: "Richiesta azione operatore",
    sc_all_ok: "Tutto regolare",
    sc_critical_events: "Eventi critici di sistema",
    ac_title: "Centro di governance e segnalazioni",
    ac_subtitle: "Consenso di governance e abuso di GaiaCom",
    ac_tab_my_reports: "Le mie segnalazioni",
    ac_tab_queue: "Coda di revisione",
    ac_tab_operator: "Operatore di nodo",
    ac_tab_transparency: "Federazione e trasparenza",
    ac_loading: "Caricamento dati...",
    ac_reported_cases: "Casi segnalati",
    ac_no_reports: "Non hai ancora inviato alcuna segnalazione.",
    ac_case_details: "Dettagli del caso",
    ac_appeal_submit: "Invia ricorso",
    ac_appeal_status: "Stato del ricorso",
    ac_appeal_reason: "Motivo del ricorso",
    ac_appeal_statement: "Dichiarazione",
    ac_btn_appeal: "Invia ricorso",
    ac_trusted_reviewer_queue: "Coda dei revisori attendibili",
    ac_case_review: "Esamina il caso",
    ac_review_category: "Categoria consigliata",
    ac_review_severity: "Gravità consigliata",
    ac_review_action: "Azione consigliata",
    ac_review_reason: "Motivazione del revisore",
    ac_btn_submit_review: "Invia revisione",
    ac_node_operator_dashboard: "Cruscotto dell'operatore di nodo",
    ac_apply_action: "Applica azione (Override)",
    ac_target_type: "Tipo di destinazione",
    ac_target_id: "ID di destinazione (GaiaID o ID del canale)",
    ac_suspend: "Sospensione attiva",
    ac_reason: "Motivo ufficiale",
    ac_btn_apply: "Applica misura",
    ac_transparency_title: "Registro del consenso e della trasparenza",
    ac_transparency_desc: "Prove snapshot visibili pubblicamente di tutti i canali e le identità moderati.",
    ac_btn_snapshot: "Crea snapshot di trasparenza",
    search_placeholder: "Cerca email per oggetto, mittente, testo...",
    abuse_center_title: "Centro abusi",
    abbrechen: "Cancellare",
    active_identities: "Identità attive",
    active_identity: "Identità attiva",
    add_btn: "Aggiungere",
    add_contact_title: "Aggiungi contatto",
    admin: "Ammin",
    adressbuch: "directory",
    aktiviert: "Abilitato",
    an: "A",
    anonymous_sender: "Mittente anonimo",
    antworten: "Risposta",
    attachment_gaia_hint: "Gli allegati GaiaCOM rimangono crittografati end-to-end.",
    attachment_smtp_hint: "Il protocollo SMTP legacy blocca gli allegati eseguibili/simili a script e salva le e-mail come non sicure.",
    attachments: "Allegati",
    auffaellig: "Notevole",
    auth_beta_notice: "Fase di beta testing: GaiaCOM è in fase di test attivo. Potrebbero verificarsi degli errori; proteggere i seed importanti ed esaminare attentamente i flussi di lavoro riservati.",
    auth_btn_login: "Carica identità e accedi",
    auth_btn_register: "Registrati e crea criptovaluta",
    auth_copied: "Copiato",
    auth_copy_seed: "Copia il seme",
    auth_generate_seed: "Genera semi",
    auth_headline: "GaiaCOM è il primo protocollo di posta elettronica e sistema di comunicazione quantistico sicuro costruito per l’umanità.",
    auth_kicker: "Comunicazione sicura post-quantistica",
    auth_mnemonic: "Frase mnemonica",
    auth_mnemonic_placeholder: "12 parole separate da spazi...",
    auth_password: "password",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "Le chiavi private non lasciano il tuo dispositivo. Solo i destinatari previsti possono decrittografare il contenuto.",
    auth_proof_gaiadata_desc: "Zero-Knowledge: mantieni il controllo dei tuoi dati. I metadati sono ridotti al minimo e non vengono utilizzati come profilo di testo semplice.",
    auth_proof_gaiadrop_desc: "Persone esterne possono inviare SMS riservati al tuo GaiaID senza un account.",
    auth_proof_gaiaproof_desc: "Le prove di consegna e integrità mostrano che il testo cifrato, il mittente e il timestamp non sono stati manomessi.",
    auth_proof_gaiavault_desc: "Le note private, le note di ripristino e i record di sicurezza rimangono crittografati localmente.",
    auth_proof_hybrid_desc: "Quantum Shield: la crittografia ibrida con ML-KEM e X25519 protegge dagli attacchi odierni e dai rischi store-now-decrypt- later.",
    auth_secure_mail: "Posta federata quantistica sicura",
    auth_subline: "GaiaCOM è un sistema di comunicazione quantistico sicuro per e-mail, chat, stanze di crisi, GaiaDrop e file di sicurezza locali. Le chiavi private rimangono sul tuo dispositivo, i contenuti sono crittografati end-to-end e le prove possono essere esportate senza testo normale.",
    auth_success_btn: "Accedi ora",
    auth_success_text: "Il tuo account GaiaCOM è stato creato. Le chiavi sono state derivate localmente dal tuo seed e non sono state archiviate sul server.",
    auth_success_title: "Registrazione riuscita",
    auth_tab_drop: "Gaia Drop",
    auth_tab_login: "Accesso/Conto",
    auth_toggle_login: "L'account esiste già",
    auth_toggle_register: "Crea nuovo account",
    auth_usecase_text: "Adatto ad avvocati, aziende, autorità, giornalisti, informatori e casi di sicurezza privata.",
    auth_usecase_title: "Costruito per comunicazioni sensibili",
    auth_username: "nome utente",
    auth_username_placeholder: "Inserisci il nome...",
    auth_value_chat: "Chatta E2E",
    auth_value_drop: "Goccia sicura",
    auth_value_mail: "Posta sicura",
    auth_value_rooms: "GaiaRooms",
    bestaetigen: "Confermare",
    bestaetigt: "Confermato",
    bio_status: "Biografia/Stato",
    biography: "biografia",
    change_password_desc: "Modifica la password di accesso lato server. La tua frase di ripristino locale rimane protetta separatamente dalla tua password di vault/sblocco.",
    change_password_menu_desc: "Aggiorna la password di accesso a GaiaCOM.",
    change_password_title: "Cambiare la password",
    channel_id: "ID del canale",
    channel_name_label: "Nome del canale",
    chat_deleted_hidden: "Chat cancellata e nascosta.",
    chat_input_placeholder: "Inserisci un messaggio sicuro...",
    chat_start_hint: "Inizia la conversazione! Tutti i messaggi di chat sono crittografati E2E con sicurezza quantistica.",
    choose_avatar: "Scegli l'avatar",
    ciphertext_hash: "Hash del testo cifrato",
    clear_chat: "Chiacchierata vuota",
    clear_for_everyone: "Vuoto per tutti",
    clear_for_me: "Vuoto solo per me",
    click_to_write_mail: "Fare clic per scrivere un'e-mail",
    click_top_right: "Clicca in alto a destra",
    close: "Vicino",
    code_kopieren: "Copia il codice",
    code_kopieren_success: "Codice copiato",
    confirm_clear_channel_desc: "Vuoi cancellare questo canale dalla tua visualizzazione locale?",
    confirm_clear_channel_title: "Canale vuoto",
    confirm_clear_chat: "Vuoi svuotare questa chat?",
    confirm_clear_chat_desc: "Vuoi svuotare questa chat?",
    confirm_clear_chat_title: "Chiacchierata vuota",
    confirm_clear_everyone: "Vuoi svuotare la chat per entrambi i partner? (OK = Per tutti, Annulla = Solo per me)",
    confirm_delete_everyone: "Vuoi eliminare il messaggio per entrambi i partner? (OK = Per tutti, Annulla = Solo per me)",
    confirm_delete_msg: "Vuoi eliminare questo messaggio?",
    confirm_delete_msg_desc: "Vuoi eliminare questo messaggio di chat?",
    confirm_delete_msg_title: "Elimina messaggio",
    confirm_new_password: "Conferma la nuova password",
    copy: "Copia",
    create_btn: "Creare",
    create_channel_title: "Crea canale",
    create_group_is_crisis: "Contrassegnare come area di crisi",
    create_group_title: "Crea nuovo gruppo",
    crypto_lock_desc: "Controlla quando GaiaCOM rimuove le chiavi crittografiche locali dalla memoria.",
    crypto_lock_menu_desc: "Controlla i timer di ricarica e di inattività.",
    crypto_lock_title: "Blocco crittografico",
    crypto_session_duration: "Sbloccato dopo la ricarica",
    crypto_session_duration_desc: "Mantiene aperta la sessione di crittografia in questa scheda del browser solo per la durata selezionata.",
    cryptographic_fingerprint: "Impronta crittografica",
    current_password: "password attuale",
    data_minimization: "Minimizzazione dei dati",
    decrypt_failed: "Non decifrabile",
    delete: "Eliminare",
    delete_account_button: "Elimina l'account irrevocabilmente",
    delete_account_confirm_label: "Immettere ELIMINA per confermare",
    delete_account_confirmation_error: "Sono necessarie la password e la conferma dell'ELIMINA.",
    delete_account_desc: "Questa modalità distrugge permanentemente il tuo account, le tue identità, le sessioni del dispositivo, i dati GaiaDrop, i metadati di caricamento e i messaggi attribuibili sul lato server.",
    delete_account_done_desc: "Tutti i dati GaiaCOM assegnabili sono stati cancellati.",
    delete_account_done_title: "Conto eliminato",
    delete_account_menu_desc: "Distruggi l'account e i dati associati.",
    delete_account_not_authenticated: "Nessun account attivo.",
    delete_account_title: "Elimina account",
    delete_for_everyone: "Elimina per tutti",
    delete_for_me: "Elimina solo per me",
    device_current: "Questo dispositivo",
    device_last_seen: "Scorso",
    device_logout: "Esci",
    device_sessions_desc: "Controlla le sessioni attive e annulla la registrazione dei dispositivi di cui non ti fidi più.",
    device_sessions_empty: "Nessun dispositivo trovato.",
    device_sessions_menu_desc: "Gestisci e termina le sessioni attive.",
    device_sessions_title: "Dispositivi registrati",
    device_since: "Da",
    display_name: "Nome da visualizzare",
    drop_address_copied: "Indirizzo GaiaDrop copiato.",
    drop_btn_decrypting: "La posta in arrivo viene decrittografata...",
    drop_btn_load: "Carica la posta in arrivo di GaiaDrop",
    drop_delete_desc: "Vuoi davvero eliminare definitivamente questo drop?",
    drop_delete_title: "Elimina GaiaDrop",
    drop_desc: "Canale di solo testo a conoscenza zero per avvisi esterni, divulgazione responsabile e segnalazioni riservate. Le parti esterne possono inviare messaggi senza un account utilizzando il tuo GaiaID.",
    drop_empty: "Nessun messaggio GaiaDrop ancora caricato.",
    drop_id: "ID rilascio:",
    drop_own_address: "Il tuo indirizzo GaiaDrop",
    drop_proof: "A PROVA DI CADUTA",
    drop_title: "Posta in arrivo sicura GaiaDrop",
    dunkler_modus: "Modalità oscura",
    e2e_chat_room_open: "Apri la chat room E2E",
    edit_profile: "Modifica profilo",
    edit_profile_desc: "Personalizza il nome visualizzato, la biografia e l'avatar.",
    einladungscode: "Codice invito",
    enter_fingerprint_chars_confirm: "Immettere i caratteri dell'impronta digitale richiesti per confermare.",
    envelope_hash: "Hash della busta",
    erasability: "Cancellabilità",
    erfolg: "Successo",
    exclude_plaintext: "Esporta senza testo normale",
    export_disclosure: "Esporta caso di sicurezza",
    export_package_desc: "Includere solo testo semplice se questa divulgazione è intesa intenzionalmente.",
    export_package_title: "Pacchetto sicurezza esportazione",
    fehler: "Errore",
    gaiacom_reader: "Lettore GaiaCOM",
    gaiadrop_inbox_title: "Posta in arrivo di GaiaDrop",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM riduce al minimo i metadati, mantiene le chiavi private locali, crittografa i contenuti end-to-end e consente la cancellazione completa dell'account.",
    gdpr_home_title: "Conforme al 100% al GDPR",
    gdpr_reason_delete: "L'eliminazione dell'account rimuove account, identità, sessioni locali e dati assegnabili lato server.",
    gdpr_reason_e2ee: "Il contenuto privato rimane decifrabile solo per i destinatari previsti.",
    gdpr_reason_minimal: "I metadati vengono utilizzati solo per il routing, la consegna e le credenziali di sicurezza.",
    gdpr_reason_zero_knowledge: "Le chiavi private e i dati di ripristino rimangono localmente sotto il controllo dell'utente.",
    gesendet: "Inviato",
    gesperrt_verdaechtig: "Bandito/Sospetto",
    group_delete_desc: "Vuoi davvero eliminare definitivamente questo gruppo? Tutti i canali e i messaggi in questo gruppo verranno eliminati.",
    group_delete_title: "Elimina gruppo",
    group_description: "Descrizione",
    group_icon_label: "Icona/avatar del gruppo",
    group_name: "Nome del gruppo",
    group_settings_avatar: "Avatar",
    group_settings_desc: "Descrizione",
    group_settings_is_crisis: "Contrassegnare come area di crisi",
    group_settings_name: "Nome del gruppo",
    group_settings_title: "Impostazioni del gruppo",
    groups_empty_desc: "Crea uno spazio di lavoro sicuro per progetti, crisi o comunicazioni di gruppo.",
    groups_empty_title: "Nessuna chat di gruppo ancora",
    gruppe_beitreten: "Gruppo unito",
    gruppe_erstellen: "+ Crea gruppo",
    gruppe_verlassen: "Lascia il gruppo",
    gruppen_chats: "Chat di gruppo",
    heller_modus: "Modalità luminosa",
    how_to_receive_drops: "Come ricevo i drop?",
    identitaets_assistent: "Assistente all'identità",
    inactivity_lock_duration: "Blocca quando inattivo",
    inactivity_lock_duration_desc: "Dopo questo periodo senza input, GaiaCOM verrà automaticamente bloccato crittograficamente.",
    inactivity_lock_notice: "GaiaCOM è stata bloccata crittograficamente per inattività.",
    include_plaintext: "Includi testo semplice",
    invite_code_label: "Codice invito",
    join_group_title: "Unisciti al gruppo",
    kanaele: "Canali",
    kanal_erstellen: "+canale",
    kein_chat_ausgewaehlt: "Nessuna chat selezionata",
    kein_kanal_ausgewaehlt: "Nessun canale selezionato",
    keine_gruppe_ausgewaehlt: "Nessun gruppo selezionato",
    keine_mails: "Nessuna email disponibile.",
    key_change_warn_desc: "La chiave pubblica di questo contatto è cambiata. Controlla l'impronta digitale prima di fidarti.",
    key_change_warn_title: "Avviso crittografico",
    key_change_warning_changed: "è cambiato. Questo potrebbe essere il segno di un attacco man-in-the-middle!",
    key_change_warning_msg: "Chiave di identità per il contatto",
    key_transparency: "Trasparenza chiave",
    kopiert: "Copiato",
    kryptographische_schluessel: "Chiavi crittografiche",
    kryptographische_schluessel_desc: "Mostra le chiavi private e la frase seed di backup.",
    laden: "Carico...",
    leeren: "Vuoto",
    loading: "Carico...",
    local_key_vault: "Insieme di credenziali delle chiavi locale",
    local_keys_label: "Chiavi locali",
    lock_on_reload: "Bloccare sempre dopo la ricarica",
    logout: "Esci",
    mail_compose: "Scrivi e-mail",
    mein_profil: "Il mio profilo",
    melden: "Rapporto",
    menu: "menu",
    message: "Notizia",
    message_id: "ID del messaggio",
    message_pin: "Spillo",
    message_pinned_title: "Messaggi fissati",
    message_react: "Reagire",
    message_reply: "Risposta",
    message_replying_to: "Rispondi a",
    message_save: "Salva",
    message_saved: "Salvato",
    message_to_channel: "Messaggio a",
    message_unpin: "Risolvere",
    message_unsave: "Non salvare",
    mitglied: "Membro",
    mitglieder: "membri",
    ml_kem: "ML-KEM",
    neue_mail: "Nuova e-mail",
    never_auto_lock: "Mai automaticamente",
    new_fingerprint: "Nuova impronta digitale",
    new_identity: "Nuova identità",
    new_password: "Nuova password",
    no_description: "Nessuna descrizione",
    no_key_history: "Nessuna cronologia chiave registrata.",
    no_specification: "Non specificato",
    old_fingerprint: "Vecchia impronta digitale",
    open_privacy_imprint: "Stampa aperta e protezione dei dati",
    post_quantum_e2e: "E2E post-quantistico",
    posteingang: "Posta in arrivo",
    powered_by: "Offerto da",
    privacy_imprint_menu_desc: "Mostra GDPR, protezione dei dati e note legali.",
    privacy_imprint_profile_desc: "GaiaCOM elabora i contenuti della comunicazione secondo i principi di minimizzazione dei dati, crittografia end-to-end e controllo della chiave locale.",
    privacy_imprint_title: "Protezione dei dati e note legali",
    profil: "profilo",
    profile_details: "Dettagli del profilo",
    profile_settings_hint: "Le impostazioni del profilo vengono visualizzate nel pannello di destra.",
    profile_unlock_desc: "Per motivi di sicurezza, è necessario reinserire la password per visualizzare le chiavi crittografiche private.",
    proof_hash: "Hash di prova:",
    public_drop_desc: "Secure Drop per informazioni di testo esterne senza un account GaiaCOM.",
    public_drop_message: "Notizia",
    public_drop_message_placeholder: "Inserisci testo riservato...",
    public_drop_send: "Invia GaiaDrop",
    public_drop_sender: "Nota del mittente facoltativa",
    public_drop_sender_placeholder: "Nome, numero di pratica o anonimo",
    public_drop_target: "Obiettivo GaiaID",
    quanten_chat: "Chat quantistica",
    quantum_secure_exchange: "Scambio quantistico sicuro tramite...",
    quantum_secure_net: "Rete sicura quantistica GaiaCOM (Ed25519 e ML-KEM)",
    quantum_shield_desc: "La rete GaiaCOM protegge la tua privacy con un protocollo di crittografia ibrido multistrato protetto dagli attacchi dei futuri computer quantistici.",
    quantum_shield_l1_desc: "Utilizza lo standard FIPS 203 per incapsulare una chiave condivisa simmetrica. Impedisce la registrazione passiva e la successiva decrittografia (\\",
    quantum_shield_l1_title: "1. Protezione post-quantistica (ML-KEM-1024)",
    quantum_shield_l2_desc: "Una classica procedura di scambio chiavi Diffie-Hellman estremamente veloce che funge da ulteriore livello di sicurezza nella procedura ibrida.",
    quantum_shield_l2_title: "2. Crittografia a curva ellittica (X25519)",
    quantum_shield_l3_desc: "Ogni messaggio e ogni busta della Federazione è firmata crittograficamente per verificare inequivocabilmente l'autenticità del mittente.",
    quantum_shield_l3_title: "3. Firme digitali (Ed25519)",
    quantum_shield_l4_desc: "Crittografa il contenuto del messaggio in modo simmetrico e collega strettamente il mittente, il destinatario e i metadati negli Authenticated Additional Data (AAD) per prevenire attacchi di riproduzione.",
    quantum_shield_l4_title: "4. Autenticazione AAD (AES-256-GCM)",
    quantum_shield_status: "Stato dello Scudo Quantico",
    receive_drops_step1: "Condividi il tuo GaiaID (ad esempio utilizzando il pulsante Copia sopra) con fonti esterne.",
    receive_drops_step2: "Questi richiamano la pagina di accesso della tua istanza GaiaCOM e passano alla scheda",
    receive_drops_step3: "e invia il loro messaggio crittografato al tuo indirizzo.",
    receiver_gaia: "Ricevitore GaiaCOM",
    receiver_smtp: "Destinatario SMTP",
    records_stored: "Record salvati",
    refresh: "Aggiornamento",
    report_abuse_desc: "Vuoi segnalare questo messaggio e inviare prove crittografiche di abuso al server?",
    report_abuse_title: "Segnala un abuso",
    reputation_status: "Stato della reputazione",
    room_chat_start_hint: "Inizia la conversazione! Tutti i messaggi in questo canale di gruppo sono crittografati E2E decentralizzati con sicurezza quantistica.",
    room_policy_audit: "Audit trail e rotazione delle chiavi attivi.",
    room_policy_crisis: "Sala crisi",
    room_policy_e2ee: "Spazio a conoscenza zero. E2EE sicuro quantistico.",
    room_policy_title: "Linee guida per la stanza",
    room_policy_zero_knowledge: "Politica",
    room_security_note_desc: "Tutte le modifiche chiave vengono convalidate tramite Key Transparency. Utilizza GaiaVault per i registri di backup privati.",
    room_security_note_title: "Nota di sicurezza appuntata",
    save_profile: "Salva profilo",
    schluessel_entsperrt: "🔑 Blocca nuovamente la chiave",
    search_gaia_label: "Trova l'indirizzo di Gaia",
    security_warning_title: "Avviso di sicurezza",
    select_channel_chat: "Seleziona un canale dalla barra laterale sinistra per chattare.",
    select_contact_chat: "Seleziona un contatto dal pannello di sinistra per avviare una chat E2E quantistica.",
    select_mail_read: "Seleziona un'e-mail dall'elenco per leggerne il contenuto quantistico o creare un nuovo messaggio.",
    senden: "Inviare",
    sender_signature: "Firma del mittente",
    server_log: "Registro del server:",
    server_received: "Server ricevuto",
    session_lock: "Blocco della sessione",
    setup_address_keys: "Creare indirizzo e set di chiavi",
    setup_profile: "Impostato nel profilo",
    smtp_inbox_title: "Ricezione SMTP",
    smtp_legacy_badge: "SMTP legacy/non sicuro",
    smtp_mode_option: "Bridge SMTP precedente",
    smtp_security_warning: "Questa email è stata trasmessa tramite il classico protocollo SMTP non crittografato. Nessuna crittografia end-to-end attiva.",
    smtp_security_warning_desc: "Questo messaggio sta lasciando la stanza di sicurezza di GaiaCom. La consegna SMTP non fornisce la garanzia end-to-end nativa di GaiaCom, nessuna garanzia TrustMesh e nessuna garanzia Godmode dal gateway.",
    spam_verdacht: "Spam/sospetto",
    spam_warning_desc: "Questo messaggio presenta segnali di reputazione sospetti.",
    spam_warning_title: "Avviso di spam",
    speichern: "Salva",
    sperren: "Bloccare",
    standard_group_status: "Chat di gruppo standard (crittografata E2EE)",
    status: "stato",
    subject: "Per quanto riguarda",
    suchen: "Trova un nuovo indirizzo Gaia...",
    tage: "giorni",
    time_unknown: "Orario sconosciuto",
    transmission_mode: "Modalità di trasferimento",
    trust_age: "Età della fiducia",
    trust_passport_title: "Passaporto di fiducia",
    unbestaetigt: "Non confermato",
    unknown_sender: "Sconosciuto",
    unlock_btn: "Sbloccare",
    unlock_btn_profile: "Sbloccare",
    unlock_desc: "Il file della tua chiave privata viene archiviato crittografato. Inserisci la tua password per caricare solo le chiavi crittografiche in memoria.",
    unlock_logout: "Disconnettersi e chiudere le chiavi locali",
    unlock_title: "Sblocca l'identità",
    untrusted: "Non affidabile",
    update_password: "Aggiorna password",
    upload_avatar_btn: "Carica immagine (igienizzata)",
    vault_btn_encrypt: "Crittografare il record",
    vault_btn_lock: "Blocca la cassaforte",
    vault_btn_unlock: "Sblocca la cassaforte",
    vault_copied_success: "Copiato negli appunti",
    vault_decrypted_content: "Contenuto decriptato",
    vault_desc: "Deposito locale crittografato per backup di ripristino, note di identità, accesso al server, contatti di emergenza, note legali, eventi di sicurezza e registri privati.",
    vault_empty: "Nessun record protetto ancora salvato.",
    vault_locked_pane_notice: "La cassaforte è chiusa a chiave. Si prega di sbloccare a destra.",
    vault_new_record: "Nuovo record sicuro",
    vault_pwd_placeholder: "Inserisci la password della cassaforte...",
    vault_record_body: "Registra il contenuto",
    vault_record_body_placeholder: "Inserisci il contenuto del record crittografato...",
    vault_record_category: "categoria",
    vault_record_title: "Titolo del disco",
    vault_record_title_placeholder: "Titolo del record protetto",
    vault_title: "GaiaVault registra in modo sicuro",
    verify_new_fingerprint_hint: "Controllare la nuova impronta digitale prima di accettare la chiave.",
    vertrauenswuerdig: "Affidabile",
    vision_gaia_technology: "VisionGaiaTecnologia",
    von: "Da",
    warnung: "avvertimento",
    wizard_address: "indirizzo",
    wizard_back: "Indietro",
    wizard_check1: "Ho salvato in modo sicuro il mio seme.",
    wizard_custom_domain: "Utilizza il tuo dominio",
    wizard_desc1: "GaiaCOM non memorizza le chiavi private lato server. Senza Mnemonic Seed nessuno può recuperare i messaggi perduti.",
    wizard_desc2: "Il tuo indirizzo determina il nodo federato attraverso il quale vengono instradate le buste crittografate.",
    wizard_fallback: "Nodi di fallback",
    wizard_finish: "Configurazione completa",
    wizard_next: "Ulteriore",
    wizard_server_domain: "Dominio del nodo server",
    wizard_step1: "1. Seme di backup",
    wizard_step2: "2. Indirizzo e server",
    wizard_title1: "Eseguire il backup della chiave di ripristino",
    wizard_title2: "Seleziona l'indirizzo GaiaCOM",
    write_message_placeholder: "Scrivi un messaggio sicuro...",
    you: "Voi",
    zero_knowledge: "Conoscenza zero",
    zero_knowledge_encryption: "Crittografia a conoscenza zero",
    "Chat fuer alle geleert": "La chat è stata svuotata per tutti i partecipanti.",
    "Chat geleert": "La chat è stata cancellata per la tua casella di posta locale.",
    "Nachricht fuer alle geloescht": "Il messaggio è stato eliminato per tutti i partecipanti.",
    "Nachricht geloescht": "Il messaggio di chat è stato rimosso localmente dalla tua casella di posta.",
    "anpinnen": "Spillo",
    "chat_loeschen": "Elimina la chat",
    "confirm_delete_chat_desc": "Sei sicuro di voler eliminare e nascondere la chat?",
    "confirm_leave_group_desc": "Vuoi davvero lasciare questo gruppo?",
    "entpinnen": "Sblocca",
    "group_deleted": "Gruppo eliminato correttamente.",
    "group_left": "Lascia il gruppo con successo.",
    "gruppe_loeschen": "Elimina gruppo",
    "loeschen": "Eliminare",
    "no_active_chats": "Nessuna chat attiva. Cerca i contatti qui sopra per avviare una chat.",
    "pinned": "Appuntato",
    "wizard_check_credentials": "Sono responsabile della sicurezza dei miei dati di accesso.",
    "wizard_check_is_beta": "Capisco che GaiaCom è un software beta.",
    "wizard_check_no_illegal": "Non utilizzerò GaiaCom per scopi illegali.",
    "wizard_check_no_uptime": "Capisco che non vi è alcuna garanzia di disponibilità.",
    "wizard_check_smtp_security": "Comprendo che i messaggi SMTP non forniscono la completa sicurezza GaiaCom.",
    "wizard_check_terms_read": "Ho letto i Termini di servizio della beta.",
    "wizard_step_terms": "Termini di utilizzo",
    "wizard_terms_text": "Termini di utilizzo di GaiaCom e accordo di beta testing (fase beta)\n\nFornitore: VisionGaiaTechnology (di seguito denominato “Fornitore”)\nStato: fase di beta testing pubblica\nValidità: dal 21 giugno 2026\n\n⚠️ LA NOTA PIÙ IMPORTANTE IN ANTICIPO (LEGGERE ATTENTAMENTE)\nGaiaCom è in fase di beta testing pubblico. Nonostante ampie misure di sicurezza, non è possibile garantire l’assenza di errori, la disponibilità continua o l’assoluta sicurezza del software e dell’infrastruttura sottostante. Utilizzare a proprio rischio. Gli utenti sono responsabili della conservazione sicura dei propri dati di accesso (in particolare delle chiavi per GaiaVault) e del rispetto delle leggi applicabili.\n\n1. Oggetto e scopo della fase di beta test\n1.1. Scopo della fornitura: GaiaCom è un nuovo servizio di posta elettronica e chat basato sulla crittografia post-quantistica (PQC). La fornitura durante la fase beta è destinata esclusivamente ai test tecnici, alla simulazione del carico, all'individuazione di errori di programma (bug) e all'ottimizzazione della facilità d'uso.\n1.2. Stato beta: l'utente è consapevole che il software offerto è una versione preliminare (software beta). Questo non è ancora completamente sviluppato dal punto di vista tecnico, non soddisfa lo standard di un prodotto finale e commerciale e può causare errori, perdita di dati, ritardi di trasmissione o arresti anomali del sistema.\n1.3. Nessun diritto alla continuazione: l'offerente ha il diritto in qualsiasi momento di interrompere del tutto o in parte il servizio, di modificare o limitare le funzioni oppure di rimuoverle temporaneamente o permanentemente senza indicarne i motivi.\n\n2. Disponibilità ed esclusione di garanzia\n2.1. Nessuna garanzia di disponibilità: GaiaCom viene fornito senza alcuna garanzia di disponibilità o uptime. Non esiste alcun diritto alla disponibilità ininterrotta del servizio.\n2.2. Esclusione di garanzia: il software viene fornito nel suo stato attuale (\"così com'è\") e soggetto a disponibilità. Nella misura consentita dalla legge, sono escluse eventuali richieste di garanzia per difetti materiali e legali del software. In particolare non vi è alcuna garanzia che il software sia privo di errori, privo di malware o adatto a uno scopo particolare.\n\n3. Gestione del rischio e obblighi degli utenti\n3.1. Divieto di archiviazione di dati critici: l'utente si impegna a non archiviare o trasmettere esclusivamente tramite GaiaCom dati critici per l'azienda, vitali, necessari dal punto di vista operativo o giuridicamente particolarmente sensibili (come cartelle cliniche, dati finanziari altamente sensibili o segreti regolamentati ufficialmente). Il servizio non può essere utilizzato per infrastrutture in cui guasti imprevisti potrebbero causare lesioni personali, danni materiali o perdite finanziarie significative.\n3.2. Backup auto-responsabile: L'utente è responsabile del backup di tutti i dati ricevuti o inviati tramite GaiaCom di cui ha bisogno a lungo termine sui propri sistemi indipendenti (copie di backup). Il fornitore non garantisce la memorizzazione permanente o la ripristinabilità dei dati sui propri server.\n\n4. Funzionalità crittografiche e GaiaVault\n4.1. Crittografia post-quantistica (PQC): GaiaCom implementa processi di crittografia all’avanguardia e orientati al futuro, progettati per resistere agli attacchi dei futuri computer quantistici. Tuttavia, l'utente è consapevole che si tratta di un campo scientifico dinamico e nuovo. Allo stato attuale della scienza e della tecnologia non è possibile garantire una sicurezza assoluta e inconfutabile. Termini come “sicuro al 100%, “non crackabile” o “militare sicuro” non sono espressamente garantiti.\n4.2. Nessuna garanzia di recupero (GaiaVault): GaiaCom si affida a un concetto di sicurezza coerente a conoscenza zero. I cunei di crittografia e i dati di accesso rimangono esclusivamente sotto il controllo dell'utente (protetti tramite GaiaVault).\nIMPORTANTE: se l'utente perde password, passphrase, chiavi private o seed di ripristino, il provider non ha la capacità tecnica di ricostruire o reimpostare questi dati. La perdita di questi dati di accesso porta inevitabilmente alla perdita irrevocabile dell'accesso all'account utente e a tutti i dati in esso crittografati.\n4.3. Non ancora completamente controllato: il software è continuamente sottoposto a controlli di sicurezza interni, ma al momento di questa fase beta non è ancora stato sottoposto a un controllo di sicurezza esterno finale e completo da parte di organismi di test indipendenti.\n\n5. Interfacce, protocolli legacy e federazione\n5.1. SMTP Bridge Nota: GaiaCom offre la possibilità di comunicare tramite i classici protocolli di posta elettronica (come SMTP). L'utente è consapevole che i messaggi che escono dall'area di sicurezza nativa di GaiaCom (ad esempio se inviati ad un indirizzo convenzionale @gmail.com o @gmx.de) vengono trasportati tramite server non crittografati o di terze parti. Le garanzie di sicurezza end-to-end di GaiaCom si applicano solo in misura limitata o non si applicano affatto a tali messaggi legacy in uscita o in entrata esternamente.\n5.2. Nota sulla Federazione: Se GaiaCom opera su una rete federata, i messaggi e i dati potrebbero passare attraverso server di terze parti. Mentre il contenuto dei messaggi rimane protetto mediante crittografia end-to-end, i metadati (come l'ora di invio, gli indirizzi IP dei server coinvolti e gli indirizzi dei destinatari) possono essere tecnicamente visibili agli operatori di questi server federati. Il fornitore non ha alcuna influenza sulle pratiche di protezione dei dati degli operatori di server terzi nella rete federata.\n\n6. Usi accettabili e attività vietate\nL'utente si impegna a non utilizzare il servizio in modo improprio o per scopi illegali. In particolare sono vietati:\n- Distribuire, inviare o ospitare virus, malware, contenuti di phishing o altro software dannoso.\n- Utilizzo del Servizio per condurre attacchi Denial of Service (DDoS) o invii di posta in blocco non richiesti (spam).\n- Abusare del sistema per commettere frodi.\n- Distribuzione o scambio di contenuti illegali, in particolare raffigurazioni di abusi sessuali su minori (CSAM), propaganda terroristica, inviti alla violenza o altri contenuti penalmente rilevanti.\n\n7. Sistema di segnalazione degli abusi\n7.1. Segnalazione di comportamenti abusivi: gli utenti hanno la possibilità di segnalare comunicazioni abusive o attività illegali tramite il sistema di abusi integrato.\n7.2. Elaborazione delle segnalazioni: per garantire la protezione contro gli abusi, le segnalazioni in arrivo possono essere analizzate tecnicamente (mantenendo i limiti di privacy e crittografia). Ciò può portare alla sospensione temporanea o permanente degli account utente o degli indirizzi IP in caso di comprovate violazioni delle presenti condizioni d'uso.\n\n8. Limitazione di responsabilità\n8.1. Standard di responsabilità: il software beta viene fornito gratuitamente. Secondo le norme legali per donazioni o prestiti, l'offerente è quindi responsabile solo in caso di dolo (danno intenzionale) e negligenza grave.\n8.2. Esclusione di responsabilità per la perdita di dati: La responsabilità per la perdita di dati è esclusa a meno che la perdita non sia stata causata intenzionalmente o per negligenza grave da parte del fornitore e l'utente non abbia adempiuto al proprio obbligo di mitigare il danno attraverso backup regolari (al di fuori di GaiaCom).\n8.3. Limiti legali: le limitazioni di responsabilità di cui sopra non si applicano ai danni alla vita, al corpo o alla salute o alla responsabilità ai sensi della legge sulla responsabilità del prodotto.\n\n9. Fonte aperta\nAlcuni componenti, librerie o applicazioni client GaiaCom possono essere concessi in licenza con licenze open source (ad esempio GPL, MIT, Apache). I rispettivi termini di licenza di questi componenti rimangono inalterati dalle presenti condizioni di utilizzo e possono essere visualizzati nei corrispondenti repository del codice sorgente.\n\n10. Controllo e conformità delle esportazioni\nL'utente è consapevole che il software crittografico può essere soggetto a severi controlli sulle esportazioni e restrizioni legali. L'utente è responsabile di garantire che l'utilizzo di GaiaCom non violi le leggi, le restrizioni all'importazione/esportazione o le normative sulla crittografia del rispettivo paese di residenza.\n\n11. Informativa sulla privacy (versione breve per la versione beta)\n11.1. Raccolta minima dei dati: nell'ambito della fase beta il fornitore raccoglie solo i dati assolutamente necessari per il funzionamento tecnico, la risoluzione dei problemi e l'ulteriore sviluppo (ad es. file di registro del server per la diagnosi degli errori).\n11.2. Nessuna visione del contenuto: grazie alla costante crittografia a conoscenza zero e E2E, il provider non ha mai accesso ai contenuti delle tue chat, e-mail o chiavi archiviate in GaiaVault.\n11.3. Dichiarazione dettagliata sulla protezione dei dati: le norme dettagliate sulla protezione dei dati sono collegate separatamente e devono essere prese in considerazione anche dall'utente prima della registrazione.\n\n12. Disposizioni finali\n12.1. Legge applicabile: Si applica la legge della Repubblica Federale Tedesca, ad esclusione della Convenzione delle Nazioni Unite sui contratti di vendita internazionale di merci.\n12.2. Con riserva di modifiche: poiché GaiaCom è in fase di sviluppo attivo, il fornitore si riserva il diritto di adattare queste condizioni in qualsiasi momento con effetto per il futuro. La versione attuale è disponibile nell'applicazione.",
    "wizard_terms_title": "Termini di utilizzo di GaiaCom e accordo di beta testing (fase beta)",
    "node_operator": "Operatore del nodo",
    "search_channels": "Cerca canali...",
    "senior_reviewer": "Revisore senior",
    "trusted_reviewer": "Revisore fidato",
    "active_frequencies": "Frequenze attive",
    "connected_rooms": "SPAZI CONNESSI",
    "dashboard": "Pannello di controllo",
    "empty_chats": "Nessuna chat attiva disponibile.",
    "empty_messages": "Nessun nuovo messaggio disponibile.",
    "encrypted": "Crittografato",
    "gaiacom_uplink": "COLLEGAMENTO GAIACOM",
    "install_app": "Installa l'app",
    "install_app_desc": "Per l'avvio rapido e la modalità offline",
    "kommandozentrale_alpha": "Centro di comando ALFA",
    "network_online": "RETE: ONLINE",
    "new_room": "Nuovo spazio",
    "no_frequencies_active": "Nessuna frequenza attiva. Crea una nuova stanza per iniziare la comunicazione.",
    "no_id": "Nessun documento d'identità",
    "open_chats": "Apri chat",
    "open_inbox": "Apri la posta in arrivo",
    "primary_identity": "IDENTITÀ PRIMARIA",
    "recent_chats": "Nuove chat",
    "recent_messages": "Ultime notizie",
    "session_encrypted": "Sessione crittografata: {nome}",
    "session_secure": "STATO: SICURO",
    "system_verlassen": "Uscire dal sistema",
    "write_message": "Scrivi un messaggio",
  },
  pl: {
    sc_title: "Centrum bezpieczeństwa",
    sc_subtitle: "Zintegrowana warstwa zabezpieczeń GaiaShield",
    sc_tab_status: "🛡️ Stan ochrony",
    sc_tab_events: "📋 Dziennik bezpieczeństwa",
    sc_tab_node: "⚙️ Bezpieczeństwo węzła",
    sc_loading: "Ładowanie danych bezpieczeństwa...",
    sc_status_secured: "Stan systemu: Konto jest chronione",
    sc_status_warning: "Stan systemu: Ostrzeżenia aktywne",
    sc_desc_secured: "Brak aktywnych krytycznych ostrzeżeń. GaiaShield aktywnie monitoruje Twoje konto.",
    sc_desc_warning: "Uwaga: Istnieją aktywne zdarzenia bezpieczeństwa, które wymagają Twojej uwagi.",
    sc_account_protection: "Ochrona konta",
    sc_message_protection: "Ochrona wiadomości",
    sc_audits: "Audyty bezpieczeństwa",
    sc_active: "AKTYWNY",
    sc_failed_logins: "Nieudane logowania",
    sc_tamper_checks: "Kontrole manipulacji",
    sc_blocked_replays: "Zablokowane powtórzenia",
    sc_last_check: "Ostatnia kontrola",
    sc_just_now: "Przed chwilą",
    sc_open_warnings: "Otwarte ostrzeżenia",
    sc_btn_acknowledge: "Potwierdź",
    sc_filter_severity: "Poziom ważności",
    sc_filter_category: "Kategoria",
    sc_filter_hide_ack: "Ukryj potwierdzone",
    sc_btn_export: "Eksportuj",
    sc_col_details: "Szczegóły",
    sc_col_time: "Czas",
    sc_col_status: "Status",
    sc_col_action: "Akcja",
    sc_no_events: "Nie znaleziono zdarzeń bezpieczeństwa.",
    sc_node_title: "Konsola bezpieczeństwa operatora węzła",
    sc_system_health: "Stan systemu",
    sc_last_audit: "Ostatni audyt",
    sc_packed_logs: "Spakowane dzienniki",
    sc_unconfirmed_events: "Niepotwierdzone zdarzenia",
    sc_operator_action: "Wymagana akcja operatora",
    sc_all_ok: "Wszystko w porządku",
    sc_critical_events: "Krytyczne zdarzenia systemowe",
    ac_title: "Centrum zarządzania i zgłoszeń",
    ac_subtitle: "Konsensus dotyczący zarządzania i zgłoszeń GaiaCom",
    ac_tab_my_reports: "Moje zgłoszenia",
    ac_tab_queue: "Kolejka recenzji",
    ac_tab_operator: "Operator węzła",
    ac_tab_transparency: "Federacja i przejrzystość",
    ac_loading: "Ładowanie danych...",
    ac_reported_cases: "Zgłoszone przypadki",
    ac_no_reports: "Nie przesłałeś jeszcze żadnych zgłoszeń.",
    ac_case_details: "Szczegóły sprawy",
    ac_appeal_submit: "Złóż odwołanie",
    ac_appeal_status: "Status odwołania",
    ac_appeal_reason: "Powód odwołania",
    ac_appeal_statement: "Oświadczenie",
    ac_btn_appeal: "Wyślij odwołanie",
    ac_trusted_reviewer_queue: "Kolejka zaufanych recenzentów",
    ac_case_review: "Przejrzyj sprawę",
    ac_review_category: "Zalecana kategoria",
    ac_review_severity: "Zalecany poziom ważności",
    ac_review_action: "Zalecana akcja",
    ac_review_reason: "Powód recenzenta",
    ac_btn_submit_review: "Prześlij recenzję",
    ac_node_operator_dashboard: "Panel operatora węzła",
    ac_apply_action: "Zastosuj akcję (Zastąp)",
    ac_target_type: "Typ docelowy",
    ac_target_id: "Identyfikator docelowy (GaiaID lub ID kanału)",
    ac_suspend: "Zawieszenie aktywne",
    ac_reason: "Oficjalny powód",
    ac_btn_apply: "Egzekwuj akcję",
    ac_transparency_title: "Dziennik konsensusu i przejrzystości",
    ac_transparency_desc: "Publicznie widoczne dowody migawek wszystkich moderowanych kanałów i tożsamości.",
    ac_btn_snapshot: "Utwórz migawkę przejrzystości",
    search_placeholder: "Szukaj wiadomości według tematu, nadawcy, treści...",
    abuse_center_title: "Centrum zgłaszania nadużyć",
    abbrechen: "Anulować",
    active_identities: "Aktywne tożsamości",
    active_identity: "Aktywna tożsamość",
    add_btn: "Dodać",
    add_contact_title: "Dodaj kontakt",
    admin: "Administrator",
    adressbuch: "informator",
    aktiviert: "Włączony",
    an: "Do",
    anonymous_sender: "Anonimowy nadawca",
    antworten: "Odpowiedź",
    attachment_gaia_hint: "Załączniki GaiaCOM pozostają w pełni zaszyfrowane.",
    attachment_smtp_hint: "Starsza wersja protokołu SMTP blokuje załączniki wykonywalne/skryptowe i zapisuje wiadomości e-mail jako niebezpieczne.",
    attachments: "Załączniki",
    auffaellig: "Zauważalny",
    auth_beta_notice: "Faza testów beta: GaiaCOM jest aktywnie testowany. Mogą wystąpić błędy; zabezpiecz ważne nasiona i dokładnie przejrzyj poufne przepływy pracy.",
    auth_btn_login: "Załaduj tożsamość i zaloguj się",
    auth_btn_register: "Zarejestruj się i utwórz kryptowalutę",
    auth_copied: "Skopiowano",
    auth_copy_seed: "Skopiuj ziarno",
    auth_generate_seed: "Generuj nasiona",
    auth_headline: "GaiaCOM to pierwszy kwantowo bezpieczny protokół poczty elektronicznej i system komunikacji zbudowany dla ludzkości.",
    auth_kicker: "Bezpieczna komunikacja post-kwantowa",
    auth_mnemonic: "Wyrażenie mnemoniczne",
    auth_mnemonic_placeholder: "12 słów oddzielonych spacjami...",
    auth_password: "hasło",
    auth_password_placeholder: "•••••••••·•••",
    auth_proof_e2ee_desc: "Klucze prywatne nie opuszczają Twojego urządzenia. Tylko zamierzeni odbiorcy mogą odszyfrować treść.",
    auth_proof_gaiadata_desc: "Wiedza zerowa: zachowujesz kontrolę nad swoimi danymi. Metadane są zminimalizowane i nie są używane jako profil zwykłego tekstu.",
    auth_proof_gaiadrop_desc: "Osoby z zewnątrz mogą wysyłać poufne wiadomości tekstowe na Twój GaiaID bez posiadania konta.",
    auth_proof_gaiaproof_desc: "Dowody dostarczenia i integralności wskazują, że szyfrogram, nadawca i znacznik czasu nie zostały naruszone.",
    auth_proof_gaiavault_desc: "Prywatne notatki, notatki dotyczące odzyskiwania i zapisy bezpieczeństwa pozostają lokalnie zaszyfrowane.",
    auth_proof_hybrid_desc: "Quantum Shield: szyfrowanie hybrydowe za pomocą ML-KEM i X25519 chroni przed współczesnymi atakami i zagrożeniami typu: przechowuj teraz, odszyfruj, później.",
    auth_secure_mail: "Bezpieczna poczta federacyjna Quantum",
    auth_subline: "GaiaCOM to kwantowo bezpieczny system komunikacji dla poczty elektronicznej, czatów, pokojów kryzysowych, GaiaDrop i lokalnych plików bezpieczeństwa. Klucze prywatne pozostają na Twoim urządzeniu, treść jest kompleksowo szyfrowana, a dowody można eksportować bez zwykłego tekstu.",
    auth_success_btn: "Zaloguj się teraz",
    auth_success_text: "Twoje konto GaiaCOM zostało utworzone. Klucze zostały wygenerowane lokalnie z Twojego materiału siewnego i nie były przechowywane na serwerze.",
    auth_success_title: "Rejestracja przebiegła pomyślnie",
    auth_tab_drop: "GaiaDrop",
    auth_tab_login: "Zaloguj się/Konto",
    auth_toggle_login: "Konto już istnieje",
    auth_toggle_register: "Utwórz nowe konto",
    auth_usecase_text: "Odpowiedni dla prawników, firm, władz, dziennikarzy, sygnalistów i prywatnych spraw związanych z bezpieczeństwem.",
    auth_usecase_title: "Zbudowany z myślą o wrażliwej komunikacji",
    auth_username: "nazwa użytkownika",
    auth_username_placeholder: "Wpisz nazwę...",
    auth_value_chat: "Czat E2E",
    auth_value_drop: "Bezpieczny zrzut",
    auth_value_mail: "Bezpieczna poczta",
    auth_value_rooms: "Pokoje Gaia",
    bestaetigen: "Potwierdzać",
    bestaetigt: "Potwierdzony",
    bio_status: "Biografia/status",
    biography: "biografia",
    change_password_desc: "Zmienia hasło logowania po stronie serwera. Twoja lokalna fraza odzyskiwania pozostaje oddzielnie chroniona hasłem skarbca/odblokowania.",
    change_password_menu_desc: "Zaktualizuj hasło logowania GaiaCOM.",
    change_password_title: "Zmień hasło",
    channel_id: "Identyfikator kanału",
    channel_name_label: "Nazwa kanału",
    chat_deleted_hidden: "Czat usunięty i ukryty.",
    chat_input_placeholder: "Wpisz bezpieczną wiadomość...",
    chat_start_hint: "Rozpocznij rozmowę! Wszystkie wiadomości na czacie są szyfrowane kwantowo E2E.",
    choose_avatar: "Wybierz awatar",
    ciphertext_hash: "Hash tekstu zaszyfrowanego",
    clear_chat: "Pusty czat",
    clear_for_everyone: "Puste dla wszystkich",
    clear_for_me: "Puste, tylko dla mnie",
    click_to_write_mail: "Kliknij, aby napisać e-mail",
    click_top_right: "Kliknij w prawym górnym rogu",
    close: "Zamknąć",
    code_kopieren: "Skopiuj kod",
    code_kopieren_success: "Kod skopiowany",
    confirm_clear_channel_desc: "Czy chcesz usunąć ten kanał z widoku lokalnego?",
    confirm_clear_channel_title: "Pusty kanał",
    confirm_clear_chat: "Czy chcesz opróżnić ten czat?",
    confirm_clear_chat_desc: "Czy chcesz opróżnić ten czat?",
    confirm_clear_chat_title: "Pusty czat",
    confirm_clear_everyone: "Czy chcesz opróżnić czat dla obu partnerów? (OK = dla wszystkich, Anuluj = tylko dla mnie)",
    confirm_delete_everyone: "Czy chcesz usunąć wiadomość dla obu partnerów? (OK = dla wszystkich, Anuluj = tylko dla mnie)",
    confirm_delete_msg: "Czy chcesz usunąć tę wiadomość?",
    confirm_delete_msg_desc: "Czy chcesz usunąć tę wiadomość na czacie?",
    confirm_delete_msg_title: "Usuń wiadomość",
    confirm_new_password: "Potwierdź nowe hasło",
    copy: "Kopia",
    create_btn: "Tworzyć",
    create_channel_title: "Utwórz kanał",
    create_group_is_crisis: "Oznacz jako obszar kryzysowy",
    create_group_title: "Utwórz nową grupę",
    crypto_lock_desc: "Kontroluje, kiedy GaiaCOM usuwa lokalne klucze kryptograficzne z pamięci.",
    crypto_lock_menu_desc: "Kontroluj liczniki przeładowania i braku aktywności.",
    crypto_lock_title: "Zamek kryptograficzny",
    crypto_session_duration: "Odblokowane po przeładowaniu",
    crypto_session_duration_desc: "Utrzymuje sesję kryptograficzną otwartą w tej karcie przeglądarki tylko przez wybrany czas.",
    cryptographic_fingerprint: "Kryptograficzny odcisk palca",
    current_password: "Aktualne hasło",
    data_minimization: "Minimalizacja danych",
    decrypt_failed: "Nie do rozszyfrowania",
    delete: "Usuwać",
    delete_account_button: "Usuń konto nieodwołalnie",
    delete_account_confirm_label: "Wpisz USUŃ, aby potwierdzić",
    delete_account_confirmation_error: "Wymagane jest hasło i potwierdzenie USUŃ.",
    delete_account_desc: "Ten tryb trwale niszczy Twoje konto, tożsamość, sesje urządzeń, dane GaiaDrop, przesłane metadane i wiadomości przypisane po stronie serwera.",
    delete_account_done_desc: "Wszystkie możliwe do przypisania dane GaiaCOM zostały usunięte.",
    delete_account_done_title: "Konto usunięte",
    delete_account_menu_desc: "Zniszcz konto i powiązane dane.",
    delete_account_not_authenticated: "Brak aktywnego konta.",
    delete_account_title: "Usuń konto",
    delete_for_everyone: "Usuń dla wszystkich",
    delete_for_me: "Usuń tylko dla mnie",
    device_current: "To urządzenie",
    device_last_seen: "Ostatni",
    device_logout: "Wyloguj się",
    device_sessions_desc: "Sprawdź aktywne sesje i wyrejestruj urządzenia, którym już nie ufasz.",
    device_sessions_empty: "Nie znaleziono żadnych urządzeń.",
    device_sessions_menu_desc: "Zarządzaj i kończ aktywne sesje.",
    device_sessions_title: "Zarejestrowane urządzenia",
    device_since: "Od",
    display_name: "Nazwa wyświetlana",
    drop_address_copied: "Skopiowano adres GaiaDrop.",
    drop_btn_decrypting: "Trwa odszyfrowywanie skrzynki odbiorczej...",
    drop_btn_load: "Załaduj skrzynkę odbiorczą GaiaDrop",
    drop_delete_desc: "Czy na pewno chcesz trwale usunąć tę kroplę?",
    drop_delete_title: "Usuń GaiaDrop",
    drop_desc: "Kanał zrzutu wiedzy o zerowej wiedzy składający się wyłącznie z tekstu, umożliwiający przesyłanie powiadomień zewnętrznych, odpowiedzialnego ujawniania informacji i poufnych raportów. Strony zewnętrzne mogą wysyłać wiadomości bez konta, korzystając z Twojego GaiaID.",
    drop_empty: "Nie załadowano jeszcze żadnych wiadomości GaiaDrop.",
    drop_id: "Identyfikator upuszczenia:",
    drop_own_address: "Twój adres GaiaDrop",
    drop_proof: "Odporność na upadki",
    drop_title: "Bezpieczna skrzynka odbiorcza GaiaDrop",
    dunkler_modus: "Tryb ciemny",
    e2e_chat_room_open: "Otwórz pokój rozmów E2E",
    edit_profile: "Edytuj profil",
    edit_profile_desc: "Dostosuj nazwę wyświetlaną, biografię i awatar.",
    einladungscode: "Kod zaproszenia",
    enter_fingerprint_chars_confirm: "Wprowadź żądane znaki odcisków palców, aby potwierdzić.",
    envelope_hash: "Hash koperty",
    erasability: "Wymazywalność",
    erfolg: "Sukces",
    exclude_plaintext: "Eksportuj bez zwykłego tekstu",
    export_disclosure: "Eksportuj obudowę zabezpieczającą",
    export_package_desc: "Dołącz zwykły tekst tylko wtedy, gdy ujawnienie jest zamierzone.",
    export_package_title: "Eksportuj pakiet zabezpieczeń",
    fehler: "Błąd",
    gaiacom_reader: "Czytnik GaiaCOM",
    gaiadrop_inbox_title: "Skrzynka odbiorcza GaiaDrop",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM minimalizuje metadane, przechowuje klucze prywatne lokalnie, szyfruje zawartość od początku do końca i umożliwia całkowite usunięcie konta.",
    gdpr_home_title: "100% zgodności z RODO",
    gdpr_reason_delete: "Usunięcie konta powoduje usunięcie konta, tożsamości, sesji lokalnych i danych, które można przypisać po stronie serwera.",
    gdpr_reason_e2ee: "Treści prywatne można odszyfrować tylko dla zamierzonych odbiorców.",
    gdpr_reason_minimal: "Metadane są wykorzystywane wyłącznie do celów routingu, dostarczania i zabezpieczeń.",
    gdpr_reason_zero_knowledge: "Klucze prywatne i dane odzyskiwania pozostają lokalnie pod kontrolą użytkownika.",
    gesendet: "Wysłano",
    gesperrt_verdaechtig: "Zablokowany / Podejrzany",
    group_delete_desc: "Czy na pewno chcesz trwale usunąć tę grupę? Wszystkie kanały i wiadomości w tej grupie zostaną usunięte.",
    group_delete_title: "Usuń grupę",
    group_description: "Opis",
    group_icon_label: "Ikona/awatar grupy",
    group_name: "Nazwa grupy",
    group_settings_avatar: "Awatara",
    group_settings_desc: "Opis",
    group_settings_is_crisis: "Oznacz jako obszar kryzysowy",
    group_settings_name: "Nazwa grupy",
    group_settings_title: "Ustawienia grupy",
    groups_empty_desc: "Stwórz bezpieczną przestrzeń do pracy dla projektu, kryzysu lub komunikacji w zespole.",
    groups_empty_title: "Nie ma jeszcze czatów grupowych",
    gruppe_beitreten: "Dołączyła do grupy",
    gruppe_erstellen: "+ Utwórz grupę",
    gruppe_verlassen: "Opuść grupę",
    gruppen_chats: "Czaty grupowe",
    heller_modus: "Tryb jasny",
    how_to_receive_drops: "Jak otrzymać dropy?",
    identitaets_assistent: "Asystent tożsamości",
    inactivity_lock_duration: "Zablokuj, gdy jest nieaktywny",
    inactivity_lock_duration_desc: "Po tym okresie braku danych GaiaCOM zostanie automatycznie zablokowany kryptograficznie.",
    inactivity_lock_notice: "GaiaCOM został kryptograficznie zablokowany z powodu braku aktywności.",
    include_plaintext: "Dołącz zwykły tekst",
    invite_code_label: "Kod zaproszenia",
    join_group_title: "Dołącz do grupy",
    kanaele: "Kanały",
    kanal_erstellen: "+ kanał",
    kein_chat_ausgewaehlt: "Nie wybrano czatu",
    kein_kanal_ausgewaehlt: "Nie wybrano kanału",
    keine_gruppe_ausgewaehlt: "Nie wybrano grupy",
    keine_mails: "Brak dostępnych e-maili.",
    key_change_warn_desc: "Klucz publiczny tego kontaktu uległ zmianie. Zanim zaufasz, sprawdź odcisk palca.",
    key_change_warn_title: "Ostrzeżenie kryptograficzne",
    key_change_warning_changed: "się zmieniło. Może to być oznaką ataku typu man-in-the-middle!",
    key_change_warning_msg: "Klucz tożsamości kontaktu",
    key_transparency: "Kluczowa przejrzystość",
    kopiert: "Skopiowano",
    kryptographische_schluessel: "Klucze kryptograficzne",
    kryptographische_schluessel_desc: "Pokaż klucze prywatne i kopię zapasową frazy początkowej.",
    laden: "Obciążenie...",
    leeren: "Pusty",
    loading: "Obciążenie...",
    local_key_vault: "Lokalny magazyn kluczy",
    local_keys_label: "Klucze lokalne",
    lock_on_reload: "Zawsze blokuj po przeładowaniu",
    logout: "Wyloguj się",
    mail_compose: "Napisz e-mail",
    mein_profil: "Mój profil",
    melden: "Raport",
    menu: "menu",
    message: "Aktualności",
    message_id: "Identyfikator wiadomości",
    message_pin: "Szpilka",
    message_pinned_title: "Przypięte wiadomości",
    message_react: "Zareagować",
    message_reply: "Odpowiedź",
    message_replying_to: "Odpowiedź na",
    message_save: "Ratować",
    message_saved: "Zapisano",
    message_to_channel: "Wiadomość do",
    message_unpin: "Rozwiązywać",
    message_unsave: "Nie oszczędzaj",
    mitglied: "Członek",
    mitglieder: "członkowie",
    ml_kem: "ML-KEM",
    neue_mail: "Nowy e-mail",
    never_auto_lock: "Nigdy automatycznie",
    new_fingerprint: "Nowy odcisk palca",
    new_identity: "Nowa tożsamość",
    new_password: "Nowe hasło",
    no_description: "Brak opisu",
    no_key_history: "Nie zapisano historii kluczy.",
    no_specification: "Nie określono",
    old_fingerprint: "Stary odcisk palca",
    open_privacy_imprint: "Otwarty nadruk i ochrona danych",
    post_quantum_e2e: "Postkwantowa E2E",
    posteingang: "Skrzynka odbiorcza",
    powered_by: "Obsługiwane przez",
    privacy_imprint_menu_desc: "Pokaż RODO, ochronę danych i notę ​​prawną.",
    privacy_imprint_profile_desc: "GaiaCOM przetwarza treści komunikacyjne zgodnie z zasadami minimalizacji danych, kompleksowego szyfrowania i lokalnej kontroli kluczy.",
    privacy_imprint_title: "Ochrona danych i informacja prawna",
    profil: "profil",
    profile_details: "Szczegóły profilu",
    profile_settings_hint: "Ustawienia profilu są wyświetlane w prawym panelu.",
    profile_unlock_desc: "Ze względów bezpieczeństwa musisz ponownie wprowadzić hasło, aby wyświetlić prywatne klucze kryptograficzne.",
    proof_hash: "Hash dowodu:",
    public_drop_desc: "Bezpieczny spadek zewnętrznych informacji tekstowych bez konta GaiaCOM.",
    public_drop_message: "Aktualności",
    public_drop_message_placeholder: "Wpisz poufny tekst...",
    public_drop_send: "Wyślij GaiaDrop",
    public_drop_sender: "Notatka nadawcy opcjonalna",
    public_drop_sender_placeholder: "Imię i nazwisko, numer pliku lub anonimowe",
    public_drop_target: "Docelowy GaiaID",
    quanten_chat: "Kwantowy czat",
    quantum_secure_exchange: "Kwantowo bezpieczna wymiana poprzez...",
    quantum_secure_net: "Bezpieczna sieć GaiaCOM Quantum (Ed25519 i ML-KEM)",
    quantum_shield_desc: "Sieć GaiaCOM chroni Twoją prywatność za pomocą wielowarstwowego, hybrydowego protokołu szyfrowania, który jest chroniony przed atakami ze strony przyszłych komputerów kwantowych.",
    quantum_shield_l1_desc: "Wykorzystuje standard FIPS 203 do hermetyzacji symetrycznego klucza współdzielonego. Zapobiega pasywnemu nagrywaniu i późniejszemu odszyfrowaniu („Przechowuj teraz, odszyfruj później”) przez komputery kwantowe.",
    quantum_shield_l1_title: "1. Ochrona pokwantowa (ML-KEM-1024)",
    quantum_shield_l2_desc: "Klasyczna, niezwykle szybka procedura wymiany kluczy Diffiego-Hellmana, stanowiąca dodatkową warstwę bezpieczeństwa w procedurze hybrydowej.",
    quantum_shield_l2_title: "2. Kryptografia krzywych eliptycznych (X25519)",
    quantum_shield_l3_desc: "Każda wiadomość i każda koperta Federacji jest podpisana kryptograficznie, aby jednoznacznie zweryfikować autentyczność nadawcy.",
    quantum_shield_l3_title: "3. Podpisy cyfrowe (Ed25519)",
    quantum_shield_l4_desc: "Szyfruje treść wiadomości symetrycznie i ściśle wiąże nadawcę, odbiorcę i metadane z uwierzytelnionymi danymi dodatkowymi (AAD), aby zapobiec atakom polegającym na ponownym odtwarzaniu.",
    quantum_shield_l4_title: "4. Uwierzytelnianie AAD (AES-256-GCM)",
    quantum_shield_status: "Stan Tarczy Kwantowej",
    receive_drops_step1: "Udostępnij swój identyfikator GaiaID (np. za pomocą przycisku kopiowania powyżej) źródłom zewnętrznym.",
    receive_drops_step2: "Wywołują one stronę logowania Twojej instancji GaiaCOM i przełączają do zakładki",
    receive_drops_step3: "i wyślij zaszyfrowaną wiadomość na swój adres.",
    receiver_gaia: "Odbiornik GaiaCOM",
    receiver_smtp: "Odbiorca SMTP",
    records_stored: "Zapisy zapisane",
    refresh: "Aktualizacja",
    report_abuse_desc: "Czy chcesz zgłosić tę wiadomość i przesłać na serwer kryptograficzny dowód nadużycia?",
    report_abuse_title: "Zgłoś nadużycie",
    reputation_status: "Stan reputacji",
    room_chat_start_hint: "Rozpocznij rozmowę! Wszystkie wiadomości w tym kanale grupowym są zdecentralizowane, szyfrowane kwantowo E2E.",
    room_policy_audit: "Ścieżka audytu i rotacja kluczy są aktywne.",
    room_policy_crisis: "Pokój kryzysowy",
    room_policy_e2ee: "Przestrzeń wiedzy zerowej. Bezpieczny kwantowo E2EE.",
    room_policy_title: "Wytyczne dotyczące pokoju",
    room_policy_zero_knowledge: "Polityka",
    room_security_note_desc: "Wszystkie kluczowe zmiany są sprawdzane za pomocą funkcji Key Transparency. Użyj GaiaVault do tworzenia prywatnych kopii zapasowych dzienników.",
    room_security_note_title: "Przypięta notatka dotycząca bezpieczeństwa",
    save_profile: "Zapisz profil",
    schluessel_entsperrt: "🔑Zablokuj ponownie klucz",
    search_gaia_label: "Znajdź adres Gai",
    security_warning_title: "Ostrzeżenie dotyczące bezpieczeństwa",
    select_channel_chat: "Wybierz kanał z lewego paska bocznego, aby porozmawiać.",
    select_contact_chat: "Wybierz kontakt z lewego panelu, aby rozpocząć bezpieczny czat E2E.",
    select_mail_read: "Wybierz wiadomość e-mail z listy, aby przeczytać jej zawartość bezpieczną kwantowo lub utwórz nową wiadomość.",
    senden: "Wysłać",
    sender_signature: "Podpis nadawcy",
    server_log: "Dziennik serwera:",
    server_received: "Serwer odebrany",
    session_lock: "Blokada sesji",
    setup_address_keys: "Utwórz adres i zestaw kluczy",
    setup_profile: "Skonfiguruj w profilu",
    smtp_inbox_title: "Odbiór SMTP",
    smtp_legacy_badge: "Starszy SMTP / Niebezpieczny",
    smtp_mode_option: "Starszy most SMTP",
    smtp_security_warning: "Ten e-mail został przesłany klasycznym, niezaszyfrowanym protokołem SMTP. Brak aktywnego szyfrowania typu end-to-end.",
    smtp_security_warning_desc: "Ta wiadomość opuszcza pokój bezpieczeństwa GaiaCom. Dostawa SMTP nie zapewnia kompleksowej gwarancji GaiaCom, gwarancji TrustMesh ani gwarancji Godmode z bramy.",
    spam_verdacht: "Spam/podejrzenie",
    spam_warning_desc: "Ta wiadomość zawiera podejrzane sygnały dotyczące reputacji.",
    spam_warning_title: "Ostrzeżenie o spamie",
    speichern: "Ratować",
    sperren: "Zastosować lokaut",
    standard_group_status: "Standardowy czat grupowy (szyfrowany E2EE)",
    status: "status",
    subject: "W sprawie",
    suchen: "Znajdź nowy adres Gaia...",
    tage: "dni",
    time_unknown: "Czas nieznany",
    transmission_mode: "Tryb transferu",
    trust_age: "Zaufaj wiekowi",
    trust_passport_title: "Zaufaj paszportowi",
    unbestaetigt: "Niepotwierdzone",
    unknown_sender: "Nieznany",
    unlock_btn: "Odblokować",
    unlock_btn_profile: "Odblokować",
    unlock_desc: "Twój plik klucza prywatnego jest przechowywany w postaci zaszyfrowanej. Wprowadź swoje hasło, aby załadować klucze kryptograficzne wyłącznie do pamięci.",
    unlock_logout: "Wyloguj się i zamknij klucze lokalne",
    unlock_title: "Odblokuj tożsamość",
    untrusted: "Nie godny zaufania",
    update_password: "Zaktualizuj hasło",
    upload_avatar_btn: "Prześlij obraz (oczyszczony)",
    vault_btn_encrypt: "Zaszyfruj rekord",
    vault_btn_lock: "Zablokuj sejf",
    vault_btn_unlock: "Odblokuj sejf",
    vault_copied_success: "Skopiowano do schowka",
    vault_decrypted_content: "Odszyfrowana treść",
    vault_desc: "Lokalny zaszyfrowany skarbiec do odzyskiwania kopii zapasowych, notatek identyfikacyjnych, dostępu do serwera, kontaktów awaryjnych, notatek prawnych, zdarzeń związanych z bezpieczeństwem i prywatnych dzienników.",
    vault_empty: "Nie zapisano jeszcze żadnych bezpiecznych rekordów.",
    vault_locked_pane_notice: "Sejf jest zamknięty. Proszę odblokować po prawej stronie.",
    vault_new_record: "Nowy bezpieczny rekord",
    vault_pwd_placeholder: "Wprowadź hasło do skarbca...",
    vault_record_body: "Nagraj zawartość",
    vault_record_body_placeholder: "Wprowadź zaszyfrowaną treść rekordu...",
    vault_record_category: "kategoria",
    vault_record_title: "Tytuł nagrania",
    vault_record_title_placeholder: "Tytuł bezpiecznego zapisu",
    vault_title: "Bezpieczne rekordy GaiaVault",
    verify_new_fingerprint_hint: "Przed przyjęciem klucza sprawdź nowy odcisk palca.",
    vertrauenswuerdig: "Godny zaufania",
    vision_gaia_technology: "WizjaGaiaTechnologia",
    von: "Z",
    warnung: "ostrzeżenie",
    wizard_address: "adres",
    wizard_back: "Z powrotem",
    wizard_check1: "Bezpiecznie uratowałem moje nasienie.",
    wizard_custom_domain: "Użyj własnej domeny",
    wizard_desc1: "GaiaCOM nie przechowuje kluczy prywatnych po stronie serwera. Bez Mnemonic Seed nikt nie będzie w stanie odzyskać utraconych wiadomości.",
    wizard_desc2: "Twój adres określa węzeł stowarzyszony, przez który kierowane są zaszyfrowane koperty.",
    wizard_fallback: "Węzły rezerwowe",
    wizard_finish: "Zakończ konfigurację",
    wizard_next: "Dalej",
    wizard_server_domain: "Domena węzła serwera",
    wizard_step1: "1. Zapasowe ziarno",
    wizard_step2: "2. Adres i serwer",
    wizard_title1: "Utwórz kopię zapasową klucza odzyskiwania",
    wizard_title2: "Wybierz adres GaiaCOM",
    write_message_placeholder: "Napisz bezpieczną wiadomość...",
    you: "Ty",
    zero_knowledge: "Zerowa wiedza",
    zero_knowledge_encryption: "Szyfrowanie z wiedzą zerową",
    "Chat fuer alle geleert": "Czat został pusty dla wszystkich uczestników.",
    "Chat geleert": "Czat został wyczyszczony w Twojej lokalnej skrzynce odbiorczej.",
    "Nachricht fuer alle geloescht": "Wiadomość została usunięta w przypadku wszystkich uczestników.",
    "Nachricht geloescht": "Wiadomość czatu została usunięta lokalnie z Twojej skrzynki odbiorczej.",
    "anpinnen": "Szpilka",
    "chat_loeschen": "Usuń czat",
    "confirm_delete_chat_desc": "Czy na pewno chcesz usunąć i ukryć czat?",
    "confirm_leave_group_desc": "Czy na pewno chcesz opuścić tę grupę?",
    "entpinnen": "Odpiąć",
    "group_deleted": "Grupa została pomyślnie usunięta.",
    "group_left": "Opuść grupę pomyślnie.",
    "gruppe_loeschen": "Usuń grupę",
    "loeschen": "Usuwać",
    "no_active_chats": "Brak aktywnych czatów. Wyszukaj kontakty powyżej, aby rozpocząć czat.",
    "pinned": "Przypięty",
    "wizard_check_credentials": "Jestem odpowiedzialny za bezpieczeństwo moich danych dostępowych.",
    "wizard_check_is_beta": "Rozumiem, że GaiaCom jest oprogramowaniem w wersji beta.",
    "wizard_check_no_illegal": "Nie będę używać GaiaCom do celów niezgodnych z prawem.",
    "wizard_check_no_uptime": "Rozumiem, że nie ma gwarancji dostępności.",
    "wizard_check_smtp_security": "Rozumiem, że wiadomości SMTP nie zapewniają pełnego bezpieczeństwa GaiaCom.",
    "wizard_check_terms_read": "Zapoznałem się z Warunkami korzystania z usługi Beta.",
    "wizard_step_terms": "Warunki użytkowania",
    "wizard_terms_text": "Warunki korzystania z GaiaCom i umowa dotycząca testów beta (faza beta)\n\nDostawca: VisionGaiaTechnology (zwany dalej „Dostawcą”)\nStatus: Faza publicznych testów beta\nWażność: od 21 czerwca 2026 r\n\n⚠️ NAJWAŻNIEJSZA UWAGA Z WCZEŚNIEJ (PROSZĘ UWAŻNIE PRZECZYTAĆ)\nGaiaCom jest w fazie publicznych testów beta. Pomimo szeroko zakrojonych środków bezpieczeństwa nie można zagwarantować braku błędów, ciągłej dostępności ani całkowitego bezpieczeństwa oprogramowania i podstawowej infrastruktury. Używaj na własne ryzyko. Użytkownicy są odpowiedzialni za bezpieczne przechowywanie swoich danych dostępowych (w szczególności kluczy do GaiaVault) oraz za zgodność z obowiązującymi przepisami prawa.\n\n1. Przedmiot i cel fazy beta testów\n1.1. Cel świadczenia usługi: GaiaCom to nowatorska usługa poczty elektronicznej i czatu oparta na kryptografii postkwantowej (PQC). Udostępnienie w fazie beta jest przeznaczone wyłącznie do testów technicznych, symulacji obciążenia, wyszukiwania błędów programu (błędów) i optymalizacji przyjazności dla użytkownika.\n1.2. Status Beta: Użytkownik jest świadomy, że oferowane oprogramowanie jest wersją wstępną (oprogramowanie beta). Nie jest to jeszcze w pełni rozwinięte technicznie, nie spełnia standardów produktu końcowego, komercyjnego i może powodować błędy, utratę danych, opóźnienia w transmisji lub awarie systemu.\n1.3. Brak prawa do kontynuacji: Usługodawca ma prawo w dowolnym momencie zaprzestać świadczenia usługi w całości lub w części, zmienić lub ograniczyć funkcje lub usunąć je czasowo lub na stałe bez podania przyczyny.\n\n2. Dostępność i wyłączenie gwarancji\n2.1. Brak gwarancji dostępności: GaiaCom jest dostarczany bez żadnej gwarancji dostępności lub czasu pracy. Nie ma prawa do nieprzerwanej dostępności usługi.\n2.2. Wyłączenie gwarancji: Oprogramowanie jest dostarczane w obecnym stanie („takie, jakie jest”) i zależne od jego dostępności. W zakresie dozwolonym przez prawo wykluczone są wszelkie roszczenia z tytułu rękojmi za wady fizyczne i prawne oprogramowania. W szczególności nie ma gwarancji, że oprogramowanie jest wolne od błędów, szkodliwego oprogramowania lub nadaje się do określonego celu.\n\n3. Zarządzanie ryzykiem i obowiązki użytkowników\n3.1. Zakaz przechowywania danych krytycznych: Użytkownik zobowiązuje się nie przechowywać ani nie przesyłać za pośrednictwem GaiaCom wyłącznie danych o znaczeniu krytycznym dla działalności gospodarczej, istotnych, niezbędnych operacyjnie lub szczególnie wrażliwych z prawnego punktu widzenia (takich jak akta pacjentów, wysoce wrażliwe dane finansowe lub tajemnice urzędowe). Usługa nie może być wykorzystywana w infrastrukturze, w której nieprzewidziane awarie mogłyby skutkować obrażeniami ciała, szkodami w mieniu lub znaczącymi stratami finansowymi.\n3.2. Samodzielna kopia zapasowa: Użytkownik jest odpowiedzialny za tworzenie kopii zapasowych wszystkich danych otrzymanych lub wysłanych za pośrednictwem GaiaCom, których potrzebuje w dłuższej perspektywie, na swoich własnych, niezależnych systemach (kopie zapasowe). Dostawca nie gwarantuje trwałego przechowywania ani możliwości przywracania danych na swoich serwerach.\n\n4. Funkcje kryptograficzne i GaiaVault\n4.1. Kryptografia postkwantowa (PQC): GaiaCom wdraża najnowocześniejsze, przyszłościowe procesy szyfrowania, które mają wytrzymać ataki przyszłych komputerów kwantowych. Użytkownik ma jednak świadomość, że jest to dynamiczna i nowa dziedzina naukowa. Przy obecnym stanie nauki i technologii nie można zagwarantować absolutnego i niezaprzeczalnego bezpieczeństwa. Terminy takie jak „100% bezpieczne”, „nie do złamania” lub „bezpieczne militarnie” nie są wyraźnie gwarantowane.\n4.2. Brak gwarancji odzyskania danych (GaiaVault): GaiaCom opiera się na spójnej koncepcji bezpieczeństwa opartej na wiedzy zerowej. Kliny szyfrujące i dane dostępowe pozostają wyłącznie pod kontrolą użytkownika (zabezpieczone przez GaiaVault).\nWAŻNE: Jeśli użytkownik straci swoje hasła, hasła, klucze prywatne lub nasiona odzyskiwania, dostawca nie ma technicznych możliwości odtworzenia lub zresetowania tych danych. Utrata tych danych dostępowych nieuchronnie prowadzi do nieodwracalnej utraty dostępu do konta użytkownika i wszystkich danych w nim zaszyfrowanych.\n4.3. Jeszcze nie w pełni kontrolowane: oprogramowanie jest stale poddawane wewnętrznym kontrolom bezpieczeństwa, ale w fazie beta nie przeszło jeszcze ostatecznego, kompleksowego zewnętrznego audytu bezpieczeństwa przeprowadzanego przez niezależne instytucje testujące.\n\n5. Interfejsy, starsze protokoły i federacja\n5.1. Most SMTP Uwaga: GaiaCom oferuje możliwość komunikacji za pośrednictwem klasycznych protokołów e-mail (takich jak SMTP). Użytkownik jest świadomy, że wiadomości opuszczające rodzimy obszar bezpieczeństwa GaiaCom (np. wysłane na konwencjonalny adres @gmail.com lub @gmx.de) są przesyłane za pośrednictwem serwerów niezaszyfrowanych lub serwerów stron trzecich. Kompleksowe gwarancje bezpieczeństwa GaiaCom mają zastosowanie jedynie w ograniczonym zakresie lub w ogóle nie dotyczą takich starszych wiadomości wychodzących lub przychodzących z zewnątrz.\n5.2. Uwaga dotycząca federacji: Jeśli GaiaCom działa w sieci stowarzyszonej, wiadomości i dane mogą przechodzić przez serwery stron trzecich. Choć treść wiadomości pozostaje chroniona kompleksowym szyfrowaniem, metadane (takie jak godzina wysłania, adresy IP zaangażowanych serwerów i adresy odbiorców) mogą być technicznie widoczne dla operatorów tych serwerów stowarzyszonych. Dostawca nie ma wpływu na praktyki ochrony danych zewnętrznych operatorów serwerów w sieci stowarzyszonej.\n\n6. Dopuszczalne zastosowania i działania zabronione\nUżytkownik zobowiązuje się nie korzystać z usługi w sposób niewłaściwy lub niezgodny z prawem. W szczególności zabrania się:\n- Dystrybucja, wysyłanie lub hosting wirusów, złośliwego oprogramowania, treści phishingowych lub innego złośliwego oprogramowania.\n- Korzystanie z Usługi w celu przeprowadzania ataków typu „odmowa usługi” (DDoS) lub niechcianej wysyłki masowej (spamu).\n- Nadużywanie systemu w celu popełnienia oszustwa.\n- Dystrybucja lub wymiana nielegalnych treści, w szczególności przedstawiających niegodziwe traktowanie dzieci w celach seksualnych (CSAM), propagandę terrorystyczną, nawoływania do przemocy lub inne treści o charakterze karnym.\n\n7. System zgłaszania nadużyć\n7.1. Zgłaszanie nadużyć: Użytkownicy mają możliwość zgłaszania nadużyć w komunikacji lub nielegalnych działań za pośrednictwem zintegrowanego systemu nadużyć.\n7.2. Przetwarzanie raportów: W celu zapewnienia ochrony przed nadużyciami, przychodzące raporty mogą być analizowane technicznie (przy zachowaniu limitów prywatności i szyfrowania). Może to prowadzić do tymczasowego lub stałego zawieszenia kont użytkowników lub adresów IP w przypadku udowodnionego naruszenia niniejszych warunków użytkowania.\n\n8. Ograniczenie odpowiedzialności\n8.1. Standard odpowiedzialności: Oprogramowanie w wersji beta jest dostarczane bezpłatnie. Zgodnie z przepisami prawnymi dotyczącymi darowizn lub pożyczek usługodawca ponosi zatem odpowiedzialność wyłącznie za działanie umyślne (szkoda umyślna) i rażące niedbalstwo.\n8.2. Wyłączenie odpowiedzialności za utratę danych: Odpowiedzialność za utratę danych jest wykluczona, chyba że utrata została spowodowana umyślnie lub w wyniku rażącego niedbalstwa ze strony dostawcy, a użytkownik wywiązał się ze swojego obowiązku ograniczenia szkód poprzez regularne tworzenie kopii zapasowych (poza GaiaCom).\n8.3. Granice prawne: Powyższe ograniczenia odpowiedzialności nie dotyczą szkód na życiu, ciele i zdrowiu ani odpowiedzialności wynikającej z ustawy o odpowiedzialności za produkt.\n\n9. Otwarte źródło\nNiektóre komponenty, biblioteki lub aplikacje klienckie GaiaCom mogą być objęte licencjami typu open source (np. GPL, MIT, Apache). Niniejsze warunki użytkowania nie mają wpływu na odpowiednie warunki licencji tych komponentów i można je przeglądać w odpowiednich repozytoriach kodu źródłowego.\n\n10. Kontrola eksportu i zgodność\nUżytkownik jest świadomy, że oprogramowanie kryptograficzne może podlegać ścisłej kontroli eksportu i ograniczeniom prawnym. Użytkownik jest odpowiedzialny za zapewnienie, że korzystanie z GaiaCom nie narusza prawa, ograniczeń importowych/eksportowych lub przepisów kryptograficznych obowiązujących w jego kraju zamieszkania.\n\n11. Informacja o ochronie danych (wersja skrócona dla wersji beta)\n11.1. Minimalne gromadzenie danych: W ramach fazy beta dostawca gromadzi wyłącznie dane, które są absolutnie niezbędne do obsługi technicznej, rozwiązywania problemów i dalszego rozwoju (np. pliki dziennika serwera do diagnozowania błędów).\n11.2. Brak wglądu w treść: dzięki spójnej wiedzy zerowej i szyfrowaniu E2E dostawca nigdy nie ma dostępu do treści Twoich czatów, e-maili ani kluczy przechowywanych w GaiaVault.\n11.3. Szczegółowe oświadczenie o ochronie danych: Szczegółowe przepisy dotyczące ochrony danych są powiązane osobno i użytkownik musi je również wziąć pod uwagę przed rejestracją.\n\n12. Postanowienia końcowe\n12.1. Obowiązujące prawo: Obowiązuje prawo Republiki Federalnej Niemiec, z wyłączeniem Konwencji Narodów Zjednoczonych o umowach międzynarodowej sprzedaży towarów.\n12.2. Zastrzega się możliwość zmian: Ponieważ GaiaCom jest w fazie aktywnego rozwoju, dostawca zastrzega sobie prawo do dostosowania niniejszych warunków w dowolnym momencie ze skutkiem na przyszłość. Aktualna wersja dostępna jest w aplikacji.",
    "wizard_terms_title": "Warunki korzystania z GaiaCom i umowa dotycząca testów beta (faza beta)",
    "node_operator": "Operator węzła",
    "search_channels": "Wyszukaj kanały...",
    "senior_reviewer": "Starszy recenzent",
    "trusted_reviewer": "Zaufany recenzent",
    "active_frequencies": "Aktywne częstotliwości",
    "connected_rooms": "POŁĄCZONE PRZESTRZENIE",
    "dashboard": "Panel",
    "empty_chats": "Brak dostępnych aktywnych czatów.",
    "empty_messages": "Brak nowych wiadomości.",
    "encrypted": "Zaszyfrowane",
    "gaiacom_uplink": "ŁĄCZE GAIACOM",
    "install_app": "Zainstaluj aplikację",
    "install_app_desc": "Do szybkiego uruchamiania i trybu offline",
    "kommandozentrale_alpha": "Centrum dowodzenia ALFA",
    "network_online": "SIEĆ: ONLINE",
    "new_room": "Nowa przestrzeń",
    "no_frequencies_active": "Brak aktywnych częstotliwości. Utwórz nowy pokój, aby rozpocząć komunikację.",
    "no_id": "Brak identyfikatora",
    "open_chats": "Otwórz czaty",
    "open_inbox": "Otwórz skrzynkę odbiorczą",
    "primary_identity": "PODSTAWOWA TOŻSAMOŚĆ",
    "recent_chats": "Nowe czaty",
    "recent_messages": "Najnowsze wiadomości",
    "session_encrypted": "Sesja zaszyfrowana: {name}",
    "session_secure": "STATUS: BEZPIECZNY",
    "system_verlassen": "Wyjdź z systemu",
    "write_message": "Napisz wiadomość",
  },
  uk: {
    sc_title: "Центр безпеки",
    sc_subtitle: "Інтегрований рівень безпеки GaiaShield",
    sc_tab_status: "🛡️ Статус захисту",
    sc_tab_events: "📋 Журнал безпеки",
    sc_tab_node: "⚙️ Безпека вузла",
    sc_loading: "Завантаження даних безпеки...",
    sc_status_secured: "Статус системи: Обліковий запис захищено",
    sc_status_warning: "Статус системи: Активні попередження",
    sc_desc_secured: "Немає активних критичних попереджень. GaiaShield активно моніторить ваш обліковий запис.",
    sc_desc_warning: "Увага: Є активні події безпеки, які потребують вашої уваги.",
    sc_account_protection: "Захист облікового запису",
    sc_message_protection: "Захист повідомлень",
    sc_audits: "Аудит безпеки",
    sc_active: "АКТИВНО",
    sc_failed_logins: "Невдалі входи",
    sc_tamper_checks: "Перевірки втручання",
    sc_blocked_replays: "Заблоковані повтори",
    sc_last_check: "Остання перевірка",
    sc_just_now: "Щойно",
    sc_open_warnings: "Відкриті попередження",
    sc_btn_acknowledge: "Підтвердити",
    sc_filter_severity: "Важливість",
    sc_filter_category: "Категорія",
    sc_filter_hide_ack: "Приховати підтверджені",
    sc_btn_export: "Експорт",
    sc_col_details: "Деталі",
    sc_col_time: "Час",
    sc_col_status: "Статус",
    sc_col_action: "Дія",
    sc_no_events: "Подій безпеки не знайдено.",
    sc_node_title: "Консоль безпеки оператора вузла",
    sc_system_health: "Стан системи",
    sc_last_audit: "Останній аудит",
    sc_packed_logs: "Архівовані журнали",
    sc_unconfirmed_events: "Непідтверджені події",
    sc_operator_action: "Потрібна дія оператора",
    sc_all_ok: "Все в порядку",
    sc_critical_events: "Критичні події системи",
    ac_title: "Центр управління та скарг",
    ac_subtitle: "Консенсус управління та скарг GaiaCom",
    ac_tab_my_reports: "Мої скарги",
    ac_tab_queue: "Черга перевірок",
    ac_tab_operator: "Оператор вузла",
    ac_tab_transparency: "Федерація та прозорість",
    ac_loading: "Завантаження даних...",
    ac_reported_cases: "Повідомлені випадки",
    ac_no_reports: "Ви ще не надсилали скарг.",
    ac_case_details: "Деталі справи",
    ac_appeal_submit: "Подати апеляцію",
    ac_appeal_status: "Статус апеляції",
    ac_appeal_reason: "Причина апеляції",
    ac_appeal_statement: "Заява",
    ac_btn_appeal: "Надіслати апеляцію",
    ac_trusted_reviewer_queue: "Черга довірених рецензентів",
    ac_case_review: "Розглянути справу",
    ac_review_category: "Рекомендована категорія",
    ac_review_severity: "Рекомендована важливість",
    ac_review_action: "Рекомендована дія",
    ac_review_reason: "Обґрунтування рецензента",
    ac_btn_submit_review: "Надіслати перевірку",
    ac_node_operator_dashboard: "Панель оператора вузла",
    ac_apply_action: "Застосувати дію (Перевизначення)",
    ac_target_type: "Тип цілі",
    ac_target_id: "ID цілі (GaiaID або ID каналу)",
    ac_suspend: "Призупинення активне",
    ac_reason: "Офіційна причина",
    ac_btn_apply: "Застосувати захід",
    ac_transparency_title: "Журнал консенсусу та прозорості",
    ac_transparency_desc: "Загальнодоступні докази моментальних знімків усіх модерованих каналів та ідентичностей.",
    ac_btn_snapshot: "Створити моментальний знімок прозорості",
    search_placeholder: "Пошук листів за темою, відправником, текстом...",
    abuse_center_title: "Центр скарг",
    abbrechen: "Скасувати",
    active_identities: "Активні ідентичності",
    active_identity: "Активна ідентичність",
    add_btn: "додати",
    add_contact_title: "Додати контакт",
    admin: "адмін",
    adressbuch: "каталог",
    aktiviert: "Увімкнено",
    an: "до",
    anonymous_sender: "Анонімний відправник",
    antworten: "Відповідь",
    attachment_gaia_hint: "Вкладення GaiaCOM залишаються в наскрізному шифруванні.",
    attachment_smtp_hint: "Застарілий SMTP блокує виконувані файли/вкладення, схожі на сценарії, і зберігає електронні листи як незахищені.",
    attachments: "Додатки",
    auffaellig: "Помітно",
    auth_beta_notice: "Стадія бета-тестування: GaiaCOM активно тестується. Можуть виникати помилки; захистити важливі вихідні дані та ретельно перевірити конфіденційні робочі процеси.",
    auth_btn_login: "Завантажте ідентифікатор і увійдіть",
    auth_btn_register: "Зареєструйтеся та створіть криптовалюту",
    auth_copied: "Скопійовано",
    auth_copy_seed: "Копіювати насіння",
    auth_generate_seed: "Генерувати насіння",
    auth_headline: "GaiaCOM — це перший квантово безпечний протокол електронної пошти та система зв’язку, створена для людства.",
    auth_kicker: "Постквантовий безпечний зв'язок",
    auth_mnemonic: "Мнемонічна фраза",
    auth_mnemonic_placeholder: "12 слів, розділених пробілами...",
    auth_password: "пароль",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "Приватні ключі не залишають ваш пристрій. Лише цільові одержувачі можуть розшифрувати вміст.",
    auth_proof_gaiadata_desc: "Нульовий рівень знань: Ви продовжуєте контролювати свої дані. Метадані зведені до мінімуму та не використовуються як простий текстовий профіль.",
    auth_proof_gaiadrop_desc: "Зовнішні люди можуть надсилати конфіденційні текстові повідомлення на ваш GaiaID без облікового запису.",
    auth_proof_gaiaproof_desc: "Докази доставки та цілісності показують, що зашифрований текст, відправник і позначка часу не були підроблені.",
    auth_proof_gaiavault_desc: "Особисті нотатки, нотатки щодо відновлення та записи безпеки залишаються локально зашифрованими.",
    auth_proof_hybrid_desc: "Quantum Shield: гібридне шифрування з ML-KEM і X25519 захищає від сучасних атак і ризиків зберігання, розшифрування й пізніше.",
    auth_secure_mail: "Безпечна Quantum Federated Mail",
    auth_subline: "GaiaCOM — це квантова захищена комунікаційна система для електронної пошти, чату, кризових кімнат, GaiaDrop і локальних файлів безпеки. Приватні ключі залишаються на вашому пристрої, вміст наскрізно шифрується, а докази можна експортувати без звичайного тексту.",
    auth_success_btn: "Увійдіть зараз",
    auth_success_text: "Ваш обліковий запис GaiaCOM створено. Ключі були отримані локально з вашого початкового коду і не зберігалися на сервері.",
    auth_success_title: "Реєстрація успішна",
    auth_tab_drop: "GaiaDrop",
    auth_tab_login: "Логін/Обліковий запис",
    auth_toggle_login: "Обліковий запис уже існує",
    auth_toggle_register: "Створити новий акаунт",
    auth_usecase_text: "Підходить для юристів, компаній, органів влади, журналістів, інформаторів і приватних охоронців.",
    auth_usecase_title: "Створено для чутливого спілкування",
    auth_username: "ім'я користувача",
    auth_username_placeholder: "Введіть ім'я...",
    auth_value_chat: "Чат E2E",
    auth_value_drop: "Безпечне падіння",
    auth_value_mail: "Безпечна пошта",
    auth_value_rooms: "GaiaRooms",
    bestaetigen: "Підтвердити",
    bestaetigt: "Підтверджено",
    bio_status: "Біографія/Статус",
    biography: "біографія",
    change_password_desc: "Змінює ваш пароль для входу на стороні сервера. Ваша локальна фраза відновлення залишається окремо захищеною вашим паролем сховища/розблокування.",
    change_password_menu_desc: "Оновіть пароль для входу в GaiaCOM.",
    change_password_title: "Змінити пароль",
    channel_id: "ID каналу",
    channel_name_label: "Назва каналу",
    chat_deleted_hidden: "Чат видалено та приховано.",
    chat_input_placeholder: "Введіть безпечне повідомлення...",
    chat_start_hint: "Почніть розмову! Усі повідомлення чату шифруються квантово безпечно E2E.",
    choose_avatar: "Виберіть аватар",
    ciphertext_hash: "Хеш зашифрованого тексту",
    clear_chat: "Порожній чат",
    clear_for_everyone: "Пусто для всіх",
    clear_for_me: "Порожній лише для мене",
    click_to_write_mail: "Натисніть, щоб написати електронний лист",
    click_top_right: "Натисніть у верхньому правому куті",
    close: "Закрити",
    code_kopieren: "Скопіюйте код",
    code_kopieren_success: "Код скопійовано",
    confirm_clear_channel_desc: "Ви хочете очистити цей канал від локального перегляду?",
    confirm_clear_channel_title: "Порожній канал",
    confirm_clear_chat: "Ви хочете очистити цей чат?",
    confirm_clear_chat_desc: "Ви хочете очистити цей чат?",
    confirm_clear_chat_title: "Порожній чат",
    confirm_clear_everyone: "Ви хочете очистити чат для обох партнерів? (OK = Для всіх, Скасувати = Тільки для мене)",
    confirm_delete_everyone: "Ви бажаєте видалити повідомлення для обох партнерів? (OK = Для всіх, Скасувати = Тільки для мене)",
    confirm_delete_msg: "Ви бажаєте видалити це повідомлення?",
    confirm_delete_msg_desc: "Ви бажаєте видалити це повідомлення чату?",
    confirm_delete_msg_title: "Видалити повідомлення",
    confirm_new_password: "Підтвердьте новий пароль",
    copy: "Копія",
    create_btn: "Створити",
    create_channel_title: "Створити канал",
    create_group_is_crisis: "Позначити як кризову зону",
    create_group_title: "Створити нову групу",
    crypto_lock_desc: "Контролює, коли GaiaCOM видаляє локальні криптографічні ключі з пам’яті.",
    crypto_lock_menu_desc: "Керуйте таймерами перезавантаження та неактивності.",
    crypto_lock_title: "Криптографічний замок",
    crypto_session_duration: "Розблоковано після перезавантаження",
    crypto_session_duration_desc: "Тримає крипто-сеанс відкритим лише на цій вкладці браузера протягом вибраного періоду.",
    cryptographic_fingerprint: "Криптографічний відбиток",
    current_password: "Поточний пароль",
    data_minimization: "Мінімізація даних",
    decrypt_failed: "Не розшифровується",
    delete: "Видалити",
    delete_account_button: "Безповоротно видалити обліковий запис",
    delete_account_confirm_label: "Введіть DELETE для підтвердження",
    delete_account_confirmation_error: "Необхідні пароль і підтвердження DELETE.",
    delete_account_desc: "Цей режим назавжди знищує ваш обліковий запис, ідентифікаційні дані, сеанси пристрою, дані GaiaDrop, метадані завантаження та пов’язані з сервером повідомлення.",
    delete_account_done_desc: "Усі дані GaiaCOM, які можна призначити, видалено.",
    delete_account_done_title: "Обліковий запис видалено",
    delete_account_menu_desc: "Знищити обліковий запис і пов’язані з ним дані.",
    delete_account_not_authenticated: "Немає активного облікового запису.",
    delete_account_title: "Видалити акаунт",
    delete_for_everyone: "Видалити для всіх",
    delete_for_me: "Видалити тільки для мене",
    device_current: "Цей пристрій",
    device_last_seen: "Останній",
    device_logout: "Вийти",
    device_sessions_desc: "Перевірте активні сесії та скасуйте реєстрацію пристроїв, яким більше не довіряєте.",
    device_sessions_empty: "Пристроїв не знайдено.",
    device_sessions_menu_desc: "Керуйте та завершуйте активні сеанси.",
    device_sessions_title: "Зареєстровані пристрої",
    device_since: "Оскільки",
    display_name: "Відображуване ім'я",
    drop_address_copied: "Адресу GaiaDrop скопійовано.",
    drop_btn_decrypting: "Вхідні розшифровуються...",
    drop_btn_load: "Завантажте папку \\",
    drop_delete_desc: "Ви справді бажаєте остаточно видалити цю крапку?",
    drop_delete_title: "Видалити GaiaDrop",
    drop_desc: "Лише текстовий канал із нульовим знанням для зовнішніх повідомлень, відповідального розкриття та конфіденційних звітів. Зовнішні сторони можуть надсилати повідомлення без облікового запису за допомогою вашого GaiaID.",
    drop_empty: "Ще не завантажено жодного повідомлення GaiaDrop.",
    drop_id: "ID падіння:",
    drop_own_address: "Ваша адреса GaiaDrop",
    drop_proof: "ЗАХИСТ ДО ПАДІННЯ",
    drop_title: "GaiaDrop Secure Inbox",
    dunkler_modus: "Темний режим",
    e2e_chat_room_open: "Відкрийте чат E2E",
    edit_profile: "Редагувати профіль",
    edit_profile_desc: "Налаштуйте ім'я, біографію та аватар.",
    einladungscode: "Код запрошення",
    enter_fingerprint_chars_confirm: "Для підтвердження введіть потрібні символи відбитків пальців.",
    envelope_hash: "Хеш конверта",
    erasability: "Стираемість",
    erfolg: "Успіх",
    exclude_plaintext: "Експорт без звичайного тексту",
    export_disclosure: "Експортний футляр безпеки",
    export_package_desc: "Включайте звичайний текст, лише якщо таке розголошення є навмисним.",
    export_package_title: "Експорт пакета безпеки",
    fehler: "помилка",
    gaiacom_reader: "Читач GaiaCOM",
    gaiadrop_inbox_title: "Вхідні GaiaDrop",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM мінімізує метадані, зберігає приватні ключі локально, наскрізно шифрує вміст і дозволяє повністю видалити обліковий запис.",
    gdpr_home_title: "100% сумісність з GDPR",
    gdpr_reason_delete: "Видалення облікового запису видаляє обліковий запис, особисті дані, локальні сеанси та дані, які можна призначити на стороні сервера.",
    gdpr_reason_e2ee: "Приватний вміст залишається розшифрованим лише для призначених одержувачів.",
    gdpr_reason_minimal: "Метадані використовуються лише для маршрутизації, доставки та облікових даних безпеки.",
    gdpr_reason_zero_knowledge: "Приватні ключі та дані відновлення залишаються локально під контролем користувача.",
    gesendet: "Надіслано",
    gesperrt_verdaechtig: "Забанено/підозріло",
    group_delete_desc: "Ви справді бажаєте остаточно видалити цю групу? Усі канали та повідомлення в цій групі буде видалено.",
    group_delete_title: "Видалити групу",
    group_description: "опис",
    group_icon_label: "Значок/аватар групи",
    group_name: "Назва групи",
    group_settings_avatar: "Аватар",
    group_settings_desc: "опис",
    group_settings_is_crisis: "Позначити як кризову зону",
    group_settings_name: "Назва групи",
    group_settings_title: "Налаштування групи",
    groups_empty_desc: "Створіть безпечний робочий простір для проектів, криз або командного спілкування.",
    groups_empty_title: "Групових чатів ще немає",
    gruppe_beitreten: "Приєднався до групи",
    gruppe_erstellen: "+ Створити групу",
    gruppe_verlassen: "Вийти з групи",
    gruppen_chats: "Групові чати",
    heller_modus: "Яскравий режим",
    how_to_receive_drops: "Як отримати краплі?",
    identitaets_assistent: "Помічник ідентифікації",
    inactivity_lock_duration: "Блокувати, коли неактивний",
    inactivity_lock_duration_desc: "Після цього періоду відсутності введення GaiaCOM буде автоматично заблоковано криптографічно.",
    inactivity_lock_notice: "GaiaCOM криптографічно заблоковано через бездіяльність.",
    include_plaintext: "Додайте звичайний текст",
    invite_code_label: "Код запрошення",
    join_group_title: "Приєднатися до групи",
    kanaele: "Канали",
    kanal_erstellen: "+ канал",
    kein_chat_ausgewaehlt: "Чат не вибрано",
    kein_kanal_ausgewaehlt: "Канал не вибрано",
    keine_gruppe_ausgewaehlt: "Не вибрано жодної групи",
    keine_mails: "Немає доступних електронних листів.",
    key_change_warn_desc: "Відкритий ключ цього контакту змінено. Перевірте відбиток пальця, перш ніж довіряти йому.",
    key_change_warn_title: "Криптографічне попередження",
    key_change_warning_changed: "змінився. Це може бути ознакою нападу \\",
    key_change_warning_msg: "Ключ ідентифікації для контакту",
    key_transparency: "Ключова прозорість",
    kopiert: "Скопійовано",
    kryptographische_schluessel: "Криптографічні ключі",
    kryptographische_schluessel_desc: "Показати закриті ключі та резервну початкову фразу.",
    laden: "Завантажити...",
    leeren: "Порожній",
    loading: "Завантажити...",
    local_key_vault: "Місцеве сховище ключів",
    local_keys_label: "Локальні ключі",
    lock_on_reload: "Завжди блокувати після перезавантаження",
    logout: "Вийти",
    mail_compose: "Напишіть електронний лист",
    mein_profil: "Мій профіль",
    melden: "звіт",
    menu: "меню",
    message: "Новини",
    message_id: "ID повідомлення",
    message_pin: "Pin",
    message_pinned_title: "Закріплені повідомлення",
    message_react: "Реагувати",
    message_reply: "Відповідь",
    message_replying_to: "Відповідь на",
    message_save: "зберегти",
    message_saved: "Збережено",
    message_to_channel: "Повідомлення до",
    message_unpin: "Розв'язати",
    message_unsave: "Не економте",
    mitglied: "Член",
    mitglieder: "членів",
    ml_kem: "МЛ-КЕМ",
    neue_mail: "Нова електронна пошта",
    never_auto_lock: "Ніколи автоматично",
    new_fingerprint: "Новий відбиток пальця",
    new_identity: "Нова ідентичність",
    new_password: "Новий пароль",
    no_description: "Без опису",
    no_key_history: "Історія ключів не записана.",
    no_specification: "Не вказано",
    old_fingerprint: "Старий відбиток пальця",
    open_privacy_imprint: "Відкрити вихідні дані та захист даних",
    post_quantum_e2e: "Постквантовий E2E",
    posteingang: "Вхідні",
    powered_by: "На основі",
    privacy_imprint_menu_desc: "Показати GDPR, захист даних і правове повідомлення.",
    privacy_imprint_profile_desc: "GaiaCOM обробляє комунікаційний контент відповідно до принципів мінімізації даних, наскрізного шифрування та контролю локального ключа.",
    privacy_imprint_title: "Захист даних і правове повідомлення",
    profil: "профіль",
    profile_details: "Деталі профілю",
    profile_settings_hint: "Параметри профілю відображаються на правій панелі.",
    profile_unlock_desc: "З міркувань безпеки ви повинні повторно ввести свій пароль, щоб переглянути свої приватні криптографічні ключі.",
    proof_hash: "Доказовий хеш:",
    public_drop_desc: "Secure Drop для зовнішньої текстової інформації без облікового запису GaiaCOM.",
    public_drop_message: "Новини",
    public_drop_message_placeholder: "Введіть конфіденційний текст...",
    public_drop_send: "Надіслати GaiaDrop",
    public_drop_sender: "Примітка відправника необов’язкова",
    public_drop_sender_placeholder: "Ім'я, номер файлу або анонім",
    public_drop_target: "Цільовий GaiaID",
    quanten_chat: "Квантовий чат",
    quantum_secure_exchange: "Квантовий безпечний обмін через...",
    quantum_secure_net: "GaiaCOM Quantum Secure Network (Ed25519 & ML-KEM)",
    quantum_shield_desc: "Мережа GaiaCOM захищає вашу конфіденційність за допомогою багаторівневого гібридного протоколу шифрування, захищеного від атак з квантових комп’ютерів майбутнього.",
    quantum_shield_l1_desc: "Використовує стандарт FIPS 203 для інкапсуляції симетричного спільного ключа. Запобігає пасивному запису та подальшому розшифруванню («Зберігати зараз, розшифрувати пізніше») квантовими комп’ютерами.",
    quantum_shield_l1_title: "1. Постквантовий захист (ML-KEM-1024)",
    quantum_shield_l2_desc: "Класична надзвичайно швидка процедура обміну ключами Діффі-Хеллмана, яка служить додатковим рівнем безпеки в гібридній процедурі.",
    quantum_shield_l2_title: "2. Криптографія еліптичної кривої (X25519)",
    quantum_shield_l3_desc: "Кожне повідомлення та кожен конверт Федерації підписано криптографічно, щоб однозначно перевірити автентичність відправника.",
    quantum_shield_l3_title: "3. Цифрові підписи (Ed25519)",
    quantum_shield_l4_desc: "Шифрує вміст повідомлення симетрично та тісно прив’язує відправника, одержувача та метадані до автентифікованих додаткових даних (AAD), щоб запобігти атакам відтворення.",
    quantum_shield_l4_title: "4. Аутентифікація AAD (AES-256-GCM)",
    quantum_shield_status: "Статус Quantum Shield",
    receive_drops_step1: "Поділіться своїм GaiID (наприклад, за допомогою кнопки копіювання вище) зовнішнім джерелам.",
    receive_drops_step2: "Вони викликають сторінку входу вашого екземпляра GaiaCOM і переходять на вкладку",
    receive_drops_step3: "і відправити зашифроване повідомлення на вашу адресу.",
    receiver_gaia: "Приймач GaiaCOM",
    receiver_smtp: "Одержувач SMTP",
    records_stored: "Записи збережено",
    refresh: "оновлення",
    report_abuse_desc: "Ви бажаєте повідомити про це повідомлення та надіслати на сервер криптографічні докази порушення?",
    report_abuse_title: "Повідомити про порушення",
    reputation_status: "Статус репутації",
    room_chat_start_hint: "Почніть розмову! Усі повідомлення в цьому груповому каналі децентралізовано квантово-безпечно зашифровані E2E.",
    room_policy_audit: "Журнал аудиту та ротація ключів активні.",
    room_policy_crisis: "Кризова кімната",
    room_policy_e2ee: "Простір нульових знань. Квантовий безпечний E2EE.",
    room_policy_title: "Правила кімнати",
    room_policy_zero_knowledge: "політика",
    room_security_note_desc: "Усі ключові зміни перевіряються через Key Transparency. Використовуйте GaiaVault для приватних журналів резервного копіювання.",
    room_security_note_title: "Закріплена примітка безпеки",
    save_profile: "Зберегти профіль",
    schluessel_entsperrt: "🔑 Знову заблокуйте ключ",
    search_gaia_label: "Знайдіть адресу Gaia",
    security_warning_title: "Попередження безпеки",
    select_channel_chat: "Щоб поспілкуватися, виберіть канал на лівій бічній панелі.",
    select_contact_chat: "Виберіть контакт на лівій панелі, щоб розпочати квантово-безпечний чат E2E.",
    select_mail_read: "Виберіть електронний лист зі списку, щоб прочитати його квантово безпечний вміст або створити нове повідомлення.",
    senden: "Надіслати",
    sender_signature: "Підпис відправника",
    server_log: "Журнал сервера:",
    server_received: "Сервер отримано",
    session_lock: "Блокування сесії",
    setup_address_keys: "Створіть адресу та набір ключів",
    setup_profile: "Налаштувати в профілі",
    smtp_inbox_title: "прийом SMTP",
    smtp_legacy_badge: "Застарілий SMTP/небезпечний",
    smtp_mode_option: "Застарілий міст SMTP",
    smtp_security_warning: "Цей електронний лист було передано через класичний незашифрований протокол SMTP. Наскрізне шифрування не активне.",
    smtp_security_warning_desc: "Це повідомлення виходить із кімнати безпеки GaiaCom. Доставка SMTP не надає вбудованої наскрізної гарантії GaiCom, гарантії TrustMesh і Godmode від шлюзу.",
    spam_verdacht: "Спам/підозра",
    spam_warning_desc: "Це повідомлення має підозрілу репутацію.",
    spam_warning_title: "Попередження про спам",
    speichern: "зберегти",
    sperren: "Блокування",
    standard_group_status: "Стандартний груповий чат (зашифрований E2EE)",
    status: "статус",
    subject: "Щодо",
    suchen: "Знайти нову адресу Gaia...",
    tage: "днів",
    time_unknown: "Час невідомий",
    transmission_mode: "Режим передачі",
    trust_age: "Вік довіри",
    trust_passport_title: "Паспорт довіри",
    unbestaetigt: "Непідтверджено",
    unknown_sender: "Невідомий",
    unlock_btn: "Розблокувати",
    unlock_btn_profile: "Розблокувати",
    unlock_desc: "Ваш файл закритого ключа зберігається в зашифрованому вигляді. Введіть свій пароль, щоб завантажити криптографічні ключі лише в пам’ять.",
    unlock_logout: "Вийдіть із системи та закрийте локальні ключі",
    unlock_title: "Розблокувати ідентифікатор",
    untrusted: "Не заслуговує довіри",
    update_password: "Оновити пароль",
    upload_avatar_btn: "Завантажити зображення (дезінфіковане)",
    vault_btn_encrypt: "Зашифрувати запис",
    vault_btn_lock: "Сейф на замок",
    vault_btn_unlock: "Розблокувати сейф",
    vault_copied_success: "Скопійовано в буфер обміну",
    vault_decrypted_content: "Розшифрований вміст",
    vault_desc: "Локальне зашифроване сховище для резервних копій для відновлення, ідентифікаційних нотаток, доступу до сервера, екстрених контактів, юридичних приміток, подій безпеки та особистих журналів.",
    vault_empty: "Захищених записів ще не збережено.",
    vault_locked_pane_notice: "Сейф замкнений. Будь ласка, розблокуйте праворуч.",
    vault_new_record: "Новий безпечний запис",
    vault_pwd_placeholder: "Введіть пароль сховища...",
    vault_record_body: "Запис вмісту",
    vault_record_body_placeholder: "Введіть зашифрований вміст запису...",
    vault_record_category: "категорія",
    vault_record_title: "Назва запису",
    vault_record_title_placeholder: "Назва захищеного запису",
    vault_title: "Захищені записи GaiaVault",
    verify_new_fingerprint_hint: "Перш ніж прийняти ключ, перевірте новий відбиток пальця.",
    vertrauenswuerdig: "Заслуговує довіри",
    vision_gaia_technology: "Технологія VisionGaia",
    von: "Від",
    warnung: "УВАГА",
    wizard_address: "адресу",
    wizard_back: "Назад",
    wizard_check1: "Я безпечно зберіг своє насіння.",
    wizard_custom_domain: "Використовуйте власний домен",
    wizard_desc1: "GaiaCOM не зберігає закриті ключі на стороні сервера. Без Mnemonic Seed ніхто не зможе відновити втрачені повідомлення.",
    wizard_desc2: "Ваша адреса визначає об'єднаний вузол, через який маршрутизуються зашифровані конверти.",
    wizard_fallback: "Резервні вузли",
    wizard_finish: "Повне налаштування",
    wizard_next: "Далі",
    wizard_server_domain: "Домен вузла сервера",
    wizard_step1: "1. Резервне насіння",
    wizard_step2: "2. Адреса та сервер",
    wizard_title1: "Резервне копіювання ключа відновлення",
    wizard_title2: "Виберіть адресу GaiaCOM",
    write_message_placeholder: "Напишіть безпечне повідомлення...",
    you: "Ви",
    zero_knowledge: "Нуль знань",
    zero_knowledge_encryption: "Шифрування з нульовим знанням",
    "Chat fuer alle geleert": "Чат порожній для всіх учасників.",
    "Chat geleert": "Чат очищено для вашої локальної папки \"Вхідні\".",
    "Nachricht fuer alle geloescht": "Повідомлення видалено для всіх учасників.",
    "Nachricht geloescht": "Повідомлення чату було видалено локально з вашої папки \"Вхідні\".",
    "anpinnen": "Pin",
    "chat_loeschen": "Видалити чат",
    "confirm_delete_chat_desc": "Ви впевнені, що хочете видалити та приховати чат?",
    "confirm_leave_group_desc": "Ви дійсно хочете залишити цю групу?",
    "entpinnen": "Відкріпити",
    "group_deleted": "Групу успішно видалено.",
    "group_left": "Успішно покинути групу.",
    "gruppe_loeschen": "Видалити групу",
    "loeschen": "Видалити",
    "no_active_chats": "Немає активних чатів. Знайдіть контакти вище, щоб розпочати чат.",
    "pinned": "Закріплено",
    "wizard_check_credentials": "Я відповідаю за безпеку своїх даних доступу.",
    "wizard_check_is_beta": "Я розумію, що GaiaCom є бета-версією програмного забезпечення.",
    "wizard_check_no_illegal": "Я не використовуватиму GaiaCom у протиправних цілях.",
    "wizard_check_no_uptime": "Я розумію, що немає гарантії наявності.",
    "wizard_check_smtp_security": "Я розумію, що повідомлення SMTP не забезпечують повну безпеку GaiaCom.",
    "wizard_check_terms_read": "Я прочитав бета-версію Умов використання.",
    "wizard_step_terms": "Умови використання",
    "wizard_terms_text": "Умови використання та бета-тестування GaiaCom (бета-фаза)\n\nПостачальник: VisionGaiaTechnology (надалі «Постачальник»)\nСтатус: публічна фаза бета-тестування\nТермін дії: з 21 червня 2026 року\n\n⚠️ НАЙВАЖЛИВІШЕ ПРИМІТКА ПОПЕРЕДНІЙ (БУДЬ ЛАСКА, ПРОЧИТАЙТЕ УВАЖНО)\nGaiaCom знаходиться на етапі публічного бета-тестування. Незважаючи на широкі заходи безпеки, не можна гарантувати відсутність помилок, постійну доступність або абсолютну безпеку програмного забезпечення та базової інфраструктури. Використовуйте на свій страх і ризик. Користувачі несуть відповідальність за безпечне зберігання своїх даних доступу (особливо ключів для GaiaVault) і за дотримання чинного законодавства.\n\n1. Предмет і мета етапу бета-тестування\n1.1. Мета надання: GaiaCom — це новий сервіс електронної пошти та чату, заснований на постквантовій криптографії (PQC). Положення під час бета-фази призначене виключно для технічного тестування, моделювання навантаження, пошуку програмних помилок (багів) і оптимізації зручності для користувача.\n1.2. Бета-статус: користувач усвідомлює, що запропоноване програмне забезпечення є попередньою версією (бета-версія програмного забезпечення). Це ще не повністю технічно розроблено, не відповідає стандартам кінцевого комерційного продукту та може спричинити помилки, втрату даних, затримки передачі або збої системи.\n1.3. Відсутність права на продовження: Постачальник має право в будь-який час повністю або частково припинити надання послуги, змінити або обмежити функції або видалити їх тимчасово або остаточно без пояснення причин.\n\n2. Наявність і відмова від гарантії\n2.1. Немає гарантії доступності: GaiCom надається без жодних гарантій доступності чи безвідмовної роботи. Немає права на безперебійну доступність послуги.\n2.2. Виняток гарантії: програмне забезпечення надається в поточному стані («як є») і залежить від наявності. У межах, дозволених законодавством, будь-які гарантійні претензії щодо матеріальних і юридичних дефектів програмного забезпечення виключаються. Зокрема, немає жодної гарантії, що програмне забезпечення без помилок, шкідливих програм або підходить для певної мети.\n\n3. Управління ризиками та зобов'язання користувачів\n3.1. Заборона зберігання критично важливих даних: Користувач зобов’язується не зберігати та не передавати виключно через GaiaCom будь-які критично важливі для бізнесу, життєво важливі, операційно необхідні або юридично особливо конфіденційні дані (наприклад, файли пацієнтів, дуже конфіденційні фінансові дані чи офіційно регульовані секрети). Послугу не можна використовувати для інфраструктури, де непередбачені збої можуть призвести до травм, пошкодження майна або значних фінансових втрат.\n3.2. Самостійне резервне копіювання: користувач несе відповідальність за резервне копіювання всіх даних, отриманих або надісланих через GaiaCom, які йому потрібні в довгостроковій перспективі, у власних незалежних системах (резервні копії). Провайдер не гарантує постійного зберігання або відновлення даних на своїх серверах.\n\n4. Криптографічні функції та GaiaVault\n4.1. Постквантова криптографія (PQC): GaiaCom реалізує найсучасніші, орієнтовані на майбутнє процеси шифрування, які розроблені, щоб протистояти атакам квантових комп’ютерів майбутнього. Однак користувач усвідомлює, що це динамічна та нова наукова сфера. Абсолютна, незаперечна безпека не може бути гарантована на основі поточного стану науки і техніки. Такі терміни, як «на 100% безпечний», «незламний» або «військовий захист» прямо не гарантуються.\n4.2. Відсутність гарантії відновлення (GaiaVault): GaiaCom покладається на послідовну концепцію безпеки без знань. Шифрування та дані доступу залишаються виключно під контролем користувача (захищено через GaiaVault).\nВАЖЛИВО: якщо користувач втратить свої паролі, парольні фрази, приватні ключі або вихідні коди відновлення, постачальник не матиме технічної можливості відновити або скинути ці дані. Втрата цих даних доступу неминуче призводить до безповоротної втрати доступу до облікового запису користувача та всіх зашифрованих у ньому даних.\n4.3. Ще не повністю перевірено: програмне забезпечення постійно піддається внутрішнім перевіркам безпеки, але на момент цієї бета-фази воно ще не пройшло остаточний, комплексний зовнішній аудит безпеки незалежними органами тестування.\n\n5. Інтерфейси, застарілі протоколи та об'єднання\n5.1. Примітка SMTP Bridge: GaiaCom пропонує можливість спілкуватися через класичні протоколи електронної пошти (наприклад, SMTP). Користувач усвідомлює, що повідомлення, які залишають власну зону безпеки GaiaCom (наприклад, надсилаються на звичайну адресу @gmail.com або @gmx.de), транспортуються через незашифровані або сторонні сервери. Наскрізні гарантії безпеки GaiaCom застосовуються лише обмежено або взагалі не застосовуються до таких вихідних або зовнішніх вхідних застарілих повідомлень.\n5.2. Примітка федерації: якщо GaiaCom працює в об’єднаній мережі, повідомлення та дані можуть проходити через сторонні сервери. Хоча вміст повідомлень залишається захищеним наскрізним шифруванням, метадані (такі як час надсилання, IP-адреси залучених серверів і адреси одержувачів) можуть бути технічно видимими для операторів цих об’єднаних серверів. Постачальник не має впливу на практику захисту даних сторонніх операторів серверів у об’єднаній мережі.\n\n6. Прийнятне використання та заборонена діяльність\nКористувач зобов'язується не використовувати сервіс неналежним чином або в незаконних цілях. Зокрема, заборонено:\n- Розповсюдження, надсилання або розміщення вірусів, зловмисного програмного забезпечення, фішингового вмісту чи іншого шкідливого програмного забезпечення.\n- Використання Сервісу для проведення атак на відмову в обслуговуванні (DDoS) або небажаної масової розсилки (спам).\n- Зловживання системою для здійснення шахрайства.\n- Розповсюдження або обмін незаконним контентом, зокрема зображенням сексуального насильства над дітьми (CSAM), терористичною пропагандою, закликами до насильства чи іншим вмістом кримінального значення.\n\n7. Система звітності про зловживання\n7.1. Повідомлення про образливу поведінку: користувачі мають можливість повідомити про образливе спілкування або незаконну діяльність через інтегровану систему порушення.\n7.2. Обробка звітів: щоб забезпечити захист від зловживання, вхідні звіти можна технічно аналізувати (зберігаючи конфіденційність і обмеження шифрування). Це може призвести до тимчасового або постійного призупинення облікових записів користувачів або IP-адрес у разі доведених порушень цих умов використання.\n\n8. Обмеження відповідальності\n8.1. Стандарт відповідальності: бета-версія програмного забезпечення надається безкоштовно. Згідно з правовими нормами щодо пожертвувань або позик, постачальник несе відповідальність лише за намір (навмисне пошкодження) та грубу недбалість.\n8.2. Виняток відповідальності за втрату даних: відповідальність за втрату даних виключається, якщо втрата не була спричинена навмисно або через грубу недбалість постачальника, а користувач виконав свої зобов’язання щодо зменшення збитків шляхом регулярного резервного копіювання (за межами GaiaCom).\n8.3. Юридичні обмеження. Наведені вище обмеження відповідальності не застосовуються до шкоди життю, тілу чи здоров’ю або до відповідальності відповідно до Закону про відповідальність за продукцію.\n\n9. Відкритий код\nДеякі компоненти, бібліотеки або клієнтські програми GaiaCom можуть бути ліцензовані за ліцензіями з відкритим кодом (наприклад, GPL, MIT, Apache). Ці умови використання не впливають на відповідні умови ліцензії цих компонентів, і їх можна переглянути у відповідних сховищах вихідного коду.\n\n10. Експортний контроль і відповідність\nКористувач усвідомлює, що криптографічне програмне забезпечення може підлягати суворому експортному контролю та юридичним обмеженням. Користувач несе відповідальність за те, щоб використання GaiaCom не порушувало законів, імпортних/експортних обмежень або правил криптографії відповідної країни проживання.\n\n11. Повідомлення про захист даних (коротка версія для бета-версії)\n11.1. Мінімальний збір даних: у рамках бета-фази постачальник збирає лише дані, які абсолютно необхідні для технічної роботи, усунення несправностей і подальшого розвитку (наприклад, файли журналу сервера для діагностики помилок).\n11.2. Відсутність уявлення про вміст: завдяки постійному нульовому шифруванню та шифруванню E2E постачальник ніколи не матиме доступу до вмісту ваших чатів, електронних листів або ключів, що зберігаються в GaiaVault.\n11.3. Детальна декларація про захист даних: докладні положення про захист даних наведено окремо, і користувач також повинен їх врахувати перед реєстрацією.\n\n12. Прикінцеві положення\n12.1. Застосовне право: Застосовується законодавство Федеративної Республіки Німеччина, за винятком Конвенції ООН про договори міжнародної купівлі-продажу товарів.\n12.2. Можливі зміни: оскільки GaiaCom знаходиться в стадії активного розвитку, провайдер залишає за собою право змінювати ці умови в будь-який час з урахуванням майбутнього. Поточна версія доступна в додатку.",
    "wizard_terms_title": "Умови використання та бета-тестування GaiaCom (бета-фаза)",
    "node_operator": "Оператор вузла",
    "search_channels": "Пошук каналів...",
    "senior_reviewer": "Старший рецензент",
    "trusted_reviewer": "Довірений рецензент",
    "active_frequencies": "Активні частоти",
    "connected_rooms": "ПОВ’ЯЗАНІ ПРОСТОРИ",
    "dashboard": "Приладова панель",
    "empty_chats": "Немає активних чатів.",
    "empty_messages": "Немає нових повідомлень.",
    "encrypted": "Зашифровано",
    "gaiacom_uplink": "GAIACOM UPLINK",
    "install_app": "Встановити додаток",
    "install_app_desc": "Для швидкого запуску та режиму офлайн",
    "kommandozentrale_alpha": "Командний центр АЛЬФА",
    "network_online": "МЕРЕЖА: ОНЛАЙН",
    "new_room": "Новий простір",
    "no_frequencies_active": "Немає активних частот. Створіть нову кімнату, щоб почати спілкування.",
    "no_id": "Без посвідчення особи",
    "open_chats": "Відкрити чати",
    "open_inbox": "Відкрити вхідні",
    "primary_identity": "ПЕРВИННА ІДЕНТИЧНІСТЬ",
    "recent_chats": "Нові чати",
    "recent_messages": "Останні новини",
    "session_encrypted": "Сеанс зашифровано: {name}",
    "session_secure": "СТАТУС: БЕЗПЕКА",
    "system_verlassen": "Система виходу",
    "write_message": "Написати повідомлення",
  },
  ko: {
    sc_title: "보안 센터",
    sc_subtitle: "GaiaShield 통합 보안 계층",
    sc_tab_status: "🛡️ 보호 상태",
    sc_tab_events: "📋 보안 로그",
    sc_tab_node: "⚙️ 노드 보안",
    sc_loading: "보안 데이터 로드 중...",
    sc_status_secured: "시스템 상태: 계정이 보호됨",
    sc_status_warning: "시스템 상태: 경고 활성화됨",
    sc_desc_secured: "활성 상태의 심각한 보안 경고가 없습니다. GaiaShield가 계정을 적극적으로 모니터링하고 있습니다.",
    sc_desc_warning: "주의: 주의가 필요한 활성 보안 이벤트가 있습니다.",
    sc_account_protection: "계정 보호",
    sc_message_protection: "메시지 보호",
    sc_audits: "보안 감사",
    sc_active: "활성화됨",
    sc_failed_logins: "로그인 실패",
    sc_tamper_checks: "변조 확인",
    sc_blocked_replays: "차단된 리플레이",
    sc_last_check: "마지막 확인",
    sc_just_now: "방금 전",
    sc_open_warnings: "해결되지 않은 경고",
    sc_btn_acknowledge: "확인",
    sc_filter_severity: "심각도",
    sc_filter_category: "카테고리",
    sc_filter_hide_ack: "확인된 항목 숨기기",
    sc_btn_export: "내보내기",
    sc_col_details: "상세 정보",
    sc_col_time: "시간",
    sc_col_status: "상태",
    sc_col_action: "작업",
    sc_no_events: "보안 이벤트가 없습니다.",
    sc_node_title: "노드 운영자 보안 콘ソール",
    sc_system_health: "시스템 상태",
    sc_last_audit: "마지막 감사",
    sc_packed_logs: "패키징된 로그",
    sc_unconfirmed_events: "미확인 이벤트",
    sc_operator_action: "운영자 조치 필요",
    sc_all_ok: "모두 정상",
    sc_critical_events: "심각한 시스템 이벤트",
    ac_title: "거버넌스 및 신고 센터",
    ac_subtitle: "GaiaCom 거버넌스 및 신고 합의",
    ac_tab_my_reports: "내 신고 내역",
    ac_tab_queue: "검토 대기열",
    ac_tab_operator: "노드 운영자",
    ac_tab_transparency: "연합 및 투명성",
    ac_loading: "데이터 로드 중...",
    ac_reported_cases: "신고된 케이스",
    ac_no_reports: "아직 신고한 내역이 없습니다.",
    ac_case_details: "케이스 상세 정보",
    ac_appeal_submit: "이의 제기 제출",
    ac_appeal_status: "이의 제기 상태",
    ac_appeal_reason: "이의 제기 이유",
    ac_appeal_statement: "의견서",
    ac_btn_appeal: "이의 제기 보내기",
    ac_trusted_reviewer_queue: "신뢰할 수 있는 검토자 대기열",
    ac_case_review: "케이스 검토",
    ac_review_category: "권장 카테고리",
    ac_review_severity: "권장 심각도",
    ac_review_action: "권장 조치",
    ac_review_reason: "검토자 사유",
    ac_btn_submit_review: "검토 결과 제출",
    ac_node_operator_dashboard: "노드 운영자 대시보드",
    ac_apply_action: "조치 적용 (재정의)",
    ac_target_type: "대상 유형",
    ac_target_id: "대상 ID (GaiaID 또는 채널 ID)",
    ac_suspend: "정지 활성화됨",
    ac_reason: "공식 사유",
    ac_btn_apply: "조치 시행",
    ac_transparency_title: "합의 및 투명성 기록부",
    ac_transparency_desc: "조정된 모든 채널 및 신원의 공개 가능한 스냅샷 증명.",
    ac_btn_snapshot: "투명성 스냅샷 만들기",
    search_placeholder: "제목, 보낸 사람, 본문으로 메일 검색...",
    abuse_center_title: "신고 센터",
    abbrechen: "취소",
    active_identities: "활성 ID",
    active_identity: "활성 신원",
    add_btn: "추가하다",
    add_contact_title: "연락처 추가",
    admin: "관리자",
    adressbuch: "예배 규칙서",
    aktiviert: "활성화됨",
    an: "에게",
    anonymous_sender: "익명의 발신자",
    antworten: "답변",
    attachment_gaia_hint: "GaiaCOM 첨부 파일은 종단 간 암호화된 상태로 유지됩니다.",
    attachment_smtp_hint: "레거시 SMTP는 실행 가능/스크립트와 유사한 첨부 파일을 차단하고 이메일을 안전하지 않은 것으로 저장합니다.",
    attachments: "첨부파일",
    auffaellig: "눈에 띄는",
    auth_beta_notice: "베타 테스트 단계: GaiaCOM은 적극적으로 테스트되고 있습니다. 오류가 발생할 수 있습니다. 중요한 씨앗을 확보하고 기밀 작업 흐름을 주의 깊게 검토하세요.",
    auth_btn_login: "ID 로드 및 로그인",
    auth_btn_register: "암호화폐 등록 및 생성",
    auth_copied: "복사됨",
    auth_copy_seed: "시드 복사",
    auth_generate_seed: "시드 생성",
    auth_headline: "GaiaCOM은 인류를 위해 구축된 최초의 양자 안전 이메일 프로토콜 및 통신 시스템입니다.",
    auth_kicker: "포스트퀀텀 보안통신",
    auth_mnemonic: "니모닉 문구",
    auth_mnemonic_placeholder: "공백으로 구분된 12단어...",
    auth_password: "비밀번호",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "개인 키는 장치 외부로 유출되지 않습니다. 의도된 수신자만 콘텐츠를 해독할 수 있습니다.",
    auth_proof_gaiadata_desc: "영지식: 귀하는 귀하의 데이터를 계속 통제할 수 있습니다. 메타데이터는 최소화되며 일반 텍스트 프로필로 사용되지 않습니다.",
    auth_proof_gaiadrop_desc: "외부인은 계정 없이 귀하의 GaiaID에 기밀 문자 메시지를 보낼 수 있습니다.",
    auth_proof_gaiaproof_desc: "배달 및 무결성 증거는 암호문, 보낸 사람 및 타임스탬프가 변조되지 않았음을 보여줍니다.",
    auth_proof_gaiavault_desc: "개인 메모, 복구 메모 및 보안 기록은 로컬로 암호화된 상태로 유지됩니다.",
    auth_proof_hybrid_desc: "Quantum Shield: ML-KEM 및 X25519를 사용한 하이브리드 암호화는 오늘날의 공격과 나중에 암호 해독 저장 위험으로부터 보호합니다.",
    auth_secure_mail: "보안 양자 페더레이션 메일",
    auth_subline: "GaiaCOM은 이메일, 채팅, 위기관리실, GaiaDrop 및 로컬 보안 파일을 위한 양자 보안 통신 시스템입니다. 개인 키는 장치에 유지되고 콘텐츠는 종단 간 암호화되며 일반 텍스트 없이 증거를 내보낼 수 있습니다.",
    auth_success_btn: "지금 로그인하세요",
    auth_success_text: "귀하의 GaiaCOM 계정이 생성되었습니다. 키는 시드에서 로컬로 파생되었으며 서버에 저장되지 않았습니다.",
    auth_success_title: "등록 성공",
    auth_tab_drop: "가이아드롭",
    auth_tab_login: "로그인/계정",
    auth_toggle_login: "계정이 이미 존재합니다.",
    auth_toggle_register: "새 계정 만들기",
    auth_usecase_text: "변호사, 회사, 당국, 언론인, 내부 고발자 및 개인 보안 사건에 적합합니다.",
    auth_usecase_title: "민감한 커뮤니케이션을 위해 제작됨",
    auth_username: "사용자 이름",
    auth_username_placeholder: "이름을 입력하세요...",
    auth_value_chat: "E2E 채팅",
    auth_value_drop: "보안 드롭",
    auth_value_mail: "보안 메일",
    auth_value_rooms: "가이아룸스",
    bestaetigen: "확인하다",
    bestaetigt: "확인됨",
    bio_status: "약력/현황",
    biography: "전기",
    change_password_desc: "서버 측 로그인 비밀번호를 변경합니다. 로컬 복구 문구는 볼트/잠금 해제 비밀번호로 별도로 보호됩니다.",
    change_password_menu_desc: "GaiaCOM 로그인 비밀번호를 업데이트하세요.",
    change_password_title: "비밀번호 변경",
    channel_id: "채널 ID",
    channel_name_label: "채널 이름",
    chat_deleted_hidden: "채팅이 삭제되고 숨겨졌습니다.",
    chat_input_placeholder: "보안 메시지를 입력하세요...",
    chat_start_hint: "대화를 시작하세요! 모든 채팅 메시지는 양자 보안 E2E 암호화됩니다.",
    choose_avatar: "아바타 선택",
    ciphertext_hash: "암호문 해시",
    clear_chat: "빈 채팅",
    clear_for_everyone: "모두를 위해 비워두세요",
    clear_for_me: "나만을 위해 비워두세요",
    click_to_write_mail: "이메일을 작성하려면 클릭하세요.",
    click_top_right: "오른쪽 상단을 클릭하세요.",
    close: "닫다",
    code_kopieren: "코드 복사",
    code_kopieren_success: "코드 복사됨",
    confirm_clear_channel_desc: "로컬 보기에서 이 채널을 삭제하시겠습니까?",
    confirm_clear_channel_title: "빈 채널",
    confirm_clear_chat: "이 채팅을 비우시겠습니까?",
    confirm_clear_chat_desc: "이 채팅을 비우시겠습니까?",
    confirm_clear_chat_title: "빈 채팅",
    confirm_clear_everyone: "두 파트너 모두의 채팅을 비우시겠습니까? (OK = 모두에게, 취소 = 나만을 위해)",
    confirm_delete_everyone: "두 파트너 모두의 메시지를 삭제하시겠습니까? (OK = 모두에게, 취소 = 나만을 위해)",
    confirm_delete_msg: "이 메시지를 삭제하시겠습니까?",
    confirm_delete_msg_desc: "이 채팅 메시지를 삭제하시겠습니까?",
    confirm_delete_msg_title: "메시지 삭제",
    confirm_new_password: "새 비밀번호 확인",
    copy: "복사",
    create_btn: "만들다",
    create_channel_title: "채널 만들기",
    create_group_is_crisis: "위기지역으로 표시",
    create_group_title: "새 그룹 만들기",
    crypto_lock_desc: "GaiaCOM이 메모리에서 로컬 암호화 키를 제거하는 시기를 제어합니다.",
    crypto_lock_menu_desc: "다시 로드 및 비활성 타이머를 제어합니다.",
    crypto_lock_title: "암호화 잠금",
    crypto_session_duration: "다시 로드한 후 잠금 해제됨",
    crypto_session_duration_desc: "선택한 기간 동안만 이 브라우저 탭에서 암호화 세션을 열어 둡니다.",
    cryptographic_fingerprint: "암호화 지문",
    current_password: "현재 비밀번호",
    data_minimization: "데이터 최소화",
    decrypt_failed: "해독 불가",
    delete: "삭제",
    delete_account_button: "취소할 수 없는 계정 삭제",
    delete_account_confirm_label: "확인하려면 DELETE를 입력하세요.",
    delete_account_confirmation_error: "비밀번호와 DELETE 확인이 필요합니다.",
    delete_account_desc: "이 모드는 귀하의 계정, 신원, 장치 세션, GaiaDrop 데이터, 업로드 메타데이터 및 서버 측 속성 메시지를 영구적으로 파괴합니다.",
    delete_account_done_desc: "할당 가능한 모든 GaiaCOM 데이터가 삭제되었습니다.",
    delete_account_done_title: "계정이 삭제되었습니다",
    delete_account_menu_desc: "계정 및 관련 데이터를 파기합니다.",
    delete_account_not_authenticated: "활성 계정이 없습니다.",
    delete_account_title: "계정 삭제",
    delete_for_everyone: "모든 사람에 대해 삭제",
    delete_for_me: "나만을 위해 삭제",
    device_current: "이 장치",
    device_last_seen: "마지막",
    device_logout: "로그아웃",
    device_sessions_desc: "활성 세션을 확인하고 더 이상 신뢰하지 않는 장치의 등록을 취소하세요.",
    device_sessions_empty: "기기를 찾을 수 없습니다.",
    device_sessions_menu_desc: "활성 세션을 관리하고 종료합니다.",
    device_sessions_title: "등록된 기기",
    device_since: "부터",
    display_name: "표시 이름",
    drop_address_copied: "GaiaDrop 주소가 복사되었습니다.",
    drop_btn_decrypting: "받은편지함을 해독하는 중입니다...",
    drop_btn_load: "GaiaDrop 받은 편지함 로드",
    drop_delete_desc: "정말로 이 드롭을 영구적으로 삭제하시겠습니까?",
    drop_delete_title: "GaiaDrop 삭제",
    drop_desc: "외부 통지, 책임 있는 공개 및 기밀 보고를 위한 텍스트 전용 영지식 드롭 채널입니다. 외부 당사자는 귀하의 GaiaID를 사용하여 계정 없이도 메시지를 보낼 수 있습니다.",
    drop_empty: "아직 GaiaDrop 메시지가 로드되지 않았습니다.",
    drop_id: "삭제 ID:",
    drop_own_address: "귀하의 GaiaDrop 주소",
    drop_proof: "낙하 방지",
    drop_title: "GaiaDrop 보안 받은 편지함",
    dunkler_modus: "다크 모드",
    e2e_chat_room_open: "E2E 채팅방 열기",
    edit_profile: "프로필 수정",
    edit_profile_desc: "표시 이름, 약력, 아바타를 맞춤설정하세요.",
    einladungscode: "초대코드",
    enter_fingerprint_chars_confirm: "확인을 위해 요청된 지문 문자를 입력하세요.",
    envelope_hash: "봉투 해시",
    erasability: "지울 수 있음",
    erfolg: "성공",
    exclude_plaintext: "일반 텍스트 없이 내보내기",
    export_disclosure: "보안 케이스 수출",
    export_package_desc: "이 공개가 의도적으로 의도된 경우에만 일반 텍스트를 포함하십시오.",
    export_package_title: "보안 패키지 내보내기",
    fehler: "실수",
    gaiacom_reader: "GaiaCOM 리더",
    gaiadrop_inbox_title: "GaiaDrop 받은 편지함",
    gaiavault: "가이아볼트",
    gdpr_home_desc: "GaiaCOM은 메타데이터를 최소화하고 개인 키를 로컬에 유지하며 콘텐츠를 엔드 투 엔드로 암호화하고 완전한 계정 삭제를 가능하게 합니다.",
    gdpr_home_title: "GDPR 100% 준수",
    gdpr_reason_delete: "계정 삭제는 계정, ID, 로컬 세션 및 서버 측 할당 가능 데이터를 제거합니다.",
    gdpr_reason_e2ee: "비공개 콘텐츠는 의도된 수신자만 해독할 수 있습니다.",
    gdpr_reason_minimal: "메타데이터는 라우팅, 전달 및 보안 자격 증명에만 사용됩니다.",
    gdpr_reason_zero_knowledge: "개인 키와 복구 데이터는 사용자 제어 하에 로컬로 유지됩니다.",
    gesendet: "전송된",
    gesperrt_verdaechtig: "금지됨 / 의심됨",
    group_delete_desc: "정말로 이 그룹을 영구적으로 삭제하시겠습니까? 이 그룹의 모든 채널과 메시지가 삭제됩니다.",
    group_delete_title: "그룹 삭제",
    group_description: "설명",
    group_icon_label: "그룹 아이콘 / 아바타",
    group_name: "그룹 이름",
    group_settings_avatar: "화신",
    group_settings_desc: "설명",
    group_settings_is_crisis: "위기지역으로 표시",
    group_settings_name: "그룹 이름",
    group_settings_title: "그룹 설정",
    groups_empty_desc: "프로젝트, 위기 상황, 팀 커뮤니케이션을 위한 안전한 작업 공간을 만드세요.",
    groups_empty_title: "아직 그룹 채팅이 없습니다.",
    gruppe_beitreten: "가입된 그룹",
    gruppe_erstellen: "+ 그룹 만들기",
    gruppe_verlassen: "그룹 탈퇴",
    gruppen_chats: "그룹 채팅",
    heller_modus: "밝은 모드",
    how_to_receive_drops: "상품을 받으려면 어떻게 해야 하나요?",
    identitaets_assistent: "신원 도우미",
    inactivity_lock_duration: "비활성 시 잠금",
    inactivity_lock_duration_desc: "입력이 없는 기간이 지나면 GaiaCOM은 자동으로 암호화되어 잠깁니다.",
    inactivity_lock_notice: "GaiaCOM은 활동이 없어 암호화되어 차단되었습니다.",
    include_plaintext: "일반 텍스트 포함",
    invite_code_label: "초대코드",
    join_group_title: "그룹에 가입",
    kanaele: "채널",
    kanal_erstellen: "+ 채널",
    kein_chat_ausgewaehlt: "선택된 채팅 없음",
    kein_kanal_ausgewaehlt: "선택된 채널이 없습니다",
    keine_gruppe_ausgewaehlt: "선택한 그룹이 없습니다.",
    keine_mails: "사용할 수 있는 이메일이 없습니다.",
    key_change_warn_desc: "이 연락처의 공개 키가 변경되었습니다. 신뢰하기 전에 지문을 확인하세요.",
    key_change_warn_title: "암호화 경고",
    key_change_warning_changed: "변경되었습니다. 이는 중간자 공격의 징후일 수 있습니다!",
    key_change_warning_msg: "연락처의 ID 키",
    key_transparency: "주요 투명성",
    kopiert: "복사됨",
    kryptographische_schluessel: "암호화 키",
    kryptographische_schluessel_desc: "개인 키와 백업 시드 문구를 표시합니다.",
    laden: "짐...",
    leeren: "비어 있는",
    loading: "짐...",
    local_key_vault: "로컬 키 자격 증명 모음",
    local_keys_label: "로컬 키",
    lock_on_reload: "다시 로드한 후 항상 잠금",
    logout: "로그아웃",
    mail_compose: "이메일 쓰기",
    mein_profil: "내 프로필",
    melden: "보고서",
    menu: "메뉴",
    message: "소식",
    message_id: "메시지 ID",
    message_pin: "핀",
    message_pinned_title: "고정된 메시지",
    message_react: "반응하다",
    message_reply: "답변",
    message_replying_to: "에 대한 답변",
    message_save: "구하다",
    message_saved: "저장됨",
    message_to_channel: "메시지 보내기",
    message_unpin: "해결하다",
    message_unsave: "저장하지 않음",
    mitglied: "회원",
    mitglieder: "회원",
    ml_kem: "ML-KEM",
    neue_mail: "새 이메일",
    never_auto_lock: "자동으로 사용 안함",
    new_fingerprint: "새로운 지문",
    new_identity: "새로운 정체성",
    new_password: "새 비밀번호",
    no_description: "설명 없음",
    no_key_history: "기록된 주요 기록이 없습니다.",
    no_specification: "지정되지 않음",
    old_fingerprint: "오래된 지문",
    open_privacy_imprint: "개방형 인쇄물 및 데이터 보호",
    post_quantum_e2e: "포스트퀀텀 E2E",
    posteingang: "받은편지함",
    powered_by: "제공:",
    privacy_imprint_menu_desc: "GDPR, 데이터 보호 및 법적 고지를 표시합니다.",
    privacy_imprint_profile_desc: "GaiaCOM은 데이터 최소화, 종단 간 암호화 및 로컬 키 제어 원칙에 따라 통신 콘텐츠를 처리합니다.",
    privacy_imprint_title: "데이터 보호 및 법적 고지",
    profil: "윤곽",
    profile_details: "프로필 세부정보",
    profile_settings_hint: "프로필 설정이 오른쪽 패널에 표시됩니다.",
    profile_unlock_desc: "보안상의 이유로 개인 암호화 키를 보려면 비밀번호를 다시 입력해야 합니다.",
    proof_hash: "증명 해시:",
    public_drop_desc: "GaiaCOM 계정 없이 외부 텍스트 정보에 대한 Secure Drop.",
    public_drop_message: "소식",
    public_drop_message_placeholder: "기밀 문자를 입력하세요...",
    public_drop_send: "GaiaDrop 보내기",
    public_drop_sender: "보낸 사람 메모 선택 사항",
    public_drop_sender_placeholder: "이름, 파일 번호 또는 익명",
    public_drop_target: "대상 GaiaID",
    quanten_chat: "퀀텀채팅",
    quantum_secure_exchange: "양자 보안 교환을 통해...",
    quantum_secure_net: "GaiaCOM 양자 보안 네트워크(Ed25519 및 ML-KEM)",
    quantum_shield_desc: "GaiaCOM 네트워크는 미래 양자 컴퓨터의 공격으로부터 보호되는 다층 하이브리드 암호화 프로토콜을 통해 귀하의 개인 정보를 보호합니다.",
    quantum_shield_l1_desc: "FIPS 203 표준을 사용하여 대칭 공유 키를 캡슐화합니다. 양자 컴퓨터에 의한 수동 기록 및 나중에 암호 해독(\\",
    quantum_shield_l1_title: "1. 양자후방호(ML-KEM-1024)",
    quantum_shield_l2_desc: "하이브리드 절차에서 추가 보안 계층 ​​역할을 하는 매우 빠른 클래식 Diffie-Hellman 키 교환 절차입니다.",
    quantum_shield_l2_title: "2. 타원곡선 암호화(X25519)",
    quantum_shield_l3_desc: "모든 메시지와 모든 페더레이션 봉투는 보낸 사람의 진위 여부를 명확하게 확인하기 위해 암호화 방식으로 서명됩니다.",
    quantum_shield_l3_title: "3. 디지털 서명(Ed25519)",
    quantum_shield_l4_desc: "메시지 콘텐츠를 대칭적으로 암호화하고 발신자, 수신자 및 메타데이터를 인증된 추가 데이터(AAD)에 긴밀하게 바인딩하여 재생 공격을 방지합니다.",
    quantum_shield_l4_title: "4. AAD 인증(AES-256-GCM)",
    quantum_shield_status: "퀀텀 쉴드 상태",
    receive_drops_step1: "GaiaID를 외부 소스와 공유하세요(예: 위의 복사 버튼 사용).",
    receive_drops_step2: "GaiaCOM 인스턴스의 로그인 페이지를 호출하고 탭으로 전환합니다.",
    receive_drops_step3: "암호화된 메시지를 귀하의 주소로 보내세요.",
    receiver_gaia: "GaiaCOM 수신기",
    receiver_smtp: "SMTP 수신자",
    records_stored: "저장된 기록",
    refresh: "업데이트",
    report_abuse_desc: "이 메시지를 신고하고 남용에 대한 암호화 증거를 서버에 제출하시겠습니까?",
    report_abuse_title: "악용사례 신고",
    reputation_status: "평판 상태",
    room_chat_start_hint: "대화를 시작하세요! 이 그룹 채널의 모든 메시지는 분산형 양자 안전 E2E 암호화됩니다.",
    room_policy_audit: "감사 추적 및 키 순환이 활성화되었습니다.",
    room_policy_crisis: "위기의 방",
    room_policy_e2ee: "지식이 없는 공간. E2EE 양자 안전.",
    room_policy_title: "객실 지침",
    room_policy_zero_knowledge: "정책",
    room_security_note_desc: "모든 주요 변경 사항은 키 투명성을 통해 검증됩니다. 개인 백업 로그에는 GaiaVault를 사용하세요.",
    room_security_note_title: "고정된 보안 메모",
    save_profile: "프로필 저장",
    schluessel_entsperrt: "🔑 열쇠를 다시 잠그세요",
    search_gaia_label: "가이아 주소 찾기",
    security_warning_title: "보안 경고",
    select_channel_chat: "채팅하려면 왼쪽 사이드바에서 채널을 선택하세요.",
    select_contact_chat: "양자 안전 E2E 채팅을 시작하려면 왼쪽 패널에서 연락처를 선택하세요.",
    select_mail_read: "목록에서 이메일을 선택하여 양자 안전 콘텐츠를 읽거나 새 메시지를 작성하세요.",
    senden: "보내다",
    sender_signature: "발신자 서명",
    server_log: "서버 로그:",
    server_received: "서버 수신됨",
    session_lock: "세션 잠금",
    setup_address_keys: "주소 및 키 세트 생성",
    setup_profile: "프로필에서 설정",
    smtp_inbox_title: "SMTP 수신",
    smtp_legacy_badge: "기존 SMTP/안전하지 않음",
    smtp_mode_option: "레거시 SMTP 브리지",
    smtp_security_warning: "이 이메일은 암호화되지 않은 일반적인 SMTP 프로토콜을 통해 전송되었습니다. 활성화된 종단 간 암호화가 없습니다.",
    smtp_security_warning_desc: "이 메시지는 GaiaCom 보안실에서 나갑니다. SMTP 전달은 GaiaCom 기본 엔드투엔드 보장, TrustMesh 보장 및 게이트웨이의 Godmode 보장을 제공하지 않습니다.",
    spam_verdacht: "스팸/의심",
    spam_warning_desc: "이 메시지에는 의심스러운 평판 신호가 있습니다.",
    spam_warning_title: "스팸 경고",
    speichern: "구하다",
    sperren: "잠금",
    standard_group_status: "표준 그룹 채팅(E2EE 암호화)",
    status: "상태",
    subject: "에 관하여",
    suchen: "새 Gaia 주소 찾기...",
    tage: "날",
    time_unknown: "시간을 알 수 없음",
    transmission_mode: "전송 모드",
    trust_age: "신뢰 연령",
    trust_passport_title: "트러스트 여권",
    unbestaetigt: "확인되지 않음",
    unknown_sender: "알려지지 않은",
    unlock_btn: "터놓다",
    unlock_btn_profile: "터놓다",
    unlock_desc: "개인 키 파일은 암호화되어 저장됩니다. 암호화 키를 메모리에만 로드하려면 비밀번호를 입력하세요.",
    unlock_logout: "로그아웃하고 로컬 키 닫기",
    unlock_title: "신원 잠금 해제",
    untrusted: "신뢰할 수 없음",
    update_password: "비밀번호 업데이트",
    upload_avatar_btn: "이미지 업로드(삭제됨)",
    vault_btn_encrypt: "기록 암호화",
    vault_btn_lock: "금고를 잠그세요",
    vault_btn_unlock: "금고 잠금 해제",
    vault_copied_success: "클립보드에 복사됨",
    vault_decrypted_content: "해독된 콘텐츠",
    vault_desc: "복구 백업, ID 메모, 서버 액세스, 비상 연락처, 법적 메모, 보안 이벤트 및 개인 로그를 위한 로컬 암호화 저장소입니다.",
    vault_empty: "아직 저장된 보안 기록이 없습니다.",
    vault_locked_pane_notice: "금고는 잠겨 있습니다. 오른쪽에서 잠금을 해제해 주세요.",
    vault_new_record: "새로운 보안 기록",
    vault_pwd_placeholder: "Vault 비밀번호를 입력하세요...",
    vault_record_body: "녹음 내용",
    vault_record_body_placeholder: "암호화된 기록 내용을 입력하세요...",
    vault_record_category: "범주",
    vault_record_title: "음반 제목",
    vault_record_title_placeholder: "보안 기록의 제목",
    vault_title: "GaiaVault 보안 기록",
    verify_new_fingerprint_hint: "키를 수락하기 전에 새 지문을 확인하세요.",
    vertrauenswuerdig: "신뢰할 수 있는",
    vision_gaia_technology: "비전Gaia기술",
    von: "에서",
    warnung: "경고",
    wizard_address: "주소",
    wizard_back: "뒤쪽에",
    wizard_check1: "나는 내 씨앗을 안전하게 구했습니다.",
    wizard_custom_domain: "자신의 도메인을 사용하세요",
    wizard_desc1: "GaiaCOM은 서버 측에 개인 키를 저장하지 않습니다. Mnemonic Seed가 없으면 누구도 잃어버린 메시지를 복구할 수 없습니다.",
    wizard_desc2: "귀하의 주소는 암호화된 봉투가 라우팅되는 페더레이션 노드를 결정합니다.",
    wizard_fallback: "대체 노드",
    wizard_finish: "설정 완료",
    wizard_next: "더 나아가",
    wizard_server_domain: "서버 노드 도메인",
    wizard_step1: "1. 백업 시드",
    wizard_step2: "2. 주소 및 서버",
    wizard_title1: "복구 키 백업",
    wizard_title2: "GaiaCOM 주소를 선택하세요",
    write_message_placeholder: "보안 메시지를 작성하세요...",
    you: "너",
    zero_knowledge: "지식 제로",
    zero_knowledge_encryption: "영지식 암호화",
    "Chat fuer alle geleert": "모든 참가자의 채팅이 비워졌습니다.",
    "Chat geleert": "로컬 받은편지함의 채팅이 삭제되었습니다.",
    "Nachricht fuer alle geloescht": "모든 참가자의 메시지가 삭제되었습니다.",
    "Nachricht geloescht": "채팅 메시지가 받은 편지함에서 로컬로 제거되었습니다.",
    "anpinnen": "핀",
    "chat_loeschen": "채팅 삭제",
    "confirm_delete_chat_desc": "정말로 채팅을 삭제하고 숨기시겠습니까?",
    "confirm_leave_group_desc": "정말로 이 그룹에서 탈퇴하시겠습니까?",
    "entpinnen": "고정 해제",
    "group_deleted": "그룹이 삭제되었습니다.",
    "group_left": "그룹에서 탈퇴했습니다.",
    "gruppe_loeschen": "그룹 삭제",
    "loeschen": "삭제",
    "no_active_chats": "활성 채팅이 없습니다. 채팅을 시작하려면 위에서 연락처를 검색하세요.",
    "pinned": "고정됨",
    "wizard_check_credentials": "나는 내 액세스 데이터를 안전하게 유지할 책임이 있습니다.",
    "wizard_check_is_beta": "나는 GaiaCom이 베타 소프트웨어라는 것을 알고 있습니다.",
    "wizard_check_no_illegal": "나는 GaiaCom을 불법적인 목적으로 사용하지 않겠습니다.",
    "wizard_check_no_uptime": "가용성이 보장되지 않는다는 점을 이해합니다.",
    "wizard_check_smtp_security": "나는 SMTP 메시지가 완전한 GaiaCom 보안을 제공하지 않는다는 것을 이해합니다.",
    "wizard_check_terms_read": "베타 서비스 약관을 읽었습니다.",
    "wizard_step_terms": "이용약관",
    "wizard_terms_text": "GaiaCom 이용 약관 및 베타 테스트 계약(베타 단계)\n\n공급자: VisionGaiaTechnology(이하 “공급자”라 함)\n상태: 공개 베타 테스트 단계\n유효기간: 2026년 6월 21일부터\n\n⚠️ 사전에 가장 중요한 참고사항(자세히 읽어주세요)\nGaiaCom은 공개 베타 테스트 단계에 있습니다. 광범위한 보안 조치에도 불구하고 소프트웨어와 기본 인프라의 오류 방지, 지속적인 가용성 또는 절대적인 보안은 보장할 수 없습니다. 자신의 책임하에 사용하십시오. 사용자는 자신의 액세스 데이터(특히 GaiaVault의 키)를 안전하게 저장하고 해당 법률을 준수할 책임이 있습니다.\n\n1. 베타 테스트 단계의 주제 및 목적\n1.1. 제공 목적: GaiaCom은 PQC(포스트 퀀텀 암호화)를 기반으로 하는 새로운 이메일 및 채팅 서비스입니다. 베타 단계의 제공은 기술 테스트, 로드 시뮬레이션, 프로그램 오류(버그) 찾기 및 사용자 친화성 최적화만을 위한 것입니다.\n1.2. 베타 상태: 사용자는 제공되는 소프트웨어가 예비 버전(베타 소프트웨어)임을 알고 있습니다. 이는 아직 기술적으로 완전히 개발되지 않았으며 최종 상용 제품의 표준을 충족하지 못하며 오류, 데이터 손실, 전송 지연 또는 시스템 충돌을 일으킬 수 있습니다.\n1.3. 계속할 권리 없음: 공급자는 언제든지 서비스 전체 또는 일부를 중단하거나, 기능을 변경 또는 제한하거나, 이유를 밝히지 않고 일시적 또는 영구적으로 제거할 수 있는 권리가 있습니다.\n\n2. 보증의 가용성 및 부인\n2.1. 가용성 보장 없음: GaiaCom은 가용성이나 가동 시간에 대한 보장 없이 제공됩니다. 서비스를 중단 없이 사용할 권리는 없습니다.\n2.2. 보증 제외: 소프트웨어는 현재 상태(\"있는 그대로\")로 제공되며 가용성에 따라 달라질 수 있습니다. 법이 허용하는 한도 내에서 소프트웨어의 물질적, 법적 결함에 대한 보증 청구는 제외됩니다. 특히, 소프트웨어에 오류가 없거나, 악성 코드가 없거나, 특정 목적에 적합하다는 보장은 없습니다.\n\n3. 위험 관리 및 사용자의 의무\n3.1. 중요 데이터 저장 금지: 사용자는 비즈니스에 중요하고 중요하며 운영상 필요하거나 법적으로 특히 민감한 데이터(예: 환자 파일, 매우 민감한 금융 데이터 또는 공식적으로 규제되는 비밀)를 GaiaCom을 통해 독점적으로 저장하거나 전송하지 않을 것을 약속합니다. 예상치 못한 장애로 인해 부상, 재산 피해 또는 상당한 금전적 손실이 발생할 수 있는 인프라에는 이 서비스를 사용할 수 없습니다.\n3.2. 자체 책임 백업: 사용자는 장기적으로 필요한 GaiaCom을 통해 수신 또는 전송된 모든 데이터를 자신의 독립 시스템(백업 복사본)에 백업할 책임이 있습니다. 공급자는 서버에 있는 데이터의 영구 저장 또는 복원 가능성을 보장하지 않습니다.\n\n4. 암호화 기능 및 GaiaVault\n4.1. PQC(포스트 양자 암호화): GaiaCom은 미래 양자 컴퓨터의 공격을 견딜 수 있도록 설계된 최첨단 미래 지향적 암호화 프로세스를 구현합니다. 그러나 사용자는 이것이 역동적이고 새로운 과학 분야라는 것을 알고 있습니다. 현재의 과학기술 수준으로는 절대적이고 반박할 수 없는 보안을 보장할 수 없습니다. \"100% 보안\", \"해킹 불가\" 또는 \"군사적 보안\"과 같은 용어는 명시적으로 보장되지 않습니다.\n4.2. 복구 보장 없음(GaiaVault): GaiaCom은 일관된 영지식 보안 개념을 사용합니다. 암호화 웨지 및 액세스 데이터는 전적으로 사용자가 제어할 수 있습니다(GaiaVault를 통해 보호됨).\n중요: 사용자가 비밀번호, 패스프레이즈, 개인 키 또는 복구 시드를 분실한 경우 공급자는 이 데이터를 재구성하거나 재설정할 수 있는 기술적 능력이 없습니다. 이러한 액세스 데이터가 손실되면 필연적으로 사용자 계정 및 해당 계정에 암호화된 모든 데이터에 대한 액세스가 영구적으로 손실됩니다.\n4.3. 아직 완전히 감사되지 않음: 소프트웨어는 지속적으로 내부 보안 검사를 받지만, 베타 단계가 진행되는 시점에는 아직 독립 테스트 기관의 최종적이고 포괄적인 외부 보안 감사를 받지 않았습니다.\n\n5. 인터페이스, 레거시 프로토콜 및 연합\n5.1. SMTP 브리지 참고: GaiaCom은 기존 이메일 프로토콜(예: SMTP)을 통해 통신하는 기능을 제공합니다. 사용자는 기본 GaiaCom 보안 영역을 벗어나는 메시지(예: 기존 @gmail.com 또는 @gmx.de 주소로 전송되는 경우)가 암호화되지 않은 서버나 타사 서버를 통해 전송된다는 것을 알고 있습니다. GaiaCom의 엔드투엔드 보안 보장은 발신 또는 외부 수신 레거시 메시지에 대해 제한된 범위에만 적용되거나 전혀 적용되지 않습니다.\n5.2. 연합 참고 사항: GaiaCom이 연합 네트워크에서 작동하는 경우 메시지와 데이터는 제3자 서버를 통해 전달될 수 있습니다. 메시지 내용은 종단 간 암호화로 보호되지만 메타데이터(예: 전송 시간, 관련 서버의 IP 주소, 수신자 주소)는 이러한 페더레이션 서버의 운영자에게 기술적으로 표시될 수 있습니다. 공급자는 페더레이션 네트워크에 있는 제3자 서버 운영자의 데이터 보호 관행에 영향을 미치지 않습니다.\n\n6. 허용되는 사용 및 금지된 활동\n사용자는 서비스를 부적절하거나 불법적인 목적으로 사용하지 않을 것을 약속합니다. 특히 다음은 금지됩니다.\n- 바이러스, 악성 코드, 피싱 콘텐츠 또는 기타 악성 소프트웨어를 배포, 전송 또는 호스팅하는 행위.\n- 서비스 거부 공격(DDoS) 또는 원치 않는 대량 메일 발송(스팸)을 수행하기 위해 서비스를 이용하는 행위.\n- 시스템을 악용하여 사기를 저지르는 행위.\n- 불법 콘텐츠, 특히 아동 성적 학대(CSAM) 묘사, 테러리스트 선전, 폭력 촉구 또는 기타 범죄 관련 콘텐츠의 배포 또는 교환.\n\n7. 악용사례 신고제도\n7.1. 욕설 신고: 사용자는 통합 욕설 시스템을 통해 욕설이나 불법 행위를 신고할 수 있습니다.\n7.2. 보고서 처리: 오용을 방지하기 위해 들어오는 보고서를 기술적으로 분석할 수 있습니다(개인 정보 보호 및 암호화 제한은 유지됨). 이로 인해 본 이용 약관을 위반한 것이 입증된 경우 사용자 계정이나 IP 주소가 일시적 또는 영구적으로 정지될 수 있습니다.\n\n8. 책임의 제한\n8.1. 책임 표준: 베타 소프트웨어는 무료로 제공됩니다. 따라서 기부 또는 대출에 대한 법적 규칙에 따라 제공자는 고의(의도적 손해)와 중과실에 대해서만 책임을 집니다.\n8.2. 데이터 손실에 대한 책임 배제: 데이터 손실에 대한 책임은 공급자의 고의 또는 중과실로 인해 손실이 발생하지 않고 사용자가 정기적인 백업(GaiaCom 외부)을 통해 피해를 완화할 의무를 이행한 경우를 제외하고는 제외됩니다.\n8.3. 법적 제한: 위의 책임 제한은 생명, 신체 또는 건강에 대한 상해 또는 제조물 책임법에 따른 책임에는 적용되지 않습니다.\n\n9. 오픈 소스\n특정 GaiaCom 구성 요소, 라이브러리 또는 클라이언트 애플리케이션은 오픈 소스 라이선스(예: GPL, MIT, Apache)에 따라 라이선스가 부여될 수 있습니다. 이러한 구성 요소의 각 라이센스 조건은 본 사용 조건의 영향을 받지 않으며 해당 소스 코드 저장소에서 볼 수 있습니다.\n\n10. 수출 통제 및 규정 준수\n사용자는 암호화 소프트웨어가 엄격한 수출 통제 및 법적 제한을 받을 수 있다는 것을 알고 있습니다. 사용자는 GaiaCom의 사용이 해당 거주 국가의 법률, 수입/수출 제한 또는 암호화 규정을 위반하지 않도록 할 책임이 있습니다.\n\n11. 데이터 보호 공지(베타용 단축 버전)\n11.1. 최소 데이터 수집: 베타 단계의 일부로 공급자는 기술 운영, 문제 해결 및 추가 개발에 절대적으로 필요한 데이터(예: 오류 진단을 위한 서버 로그 파일)만 수집합니다.\n11.2. 콘텐츠에 대한 통찰력 없음: 일관된 영지식 및 E2E 암호화 덕분에 공급자는 GaiaVault에 저장된 채팅, 이메일 또는 키 콘텐츠에 절대 액세스할 수 없습니다.\n11.3. 세부 데이터 보호 선언: 세부 데이터 보호 규정은 별도로 링크되어 있으며 등록하기 전에 사용자도 이를 고려해야 합니다.\n\n12. 최종 조항\n12.1. 준거법: 국제물품매매계약에 관한 UN 협약을 제외하고 독일연방공화국 법률이 적용됩니다.\n12.2. 변경될 수 있음: GaiaCom은 활발하게 개발 중이므로 공급자는 미래에 영향을 미치기 위해 언제든지 이러한 조건을 조정할 권리를 보유합니다. 현재 버전은 응용 프로그램에서 사용할 수 있습니다.",
    "wizard_terms_title": "GaiaCom 이용 약관 및 베타 테스트 계약(베타 단계)",
    "node_operator": "노드 운영자",
    "search_channels": "채널 검색...",
    "senior_reviewer": "수석 검토자",
    "trusted_reviewer": "신뢰할 수 있는 리뷰어",
    "active_frequencies": "활성 주파수",
    "connected_rooms": "연결된 공간",
    "dashboard": "계기반",
    "empty_chats": "사용 가능한 활성 채팅이 없습니다.",
    "empty_messages": "새 메시지가 없습니다.",
    "encrypted": "암호화됨",
    "gaiacom_uplink": "가이아콤 업링크",
    "install_app": "앱 설치",
    "install_app_desc": "빠른 시작 및 오프라인 모드용",
    "kommandozentrale_alpha": "ALPHA 명령 센터",
    "network_online": "네트워크: 온라인",
    "new_room": "새로운 공간",
    "no_frequencies_active": "활성화된 주파수가 없습니다. 커뮤니케이션을 시작하려면 새 방을 만드세요.",
    "no_id": "신분증 없음",
    "open_chats": "오픈채팅",
    "open_inbox": "받은편지함 열기",
    "primary_identity": "기본 ID",
    "recent_chats": "새로운 채팅",
    "recent_messages": "최신 뉴스",
    "session_encrypted": "암호화된 세션: {name}",
    "session_secure": "상태: 안전함",
    "system_verlassen": "출구 시스템",
    "write_message": "메시지 쓰기",
  },
  id: {
    sc_title: "Pusat Keamanan",
    sc_subtitle: "Lapisan Keamanan Terintegrasi GaiaShield",
    sc_tab_status: "🛡️ Status Perlindungan",
    sc_tab_events: "📋 Log Keamanan",
    sc_tab_node: "⚙️ Keamanan Node",
    sc_loading: "Memuat data keamanan...",
    sc_status_secured: "Status Sistem: Akun terlindungi",
    sc_status_warning: "Status Sistem: Peringatan aktif",
    sc_desc_secured: "Tidak ada peringatan keamanan kritis yang aktif. GaiaShield secara aktif memantau akun Anda.",
    sc_desc_warning: "Perhatian: Ada kejadian keamanan aktif yang memerlukan perhatian Anda.",
    sc_account_protection: "Perlindungan Akun",
    sc_message_protection: "Perlindungan Pesan",
    sc_audits: "Audit Keamanan",
    sc_active: "AKTIF",
    sc_failed_logins: "Gagal Login",
    sc_tamper_checks: "Pemeriksaan Modifikasi",
    sc_blocked_replays: "Replay yang Diblokir",
    sc_last_check: "Pemeriksaan Terakhir",
    sc_just_now: "Baru saja",
    sc_open_warnings: "Peringatan Terbuka",
    sc_btn_acknowledge: "Konfirmasi",
    sc_filter_severity: "Tingkat Keparahan",
    sc_filter_category: "Kategori",
    sc_filter_hide_ack: "Sembunyikan yang Dikonfirmasi",
    sc_btn_export: "Ekspor",
    sc_col_details: "Detail",
    sc_col_time: "Waktu",
    sc_col_status: "Status",
    sc_col_action: "Tindakan",
    sc_no_events: "Kejadian keamanan tidak ditemukan.",
    sc_node_title: "Konsol Keamanan Operator Node",
    sc_system_health: "Kesehatan Sistem",
    sc_last_audit: "Audit Terakhir",
    sc_packed_logs: "Log yang Dikompres",
    sc_unconfirmed_events: "Kejadian yang Belum Dikonfirmasi",
    sc_operator_action: "Tindakan Operator Diperlukan",
    sc_all_ok: "Semua OK",
    sc_critical_events: "Kejadian Sistem Kritis",
    ac_title: "Pusat Tata Kelola & Pelaporan",
    ac_subtitle: "Konsensus Tata Kelola & Pelaporan GaiaCom",
    ac_tab_my_reports: "Laporan Saya",
    ac_tab_queue: "Antrean Peninjauan",
    ac_tab_operator: "Operator Node",
    ac_tab_transparency: "Federasi & Transparansi",
    ac_loading: "Memuat data...",
    ac_reported_cases: "Kasus yang Dilaporkan",
    ac_no_reports: "Anda belum mengirimkan laporan apa pun.",
    ac_case_details: "Detail Kasus",
    ac_appeal_submit: "Ajukan Banding",
    ac_appeal_status: "Status Banding",
    ac_appeal_reason: "Alasan Banding",
    ac_appeal_statement: "Pernyataan",
    ac_btn_appeal: "Kirim Banding",
    ac_trusted_reviewer_queue: "Antrean Peninjau Terpercaya",
    ac_case_review: "Tinjau Kasus",
    ac_review_category: "Kategori yang Direkomendasikan",
    ac_review_severity: "Tingkat Keparahan yang Direkomendasikan",
    ac_review_action: "Tindakan yang Direkomendasikan",
    ac_review_reason: "Alasan Peninjau",
    ac_btn_submit_review: "Kirim Tinjauan",
    ac_node_operator_dashboard: "Dasbor Operator Node",
    ac_apply_action: "Terapkan Tindakan (Override)",
    ac_target_type: "Tipe Target",
    ac_target_id: "ID Target (GaiaID atau ID Saluran)",
    ac_suspend: "Tangguhkan aktif",
    ac_reason: "Alasan Resmi",
    ac_btn_apply: "Terapkan Tindakan",
    ac_transparency_title: "Buku Log Konsensus & Transparansi",
    ac_transparency_desc: "Bukti snapshot yang dapat dilihat publik dari semua saluran dan identitas yang dimoderasi.",
    ac_btn_snapshot: "Buat Snapshot Transparansi",
    search_placeholder: "Cari email berdasarkan subjek, pengirim, teks...",
    abuse_center_title: "Pusat Penyalahgunaan",
    abbrechen: "Membatalkan",
    active_identities: "Identitas aktif",
    active_identity: "Identitas aktif",
    add_btn: "Menambahkan",
    add_contact_title: "Tambahkan kontak",
    admin: "Admin",
    adressbuch: "direktori",
    aktiviert: "Diaktifkan",
    an: "Ke",
    anonymous_sender: "Pengirim anonim",
    antworten: "Menjawab",
    attachment_gaia_hint: "Lampiran GaiaCOM tetap terenkripsi ujung ke ujung.",
    attachment_smtp_hint: "SMTP lama memblokir lampiran yang dapat dieksekusi/seperti skrip dan menyimpan email sebagai tidak aman.",
    attachments: "Lampiran",
    auffaellig: "Nyata",
    auth_beta_notice: "Fase pengujian beta: GaiaCOM sedang diuji secara aktif. Kesalahan mungkin terjadi; mengamankan benih penting dan meninjau dengan cermat alur kerja rahasia.",
    auth_btn_login: "Muat identitas & masuk",
    auth_btn_register: "Daftarkan & buat kripto",
    auth_copied: "Disalin",
    auth_copy_seed: "Salin benih",
    auth_generate_seed: "Hasilkan benih",
    auth_headline: "GaiaCOM adalah protokol email dan sistem komunikasi kuantum aman pertama yang dibangun untuk kemanusiaan.",
    auth_kicker: "Komunikasi Aman Pasca-Quantum",
    auth_mnemonic: "Ungkapan mnemonik",
    auth_mnemonic_placeholder: "12 kata dipisahkan dengan spasi...",
    auth_password: "kata sandi",
    auth_password_placeholder: "••••••••••••",
    auth_proof_e2ee_desc: "Kunci pribadi tidak akan meninggalkan perangkat Anda. Hanya penerima yang dituju yang dapat mendekripsi konten.",
    auth_proof_gaiadata_desc: "Tanpa Pengetahuan: Anda tetap mengontrol data Anda. Metadata diminimalkan dan tidak digunakan sebagai profil teks biasa.",
    auth_proof_gaiadrop_desc: "Orang luar dapat mengirim pesan teks rahasia ke GaiaID Anda tanpa akun.",
    auth_proof_gaiaproof_desc: "Bukti pengiriman dan integritas menunjukkan bahwa ciphertext, pengirim dan stempel waktu belum dirusak.",
    auth_proof_gaiavault_desc: "Catatan pribadi, catatan pemulihan, dan catatan keamanan tetap dienkripsi secara lokal.",
    auth_proof_hybrid_desc: "Quantum Shield: Enkripsi hibrid dengan ML-KEM dan X25519 melindungi terhadap serangan masa kini dan risiko simpan sekarang-dekripsi-nanti.",
    auth_secure_mail: "Amankan Surat Federasi Quantum",
    auth_subline: "GaiaCOM adalah sistem komunikasi kuantum aman untuk email, obrolan, ruang krisis, GaiaDrop, dan file keamanan lokal. Kunci pribadi tetap ada di perangkat Anda, konten dienkripsi secara end-to-end, dan bukti dapat diekspor tanpa teks biasa.",
    auth_success_btn: "Masuk sekarang",
    auth_success_text: "Akun GaiaCOM Anda telah dibuat. Kuncinya diambil secara lokal dari seed Anda dan tidak disimpan di server.",
    auth_success_title: "Pendaftaran berhasil",
    auth_tab_drop: "Gaia Jatuhkan",
    auth_tab_login: "Masuk/Akun",
    auth_toggle_login: "Akun sudah ada",
    auth_toggle_register: "Buat akun baru",
    auth_usecase_text: "Cocok untuk pengacara, perusahaan, otoritas, jurnalis, pelapor, dan kasus keamanan swasta.",
    auth_usecase_title: "Dibangun untuk komunikasi sensitif",
    auth_username: "nama belakang",
    auth_username_placeholder: "Masukkan nama...",
    auth_value_chat: "Obrolan E2E",
    auth_value_drop: "Jatuhkan Aman",
    auth_value_mail: "Surat aman",
    auth_value_rooms: "Kamar Gaia",
    bestaetigen: "Mengonfirmasi",
    bestaetigt: "Dikonfirmasi",
    bio_status: "Biografi/Status",
    biography: "biografi",
    change_password_desc: "Mengubah kata sandi masuk sisi server Anda. Frase pemulihan lokal Anda tetap dilindungi secara terpisah oleh kata sandi brankas/buka kunci Anda.",
    change_password_menu_desc: "Perbarui kata sandi masuk GaiaCOM.",
    change_password_title: "Ubah Kata Sandi",
    channel_id: "ID Saluran",
    channel_name_label: "Nama saluran",
    chat_deleted_hidden: "Obrolan dihapus dan disembunyikan.",
    chat_input_placeholder: "Masukkan pesan aman...",
    chat_start_hint: "Mulailah percakapan! Semua pesan obrolan dienkripsi dengan kuantum aman E2E.",
    choose_avatar: "Pilih avatar",
    ciphertext_hash: "Hash teks tersandi",
    clear_chat: "Obrolan kosong",
    clear_for_everyone: "Kosong untuk semua orang",
    clear_for_me: "Kosong hanya untukku",
    click_to_write_mail: "Klik untuk menulis email",
    click_top_right: "Klik di kanan atas",
    close: "Menutup",
    code_kopieren: "Salin kode",
    code_kopieren_success: "Kode disalin",
    confirm_clear_channel_desc: "Apakah Anda ingin menghapus saluran ini dari tampilan lokal Anda?",
    confirm_clear_channel_title: "Saluran kosong",
    confirm_clear_chat: "Apakah Anda ingin mengosongkan obrolan ini?",
    confirm_clear_chat_desc: "Apakah Anda ingin mengosongkan obrolan ini?",
    confirm_clear_chat_title: "Obrolan kosong",
    confirm_clear_everyone: "Apakah Anda ingin mengosongkan obrolan untuk kedua pasangan? (OK = Untuk semuanya, Batal = Hanya untuk saya)",
    confirm_delete_everyone: "Apakah Anda ingin menghapus pesan untuk kedua pasangan? (OK = Untuk semuanya, Batal = Hanya untuk saya)",
    confirm_delete_msg: "Apakah Anda ingin menghapus pesan ini?",
    confirm_delete_msg_desc: "Apakah Anda ingin menghapus pesan obrolan ini?",
    confirm_delete_msg_title: "Hapus pesan",
    confirm_new_password: "Konfirmasikan kata sandi baru",
    copy: "Menyalin",
    create_btn: "Membuat",
    create_channel_title: "Buat saluran",
    create_group_is_crisis: "Tandai sebagai area krisis",
    create_group_title: "Buat grup baru",
    crypto_lock_desc: "Mengontrol kapan GaiaCOM menghapus kunci kripto lokal dari memori.",
    crypto_lock_menu_desc: "Kontrol pengatur waktu muat ulang dan tidak aktif.",
    crypto_lock_title: "Kunci kriptografi",
    crypto_session_duration: "Tidak terkunci setelah memuat ulang",
    crypto_session_duration_desc: "Hanya membiarkan sesi kripto tetap terbuka di tab browser ini selama durasi yang dipilih.",
    cryptographic_fingerprint: "Sidik jari kriptografi",
    current_password: "Kata Sandi Saat Ini",
    data_minimization: "Minimalkan data",
    decrypt_failed: "Tidak dapat diuraikan",
    delete: "Menghapus",
    delete_account_button: "Hapus akun tanpa dapat ditarik kembali",
    delete_account_confirm_label: "Masukkan DELETE untuk mengonfirmasi",
    delete_account_confirmation_error: "Konfirmasi kata sandi dan DELETE diperlukan.",
    delete_account_desc: "Mode ini secara permanen menghancurkan akun, identitas, sesi perangkat, data GaiaDrop, metadata unggahan, dan pesan yang dapat diatribusikan di sisi server.",
    delete_account_done_desc: "Semua data GaiaCOM yang dapat dialihkan telah dihapus.",
    delete_account_done_title: "Akun dihapus",
    delete_account_menu_desc: "Hancurkan akun dan data terkait.",
    delete_account_not_authenticated: "Tidak ada akun aktif.",
    delete_account_title: "Hapus akun",
    delete_for_everyone: "Hapus untuk semua orang",
    delete_for_me: "Hapus hanya untukku",
    device_current: "Perangkat ini",
    device_last_seen: "Terakhir",
    device_logout: "Keluar",
    device_sessions_desc: "Periksa sesi aktif dan batalkan pendaftaran perangkat yang tidak lagi Anda percayai.",
    device_sessions_empty: "Tidak ada perangkat yang ditemukan.",
    device_sessions_menu_desc: "Kelola dan akhiri sesi aktif.",
    device_sessions_title: "Perangkat terdaftar",
    device_since: "Sejak",
    display_name: "Nama tampilan",
    drop_address_copied: "Alamat GaiaDrop disalin.",
    drop_btn_decrypting: "Kotak masuk sedang didekripsi...",
    drop_btn_load: "Muat Kotak Masuk GaiaDrop",
    drop_delete_desc: "Apakah Anda benar-benar ingin menghapus penurunan ini secara permanen?",
    drop_delete_title: "Hapus GaiaDrop",
    drop_desc: "Saluran tanpa pengetahuan hanya berupa teks untuk pemberitahuan eksternal, pengungkapan yang bertanggung jawab, dan laporan rahasia. Pihak eksternal dapat mengirim pesan tanpa akun menggunakan GaiaID Anda.",
    drop_empty: "Belum ada pesan GaiaDrop yang dimuat.",
    drop_id: "Jatuhkan ID:",
    drop_own_address: "Alamat GaiaDrop Anda",
    drop_proof: "BUKTI JATUH",
    drop_title: "Kotak Masuk Aman GaiaDrop",
    dunkler_modus: "Mode gelap",
    e2e_chat_room_open: "Buka ruang obrolan E2E",
    edit_profile: "Sunting profil",
    edit_profile_desc: "Sesuaikan nama tampilan, bio, dan avatar.",
    einladungscode: "Kode undangan",
    enter_fingerprint_chars_confirm: "Masukkan karakter sidik jari yang diminta untuk mengonfirmasi.",
    envelope_hash: "Hash amplop",
    erasability: "kemampuan untuk dihapus",
    erfolg: "Kesuksesan",
    exclude_plaintext: "Ekspor tanpa teks biasa",
    export_disclosure: "Ekspor kasus keamanan",
    export_package_desc: "Hanya sertakan teks biasa jika pengungkapan ini memang disengaja.",
    export_package_title: "Ekspor paket keamanan",
    fehler: "Kesalahan",
    gaiacom_reader: "Pembaca GaiaCOM",
    gaiadrop_inbox_title: "Kotak Masuk GaiaDrop",
    gaiavault: "Gudang Gaia",
    gdpr_home_desc: "GaiaCOM meminimalkan metadata, menjaga kunci pribadi tetap lokal, mengenkripsi konten end-to-end dan memungkinkan penghapusan akun sepenuhnya.",
    gdpr_home_title: "100% mematuhi GDPR",
    gdpr_reason_delete: "Penghapusan akun menghapus akun, identitas, sesi lokal, dan data yang dapat ditetapkan di sisi server.",
    gdpr_reason_e2ee: "Konten pribadi tetap dapat didekripsi hanya untuk penerima yang dituju.",
    gdpr_reason_minimal: "Metadata hanya digunakan untuk perutean, pengiriman, dan kredensial keamanan.",
    gdpr_reason_zero_knowledge: "Kunci pribadi dan data pemulihan tetap berada di bawah kendali pengguna secara lokal.",
    gesendet: "Terkirim",
    gesperrt_verdaechtig: "Dilarang / Mencurigakan",
    group_delete_desc: "Apakah Anda benar-benar ingin menghapus grup ini secara permanen? Semua saluran dan pesan di grup ini akan dihapus.",
    group_delete_title: "Hapus grup",
    group_description: "Keterangan",
    group_icon_label: "Ikon grup/avatar",
    group_name: "Nama grup",
    group_settings_avatar: "Avatar",
    group_settings_desc: "Keterangan",
    group_settings_is_crisis: "Tandai sebagai area krisis",
    group_settings_name: "Nama grup",
    group_settings_title: "Pengaturan grup",
    groups_empty_desc: "Ciptakan ruang kerja yang aman untuk proyek, krisis, atau komunikasi tim.",
    groups_empty_title: "Belum ada obrolan grup",
    gruppe_beitreten: "Bergabung dengan grup",
    gruppe_erstellen: "+ Buat grup",
    gruppe_verlassen: "Keluar dari grup",
    gruppen_chats: "Obrolan grup",
    heller_modus: "Modus terang",
    how_to_receive_drops: "Bagaimana cara saya menerima tetes?",
    identitaets_assistent: "Asisten Identitas",
    inactivity_lock_duration: "Kunci saat tidak aktif",
    inactivity_lock_duration_desc: "Setelah periode tidak ada input ini, GaiaCOM akan otomatis terkunci secara kriptografis.",
    inactivity_lock_notice: "GaiaCOM telah diblokir secara kriptografis karena tidak ada aktivitas.",
    include_plaintext: "Sertakan teks biasa",
    invite_code_label: "Kode undangan",
    join_group_title: "Bergabunglah dengan grup",
    kanaele: "Saluran",
    kanal_erstellen: "+ saluran",
    kein_chat_ausgewaehlt: "Tidak ada obrolan yang dipilih",
    kein_kanal_ausgewaehlt: "Tidak ada saluran yang dipilih",
    keine_gruppe_ausgewaehlt: "Tidak ada grup yang dipilih",
    keine_mails: "Tidak ada email yang tersedia.",
    key_change_warn_desc: "Kunci publik kontak ini telah berubah. Periksa sidik jari sebelum mempercayainya.",
    key_change_warn_title: "Peringatan kriptografi",
    key_change_warning_changed: "telah berubah. Ini mungkin pertanda serangan man-in-the-middle!",
    key_change_warning_msg: "Kunci identitas untuk kontak tersebut",
    key_transparency: "Transparansi Utama",
    kopiert: "Disalin",
    kryptographische_schluessel: "Kunci kriptografi",
    kryptographische_schluessel_desc: "Tampilkan kunci pribadi dan frase benih cadangan.",
    laden: "Memuat...",
    leeren: "Kosong",
    loading: "Memuat...",
    local_key_vault: "Gudang kunci lokal",
    local_keys_label: "Kunci lokal",
    lock_on_reload: "Selalu kunci setelah memuat ulang",
    logout: "Keluar",
    mail_compose: "Tulis email",
    mein_profil: "Profil saya",
    melden: "Laporan",
    menu: "menu",
    message: "Berita",
    message_id: "ID pesan",
    message_pin: "Pin",
    message_pinned_title: "Pesan yang disematkan",
    message_react: "Bereaksi",
    message_reply: "Menjawab",
    message_replying_to: "Jawaban untuk",
    message_save: "Menyimpan",
    message_saved: "Disimpan",
    message_to_channel: "Pesan ke",
    message_unpin: "Menyelesaikan",
    message_unsave: "Jangan simpan",
    mitglied: "Anggota",
    mitglieder: "anggota",
    ml_kem: "ML-KEM",
    neue_mail: "email baru",
    never_auto_lock: "Tidak pernah secara otomatis",
    new_fingerprint: "Sidik jari baru",
    new_identity: "Identitas baru",
    new_password: "Kata sandi baru",
    no_description: "Tidak ada deskripsi",
    no_key_history: "Tidak ada riwayat kunci yang tercatat.",
    no_specification: "Tidak ditentukan",
    old_fingerprint: "Sidik jari lama",
    open_privacy_imprint: "Buka lini cetak dan perlindungan data",
    post_quantum_e2e: "E2E pasca-kuantum",
    posteingang: "Kotak masuk",
    powered_by: "Didukung oleh",
    privacy_imprint_menu_desc: "Tampilkan GDPR, perlindungan data, dan pemberitahuan hukum.",
    privacy_imprint_profile_desc: "GaiaCOM memproses konten komunikasi sesuai dengan prinsip minimalisasi data, enkripsi ujung ke ujung, dan kontrol kunci lokal.",
    privacy_imprint_title: "Perlindungan data & pemberitahuan hukum",
    profil: "profil",
    profile_details: "Detail profil",
    profile_settings_hint: "Pengaturan profil ditampilkan di panel kanan.",
    profile_unlock_desc: "Demi alasan keamanan, Anda harus memasukkan kembali kata sandi untuk melihat kunci kriptografi pribadi Anda.",
    proof_hash: "Bukti hash:",
    public_drop_desc: "Amankan Drop untuk informasi teks eksternal tanpa akun GaiaCOM.",
    public_drop_message: "Berita",
    public_drop_message_placeholder: "Masukkan teks rahasia...",
    public_drop_send: "Kirim GaiaDrop",
    public_drop_sender: "Catatan pengirim opsional",
    public_drop_sender_placeholder: "Nama, nomor file atau anonim",
    public_drop_target: "Targetkan GaiaID",
    quanten_chat: "Obrolan Kuantum",
    quantum_secure_exchange: "Pertukaran aman kuantum melalui...",
    quantum_secure_net: "Jaringan Aman Kuantum GaiaCOM (Ed25519 & ML-KEM)",
    quantum_shield_desc: "Jaringan GaiaCOM melindungi privasi Anda dengan protokol enkripsi hibrid multi-lapis yang terlindung dari serangan komputer kuantum di masa depan.",
    quantum_shield_l1_desc: "Menggunakan standar FIPS 203 untuk merangkum kunci bersama simetris. Mencegah perekaman pasif dan dekripsi selanjutnya (“Simpan Sekarang, Dekripsi Nanti”) oleh komputer kuantum.",
    quantum_shield_l1_title: "1. Perlindungan Pasca-Quantum (ML-KEM-1024)",
    quantum_shield_l2_desc: "Prosedur pertukaran kunci Diffie-Hellman klasik dan sangat cepat yang berfungsi sebagai lapisan keamanan tambahan dalam prosedur hibrid.",
    quantum_shield_l2_title: "2. Kriptografi Kurva Elips (X25519)",
    quantum_shield_l3_desc: "Setiap pesan dan setiap amplop Federasi ditandatangani secara kriptografis untuk memverifikasi keaslian pengirimnya.",
    quantum_shield_l3_title: "3. Tanda Tangan Digital (Ed25519)",
    quantum_shield_l4_desc: "Mengenkripsi konten pesan secara simetris dan mengikat erat pengirim, penerima, dan metadata ke dalam Data Tambahan yang Diotentikasi (AAD) untuk mencegah serangan replay.",
    quantum_shield_l4_title: "4. Otentikasi AAD (AES-256-GCM)",
    quantum_shield_status: "Status Perisai Kuantum",
    receive_drops_step1: "Bagikan GaiaID Anda (misalnya menggunakan tombol salin di atas) dengan sumber eksternal.",
    receive_drops_step2: "Ini memanggil halaman login instance GaiaCOM Anda dan beralih ke tab",
    receive_drops_step3: "dan mengirim pesan terenkripsi mereka ke alamat Anda.",
    receiver_gaia: "Penerima GaiaCOM",
    receiver_smtp: "Penerima SMTP",
    records_stored: "Catatan disimpan",
    refresh: "Memperbarui",
    report_abuse_desc: "Apakah Anda ingin melaporkan pesan ini dan mengirimkan bukti penyalahgunaan kriptografi ke server?",
    report_abuse_title: "Laporkan penyalahgunaan",
    reputation_status: "Status Reputasi",
    room_chat_start_hint: "Mulailah percakapan! Semua pesan di saluran grup ini terdesentralisasi dengan enkripsi E2E yang aman untuk kuantum.",
    room_policy_audit: "Jejak audit dan rotasi kunci aktif.",
    room_policy_crisis: "Ruang krisis",
    room_policy_e2ee: "Ruang tanpa pengetahuan. Brankas kuantum E2EE.",
    room_policy_title: "Pedoman ruangan",
    room_policy_zero_knowledge: "Kebijakan",
    room_security_note_desc: "Semua perubahan penting divalidasi melalui Transparansi Kunci. Gunakan GaiaVault untuk log cadangan pribadi.",
    room_security_note_title: "Catatan keamanan yang disematkan",
    save_profile: "Simpan profil",
    schluessel_entsperrt: "🔑 Kunci lagi kuncinya",
    search_gaia_label: "Temukan alamat Gaia",
    security_warning_title: "Peringatan keamanan",
    select_channel_chat: "Pilih saluran dari sidebar kiri untuk mengobrol.",
    select_contact_chat: "Pilih kontak dari panel kiri untuk memulai obrolan E2E yang aman kuantum.",
    select_mail_read: "Pilih email dari daftar untuk membaca konten aman kuantumnya atau membuat pesan baru.",
    senden: "Mengirim",
    sender_signature: "Tanda Tangan Pengirim",
    server_log: "Catatan server:",
    server_received: "Server Diterima",
    session_lock: "Kunci sesi",
    setup_address_keys: "Buat alamat dan set kunci",
    setup_profile: "Atur di profil",
    smtp_inbox_title: "penerimaan SMTP",
    smtp_legacy_badge: "SMTP Lama / Tidak Aman",
    smtp_mode_option: "Jembatan SMTP lama",
    smtp_security_warning: "Email ini dikirimkan melalui protokol SMTP klasik yang tidak terenkripsi. Tidak ada enkripsi ujung ke ujung yang aktif.",
    smtp_security_warning_desc: "Pesan ini meninggalkan ruang keamanan GaiaCom. Pengiriman SMTP tidak memberikan jaminan end-to-end asli GaiaCom, tidak ada jaminan TrustMesh, dan tidak ada jaminan Godmode dari gateway.",
    spam_verdacht: "Spam/kecurigaan",
    spam_warning_desc: "Pesan ini memiliki sinyal reputasi yang mencurigakan.",
    spam_warning_title: "Peringatan spam",
    speichern: "Menyimpan",
    sperren: "Kunci keluar",
    standard_group_status: "Obrolan grup standar (terenkripsi E2EE)",
    status: "status",
    subject: "Tentang",
    suchen: "Temukan alamat Gaia baru...",
    tage: "hari",
    time_unknown: "Waktu tidak diketahui",
    transmission_mode: "Modus perpindahan",
    trust_age: "Usia kepercayaan",
    trust_passport_title: "Percayai Paspor",
    unbestaetigt: "Belum dikonfirmasi",
    unknown_sender: "Tidak dikenal",
    unlock_btn: "Membuka kunci",
    unlock_btn_profile: "Membuka kunci",
    unlock_desc: "File kunci pribadi Anda disimpan terenkripsi. Masukkan kata sandi Anda untuk memuat kunci kriptografi di memori saja.",
    unlock_logout: "Keluar dan tutup kunci lokal",
    unlock_title: "Buka Kunci Identitas",
    untrusted: "Tidak dapat dipercaya",
    update_password: "Perbarui kata sandi",
    upload_avatar_btn: "Unggah gambar (Disanitasi)",
    vault_btn_encrypt: "Enkripsi catatan",
    vault_btn_lock: "Kunci aman",
    vault_btn_unlock: "Buka kunci dengan aman",
    vault_copied_success: "Disalin ke papan klip",
    vault_decrypted_content: "Konten yang didekripsi",
    vault_desc: "Gudang terenkripsi lokal untuk cadangan pemulihan, catatan identitas, akses server, kontak darurat, catatan hukum, peristiwa keamanan, dan log pribadi.",
    vault_empty: "Belum ada catatan aman yang disimpan.",
    vault_locked_pane_notice: "Brankas terkunci. Silakan buka kunci di sebelah kanan.",
    vault_new_record: "Rekor aman baru",
    vault_pwd_placeholder: "Masukkan Kata Sandi Gudang...",
    vault_record_body: "Rekam konten",
    vault_record_body_placeholder: "Masukkan konten rekaman terenkripsi...",
    vault_record_category: "kategori",
    vault_record_title: "Judul rekaman",
    vault_record_title_placeholder: "Judul catatan aman",
    vault_title: "Catatan Aman GaiaVault",
    verify_new_fingerprint_hint: "Periksa sidik jari baru sebelum menerima kunci.",
    vertrauenswuerdig: "Terpercaya",
    vision_gaia_technology: "VisiGaiaTeknologi",
    von: "Dari",
    warnung: "peringatan",
    wizard_address: "alamat",
    wizard_back: "Kembali",
    wizard_check1: "Saya telah menyimpan benih saya dengan aman.",
    wizard_custom_domain: "Gunakan domain Anda sendiri",
    wizard_desc1: "GaiaCOM tidak menyimpan kunci pribadi di sisi server. Tanpa Mnemonic Seed, tidak ada yang bisa memulihkan pesan yang hilang.",
    wizard_desc2: "Alamat Anda menentukan simpul gabungan yang melaluinya amplop terenkripsi dirutekan.",
    wizard_fallback: "Node cadangan",
    wizard_finish: "Selesaikan penyiapan",
    wizard_next: "Lebih jauh",
    wizard_server_domain: "Domain simpul server",
    wizard_step1: "1. Benih Cadangan",
    wizard_step2: "2. Alamat & Server",
    wizard_title1: "Cadangkan kunci pemulihan",
    wizard_title2: "Pilih alamat GaiaCOM",
    write_message_placeholder: "Tulis pesan aman...",
    you: "Anda",
    zero_knowledge: "Pengetahuan nol",
    zero_knowledge_encryption: "Enkripsi tanpa pengetahuan",
    "Chat fuer alle geleert": "Obrolan telah dikosongkan untuk semua peserta.",
    "Chat geleert": "Obrolan telah dihapus untuk kotak masuk lokal Anda.",
    "Nachricht fuer alle geloescht": "Pesan telah dihapus untuk semua peserta.",
    "Nachricht geloescht": "Pesan obrolan telah dihapus secara lokal dari kotak masuk Anda.",
    "anpinnen": "Pin",
    "chat_loeschen": "Hapus obrolan",
    "confirm_delete_chat_desc": "Apakah Anda yakin ingin menghapus dan menyembunyikan obrolan tersebut?",
    "confirm_leave_group_desc": "Apakah Anda benar-benar ingin keluar dari grup ini?",
    "entpinnen": "Membuka peniti",
    "group_deleted": "Grup berhasil dihapus.",
    "group_left": "Keluar dari grup dengan sukses.",
    "gruppe_loeschen": "Hapus grup",
    "loeschen": "Menghapus",
    "no_active_chats": "Tidak ada obrolan aktif. Cari kontak di atas untuk memulai obrolan.",
    "pinned": "Disematkan",
    "wizard_check_credentials": "Saya bertanggung jawab untuk menjaga keamanan data akses saya.",
    "wizard_check_is_beta": "Saya memahami bahwa GaiaCom adalah perangkat lunak beta.",
    "wizard_check_no_illegal": "Saya tidak akan menggunakan GaiaCom untuk tujuan yang melanggar hukum.",
    "wizard_check_no_uptime": "Saya memahami bahwa tidak ada jaminan ketersediaan.",
    "wizard_check_smtp_security": "Saya memahami bahwa pesan SMTP tidak memberikan keamanan penuh GaiaCom.",
    "wizard_check_terms_read": "Saya telah membaca Ketentuan Layanan Beta.",
    "wizard_step_terms": "Ketentuan Penggunaan",
    "wizard_terms_text": "Ketentuan Penggunaan GaiaCom dan Perjanjian Pengujian Beta (Fase Beta)\n\nPenyedia: VisionGaiaTechnology (selanjutnya disebut “Penyedia”)\nStatus: Tahap pengujian beta publik\nValiditas: Mulai 21 Juni 2026\n\n⚠️ CATATAN PALING PENTING SEBELUMNYA (HARAP BACA DENGAN TELITI)\nGaiaCom sedang dalam tahap pengujian beta publik. Meskipun terdapat langkah-langkah keamanan yang ekstensif, kebebasan dari kesalahan, ketersediaan berkelanjutan, atau keamanan absolut dari perangkat lunak dan infrastruktur yang mendasarinya tidak dapat dijamin. Gunakan dengan risiko Anda sendiri. Pengguna bertanggung jawab atas penyimpanan data akses mereka dengan aman (terutama kunci untuk GaiaVault) dan kepatuhan terhadap hukum yang berlaku.\n\n1. Subjek dan tujuan tahap pengujian beta\n1.1. Tujuan penyediaan: GaiaCom adalah layanan email dan obrolan baru berdasarkan kriptografi pasca-kuantum (PQC). Penyediaan pada tahap beta ditujukan khusus untuk pengujian teknis, simulasi beban, menemukan kesalahan program (bug) dan mengoptimalkan kemudahan penggunaan.\n1.2. Status beta: Pengguna mengetahui bahwa perangkat lunak yang ditawarkan adalah versi awal (perangkat lunak beta). Hal ini belum sepenuhnya dikembangkan secara teknis, tidak memenuhi standar produk akhir komersial dan dapat menyebabkan kesalahan, kehilangan data, penundaan transmisi atau kerusakan sistem.\n1.3. Tidak ada hak untuk melanjutkan: Penyedia berhak sewaktu-waktu menghentikan layanan secara keseluruhan atau sebagian, mengubah atau membatasi fungsi atau menghapusnya untuk sementara atau permanen tanpa memberikan alasan.\n\n2. Ketersediaan dan Penafian Garansi\n2.1. Tidak ada jaminan ketersediaan: GaiaCom disediakan tanpa jaminan ketersediaan atau uptime. Tidak ada hak atas ketersediaan layanan tanpa gangguan.\n2.2. Pengecualian jaminan: Perangkat lunak disediakan dalam kondisi terkini (“sebagaimana adanya”) dan bergantung pada ketersediaan. Sejauh diizinkan oleh undang-undang, klaim jaminan apa pun atas cacat material dan hukum pada perangkat lunak tidak termasuk. Secara khusus, tidak ada jaminan bahwa perangkat lunak tersebut bebas dari kesalahan, bebas dari malware, atau cocok untuk tujuan tertentu.\n\n3. Manajemen risiko dan kewajiban pengguna\n3.1. Larangan penyimpanan data penting: Pengguna berjanji untuk tidak secara eksklusif menyimpan atau mengirimkan melalui GaiaCom data bisnis apa pun yang penting, penting, diperlukan secara operasional, atau sensitif secara hukum (seperti file pasien, data keuangan yang sangat sensitif, atau rahasia yang diatur secara resmi). Layanan ini tidak boleh digunakan untuk infrastruktur di mana kegagalan yang tidak terduga dapat mengakibatkan cedera diri, kerusakan properti, atau kerugian finansial yang signifikan.\n3.2. Pencadangan yang bertanggung jawab sendiri: Pengguna bertanggung jawab untuk mencadangkan semua data yang diterima atau dikirim melalui GaiaCom yang ia perlukan dalam jangka panjang pada sistemnya sendiri yang independen (salinan cadangan). Penyedia tidak menjamin penyimpanan permanen atau pemulihan data di servernya.\n\n4. Fitur kriptografi dan GaiaVault\n4.1. Kriptografi pasca-kuantum (PQC): GaiaCom menerapkan proses enkripsi canggih dan berorientasi masa depan yang dirancang untuk menahan serangan dari komputer kuantum di masa depan. Namun, pengguna menyadari bahwa ini adalah bidang keilmuan yang dinamis dan baru. Keamanan yang mutlak dan tidak dapat disangkal tidak dapat dijamin berdasarkan kondisi ilmu pengetahuan dan teknologi saat ini. Istilah seperti “100% aman”, “tidak dapat dipecahkan”, atau “aman militer” secara tegas tidak dijamin.\n4.2. Tidak ada jaminan pemulihan (GaiaVault): GaiaCom mengandalkan konsep keamanan tanpa pengetahuan yang konsisten. Irisan enkripsi dan data akses tetap sepenuhnya berada dalam kendali pengguna (diamankan melalui GaiaVault).\nPENTING: Jika pengguna kehilangan kata sandi, frasa sandi, kunci pribadi, atau benih pemulihan, penyedia tidak memiliki kemampuan teknis untuk merekonstruksi atau mengatur ulang data ini. Hilangnya data akses ini pasti menyebabkan hilangnya akses yang tidak dapat dibatalkan ke akun pengguna dan semua data yang dienkripsi di dalamnya.\n4.3. Belum sepenuhnya diaudit: Perangkat lunak ini terus-menerus menjalani pemeriksaan keamanan internal, namun pada tahap beta ini, perangkat lunak belum menjalani audit keamanan eksternal akhir yang komprehensif oleh badan pengujian independen.\n\n5. Antarmuka, protokol lama, dan federasi\n5.1. SMTP Bridge Catatan: GaiaCom menawarkan kemampuan untuk berkomunikasi melalui protokol email klasik (seperti SMTP). Pengguna mengetahui bahwa pesan yang meninggalkan area keamanan asli GaiaCom (misalnya saat dikirim ke alamat konvensional @gmail.com atau @gmx.de) dikirim melalui server tidak terenkripsi atau pihak ketiga. Jaminan keamanan menyeluruh GaiaCom hanya berlaku sampai batas tertentu atau tidak berlaku sama sekali terhadap pesan lama yang keluar atau masuk secara eksternal.\n5.2. Catatan Federasi: Jika GaiaCom beroperasi pada jaringan gabungan, pesan dan data dapat melewati server pihak ketiga. Meskipun isi pesan tetap dilindungi oleh enkripsi ujung ke ujung, metadata (seperti waktu pengiriman, alamat IP server yang terlibat, dan alamat penerima) secara teknis dapat dilihat oleh operator server gabungan ini. Penyedia tidak mempunyai pengaruh terhadap praktik perlindungan data operator server pihak ketiga di jaringan gabungan.\n\n6. Penggunaan yang Dapat Diterima dan Aktivitas yang Dilarang\nPengguna berjanji untuk tidak menggunakan layanan secara tidak benar atau untuk tujuan ilegal. Secara khusus, hal-hal berikut ini dilarang:\n- Mendistribusikan, mengirim atau menghosting virus, malware, konten phishing, atau perangkat lunak berbahaya lainnya.\n- Menggunakan Layanan untuk melakukan serangan penolakan layanan (DDoS) atau pengiriman massal yang tidak diminta (spam).\n- Menyalahgunakan sistem untuk melakukan penipuan.\n- Distribusi atau pertukaran konten ilegal, khususnya penggambaran pelecehan seksual terhadap anak-anak (CSAM), propaganda teroris, seruan kekerasan atau konten kriminal lainnya.\n\n7. Sistem pelaporan penyalahgunaan\n7.1. Melaporkan perilaku kasar: Pengguna memiliki kesempatan untuk melaporkan komunikasi yang kasar atau aktivitas ilegal melalui sistem penyalahgunaan terintegrasi.\n7.2. Pemrosesan laporan: Untuk memastikan perlindungan terhadap penyalahgunaan, laporan yang masuk dapat dianalisis secara teknis (dengan tetap menjaga batas privasi dan enkripsi). Hal ini dapat menyebabkan penangguhan sementara atau permanen terhadap akun pengguna atau alamat IP jika terbukti terjadi pelanggaran terhadap ketentuan penggunaan ini.\n\n8. Batasan Tanggung Jawab\n8.1. Standar pertanggungjawaban: Perangkat lunak beta disediakan secara gratis. Menurut aturan hukum mengenai sumbangan atau pinjaman, penyedia hanya bertanggung jawab atas kesengajaan (kerusakan yang disengaja) dan kelalaian berat.\n8.2. Pengecualian tanggung jawab atas kehilangan data: Tanggung jawab atas hilangnya data dikecualikan kecuali kerugian tersebut disebabkan secara sengaja atau karena kelalaian besar oleh penyedia dan pengguna telah memenuhi kewajibannya untuk memitigasi kerusakan melalui pencadangan rutin (di luar GaiaCom).\n8.3. Batasan hukum: Batasan tanggung jawab di atas tidak berlaku untuk cedera terhadap nyawa, tubuh, atau kesehatan, atau tanggung jawab berdasarkan Undang-Undang Kewajiban Produk.\n\n9. Sumber Terbuka\nKomponen, pustaka, atau aplikasi klien GaiaCom tertentu mungkin dilisensikan berdasarkan lisensi sumber terbuka (misalnya GPL, MIT, Apache). Ketentuan lisensi masing-masing komponen ini tetap tidak terpengaruh oleh ketentuan penggunaan ini dan dapat dilihat di repositori kode sumber terkait.\n\n10. Pengendalian dan Kepatuhan Ekspor\nPengguna menyadari bahwa perangkat lunak kriptografi mungkin tunduk pada kontrol ekspor yang ketat dan batasan hukum. Pengguna bertanggung jawab untuk memastikan bahwa penggunaan GaiaCom tidak melanggar hukum, pembatasan impor/ekspor, atau peraturan kriptografi di negara tempat tinggalnya masing-masing.\n\n11. Pemberitahuan perlindungan data (versi singkat untuk beta)\n11.1. Pengumpulan data minimal: Sebagai bagian dari fase beta, penyedia hanya mengumpulkan data yang benar-benar diperlukan untuk pengoperasian teknis, pemecahan masalah, dan pengembangan lebih lanjut (misalnya file log server untuk diagnosis kesalahan).\n11.2. Tidak ada wawasan tentang konten: Berkat enkripsi zero-knowledge dan E2E yang konsisten, penyedia tidak pernah memiliki akses ke konten obrolan, email, atau kunci Anda yang disimpan di GaiaVault.\n11.3. Deklarasi perlindungan data terperinci: Peraturan perlindungan data terperinci ditautkan secara terpisah dan juga harus dipertimbangkan oleh pengguna sebelum mendaftar.\n\n12. Ketentuan akhir\n12.1. Hukum yang berlaku: Hukum Republik Federal Jerman berlaku, kecuali Konvensi PBB tentang Kontrak Penjualan Barang Internasional.\n12.2. Dapat berubah sewaktu-waktu: Karena GaiaCom sedang dalam pengembangan aktif, penyedia berhak untuk menyesuaikan ketentuan ini kapan saja dan berlaku di masa mendatang. Versi saat ini tersedia di aplikasi.",
    "wizard_terms_title": "Ketentuan Penggunaan GaiaCom dan Perjanjian Pengujian Beta (Fase Beta)",
    "node_operator": "Operator simpul",
    "search_channels": "Cari saluran...",
    "senior_reviewer": "Peninjau Senior",
    "trusted_reviewer": "Peninjau Tepercaya",
    "active_frequencies": "Frekuensi aktif",
    "connected_rooms": "RUANG YANG TERHUBUNG",
    "dashboard": "Dasbor",
    "empty_chats": "Tidak ada obrolan aktif yang tersedia.",
    "empty_messages": "Tidak ada pesan baru yang tersedia.",
    "encrypted": "Terenkripsi",
    "gaiacom_uplink": "Tautan UP GAIACOM",
    "install_app": "Instal aplikasi",
    "install_app_desc": "Untuk memulai cepat & mode offline",
    "kommandozentrale_alpha": "Pusat komando ALPHA",
    "network_online": "JARINGAN: ONLINE",
    "new_room": "Ruang baru",
    "no_frequencies_active": "Tidak ada frekuensi yang aktif. Ciptakan ruang baru untuk memulai komunikasi.",
    "no_id": "Tidak ada tanda pengenal",
    "open_chats": "Buka obrolan",
    "open_inbox": "Buka kotak masuk",
    "primary_identity": "IDENTITAS UTAMA",
    "recent_chats": "Obrolan baru",
    "recent_messages": "Berita terbaru",
    "session_encrypted": "Sesi dienkripsi: {name}",
    "session_secure": "STATUS: AMAN",
    "system_verlassen": "Sistem keluar",
    "write_message": "Tulis pesan",
  },
  sq: {
    sc_title: "Qendra e Sigurisë",
    sc_subtitle: "Shtresa e Sigurisë e Integruar GaiaShield",
    sc_tab_status: "🛡️ Statusi i Mbrojtjes",
    sc_tab_events: "📋 Regjistri i Sigurisë",
    sc_tab_node: "⚙️ Siguria e Nyjes",
    sc_loading: "Duke ngarkuar të dhënat e sigurisë...",
    sc_status_secured: "Statusi i Sistemit: Llogaria është e mbrojtur",
    sc_status_warning: "Statusi i Sistemit: Paralajmërime aktive",
    sc_desc_secured: "Nuk ka paralajmërime kritike aktive për sigurinë. GaiaShield po monitoron në mënyrë aktive llogarinë tuaj.",
    sc_desc_warning: "Kujdes: Ka ngjarje aktive të sigurisë që kërkojnë vëmendjen tuaj.",
    sc_account_protection: "Mbrojtja e Llogarisë",
    sc_message_protection: "Mbrojtja e Mesazheve",
    sc_audits: "Auditime të Sigurisë",
    sc_active: "AKTIV",
    sc_failed_logins: "Hyrjet e Dështuara",
    sc_tamper_checks: "Verifikimi i Ndërhyrjeve",
    sc_blocked_replays: "Replay e Bllokuara",
    sc_last_check: "Verifikimi i Fundit",
    sc_just_now: "Tani tani",
    sc_open_warnings: "Paralajmërime të Hapura",
    sc_btn_acknowledge: "Konfirmo",
    sc_filter_severity: "Shkalla e Rrezikut",
    sc_filter_category: "Kategoria",
    sc_filter_hide_ack: "Fshih të Konfirmuarat",
    sc_btn_export: "Eksporto",
    sc_col_details: "Detajet",
    sc_col_time: "Koha",
    sc_col_status: "Statusi",
    sc_col_action: "Veprimi",
    sc_no_events: "Nuk u gjet asnjë ngjarje sigurie.",
    sc_node_title: "Konsola e Sigurisë e Operatorit të Nyjes",
    sc_system_health: "Shëndeti i Sistemit",
    sc_last_audit: "Auditi i Fundit",
    sc_packed_logs: "Regjistrat e Paketuar",
    sc_unconfirmed_events: "Ngjarje të Pakonfirmuara",
    sc_operator_action: "Kërkohet Veprim nga Operatori",
    sc_all_ok: "Gjithçka në Rregull",
    sc_critical_events: "Ngjarje Kritike të Sistemit",
    ac_title: "Qendra e Qeverisjes dhe Raportimit",
    ac_subtitle: "Konsensusi i Qeverisjes dhe Abuzimit i GaiaCom",
    ac_tab_my_reports: "Raportimet e Mia",
    ac_tab_queue: "Radha e Rishikimit",
    ac_tab_operator: "Operatori i Nyjes",
    ac_tab_transparency: "Federata dhe Transparenca",
    ac_loading: "Duke ngarkuar të dhënat...",
    ac_reported_cases: "Rastet e Raportuara",
    ac_no_reports: "Nuk keni dërguar ende asnjë raport.",
    ac_case_details: "Detajet e Rastit",
    ac_appeal_submit: "Dërgo Apelim",
    ac_appeal_status: "Statusi i Apelimit",
    ac_appeal_reason: "Arsyeja e Apelimit",
    ac_appeal_statement: "Deklarata",
    ac_btn_appeal: "Dërgo Apelimin",
    ac_trusted_reviewer_queue: "Radha e Rishikuesit të Besuar",
    ac_case_review: "Rishiko Rastin",
    ac_review_category: "Kategoria e Rekomanduar",
    ac_review_severity: "Shkalla e Rekomanduar e Rrezikut",
    ac_review_action: "Veprimi i Rekomanduar",
    ac_review_reason: "Arsyeja e Rishikuesit",
    ac_btn_submit_review: "Dërgo Rishikimin",
    ac_node_operator_dashboard: "Paneli i Operatorit të Nyjes",
    ac_apply_action: "Zbato Veprimin (Mbishkruaj)",
    ac_target_type: "Lloji i Shënjestrës",
    ac_target_id: "ID e Shënjestrës (GaiaID ose ID e Kanalit)",
    ac_suspend: "Pezullimi aktiv",
    ac_reason: "Arsyeja Zyrtare",
    ac_btn_apply: "Zbato Veprimin",
    ac_transparency_title: "Libri i Konsensusi dhe Transparencës",
    ac_transparency_desc: "Provat e snapshot-eve të shikueshme publikisht të të gjithë kanaleve dhe identiteteve të moderuara.",
    ac_btn_snapshot: "Krijo Snapshot-in e Transparencës",
    search_placeholder: "Kërko email sipas subjektit, dërguesit, tekstit...",
    abuse_center_title: "Qendra e Abuzimit",
    abbrechen: "Anulo",
    active_identities: "Identitete aktive",
    active_identity: "Identiteti aktiv",
    add_btn: "Shto",
    add_contact_title: "Shto kontakt",
    admin: "Admin",
    adressbuch: "drejtoria",
    aktiviert: "Aktivizuar",
    an: "te",
    anonymous_sender: "Dërgues anonim",
    antworten: "Përgjigju",
    attachment_gaia_hint: "Bashkëngjitjet e GaiaCOM mbeten të koduara nga skaji në skaj.",
    attachment_smtp_hint: "SMTP e trashëguar bllokon bashkëngjitjet e ekzekutueshme/si skripti dhe i ruan emailet si të pasigurta.",
    attachments: "Shtojcat",
    auffaellig: "E dukshme",
    auth_beta_notice: "Faza e testimit beta: GaiaCOM po testohet në mënyrë aktive. Mund të ndodhin gabime; siguroni fara të rëndësishme dhe rishikoni me kujdes rrjedhat konfidenciale të punës.",
    auth_btn_login: "Ngarko identitetin dhe identifikohu",
    auth_btn_register: "Regjistrohu dhe krijo kripto",
    auth_copied: "E kopjuar",
    auth_copy_seed: "Kopjo farën",
    auth_generate_seed: "Gjeneroni fara",
    auth_headline: "GaiaCOM është protokolli i parë kuantik i postës elektronike dhe sistemi i komunikimit i ndërtuar për njerëzimin.",
    auth_kicker: "Komunikimi i Sigurt pas Kuantik",
    auth_mnemonic: "Fraza mnemonike",
    auth_mnemonic_placeholder: "12 fjalë të ndara me hapësira...",
    auth_password: "fjalëkalimin",
    auth_password_placeholder: "••••••••••••••",
    auth_proof_e2ee_desc: "Çelësat privatë nuk largohen nga pajisja juaj. Vetëm marrësit e synuar mund të deshifrojnë përmbajtjen.",
    auth_proof_gaiadata_desc: "Zero-Njohuri: Ju mbeteni në kontroll të të dhënave tuaja. Metadatat minimizohen dhe nuk përdoren si profil teksti i thjeshtë.",
    auth_proof_gaiadrop_desc: "Njerëzit e jashtëm mund të dërgojnë mesazhe teksti konfidenciale në GaiaID tuaj pa një llogari.",
    auth_proof_gaiaproof_desc: "Dorëzimi dhe dëshmitë e integritetit tregojnë se teksti i koduar, dërguesi dhe vula kohore nuk janë ngacmuar.",
    auth_proof_gaiavault_desc: "Shënimet private, shënimet e rikuperimit dhe të dhënat e sigurisë mbeten të koduara në nivel lokal.",
    auth_proof_hybrid_desc: "Mburoja Quantum: Kriptimi hibrid me ML-KEM dhe X25519 mbron nga sulmet e sotme dhe nga rreziqet e depozituara tani-dekriptohen më vonë.",
    auth_secure_mail: "Postë e sigurt e federuar kuantike",
    auth_subline: "GaiaCOM është një sistem komunikimi kuantik i sigurt për email, chat, dhoma krize, GaiaDrop dhe skedarë lokalë të sigurisë. Çelësat privatë qëndrojnë në pajisjen tuaj, përmbajtja është e koduar nga skaji në skaj dhe provat mund të eksportohen pa tekst të thjeshtë.",
    auth_success_btn: "Identifikohu tani",
    auth_success_text: "Llogaria juaj GaiaCOM është krijuar. Çelësat janë marrë në nivel lokal nga fara juaj dhe nuk janë ruajtur në server.",
    auth_success_title: "Regjistrimi i suksesshëm",
    auth_tab_drop: "GaiaDrop",
    auth_tab_login: "Hyrja/Llogaria",
    auth_toggle_login: "Llogaria ekziston tashmë",
    auth_toggle_register: "Krijo llogari të re",
    auth_usecase_text: "I përshtatshëm për avokatë, kompani, autoritete, gazetarë, sinjalizues dhe çështje të sigurisë private.",
    auth_usecase_title: "Ndërtuar për komunikim të ndjeshëm",
    auth_username: "emri i përdoruesit",
    auth_username_placeholder: "Fut emrin...",
    auth_value_chat: "E2E Chat",
    auth_value_drop: "Dorëzimi i sigurt",
    auth_value_mail: "Postë e sigurt",
    auth_value_rooms: "GaiaDhomat",
    bestaetigen: "Konfirmo",
    bestaetigt: "E konfirmuar",
    bio_status: "Biografia/Statusi",
    biography: "biografi",
    change_password_desc: "Ndryshon fjalëkalimin tuaj të hyrjes nga ana e serverit. Fraza juaj e rikuperimit lokal mbetet e mbrojtur veçmas nga fjalëkalimi juaj i kasafortës/zhbllokimit.",
    change_password_menu_desc: "Përditësoni fjalëkalimin e hyrjes në GaiaCOM.",
    change_password_title: "Ndrysho fjalëkalimin",
    channel_id: "ID e kanalit",
    channel_name_label: "Emri i kanalit",
    chat_deleted_hidden: "Biseda u fshi dhe u fsheh.",
    chat_input_placeholder: "Fut një mesazh të sigurt...",
    chat_start_hint: "Filloni bisedën! Të gjitha mesazhet e bisedës janë të koduara kuantike E2E.",
    choose_avatar: "Zgjidhni avatarin",
    ciphertext_hash: "Hash i tekstit të koduar",
    clear_chat: "Bisedë bosh",
    clear_for_everyone: "Bosh për të gjithë",
    clear_for_me: "Bosh vetëm për mua",
    click_to_write_mail: "Klikoni për të shkruar një email",
    click_top_right: "Klikoni lart djathtas",
    close: "Mbylle",
    code_kopieren: "Kopjo kodin",
    code_kopieren_success: "Kodi u kopjua",
    confirm_clear_channel_desc: "Dëshiron ta fshish këtë kanal nga pamja jote lokale?",
    confirm_clear_channel_title: "Kanali bosh",
    confirm_clear_chat: "Dëshiron ta zbrazësh këtë bisedë?",
    confirm_clear_chat_desc: "Dëshiron ta zbrazësh këtë bisedë?",
    confirm_clear_chat_title: "Bisedë bosh",
    confirm_clear_everyone: "Dëshiron të zbrazësh bisedën për të dy partnerët? (OK = Për të gjithë, Anulo = Vetëm për mua)",
    confirm_delete_everyone: "Dëshiron të fshish mesazhin për të dy partnerët? (OK = Për të gjithë, Anulo = Vetëm për mua)",
    confirm_delete_msg: "Dëshiron ta fshish këtë mesazh?",
    confirm_delete_msg_desc: "Dëshiron ta fshish këtë mesazh bisede?",
    confirm_delete_msg_title: "Fshi mesazhin",
    confirm_new_password: "Konfirmo fjalëkalimin e ri",
    copy: "Kopjo",
    create_btn: "Krijo",
    create_channel_title: "Krijo kanal",
    create_group_is_crisis: "Shënoni si zonë krize",
    create_group_title: "Krijo grup të ri",
    crypto_lock_desc: "Kontrollon kur GaiaCOM heq çelësat lokalë të kriptove nga kujtesa.",
    crypto_lock_menu_desc: "Kontrolloni kohëmatësit e ringarkimit dhe joaktivitetit.",
    crypto_lock_title: "Kyçja kriptografike",
    crypto_session_duration: "Zhbllokohet pas ringarkimit",
    crypto_session_duration_desc: "Sesionin e kriptos e mban të hapur në këtë skedë të shfletuesit vetëm për kohëzgjatjen e zgjedhur.",
    cryptographic_fingerprint: "Gjurmë gishtash kriptografike",
    current_password: "Fjalëkalimi aktual",
    data_minimization: "Minimizimi i të dhënave",
    decrypt_failed: "E pa deshifrueshme",
    delete: "Fshije",
    delete_account_button: "Fshi llogarinë në mënyrë të pakthyeshme",
    delete_account_confirm_label: "Futni DELETE për të konfirmuar",
    delete_account_confirmation_error: "Kërkohet fjalëkalimi dhe konfirmimi DELETE.",
    delete_account_desc: "Ky modalitet shkatërron përgjithmonë llogarinë tuaj, identitetet, seancat e pajisjes, të dhënat e GaiaDrop, të dhënat e ngarkimit dhe mesazhet që i atribuohen serverit.",
    delete_account_done_desc: "Të gjitha të dhënat e GaiaCOM të caktueshme janë fshirë.",
    delete_account_done_title: "Llogaria u fshi",
    delete_account_menu_desc: "Shkatërroni llogarinë dhe të dhënat përkatëse.",
    delete_account_not_authenticated: "Asnjë llogari aktive.",
    delete_account_title: "Fshi llogarinë",
    delete_for_everyone: "Fshije për të gjithë",
    delete_for_me: "Fshije vetëm për mua",
    device_current: "Kjo pajisje",
    device_last_seen: "E fundit",
    device_logout: "Dilni",
    device_sessions_desc: "Kontrolloni sesionet aktive dhe çregjistroni pajisjet që nuk i besoni më.",
    device_sessions_empty: "Nuk u gjet asnjë pajisje.",
    device_sessions_menu_desc: "Menaxhoni dhe përfundoni seancat aktive.",
    device_sessions_title: "Pajisjet e regjistruara",
    device_since: "Që kur",
    display_name: "Emri i shfaqur",
    drop_address_copied: "Adresa e GaiaDrop u kopjua.",
    drop_btn_decrypting: "Kutia hyrëse po deshifrohet...",
    drop_btn_load: "Ngarko kutinë hyrëse të GaiaDrop",
    drop_delete_desc: "Dëshiron vërtet ta fshish përgjithmonë këtë pikë?",
    drop_delete_title: "Fshi GaiaDrop",
    drop_desc: "Kanali i lëshimit të njohurive zero vetëm me tekst për njoftime të jashtme, zbulime të përgjegjshme dhe raporte konfidenciale. Palët e jashtme mund të dërgojnë mesazhe pa një llogari duke përdorur GaiaID tuaj.",
    drop_empty: "Asnjë mesazh GaiaDrop nuk është ngarkuar ende.",
    drop_id: "Hiq ID-në:",
    drop_own_address: "Adresa juaj e GaiaDrop",
    drop_proof: "DËSHMI DËSHIM",
    drop_title: "Kutia hyrëse e sigurt e GaiaDrop",
    dunkler_modus: "Modaliteti i errët",
    e2e_chat_room_open: "Hapni dhomën e bisedës E2E",
    edit_profile: "Redakto profilin",
    edit_profile_desc: "Personalizo emrin e ekranit, biografinë dhe avatarin.",
    einladungscode: "Kodi i ftesës",
    enter_fingerprint_chars_confirm: "Futni karakteret e kërkuara të gjurmëve të gishtave për të konfirmuar.",
    envelope_hash: "Zarfi hash",
    erasability: "Fshirja",
    erfolg: "Suksese",
    exclude_plaintext: "Eksporto pa tekst të thjeshtë",
    export_disclosure: "Rasti i sigurisë së eksportit",
    export_package_desc: "Përfshini vetëm tekst të thjeshtë nëse ky zbulim synohet qëllimisht.",
    export_package_title: "Eksporto paketën e sigurisë",
    fehler: "Gabim",
    gaiacom_reader: "GaiaCOM Reader",
    gaiadrop_inbox_title: "GaiaDrop Inbox",
    gaiavault: "GaiaVault",
    gdpr_home_desc: "GaiaCOM minimizon metadatat, mban çelësat privatë lokalë, enkripton përmbajtjen nga fundi në fund dhe mundëson fshirjen e plotë të llogarisë.",
    gdpr_home_title: "100% në përputhje me GDPR",
    gdpr_reason_delete: "Fshirja e llogarisë heq llogarinë, identitetet, seancat lokale dhe të dhënat e caktueshme nga serveri.",
    gdpr_reason_e2ee: "Përmbajtja private mbetet e deshifrueshme vetëm për marrësit e synuar.",
    gdpr_reason_minimal: "Metadatat përdoren vetëm për kredencialet e rrugëzimit, dorëzimit dhe sigurisë.",
    gdpr_reason_zero_knowledge: "Çelësat privatë dhe të dhënat e rikuperimit mbeten në nivel lokal nën kontrollin e përdoruesit.",
    gesendet: "Dërguar",
    gesperrt_verdaechtig: "E ndaluar / e dyshimtë",
    group_delete_desc: "Dëshiron vërtet ta fshish këtë grup përgjithmonë? Të gjitha kanalet dhe mesazhet në këtë grup do të fshihen.",
    group_delete_title: "Fshi grupin",
    group_description: "Përshkrimi",
    group_icon_label: "Ikona / avatari i grupit",
    group_name: "Emri i grupit",
    group_settings_avatar: "Avatari",
    group_settings_desc: "Përshkrimi",
    group_settings_is_crisis: "Shënoni si zonë krize",
    group_settings_name: "Emri i grupit",
    group_settings_title: "Cilësimet e grupit",
    groups_empty_desc: "Krijoni një hapësirë ​​pune të sigurt për projekte, kriza ose komunikim ekipor.",
    groups_empty_title: "Nuk ka ende biseda në grup",
    gruppe_beitreten: "U bashkua me grupin",
    gruppe_erstellen: "+ Krijo grup",
    gruppe_verlassen: "Largohu nga grupi",
    gruppen_chats: "Biseda në grup",
    heller_modus: "Modaliteti i ndritshëm",
    how_to_receive_drops: "Si mund të marr pika?",
    identitaets_assistent: "Asistent Identiteti",
    inactivity_lock_duration: "Kyç kur është joaktiv",
    inactivity_lock_duration_desc: "Pas kësaj periudhe pa hyrje, GaiaCOM automatikisht do të bllokohet kriptografikisht.",
    inactivity_lock_notice: "GaiaCOM është bllokuar kriptografikisht për shkak të pasivitetit.",
    include_plaintext: "Përfshi tekst të thjeshtë",
    invite_code_label: "Kodi i ftesës",
    join_group_title: "Bashkohu në grup",
    kanaele: "Kanalet",
    kanal_erstellen: "+ kanal",
    kein_chat_ausgewaehlt: "Asnjë bisedë e zgjedhur",
    kein_kanal_ausgewaehlt: "Nuk është zgjedhur asnjë kanal",
    keine_gruppe_ausgewaehlt: "Asnjë grup i zgjedhur",
    keine_mails: "Nuk ka email të disponueshëm.",
    key_change_warn_desc: "Çelësi publik i këtij kontakti ka ndryshuar. Kontrolloni gjurmën e gishtit përpara se t'i besoni.",
    key_change_warn_title: "Paralajmërim kriptografik",
    key_change_warning_changed: "ka ndryshuar. Kjo mund të jetë një shenjë e një sulmi njeri në mes!",
    key_change_warning_msg: "Çelësi i identitetit për kontaktin",
    key_transparency: "Transparenca kryesore",
    kopiert: "E kopjuar",
    kryptographische_schluessel: "Çelësat kriptografikë",
    kryptographische_schluessel_desc: "Shfaq çelësat privatë dhe frazën e farës rezervë.",
    laden: "Ngarko...",
    leeren: "Bosh",
    loading: "Ngarko...",
    local_key_vault: "Kasaforta lokale e çelësave",
    local_keys_label: "Çelësat lokalë",
    lock_on_reload: "Gjithmonë kyçeni pas ringarkimit",
    logout: "Dilni",
    mail_compose: "Shkruani email",
    mein_profil: "Profili im",
    melden: "Raportoni",
    menu: "menu",
    message: "Lajme",
    message_id: "ID e mesazhit",
    message_pin: "Pin",
    message_pinned_title: "Mesazhet e gozhduara",
    message_react: "Reagoni",
    message_reply: "Përgjigju",
    message_replying_to: "Përgjigje për",
    message_save: "Ruaj",
    message_saved: "U ruajt",
    message_to_channel: "Mesazh për",
    message_unpin: "Zgjidheni",
    message_unsave: "Mos kurseni",
    mitglied: "Anëtar",
    mitglieder: "anëtarët",
    ml_kem: "ML-KEM",
    neue_mail: "Email i ri",
    never_auto_lock: "Asnjëherë automatikisht",
    new_fingerprint: "Gjurmët e reja të gishtave",
    new_identity: "Identiteti i ri",
    new_password: "Fjalëkalim i ri",
    no_description: "Asnjë përshkrim",
    no_key_history: "Nuk është regjistruar asnjë histori kyçe.",
    no_specification: "Nuk është specifikuar",
    old_fingerprint: "Gjurmë gishtash të vjetër",
    open_privacy_imprint: "Mbrojtja e printimit të hapur dhe e të dhënave",
    post_quantum_e2e: "E2E post-kuantike",
    posteingang: "Inbox",
    powered_by: "Mundësuar nga",
    privacy_imprint_menu_desc: "Trego GDPR, mbrojtjen e të dhënave dhe njoftimin ligjor.",
    privacy_imprint_profile_desc: "GaiaCOM përpunon përmbajtjen e komunikimit sipas parimeve të minimizimit të të dhënave, enkriptimit nga fundi në fund dhe kontrollit lokal të çelësit.",
    privacy_imprint_title: "Mbrojtja e të dhënave dhe njoftimi ligjor",
    profil: "profili",
    profile_details: "Detajet e profilit",
    profile_settings_hint: "Cilësimet e profilit shfaqen në panelin e djathtë.",
    profile_unlock_desc: "Për arsye sigurie, duhet të rifusni fjalëkalimin tuaj për të parë çelësat tuaj privatë kriptografikë.",
    proof_hash: "Hash i provës:",
    public_drop_desc: "Drop i sigurt për informacione të tekstit të jashtëm pa një llogari GaiaCOM.",
    public_drop_message: "Lajme",
    public_drop_message_placeholder: "Fut tekst konfidencial...",
    public_drop_send: "Dërgo GaiaDrop",
    public_drop_sender: "Shënimi i dërguesit është opsional",
    public_drop_sender_placeholder: "Emri, numri i dosjes ose anonim",
    public_drop_target: "Synoni GaiaID",
    quanten_chat: "Bisedë Kuantike",
    quantum_secure_exchange: "Shkëmbim kuantik i sigurt përmes...",
    quantum_secure_net: "Rrjeti GaiaCOM Quantum Secure (Ed25519 & ML-KEM)",
    quantum_shield_desc: "Rrjeti GaiaCOM mbron privatësinë tuaj me një protokoll kriptimi hibrid me shumë shtresa, i cili mbrohet nga sulmet nga kompjuterët kuantikë të ardhshëm.",
    quantum_shield_l1_desc: "Përdor standardin FIPS 203 për të përmbledhur një çelës të përbashkët simetrik. Parandalon regjistrimin pasiv dhe deshifrimin e mëvonshëm (\\\\\\",
    quantum_shield_l1_title: "1. Mbrojtja pas kuantike (ML-KEM-1024)",
    quantum_shield_l2_desc: "Një procedurë klasike, jashtëzakonisht e shpejtë e shkëmbimit të çelësave Diffie-Hellman që shërben si një shtresë shtesë sigurie në procedurën hibride.",
    quantum_shield_l2_title: "2. Kriptografia e kurbës eliptike (X25519)",
    quantum_shield_l3_desc: "Çdo mesazh dhe çdo zarf i Federatës është i nënshkruar në mënyrë kriptografike për të verifikuar pa mëdyshje vërtetësinë e dërguesit.",
    quantum_shield_l3_title: "3. Nënshkrimet dixhitale (Ed25519)",
    quantum_shield_l4_desc: "Kripton përmbajtjen e mesazhit në mënyrë simetrike dhe lidh fort dërguesin, marrësin dhe meta të dhënat në të dhënat shtesë të vërtetuara (AAD) për të parandaluar sulmet e përsëritjes.",
    quantum_shield_l4_title: "4. Vërtetimi AAD (AES-256-GCM)",
    quantum_shield_status: "Statusi i Mburojës Kuantike",
    receive_drops_step1: "Ndani GaiaID tuaj (p.sh. duke përdorur butonin e kopjimit më lart) me burime të jashtme.",
    receive_drops_step2: "Këto thërrasin faqen e identifikimit të shembullit tuaj GaiaCOM dhe kaloni në skedën",
    receive_drops_step3: "dhe dërgoni mesazhin e tyre të koduar në adresën tuaj.",
    receiver_gaia: "Marrës GaiaCOM",
    receiver_smtp: "Marrësi SMTP",
    records_stored: "Regjistrimet u ruajtën",
    refresh: "Përditëso",
    report_abuse_desc: "Dëshiron ta raportosh këtë mesazh dhe të dorëzosh prova kriptografike të abuzimit në server?",
    report_abuse_title: "Raportoni abuzimin",
    reputation_status: "Statusi i reputacionit",
    room_chat_start_hint: "Filloni bisedën! Të gjitha mesazhet në këtë kanal grupi janë të decentralizuara të sigurta kuantike E2E të koduara.",
    room_policy_audit: "Gjurmët e auditimit dhe rrotullimi i çelësave janë aktiv.",
    room_policy_crisis: "Dhoma e krizës",
    room_policy_e2ee: "Hapësira e njohurive zero. E2EE e sigurt kuantike.",
    room_policy_title: "Udhëzimet për dhomën",
    room_policy_zero_knowledge: "Politika",
    room_security_note_desc: "Të gjitha ndryshimet kryesore vërtetohen nëpërmjet Transparency Key. Përdorni GaiaVault për regjistrat e rezervimit privat.",
    room_security_note_title: "Shënim sigurie i gozhduar",
    save_profile: "Ruaj profilin",
    schluessel_entsperrt: "🔑 Kyçeni përsëri çelësin",
    search_gaia_label: "Gjeni adresën e Gaia",
    security_warning_title: "Paralajmërim sigurie",
    select_channel_chat: "Zgjidhni një kanal nga shiriti anësor i majtë për të biseduar.",
    select_contact_chat: "Zgjidhni një kontakt nga paneli i majtë për të filluar një bisedë të sigurt kuantike E2E.",
    select_mail_read: "Zgjidhni një email nga lista për të lexuar përmbajtjen e tij të sigurt kuantike ose për të krijuar një mesazh të ri.",
    senden: "Dërgo",
    sender_signature: "Nënshkrimi i dërguesit",
    server_log: "Regjistri i serverit:",
    server_received: "Serveri u pranua",
    session_lock: "Bllokimi i seancës",
    setup_address_keys: "Krijo adresën dhe grupin e çelësave",
    setup_profile: "Vendosja në profil",
    smtp_inbox_title: "Pritja SMTP",
    smtp_legacy_badge: "SMTP e trashëguar / e pasigurt",
    smtp_mode_option: "Ura e trashëgimisë SMTP",
    smtp_security_warning: "Ky email u transmetua nëpërmjet protokollit klasik, të pakriptuar SMTP. Asnjë enkriptim nga fundi në fund nuk është aktiv.",
    smtp_security_warning_desc: "Ky mesazh po largohet nga dhoma e sigurisë GaiaCom. Dorëzimi SMTP nuk ofron garanci origjinale të GaiaCom nga fundi në fund, asnjë garanci TrustMesh dhe asnjë garanci Godmode nga porta.",
    spam_verdacht: "Spam/dyshim",
    spam_warning_desc: "Ky mesazh ka sinjale të dyshimta reputacioni.",
    spam_warning_title: "Paralajmërim për postë të padëshiruar",
    speichern: "Ruaj",
    sperren: "Mbylle jashtë",
    standard_group_status: "Biseda standarde në grup (E2EE e koduar)",
    status: "statusi",
    subject: "Në lidhje me",
    suchen: "Gjeni një adresë të re Gaia...",
    tage: "ditë",
    time_unknown: "Koha e panjohur",
    transmission_mode: "Mënyra e transferimit",
    trust_age: "Mosha e besimit",
    trust_passport_title: "Pasaporta e Besimit",
    unbestaetigt: "E pakonfirmuar",
    unknown_sender: "E panjohur",
    unlock_btn: "Zhblloko",
    unlock_btn_profile: "Zhblloko",
    unlock_desc: "Skedari juaj i çelësit privat ruhet i koduar. Futni fjalëkalimin tuaj për të ngarkuar vetëm çelësat kriptografikë në memorie.",
    unlock_logout: "Dilni dhe mbyllni çelësat lokalë",
    unlock_title: "Zhbllokoni identitetin",
    untrusted: "Jo i besueshëm",
    update_password: "Përditëso fjalëkalimin",
    upload_avatar_btn: "Ngarko imazh (të dezinfektuar)",
    vault_btn_encrypt: "Enkripto regjistrimin",
    vault_btn_lock: "Mbylle kasafortën",
    vault_btn_unlock: "Zhbllokoni kasafortën",
    vault_copied_success: "Kopjuar në kujtesën e fragmenteve",
    vault_decrypted_content: "Përmbajtje e deshifruar",
    vault_desc: "Kasaforta e koduar lokale për kopje rezervë të rikuperimit, shënime identiteti, akses në server, kontakte emergjente, shënime ligjore, ngjarje sigurie dhe regjistra privatë.",
    vault_empty: "Asnjë regjistrim i sigurt nuk është ruajtur ende.",
    vault_locked_pane_notice: "Kasaforta është e kyçur. Ju lutemi, zhbllokoni në të djathtë.",
    vault_new_record: "Rekord i ri i sigurt",
    vault_pwd_placeholder: "Fut fjalëkalimin e Kasafortës...",
    vault_record_body: "Regjistroni përmbajtjen",
    vault_record_body_placeholder: "Fut përmbajtjen e regjistrimit të koduar...",
    vault_record_category: "kategori",
    vault_record_title: "Titulli i regjistrimit",
    vault_record_title_placeholder: "Titulli i regjistrimit të sigurt",
    vault_title: "GaiaVault Secure Records",
    verify_new_fingerprint_hint: "Kontrolloni gjurmën e re të gishtit përpara se të pranoni çelësin.",
    vertrauenswuerdig: "I besueshëm",
    vision_gaia_technology: "VisionGaiaTechnology",
    von: "Nga",
    warnung: "paralajmërim",
    wizard_address: "adresa",
    wizard_back: "Mbrapa",
    wizard_check1: "Unë e kam ruajtur në mënyrë të sigurt farën time.",
    wizard_custom_domain: "Përdorni domenin tuaj",
    wizard_desc1: "GaiaCOM nuk ruan çelësat privatë në anën e serverit. Pa Mnemonic Seed, askush nuk mund të rikuperojë mesazhet e humbura.",
    wizard_desc2: "Adresa juaj përcakton nyjen e federuar përmes së cilës drejtohen zarfet e koduar.",
    wizard_fallback: "Nyjet e kthimit",
    wizard_finish: "Konfigurimi i plotë",
    wizard_next: "Më tej",
    wizard_server_domain: "Domeni i nyjës së serverit",
    wizard_step1: "1. Backup Seed",
    wizard_step2: "2. Adresa & Serveri",
    wizard_title1: "Rezervo çelësin e rikuperimit",
    wizard_title2: "Zgjidhni adresën GaiaCOM",
    write_message_placeholder: "Shkruani një mesazh të sigurt...",
    you: "Ju",
    zero_knowledge: "Njohuri zero",
    zero_knowledge_encryption: "Kriptimi me njohuri zero",
    "Chat fuer alle geleert": "Biseda është zbrazur për të gjithë pjesëmarrësit.",
    "Chat geleert": "Biseda është pastruar për kutinë tuaj hyrëse lokale.",
    "Nachricht fuer alle geloescht": "Mesazhi është fshirë për të gjithë pjesëmarrësit.",
    "Nachricht geloescht": "Mesazhi i bisedës është hequr lokalisht nga kutia juaj hyrëse.",
    "anpinnen": "Pin",
    "chat_loeschen": "Fshi bisedën",
    "confirm_delete_chat_desc": "Jeni i sigurt që dëshironi të fshini dhe fshehni bisedën?",
    "confirm_leave_group_desc": "Dëshiron vërtet të largohesh nga ky grup?",
    "entpinnen": "Zhgozhdoni",
    "group_deleted": "Grupi u fshi me sukses.",
    "group_left": "Largohu me sukses nga grupi.",
    "gruppe_loeschen": "Fshi grupin",
    "loeschen": "Fshije",
    "no_active_chats": "Nuk ka biseda aktive. Kërkoni kontaktet e mësipërme për të filluar një bisedë.",
    "pinned": "E ngulitur",
    "wizard_check_credentials": "Unë jam përgjegjës për ruajtjen e të dhënave të mia të aksesit të sigurta.",
    "wizard_check_is_beta": "Unë e kuptoj që GaiaCom është softuer beta.",
    "wizard_check_no_illegal": "Nuk do ta përdor GaiaCom për qëllime të paligjshme.",
    "wizard_check_no_uptime": "Unë e kuptoj që nuk ka asnjë garanci për disponueshmërinë.",
    "wizard_check_smtp_security": "Unë e kuptoj që mesazhet SMTP nuk ofrojnë siguri të plotë të GaiaCom.",
    "wizard_check_terms_read": "Kam lexuar Kushtet e Shërbimit Beta.",
    "wizard_step_terms": "Kushtet e Përdorimit",
    "wizard_terms_text": "Kushtet e përdorimit të GaiaCom dhe Marrëveshja e testimit beta (faza beta)\n\nOfruesi: VisionGaiaTechnology (në tekstin e mëtejmë \"Ofruesi\")\nStatusi: Faza e testimit beta publike\nVlefshmëria: Nga 21 qershor 2026\n\n⚠️ SHËNIM MË I RËNDËSISHËM PARAPARA (JU LUTEM LEXOJENI ME KUJDES)\nGaiaCom është në një fazë testimi publik beta. Pavarësisht masave të gjera të sigurisë, liria nga gabimet, disponueshmëria e vazhdueshme ose siguria absolute e softuerit dhe infrastrukturës bazë nuk mund të garantohet. Përdoreni në rrezikun tuaj. Përdoruesit janë përgjegjës për ruajtjen e sigurt të të dhënave të tyre të aksesit (veçanërisht çelësat për GaiaVault) dhe për pajtueshmërinë me ligjet në fuqi.\n\n1. Subjekti dhe qëllimi i fazës së testit beta\n1.1. Qëllimi i ofrimit: GaiaCom është një shërbim i ri për email dhe bisedë i bazuar në kriptografinë post-kuantike (PQC). Dispozita gjatë fazës beta ka për qëllim ekskluzivisht testimin teknik, simulimin e ngarkesës, gjetjen e gabimeve të programit (bugs) dhe optimizimin e përshtatshmërisë ndaj përdoruesit.\n1.2. Statusi beta: Përdoruesi është i vetëdijshëm se softueri i ofruar është një version paraprak (softuer beta). Ky nuk është ende plotësisht i zhvilluar teknikisht, nuk plotëson standardin e një produkti përfundimtar, komercial dhe mund të shkaktojë gabime, humbje të të dhënave, vonesa të transmetimit ose prishje të sistemit.\n1.3. Nuk ka të drejtë për vazhdim: Ofruesi ka të drejtë në çdo kohë të ndërpresë shërbimin tërësisht ose pjesërisht, të ndryshojë ose kufizojë funksionet ose t'i heqë ato përkohësisht ose përgjithmonë pa dhënë arsye.\n\n2. Disponueshmëria dhe mohimi i garancisë\n2.1. Asnjë garanci disponueshmërie: GaiaCom ofrohet pa asnjë garanci për disponueshmërinë ose kohën e funksionimit. Nuk ka të drejtë për disponueshmëri të pandërprerë të shërbimit.\n2.2. Përjashtimi i garancisë: Softueri ofrohet në gjendjen e tij aktuale (“siç është”) dhe i nënshtrohet disponueshmërisë. Për aq sa lejohet me ligj, çdo pretendim garancie për defekte materiale dhe ligjore në softuer përjashtohet. Në veçanti, nuk ka asnjë garanci që softueri është pa gabime, pa malware ose i përshtatshëm për një qëllim të caktuar.\n\n3. Menaxhimi i riskut dhe detyrimet e përdoruesve\n3.1. Ndalimi i ruajtjes së të dhënave kritike: Përdoruesi merr përsipër të mos ruajë ose transmetojë ekskluzivisht përmes GaiaCom asnjë të dhënë kritike biznesi, jetike, operacionale ose veçanërisht të ndjeshme ligjërisht (si skedarët e pacientëve, të dhënat financiare shumë të ndjeshme ose sekretet e rregulluara zyrtarisht). Shërbimi nuk mund të përdoret për infrastrukturë ku dështimet e paparashikuara mund të rezultojnë në dëmtim personal, dëmtim të pronës ose humbje të konsiderueshme financiare.\n3.2. Rezervimi i vetëpërgjegjshëm: Përdoruesi është përgjegjës për rezervimin e të gjitha të dhënave të marra ose të dërguara nëpërmjet GaiaCom që i nevojiten për një kohë të gjatë në sistemet e tij të pavarura (kopje rezervë). Ofruesi nuk garanton ruajtjen ose rikthimin e përhershëm të të dhënave në serverët e tij.\n\n4. Karakteristikat kriptografike dhe GaiaVault\n4.1. Kriptografia post-kuantike (PQC): GaiaCom zbaton procese kriptimi të orientuara drejt së ardhmes, të cilat janë të dizajnuara për t'i bërë ballë sulmeve nga kompjuterët kuantikë të ardhshëm. Megjithatë, përdoruesi është i vetëdijshëm se kjo është një fushë shkencore dinamike dhe e re. Siguria absolute dhe e pakundërshtueshme nuk mund të garantohet bazuar në gjendjen aktuale të shkencës dhe teknologjisë. Terma të tillë si \"100% i sigurt\", \"i pathyeshëm\" ose \"i sigurt ushtarak\" nuk garantohen shprehimisht.\n4.2. Asnjë garanci rikuperimi (GaiaVault): GaiaCom mbështetet në një koncept të qëndrueshëm sigurie me njohuri zero. Pykat e kriptimit dhe të dhënat e aksesit mbeten vetëm në kontrollin e përdoruesit (të siguruara nëpërmjet GaiaVault).\nE RËNDËSISHME: Nëse përdoruesi humbet fjalëkalimet, frazat e kalimit, çelësat privatë ose farat e rikuperimit, ofruesi nuk ka aftësi teknike për të rindërtuar ose rivendosur këto të dhëna. Humbja e këtyre të dhënave të aksesit çon në mënyrë të pashmangshme në humbjen e pakthyeshme të aksesit në llogarinë e përdoruesit dhe të gjitha të dhënat e koduara në të.\n4.3. Ende i pa audituar plotësisht: Softueri i nënshtrohet vazhdimisht kontrolleve të brendshme të sigurisë, por në kohën e kësaj faze beta nuk i është nënshtruar ende një auditimi përfundimtar, gjithëpërfshirës të sigurisë së jashtme nga organe të pavarura testimi.\n\n5. Ndërfaqet, protokollet e trashëgimisë dhe federata\n5.1. SMTP Bridge Shënim: GaiaCom ofron mundësinë për të komunikuar nëpërmjet protokolleve klasike të postës elektronike (si p.sh. SMTP). Përdoruesi është i vetëdijshëm se mesazhet që largohen nga zona e sigurisë së GaiaCom (p.sh. kur dërgohen në një adresë konvencionale @gmail.com ose @gmx.de) transportohen nëpërmjet serverëve të pa enkriptuar ose të palëve të treta. Garancitë e sigurisë nga fundi në fund të GaiaCom zbatohen vetëm në një masë të kufizuar ose aspak për mesazhe të tilla të vjetra dalëse ose hyrëse.\n5.2. Shënim i Federatës: Nëse GaiaCom operon në një rrjet të federuar, mesazhet dhe të dhënat mund të kalojnë përmes serverëve të palëve të treta. Ndërsa përmbajtja e mesazheve mbetet e mbrojtur nga kriptimi nga skaji në fund, meta të dhënat (siç është koha e dërgimit, adresat IP të serverëve të përfshirë dhe adresat e marrësve) mund të jenë teknikisht të dukshme për operatorët e këtyre serverëve të federuar. Ofruesi nuk ka asnjë ndikim në praktikat e mbrojtjes së të dhënave të operatorëve të serverëve të palëve të treta në rrjetin e federuar.\n\n6. Përdorime të pranueshme dhe aktivitete të ndaluara\nPërdoruesi merr përsipër të mos e përdorë shërbimin në mënyrë të pahijshme ose për qëllime të paligjshme. Në veçanti, të mëposhtmet janë të ndaluara:\n- Shpërndarja, dërgimi ose mbajtja e viruseve, malware, përmbajtjeve të phishing ose programeve të tjera me qëllim të keq.\n- Përdorimi i Shërbimit për të kryer sulme të mohimit të shërbimit (DDoS) ose postime të pakërkuara me shumicë (spam).\n- Abuzimi i sistemit për të kryer mashtrime.\n- Shpërndarja ose shkëmbimi i përmbajtjes ilegale, në veçanti përshkrimet e abuzimit seksual të fëmijëve (CSAM), propaganda terroriste, thirrjet për dhunë ose përmbajtje të tjera të rëndësishme kriminale.\n\n7. Sistemi i raportimit të abuzimeve\n7.1. Raportimi i sjelljes abuzive: Përdoruesit kanë mundësinë të raportojnë komunikime abuzive ose aktivitete të paligjshme nëpërmjet sistemit të integruar të abuzimit.\n7.2. Përpunimi i raporteve: Për të siguruar mbrojtje nga keqpërdorimi, raportet hyrëse mund të analizohen teknikisht (duke ruajtur kufizimet e privatësisë dhe të enkriptimit). Kjo mund të çojë në pezullim të përkohshëm ose të përhershëm të llogarive të përdoruesve ose adresave IP në rast të shkeljeve të vërtetuara të këtyre kushteve të përdorimit.\n\n8. Kufizimi i përgjegjësisë\n8.1. Standardi i përgjegjësisë: Softueri beta ofrohet pa pagesë. Sipas rregullave ligjore për donacionet ose huatë, ofruesi është për këtë arsye përgjegjës vetëm për qëllim (dëm të qëllimshëm) dhe pakujdesi të rëndë.\n8.2. Përjashtimi i përgjegjësisë për humbjen e të dhënave: Përgjegjësia për humbjen e të dhënave përjashtohet nëse humbja është shkaktuar me dashje ose nga neglizhenca e rëndë nga ofruesi dhe përdoruesi ka përmbushur detyrimin e tij për të zbutur dëmin përmes kopjeve rezervë të rregullt (jashtë GaiaCom).\n8.3. Kufijtë ligjorë: Kufizimet e mësipërme të përgjegjësisë nuk zbatohen për dëmtimin e jetës, trupit ose shëndetit ose për përgjegjësinë sipas Ligjit për Përgjegjësinë e Produkteve.\n\n9. Burim i hapur\nDisa komponentë, biblioteka ose aplikacione klienti të GaiaCom mund të licencohen me licenca me burim të hapur (p.sh. GPL, MIT, Apache). Kushtet përkatëse të licencës të këtyre komponentëve mbeten të paprekura nga këto kushte përdorimi dhe mund të shikohen në depot përkatëse të kodit burimor.\n\n10. Kontrolli dhe Pajtueshmëria e Eksportit\nPërdoruesi është i vetëdijshëm se softueri kriptografik mund t'i nënshtrohet kontrolleve të rrepta të eksportit dhe kufizimeve ligjore. Përdoruesi është përgjegjës për të siguruar që përdorimi i GaiaCom nuk shkel ligjet, kufizimet e importit/eksportit ose rregulloret e kriptografisë të vendit të tyre përkatës të banimit.\n\n11. Njoftim për mbrojtjen e të dhënave (versioni i shkurtër për beta)\n11.1. Mbledhja minimale e të dhënave: Si pjesë e fazës beta, ofruesi mbledh vetëm të dhëna që janë absolutisht të nevojshme për funksionimin teknik, zgjidhjen e problemeve dhe zhvillimin e mëtejshëm (p.sh. skedarët e regjistrit të serverit për diagnostikimin e gabimeve).\n11.2. Nuk ka njohuri për përmbajtjen: Falë njohurive të qëndrueshme zero dhe enkriptimit E2E, ofruesi nuk ka kurrë qasje në përmbajtjen e bisedave, emaileve ose çelësave tuaj të ruajtur në GaiaVault.\n11.3. Deklarata e detajuar e mbrojtjes së të dhënave: Rregulloret e detajuara të mbrojtjes së të dhënave janë të lidhura veçmas dhe duhet gjithashtu të merren parasysh nga përdoruesi përpara se të regjistrohet.\n\n12. Dispozitat përfundimtare\n12.1. Ligji në fuqi: Zbatohet ligji i Republikës Federale të Gjermanisë, duke përjashtuar Konventën e OKB-së për Kontratat për Shitjen Ndërkombëtare të Mallrave.\n12.2. Subjekt për ndryshim: Meqenëse GaiaCom është në zhvillim aktiv, ofruesi rezervon të drejtën t'i përshtatë këto kushte në çdo kohë me efekt për të ardhmen. Versioni aktual është i disponueshëm në aplikacion.",
    "wizard_terms_title": "Kushtet e përdorimit të GaiaCom dhe Marrëveshja e testimit beta (faza beta)",
    "node_operator": "Operatori i nyjës",
    "search_channels": "Kërko kanale...",
    "senior_reviewer": "Recensues i lartë",
    "trusted_reviewer": "Rishikues i besuar",
    "active_frequencies": "Frekuenca aktive",
    "connected_rooms": "HAPËSIRAT E LIDHUR",
    "dashboard": "Paneli",
    "empty_chats": "Nuk disponohen biseda aktive.",
    "empty_messages": "Nuk ka mesazhe të reja në dispozicion.",
    "encrypted": "E koduar",
    "gaiacom_uplink": "GAIACOM UPLINK",
    "install_app": "Instaloni aplikacionin",
    "install_app_desc": "Për fillimin e shpejtë dhe modalitetin offline",
    "kommandozentrale_alpha": "Qendra komanduese ALPHA",
    "network_online": "RRJETI: ONLINE",
    "new_room": "Hapësirë ​​e re",
    "no_frequencies_active": "Nuk ka frekuenca aktive. Krijo një dhomë të re për të filluar komunikimin.",
    "no_id": "Nuk ka ID",
    "open_chats": "Hapni bisedat",
    "open_inbox": "Hap kutinë hyrëse",
    "primary_identity": "IDENTITET PRIMAR",
    "recent_chats": "Biseda të reja",
    "recent_messages": "Lajmet e fundit",
    "session_encrypted": "Sesioni i koduar: {name}",
    "session_secure": "STATUSI: I SIGURT",
    "system_verlassen": "Sistemi i daljes",
    "write_message": "Shkruani një mesazh",
  }
};

const LanguageContext = React.createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem('gaia_lang') || 'de';
  });

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguageState(lang);
      localStorage.setItem('gaia_lang', lang);
    }
  };

  const t = (key) => {
    if (!key) return '';
    const langData = translations[language] || translations.de;
    if (langData && langData[key] !== undefined) return langData[key];
    if (translations.de && translations.de[key] !== undefined) return translations.de[key];
    return undefined;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const context = React.useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
}
